webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {/* jshint node:true */
	'use strict';
	
	var Debug = __webpack_require__(8);
	var clientDebug = __webpack_require__(8)('app:client:debug');
	var React = __webpack_require__(11);
	var Router = __webpack_require__(166);
	var HistoryLocation = __webpack_require__(205);
	var appConfig = __webpack_require__(206);
	var app = __webpack_require__(207)(appConfig.uid);
	var browser = __webpack_require__(252);
	var clientStateHandlers = __webpack_require__(436);
	var Path = __webpack_require__(253);
	var inited = false;
	
	window.Debug = Debug;
	
	Debug.disable();
	
	var context = app.createContext();
	
	function renderReact(context, Handler, sport, routeChange, state) {
	    var actionContext = context.getActionContext();
	    var isGamePackage = isGamePackageRoute(state.routes) && !(window.__noShell === true);
	
	    /**
	     * Check and append main-container div
	     * if route is game package and if the div doesn't exist
	     */
	    if (!jQuery('#pane-main>#' + appConfig.uid).length && isGamePackage) {
	        appendPlaceholder();
	    }
	
	    try {
	        React.render(React.createElement(Handler, {
	            context: context.getActionContext()
	        }), document.getElementById(appConfig.uid), function () {
	            var request = Path.decode(this.state.pathname);
	            clientStateHandlers.postRouteRender(sport, request.page, routeChange, isGamePackage);
	            clientDebug('Render complete');
	        });
	    } catch (e) {
	        console.log(e.stack || e);
	    }
	}
	
	/**
	 * Appends the main-container
	 */
	function appendPlaceholder() {
	    try {
	        jQuery('#pane-main').append('<div id="' + appConfig.uid + '" ></div>');
	    } catch (e) {}
	}
	
	/**
	 * Checks if the current route is gamepackage
	 * @param  {Array}  routes
	 * @return {Boolean}
	 */
	function isGamePackageRoute(routes) {
	    var isGamePackage = false;
	    routes = routes || [];
	
	    routes.map(function (r, i) {
	        if (r && r.handler && r.handler.displayName === 'Gamecast') {
	            isGamePackage = true;
	        }
	    });
	    return isGamePackage;
	}
	
	/**
	 * Checks and returns `true` if route has changed
	 * @param  {Object}  state
	 * @return {Boolean}
	 */
	function hasRouteChanged(state) {
	    return !!((history.state && history.state.path || '').replace(/\/?$/, '/') !== state.path.replace(/\/?$/, '/'));
	}
	
	Router.run(app.getComponent(), HistoryLocation, function (Handler, state) {
	    if (!inited) {
	        inited = true;
	    }
	    var request = Path.decode(state.pathname);
	    var sport = state.params.league;
	    /**
	     * Execute pre render tasks
	     */
	    var routeChange = hasRouteChanged(state);
	    clientStateHandlers.preRouteRender(sport, request.page, routeChange);
	    var actions = state.routes.filter(function (route) {
	        /**
	         * Actions for Proxy loaded components are in the Mixin object
	         */
	        route.handler.loadAction = route.handler.loadAction || route.handler.Mixin && route.handler.Mixin.loadAction;
	        return route.handler.loadAction ? true : false;
	    });
	    /**
	     * if actions exist, execute them, else render directly
	     * @param  {Array} actions.length
	     */
	    if (actions.length) {
	        clientDebug('Load action found');
	        actions.map(function (route, i) {
	            state.appInited = inited;
	            context.getActionContext().executeAction(route.handler.loadAction, state, function () {
	                renderReact(context, Handler, sport, routeChange, state);
	            });
	        });
	    } else {
	        clientDebug('Load action not found');
	        renderReact(context, Handler, sport, routeChange, state);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(9);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(10);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 10 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.DefaultRoute = __webpack_require__(167);
	exports.Link = __webpack_require__(180);
	exports.NotFoundRoute = __webpack_require__(181);
	exports.Redirect = __webpack_require__(182);
	exports.Route = __webpack_require__(179);
	exports.ActiveHandler = __webpack_require__(177);
	exports.RouteHandler = exports.ActiveHandler;
	
	exports.HashLocation = __webpack_require__(183);
	exports.HistoryLocation = __webpack_require__(186);
	exports.RefreshLocation = __webpack_require__(187);
	exports.StaticLocation = __webpack_require__(188);
	exports.TestLocation = __webpack_require__(189);
	
	exports.ImitateBrowserBehavior = __webpack_require__(190);
	exports.ScrollToTopBehavior = __webpack_require__(191);
	
	exports.History = __webpack_require__(185);
	exports.Navigation = __webpack_require__(192);
	exports.State = __webpack_require__(193);
	
	exports.createRoute = __webpack_require__(169).createRoute;
	exports.createDefaultRoute = __webpack_require__(169).createDefaultRoute;
	exports.createNotFoundRoute = __webpack_require__(169).createNotFoundRoute;
	exports.createRedirect = __webpack_require__(169).createRedirect;
	exports.createRoutesFromReactChildren = __webpack_require__(194);
	
	exports.create = __webpack_require__(195);
	exports.run = __webpack_require__(204);

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var PropTypes = __webpack_require__(168);
	var RouteHandler = __webpack_require__(177);
	var Route = __webpack_require__(179);
	
	/**
	 * A <DefaultRoute> component is a special kind of <Route> that
	 * renders when its parent matches but none of its siblings do.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var DefaultRoute = (function (_Route) {
	  function DefaultRoute() {
	    _classCallCheck(this, DefaultRoute);
	
	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }
	
	  _inherits(DefaultRoute, _Route);
	
	  return DefaultRoute;
	})(Route);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	DefaultRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	DefaultRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = DefaultRoute;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(22);
	var ReactPropTypes = __webpack_require__(11).PropTypes;
	var Route = __webpack_require__(169);
	
	var PropTypes = assign({}, ReactPropTypes, {
	
	  /**
	   * Indicates that a prop should be falsy.
	   */
	  falsy: function falsy(props, propName, componentName) {
	    if (props[propName]) {
	      return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	    }
	  },
	
	  /**
	   * Indicates that a prop should be a Route object.
	   */
	  route: ReactPropTypes.instanceOf(Route),
	
	  /**
	   * Indicates that a prop should be a Router object.
	   */
	  //router: ReactPropTypes.instanceOf(Router) // TODO
	  router: ReactPropTypes.func
	
	});
	
	module.exports = PropTypes;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var assign = __webpack_require__(22);
	var invariant = __webpack_require__(16);
	var warning = __webpack_require__(24);
	var PathUtils = __webpack_require__(170);
	
	var _currentRoute;
	
	var Route = (function () {
	  function Route(name, path, ignoreScrollBehavior, isDefault, isNotFound, onEnter, onLeave, handler) {
	    _classCallCheck(this, Route);
	
	    this.name = name;
	    this.path = path;
	    this.paramNames = PathUtils.extractParamNames(this.path);
	    this.ignoreScrollBehavior = !!ignoreScrollBehavior;
	    this.isDefault = !!isDefault;
	    this.isNotFound = !!isNotFound;
	    this.onEnter = onEnter;
	    this.onLeave = onLeave;
	    this.handler = handler;
	  }
	
	  _createClass(Route, [{
	    key: 'appendChild',
	
	    /**
	     * Appends the given route to this route's child routes.
	     */
	    value: function appendChild(route) {
	      invariant(route instanceof Route, 'route.appendChild must use a valid Route');
	
	      if (!this.childRoutes) this.childRoutes = [];
	
	      this.childRoutes.push(route);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var string = '<Route';
	
	      if (this.name) string += ' name="' + this.name + '"';
	
	      string += ' path="' + this.path + '">';
	
	      return string;
	    }
	  }], [{
	    key: 'createRoute',
	
	    /**
	     * Creates and returns a new route. Options may be a URL pathname string
	     * with placeholders for named params or an object with any of the following
	     * properties:
	     *
	     * - name                     The name of the route. This is used to lookup a
	     *                            route relative to its parent route and should be
	     *                            unique among all child routes of the same parent
	     * - path                     A URL pathname string with optional placeholders
	     *                            that specify the names of params to extract from
	     *                            the URL when the path matches. Defaults to `/${name}`
	     *                            when there is a name given, or the path of the parent
	     *                            route, or /
	     * - ignoreScrollBehavior     True to make this route (and all descendants) ignore
	     *                            the scroll behavior of the router
	     * - isDefault                True to make this route the default route among all
	     *                            its siblings
	     * - isNotFound               True to make this route the "not found" route among
	     *                            all its siblings
	     * - onEnter                  A transition hook that will be called when the
	     *                            router is going to enter this route
	     * - onLeave                  A transition hook that will be called when the
	     *                            router is going to leave this route
	     * - handler                  A React component that will be rendered when
	     *                            this route is active
	     * - parentRoute              The parent route to use for this route. This option
	     *                            is automatically supplied when creating routes inside
	     *                            the callback to another invocation of createRoute. You
	     *                            only ever need to use this when declaring routes
	     *                            independently of one another to manually piece together
	     *                            the route hierarchy
	     *
	     * The callback may be used to structure your route hierarchy. Any call to
	     * createRoute, createDefaultRoute, createNotFoundRoute, or createRedirect
	     * inside the callback automatically uses this route as its parent.
	     */
	    value: function createRoute(options, callback) {
	      options = options || {};
	
	      if (typeof options === 'string') options = { path: options };
	
	      var parentRoute = _currentRoute;
	
	      if (parentRoute) {
	        warning(options.parentRoute == null || options.parentRoute === parentRoute, 'You should not use parentRoute with createRoute inside another route\'s child callback; it is ignored');
	      } else {
	        parentRoute = options.parentRoute;
	      }
	
	      var name = options.name;
	      var path = options.path || name;
	
	      if (path && !(options.isDefault || options.isNotFound)) {
	        if (PathUtils.isAbsolute(path)) {
	          if (parentRoute) {
	            invariant(path === parentRoute.path || parentRoute.paramNames.length === 0, 'You cannot nest path "%s" inside "%s"; the parent requires URL parameters', path, parentRoute.path);
	          }
	        } else if (parentRoute) {
	          // Relative paths extend their parent.
	          path = PathUtils.join(parentRoute.path, path);
	        } else {
	          path = '/' + path;
	        }
	      } else {
	        path = parentRoute ? parentRoute.path : '/';
	      }
	
	      if (options.isNotFound && !/\*$/.test(path)) path += '*'; // Auto-append * to the path of not found routes.
	
	      var route = new Route(name, path, options.ignoreScrollBehavior, options.isDefault, options.isNotFound, options.onEnter, options.onLeave, options.handler);
	
	      if (parentRoute) {
	        if (route.isDefault) {
	          invariant(parentRoute.defaultRoute == null, '%s may not have more than one default route', parentRoute);
	
	          parentRoute.defaultRoute = route;
	        } else if (route.isNotFound) {
	          invariant(parentRoute.notFoundRoute == null, '%s may not have more than one not found route', parentRoute);
	
	          parentRoute.notFoundRoute = route;
	        }
	
	        parentRoute.appendChild(route);
	      }
	
	      // Any routes created in the callback
	      // use this route as their parent.
	      if (typeof callback === 'function') {
	        var currentRoute = _currentRoute;
	        _currentRoute = route;
	        callback.call(route, route);
	        _currentRoute = currentRoute;
	      }
	
	      return route;
	    }
	  }, {
	    key: 'createDefaultRoute',
	
	    /**
	     * Creates and returns a route that is rendered when its parent matches
	     * the current URL.
	     */
	    value: function createDefaultRoute(options) {
	      return Route.createRoute(assign({}, options, { isDefault: true }));
	    }
	  }, {
	    key: 'createNotFoundRoute',
	
	    /**
	     * Creates and returns a route that is rendered when its parent matches
	     * the current URL but none of its siblings do.
	     */
	    value: function createNotFoundRoute(options) {
	      return Route.createRoute(assign({}, options, { isNotFound: true }));
	    }
	  }, {
	    key: 'createRedirect',
	
	    /**
	     * Creates and returns a route that automatically redirects the transition
	     * to another route. In addition to the normal options to createRoute, this
	     * function accepts the following options:
	     *
	     * - from         An alias for the `path` option. Defaults to *
	     * - to           The path/route/route name to redirect to
	     * - params       The params to use in the redirect URL. Defaults
	     *                to using the current params
	     * - query        The query to use in the redirect URL. Defaults
	     *                to using the current query
	     */
	    value: function createRedirect(options) {
	      return Route.createRoute(assign({}, options, {
	        path: options.path || options.from || '*',
	        onEnter: function onEnter(transition, params, query) {
	          transition.redirect(options.to, options.params || params, options.query || query);
	        }
	      }));
	    }
	  }]);
	
	  return Route;
	})();
	
	module.exports = Route;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(16);
	var assign = __webpack_require__(171);
	var qs = __webpack_require__(172);
	
	var paramCompileMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|[*.()\[\]\\+|{}^$]/g;
	var paramInjectMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$?]*[?]?)|[*]/g;
	var paramInjectTrailingSlashMatcher = /\/\/\?|\/\?\/|\/\?/g;
	var queryMatcher = /\?(.*)$/;
	
	var _compiledPatterns = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in _compiledPatterns)) {
	    var paramNames = [];
	    var source = pattern.replace(paramCompileMatcher, function (match, paramName) {
	      if (paramName) {
	        paramNames.push(paramName);
	        return '([^/?#]+)';
	      } else if (match === '*') {
	        paramNames.push('splat');
	        return '(.*?)';
	      } else {
	        return '\\' + match;
	      }
	    });
	
	    _compiledPatterns[pattern] = {
	      matcher: new RegExp('^' + source + '$', 'i'),
	      paramNames: paramNames
	    };
	  }
	
	  return _compiledPatterns[pattern];
	}
	
	var PathUtils = {
	
	  /**
	   * Returns true if the given path is absolute.
	   */
	  isAbsolute: function isAbsolute(path) {
	    return path.charAt(0) === '/';
	  },
	
	  /**
	   * Joins two URL paths together.
	   */
	  join: function join(a, b) {
	    return a.replace(/\/*$/, '/') + b;
	  },
	
	  /**
	   * Returns an array of the names of all parameters in the given pattern.
	   */
	  extractParamNames: function extractParamNames(pattern) {
	    return compilePattern(pattern).paramNames;
	  },
	
	  /**
	   * Extracts the portions of the given URL path that match the given pattern
	   * and returns an object of param name => value pairs. Returns null if the
	   * pattern does not match the given path.
	   */
	  extractParams: function extractParams(pattern, path) {
	    var _compilePattern = compilePattern(pattern);
	
	    var matcher = _compilePattern.matcher;
	    var paramNames = _compilePattern.paramNames;
	
	    var match = path.match(matcher);
	
	    if (!match) {
	      return null;
	    }var params = {};
	
	    paramNames.forEach(function (paramName, index) {
	      params[paramName] = match[index + 1];
	    });
	
	    return params;
	  },
	
	  /**
	   * Returns a version of the given route path with params interpolated. Throws
	   * if there is a dynamic segment of the route path for which there is no param.
	   */
	  injectParams: function injectParams(pattern, params) {
	    params = params || {};
	
	    var splatIndex = 0;
	
	    return pattern.replace(paramInjectMatcher, function (match, paramName) {
	      paramName = paramName || 'splat';
	
	      // If param is optional don't check for existence
	      if (paramName.slice(-1) === '?') {
	        paramName = paramName.slice(0, -1);
	
	        if (params[paramName] == null) return '';
	      } else {
	        invariant(params[paramName] != null, 'Missing "%s" parameter for path "%s"', paramName, pattern);
	      }
	
	      var segment;
	      if (paramName === 'splat' && Array.isArray(params[paramName])) {
	        segment = params[paramName][splatIndex++];
	
	        invariant(segment != null, 'Missing splat # %s for path "%s"', splatIndex, pattern);
	      } else {
	        segment = params[paramName];
	      }
	
	      return segment;
	    }).replace(paramInjectTrailingSlashMatcher, '/');
	  },
	
	  /**
	   * Returns an object that is the result of parsing any query string contained
	   * in the given path, null if the path contains no query string.
	   */
	  extractQuery: function extractQuery(path) {
	    var match = path.match(queryMatcher);
	    return match && qs.parse(match[1]);
	  },
	
	  /**
	   * Returns a version of the given path without the query string.
	   */
	  withoutQuery: function withoutQuery(path) {
	    return path.replace(queryMatcher, '');
	  },
	
	  /**
	   * Returns a version of the given path with the parameters in the given
	   * query merged into the query string.
	   */
	  withQuery: function withQuery(path, query) {
	    var existingQuery = PathUtils.extractQuery(path);
	
	    if (existingQuery) query = query ? assign(existingQuery, query) : existingQuery;
	
	    var queryString = qs.stringify(query, { arrayFormat: 'brackets' });
	
	    if (queryString) {
	      return PathUtils.withoutQuery(path) + '?' + queryString;
	    }return PathUtils.withoutQuery(path);
	  }
	
	};
	
	module.exports = PathUtils;

/***/ },
/* 171 */
/***/ function(module, exports) {

	'use strict';
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = Object.keys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(173);


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Stringify = __webpack_require__(174);
	var Parse = __webpack_require__(176);
	
	
	// Declare internals
	
	var internals = {};
	
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(175);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix, key) {
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix, key) {
	            return prefix;
	        }
	    }
	};
	
	
	internals.stringify = function (obj, prefix, generateArrayPrefix) {
	
	    if (Utils.isBuffer(obj)) {
	        obj = obj.toString();
	    }
	    else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    }
	    else if (obj === null) {
	        obj = '';
	    }
	
	    if (typeof obj === 'string' ||
	        typeof obj === 'number' ||
	        typeof obj === 'boolean') {
	
	        return [encodeURIComponent(prefix) + '=' + encodeURIComponent(obj)];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix));
	        }
	        else {
	            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix));
	        }
	    }
	
	    return values;
	};
	
	
	module.exports = function (obj, options) {
	
	    options = options || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
	
	    var keys = [];
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    }
	    else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    }
	    else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix));
	    }
	
	    return keys.join(delimiter);
	};


/***/ },
/* 175 */
/***/ function(module, exports) {

	// Load modules
	
	
	// Declare internals
	
	var internals = {};
	
	
	exports.arrayToObject = function (source) {
	
	    var obj = {};
	    for (var i = 0, il = source.length; i < il; ++i) {
	        if (typeof source[i] !== 'undefined') {
	
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	
	exports.merge = function (target, source) {
	
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        }
	        else {
	            target[source] = true;
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        target = [target].concat(source);
	        return target;
	    }
	
	    if (Array.isArray(target) &&
	        !Array.isArray(source)) {
	
	        target = exports.arrayToObject(target);
	    }
	
	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];
	
	        if (!target[key]) {
	            target[key] = value;
	        }
	        else {
	            target[key] = exports.merge(target[key], value);
	        }
	    }
	
	    return target;
	};
	
	
	exports.decode = function (str) {
	
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	
	exports.compact = function (obj, refs) {
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return obj;
	    }
	
	    refs = refs || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	
	exports.isBuffer = function (obj) {
	
	    if (obj === null ||
	        typeof obj === 'undefined') {
	
	        return false;
	    }
	
	    return !!(obj.constructor &&
	        obj.constructor.isBuffer &&
	        obj.constructor.isBuffer(obj));
	};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(175);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000
	};
	
	
	internals.parseValues = function (str, options) {
	
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0, il = parts.length; i < il; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	        }
	        else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));
	
	            if (Object.prototype.hasOwnProperty(key)) {
	                continue;
	            }
	
	            if (!obj.hasOwnProperty(key)) {
	                obj[key] = val;
	            }
	            else {
	                obj[key] = [].concat(obj[key]).concat(val);
	            }
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseObject = function (chain, val, options) {
	
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj = {};
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    }
	    else {
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        var indexString = '' + index;
	        if (!isNaN(index) &&
	            root !== cleanRoot &&
	            indexString === cleanRoot &&
	            index >= 0 &&
	            index <= options.arrayLimit) {
	
	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        }
	        else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseKeys = function (key, val, options) {
	
	    if (!key) {
	        return;
	    }
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Don't allow them to overwrite object prototype properties
	
	    if (Object.prototype.hasOwnProperty(segment[1])) {
	        return;
	    }
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	
	        ++i;
	        if (!Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	            keys.push(segment[1]);
	        }
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return internals.parseObject(keys, val, options);
	};
	
	
	module.exports = function (str, options) {
	
	    if (str === '' ||
	        str === null ||
	        typeof str === 'undefined') {
	
	        return {};
	    }
	
	    options = options || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
	
	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj);
	    }
	
	    return Utils.compact(obj);
	};


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var React = __webpack_require__(11);
	var ContextWrapper = __webpack_require__(178);
	var assign = __webpack_require__(22);
	var PropTypes = __webpack_require__(168);
	
	var REF_NAME = '__routeHandler__';
	
	/**
	 * A <RouteHandler> component renders the active child route handler
	 * when routes are nested.
	 */
	
	var RouteHandler = (function (_React$Component) {
	  function RouteHandler() {
	    _classCallCheck(this, RouteHandler);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(RouteHandler, _React$Component);
	
	  _createClass(RouteHandler, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        routeDepth: this.context.routeDepth + 1
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._updateRouteComponent(this.refs[REF_NAME]);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._updateRouteComponent(this.refs[REF_NAME]);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._updateRouteComponent(null);
	    }
	  }, {
	    key: '_updateRouteComponent',
	    value: function _updateRouteComponent(component) {
	      this.context.router.setRouteComponentAtDepth(this.getRouteDepth(), component);
	    }
	  }, {
	    key: 'getRouteDepth',
	    value: function getRouteDepth() {
	      return this.context.routeDepth;
	    }
	  }, {
	    key: 'createChildRouteHandler',
	    value: function createChildRouteHandler(props) {
	      var route = this.context.router.getRouteAtDepth(this.getRouteDepth());
	
	      if (route == null) {
	        return null;
	      }var childProps = assign({}, props || this.props, {
	        ref: REF_NAME,
	        params: this.context.router.getCurrentParams(),
	        query: this.context.router.getCurrentQuery()
	      });
	
	      return React.createElement(route.handler, childProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var handler = this.createChildRouteHandler();
	      // <script/> for things like <CSSTransitionGroup/> that don't like null
	      return handler ? React.createElement(
	        ContextWrapper,
	        null,
	        handler
	      ) : React.createElement('script', null);
	    }
	  }]);
	
	  return RouteHandler;
	})(React.Component);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	RouteHandler.contextTypes = {
	  routeDepth: PropTypes.number.isRequired,
	  router: PropTypes.router.isRequired
	};
	
	RouteHandler.childContextTypes = {
	  routeDepth: PropTypes.number.isRequired
	};
	
	module.exports = RouteHandler;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	/**
	 * This component is necessary to get around a context warning
	 * present in React 0.13.0. It sovles this by providing a separation
	 * between the "owner" and "parent" contexts.
	 */
	
	var React = __webpack_require__(11);
	
	var ContextWrapper = (function (_React$Component) {
	  function ContextWrapper() {
	    _classCallCheck(this, ContextWrapper);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(ContextWrapper, _React$Component);
	
	  _createClass(ContextWrapper, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return ContextWrapper;
	})(React.Component);
	
	module.exports = ContextWrapper;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var React = __webpack_require__(11);
	var invariant = __webpack_require__(16);
	var PropTypes = __webpack_require__(168);
	var RouteHandler = __webpack_require__(177);
	
	/**
	 * <Route> components specify components that are rendered to the page when the
	 * URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is requested,
	 * the tree is searched depth-first to find a route whose path matches the URL.
	 * When one is found, all routes in the tree that lead to it are considered
	 * "active" and their components are rendered into the DOM, nested in the same
	 * order as they are in the tree.
	 *
	 * The preferred way to configure a router is using JSX. The XML-like syntax is
	 * a great way to visualize how routes are laid out in an application.
	 *
	 *   var routes = [
	 *     <Route handler={App}>
	 *       <Route name="login" handler={Login}/>
	 *       <Route name="logout" handler={Logout}/>
	 *       <Route name="about" handler={About}/>
	 *     </Route>
	 *   ];
	 *   
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 *
	 * Handlers for Route components that contain children can render their active
	 * child route using a <RouteHandler> element.
	 *
	 *   var App = React.createClass({
	 *     render: function () {
	 *       return (
	 *         <div class="application">
	 *           <RouteHandler/>
	 *         </div>
	 *       );
	 *     }
	 *   });
	 *
	 * If no handler is provided for the route, it will render a matched child route.
	 */
	
	var Route = (function (_React$Component) {
	  function Route() {
	    _classCallCheck(this, Route);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(Route, _React$Component);
	
	  _createClass(Route, [{
	    key: 'render',
	    value: function render() {
	      invariant(false, '%s elements are for router configuration only and should not be rendered', this.constructor.name);
	    }
	  }]);
	
	  return Route;
	})(React.Component);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	Route.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.string,
	  handler: PropTypes.func,
	  ignoreScrollBehavior: PropTypes.bool
	};
	
	Route.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = Route;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var React = __webpack_require__(11);
	var assign = __webpack_require__(22);
	var PropTypes = __webpack_require__(168);
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * <Link> components are used to create an <a> element that links to a route.
	 * When that route is active, the link gets an "active" class name (or the
	 * value of its `activeClassName` prop).
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route name="showPost" path="/posts/:postID" handler={Post}/>
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} />
	 *
	 * In addition to params, links may pass along query string parameters
	 * using the `query` prop.
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} query={{ show:true }}/>
	 */
	
	var Link = (function (_React$Component) {
	  function Link() {
	    _classCallCheck(this, Link);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(Link, _React$Component);
	
	  _createClass(Link, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var allowTransition = true;
	      var clickResult;
	
	      if (this.props.onClick) clickResult = this.props.onClick(event);
	
	      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
	        return;
	      }if (clickResult === false || event.defaultPrevented === true) allowTransition = false;
	
	      event.preventDefault();
	
	      if (allowTransition) this.context.router.transitionTo(this.props.to, this.props.params, this.props.query);
	    }
	  }, {
	    key: 'getHref',
	
	    /**
	     * Returns the value of the "href" attribute to use on the DOM element.
	     */
	    value: function getHref() {
	      return this.context.router.makeHref(this.props.to, this.props.params, this.props.query);
	    }
	  }, {
	    key: 'getClassName',
	
	    /**
	     * Returns the value of the "class" attribute to use on the DOM element, which contains
	     * the value of the activeClassName property when this <Link> is active.
	     */
	    value: function getClassName() {
	      var className = this.props.className;
	
	      if (this.getActiveState()) className += ' ' + this.props.activeClassName;
	
	      return className;
	    }
	  }, {
	    key: 'getActiveState',
	    value: function getActiveState() {
	      return this.context.router.isActive(this.props.to, this.props.params, this.props.query);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = assign({}, this.props, {
	        href: this.getHref(),
	        className: this.getClassName(),
	        onClick: this.handleClick.bind(this)
	      });
	
	      if (props.activeStyle && this.getActiveState()) props.style = props.activeStyle;
	
	      return React.DOM.a(props, this.props.children);
	    }
	  }]);
	
	  return Link;
	})(React.Component);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	Link.contextTypes = {
	  router: PropTypes.router.isRequired
	};
	
	Link.propTypes = {
	  activeClassName: PropTypes.string.isRequired,
	  to: PropTypes.oneOfType([PropTypes.string, PropTypes.route]).isRequired,
	  params: PropTypes.object,
	  query: PropTypes.object,
	  activeStyle: PropTypes.object,
	  onClick: PropTypes.func
	};
	
	Link.defaultProps = {
	  activeClassName: 'active',
	  className: ''
	};
	
	module.exports = Link;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var PropTypes = __webpack_require__(168);
	var RouteHandler = __webpack_require__(177);
	var Route = __webpack_require__(179);
	
	/**
	 * A <NotFoundRoute> is a special kind of <Route> that
	 * renders when the beginning of its parent's path matches
	 * but none of its siblings do, including any <DefaultRoute>.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var NotFoundRoute = (function (_Route) {
	  function NotFoundRoute() {
	    _classCallCheck(this, NotFoundRoute);
	
	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }
	
	  _inherits(NotFoundRoute, _Route);
	
	  return NotFoundRoute;
	})(Route);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	NotFoundRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	NotFoundRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = NotFoundRoute;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var PropTypes = __webpack_require__(168);
	var Route = __webpack_require__(179);
	
	/**
	 * A <Redirect> component is a special kind of <Route> that always
	 * redirects to another route when it matches.
	 */
	
	var Redirect = (function (_Route) {
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }
	
	  _inherits(Redirect, _Route);
	
	  return Redirect;
	})(Route);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	Redirect.propTypes = {
	  path: PropTypes.string,
	  from: PropTypes.string, // Alias for path.
	  to: PropTypes.string,
	  handler: PropTypes.falsy
	};
	
	// Redirects should not have a default handler
	Redirect.defaultProps = {};
	
	module.exports = Redirect;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(184);
	var History = __webpack_require__(185);
	
	var _listeners = [];
	var _isListening = false;
	var _actionType;
	
	function notifyChange(type) {
	  if (type === LocationActions.PUSH) History.length += 1;
	
	  var change = {
	    path: HashLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HashLocation, change);
	  });
	}
	
	function ensureSlash() {
	  var path = HashLocation.getCurrentPath();
	
	  if (path.charAt(0) === '/') {
	    return true;
	  }HashLocation.replace('/' + path);
	
	  return false;
	}
	
	function onHashChange() {
	  if (ensureSlash()) {
	    // If we don't have an _actionType then all we know is the hash
	    // changed. It was probably caused by the user clicking the Back
	    // button, but may have also been the Forward button or manual
	    // manipulation. So just guess 'pop'.
	    var curActionType = _actionType;
	    _actionType = null;
	    notifyChange(curActionType || LocationActions.POP);
	  }
	}
	
	/**
	 * A Location that uses `window.location.hash`.
	 */
	var HashLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    // Do this BEFORE listening for hashchange.
	    ensureSlash();
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener('hashchange', onHashChange, false);
	      } else {
	        window.attachEvent('onhashchange', onHashChange);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.removeEventListener) {
	        window.removeEventListener('hashchange', onHashChange, false);
	      } else {
	        window.removeEvent('onhashchange', onHashChange);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    _actionType = LocationActions.PUSH;
	    window.location.hash = path;
	  },
	
	  replace: function replace(path) {
	    _actionType = LocationActions.REPLACE;
	    window.location.replace(window.location.pathname + window.location.search + '#' + path);
	  },
	
	  pop: function pop() {
	    _actionType = LocationActions.POP;
	    History.back();
	  },
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(
	    // We can't use window.location.hash here because it's not
	    // consistent across browsers - Firefox will pre-decode it!
	    window.location.href.split('#')[1] || '');
	  },
	
	  toString: function toString() {
	    return '<HashLocation>';
	  }
	
	};
	
	module.exports = HashLocation;

/***/ },
/* 184 */
/***/ function(module, exports) {

	/**
	 * Actions that modify the URL.
	 */
	'use strict';
	
	var LocationActions = {
	
	  /**
	   * Indicates a new location is being pushed to the history stack.
	   */
	  PUSH: 'push',
	
	  /**
	   * Indicates the current location should be replaced.
	   */
	  REPLACE: 'replace',
	
	  /**
	   * Indicates the most recent entry should be removed from the history stack.
	   */
	  POP: 'pop'
	
	};
	
	module.exports = LocationActions;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(16);
	var canUseDOM = __webpack_require__(60).canUseDOM;
	
	var History = {
	
	  /**
	   * The current number of entries in the history.
	   *
	   * Note: This property is read-only.
	   */
	  length: 1,
	
	  /**
	   * Sends the browser back one entry in the history.
	   */
	  back: function back() {
	    invariant(canUseDOM, 'Cannot use History.back without a DOM');
	
	    // Do this first so that History.length will
	    // be accurate in location change listeners.
	    History.length -= 1;
	
	    window.history.back();
	  }
	
	};
	
	module.exports = History;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(184);
	var History = __webpack_require__(185);
	
	var _listeners = [];
	var _isListening = false;
	
	function notifyChange(type) {
	  var change = {
	    path: HistoryLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HistoryLocation, change);
	  });
	}
	
	function onPopState(event) {
	  if (event.state === undefined) {
	    return;
	  } // Ignore extraneous popstate events in WebKit.
	
	  notifyChange(LocationActions.POP);
	}
	
	/**
	 * A Location that uses HTML5 history.
	 */
	var HistoryLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener('popstate', onPopState, false);
	      } else {
	        window.attachEvent('onpopstate', onPopState);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.addEventListener) {
	        window.removeEventListener('popstate', onPopState, false);
	      } else {
	        window.removeEvent('onpopstate', onPopState);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    window.history.pushState({ path: path }, '', path);
	    History.length += 1;
	    notifyChange(LocationActions.PUSH);
	  },
	
	  replace: function replace(path) {
	    window.history.replaceState({ path: path }, '', path);
	    notifyChange(LocationActions.REPLACE);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(window.location.pathname + window.location.search);
	  },
	
	  toString: function toString() {
	    return '<HistoryLocation>';
	  }
	
	};
	
	module.exports = HistoryLocation;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var HistoryLocation = __webpack_require__(186);
	var History = __webpack_require__(185);
	
	/**
	 * A Location that uses full page refreshes. This is used as
	 * the fallback for HistoryLocation in browsers that do not
	 * support the HTML5 history API.
	 */
	var RefreshLocation = {
	
	  push: function push(path) {
	    window.location = path;
	  },
	
	  replace: function replace(path) {
	    window.location.replace(path);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: HistoryLocation.getCurrentPath,
	
	  toString: function toString() {
	    return '<RefreshLocation>';
	  }
	
	};
	
	module.exports = RefreshLocation;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var invariant = __webpack_require__(16);
	
	function throwCannotModify() {
	  invariant(false, 'You cannot modify a static location');
	}
	
	/**
	 * A location that only ever contains a single path. Useful in
	 * stateless environments like servers where there is no path history,
	 * only the path that was used in the request.
	 */
	
	var StaticLocation = (function () {
	  function StaticLocation(path) {
	    _classCallCheck(this, StaticLocation);
	
	    this.path = path;
	  }
	
	  _createClass(StaticLocation, [{
	    key: 'getCurrentPath',
	    value: function getCurrentPath() {
	      return this.path;
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<StaticLocation path="' + this.path + '">';
	    }
	  }]);
	
	  return StaticLocation;
	})();
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	StaticLocation.prototype.push = throwCannotModify;
	StaticLocation.prototype.replace = throwCannotModify;
	StaticLocation.prototype.pop = throwCannotModify;
	
	module.exports = StaticLocation;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var invariant = __webpack_require__(16);
	var LocationActions = __webpack_require__(184);
	var History = __webpack_require__(185);
	
	/**
	 * A location that is convenient for testing and does not require a DOM.
	 */
	
	var TestLocation = (function () {
	  function TestLocation(history) {
	    _classCallCheck(this, TestLocation);
	
	    this.history = history || [];
	    this.listeners = [];
	    this._updateHistoryLength();
	  }
	
	  _createClass(TestLocation, [{
	    key: 'needsDOM',
	    get: function () {
	      return false;
	    }
	  }, {
	    key: '_updateHistoryLength',
	    value: function _updateHistoryLength() {
	      History.length = this.history.length;
	    }
	  }, {
	    key: '_notifyChange',
	    value: function _notifyChange(type) {
	      var change = {
	        path: this.getCurrentPath(),
	        type: type
	      };
	
	      for (var i = 0, len = this.listeners.length; i < len; ++i) this.listeners[i].call(this, change);
	    }
	  }, {
	    key: 'addChangeListener',
	    value: function addChangeListener(listener) {
	      this.listeners.push(listener);
	    }
	  }, {
	    key: 'removeChangeListener',
	    value: function removeChangeListener(listener) {
	      this.listeners = this.listeners.filter(function (l) {
	        return l !== listener;
	      });
	    }
	  }, {
	    key: 'push',
	    value: function push(path) {
	      this.history.push(path);
	      this._updateHistoryLength();
	      this._notifyChange(LocationActions.PUSH);
	    }
	  }, {
	    key: 'replace',
	    value: function replace(path) {
	      invariant(this.history.length, 'You cannot replace the current path with no history');
	
	      this.history[this.history.length - 1] = path;
	
	      this._notifyChange(LocationActions.REPLACE);
	    }
	  }, {
	    key: 'pop',
	    value: function pop() {
	      this.history.pop();
	      this._updateHistoryLength();
	      this._notifyChange(LocationActions.POP);
	    }
	  }, {
	    key: 'getCurrentPath',
	    value: function getCurrentPath() {
	      return this.history[this.history.length - 1];
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<TestLocation>';
	    }
	  }]);
	
	  return TestLocation;
	})();
	
	module.exports = TestLocation;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(184);
	
	/**
	 * A scroll behavior that attempts to imitate the default behavior
	 * of modern browsers.
	 */
	var ImitateBrowserBehavior = {
	
	  updateScrollPosition: function updateScrollPosition(position, actionType) {
	    switch (actionType) {
	      case LocationActions.PUSH:
	      case LocationActions.REPLACE:
	        window.scrollTo(0, 0);
	        break;
	      case LocationActions.POP:
	        if (position) {
	          window.scrollTo(position.x, position.y);
	        } else {
	          window.scrollTo(0, 0);
	        }
	        break;
	    }
	  }
	
	};
	
	module.exports = ImitateBrowserBehavior;

/***/ },
/* 191 */
/***/ function(module, exports) {

	/**
	 * A scroll behavior that always scrolls to the top of the page
	 * after a transition.
	 */
	"use strict";
	
	var ScrollToTopBehavior = {
	
	  updateScrollPosition: function updateScrollPosition() {
	    window.scrollTo(0, 0);
	  }
	
	};
	
	module.exports = ScrollToTopBehavior;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(168);
	
	/**
	 * A mixin for components that modify the URL.
	 *
	 * Example:
	 *
	 *   var MyLink = React.createClass({
	 *     mixins: [ Router.Navigation ],
	 *     handleClick(event) {
	 *       event.preventDefault();
	 *       this.transitionTo('aRoute', { the: 'params' }, { the: 'query' });
	 *     },
	 *     render() {
	 *       return (
	 *         <a onClick={this.handleClick}>Click me!</a>
	 *       );
	 *     }
	 *   });
	 */
	var Navigation = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns an absolute URL path created from the given route
	   * name, URL parameters, and query values.
	   */
	  makePath: function makePath(to, params, query) {
	    return this.context.router.makePath(to, params, query);
	  },
	
	  /**
	   * Returns a string that may safely be used as the href of a
	   * link to the route with the given name.
	   */
	  makeHref: function makeHref(to, params, query) {
	    return this.context.router.makeHref(to, params, query);
	  },
	
	  /**
	   * Transitions to the URL specified in the arguments by pushing
	   * a new URL onto the history stack.
	   */
	  transitionTo: function transitionTo(to, params, query) {
	    this.context.router.transitionTo(to, params, query);
	  },
	
	  /**
	   * Transitions to the URL specified in the arguments by replacing
	   * the current URL in the history stack.
	   */
	  replaceWith: function replaceWith(to, params, query) {
	    this.context.router.replaceWith(to, params, query);
	  },
	
	  /**
	   * Transitions to the previous URL.
	   */
	  goBack: function goBack() {
	    return this.context.router.goBack();
	  }
	
	};
	
	module.exports = Navigation;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(168);
	
	/**
	 * A mixin for components that need to know the path, routes, URL
	 * params and query that are currently active.
	 *
	 * Example:
	 *
	 *   var AboutLink = React.createClass({
	 *     mixins: [ Router.State ],
	 *     render() {
	 *       var className = this.props.className;
	 *
	 *       if (this.isActive('about'))
	 *         className += ' is-active';
	 *
	 *       return React.DOM.a({ className: className }, this.props.children);
	 *     }
	 *   });
	 */
	var State = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns the current URL path.
	   */
	  getPath: function getPath() {
	    return this.context.router.getCurrentPath();
	  },
	
	  /**
	   * Returns the current URL path without the query string.
	   */
	  getPathname: function getPathname() {
	    return this.context.router.getCurrentPathname();
	  },
	
	  /**
	   * Returns an object of the URL params that are currently active.
	   */
	  getParams: function getParams() {
	    return this.context.router.getCurrentParams();
	  },
	
	  /**
	   * Returns an object of the query params that are currently active.
	   */
	  getQuery: function getQuery() {
	    return this.context.router.getCurrentQuery();
	  },
	
	  /**
	   * Returns an array of the routes that are currently active.
	   */
	  getRoutes: function getRoutes() {
	    return this.context.router.getCurrentRoutes();
	  },
	
	  /**
	   * A helper method to determine if a given route, params, and query
	   * are active.
	   */
	  isActive: function isActive(to, params, query) {
	    return this.context.router.isActive(to, params, query);
	  }
	
	};
	
	module.exports = State;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint -W084 */
	'use strict';
	
	var React = __webpack_require__(11);
	var assign = __webpack_require__(22);
	var warning = __webpack_require__(24);
	var DefaultRoute = __webpack_require__(167);
	var NotFoundRoute = __webpack_require__(181);
	var Redirect = __webpack_require__(182);
	var Route = __webpack_require__(169);
	
	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || 'UnknownComponent';
	
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error = propTypes[propName](props, propName, componentName);
	
	      if (error instanceof Error) warning(false, error.message);
	    }
	  }
	}
	
	function createRouteOptions(props) {
	  var options = assign({}, props);
	  var handler = options.handler;
	
	  if (handler) {
	    options.onEnter = handler.willTransitionTo;
	    options.onLeave = handler.willTransitionFrom;
	  }
	
	  return options;
	}
	
	function createRouteFromReactElement(element) {
	  if (!React.isValidElement(element)) {
	    return;
	  }var type = element.type;
	  var props = assign({}, type.defaultProps, element.props);
	
	  if (type.propTypes) checkPropTypes(type.displayName, type.propTypes, props);
	
	  if (type === DefaultRoute) {
	    return Route.createDefaultRoute(createRouteOptions(props));
	  }if (type === NotFoundRoute) {
	    return Route.createNotFoundRoute(createRouteOptions(props));
	  }if (type === Redirect) {
	    return Route.createRedirect(createRouteOptions(props));
	  }return Route.createRoute(createRouteOptions(props), function () {
	    if (props.children) createRoutesFromReactChildren(props.children);
	  });
	}
	
	/**
	 * Creates and returns an array of routes created from the given
	 * ReactChildren, all of which should be one of <Route>, <DefaultRoute>,
	 * <NotFoundRoute>, or <Redirect>, e.g.:
	 *
	 *   var { createRoutesFromReactChildren, Route, Redirect } = require('react-router');
	 *
	 *   var routes = createRoutesFromReactChildren(
	 *     <Route path="/" handler={App}>
	 *       <Route name="user" path="/user/:userId" handler={User}>
	 *         <Route name="task" path="tasks/:taskId" handler={Task}/>
	 *         <Redirect from="todos/:taskId" to="task"/>
	 *       </Route>
	 *     </Route>
	 *   );
	 */
	function createRoutesFromReactChildren(children) {
	  var routes = [];
	
	  React.Children.forEach(children, function (child) {
	    if (child = createRouteFromReactElement(child)) routes.push(child);
	  });
	
	  return routes;
	}
	
	module.exports = createRoutesFromReactChildren;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/* jshint -W058 */
	'use strict';
	
	var React = __webpack_require__(11);
	var warning = __webpack_require__(24);
	var invariant = __webpack_require__(16);
	var canUseDOM = __webpack_require__(60).canUseDOM;
	var LocationActions = __webpack_require__(184);
	var ImitateBrowserBehavior = __webpack_require__(190);
	var HashLocation = __webpack_require__(183);
	var HistoryLocation = __webpack_require__(186);
	var RefreshLocation = __webpack_require__(187);
	var StaticLocation = __webpack_require__(188);
	var ScrollHistory = __webpack_require__(196);
	var createRoutesFromReactChildren = __webpack_require__(194);
	var isReactChildren = __webpack_require__(198);
	var Transition = __webpack_require__(199);
	var PropTypes = __webpack_require__(168);
	var Redirect = __webpack_require__(201);
	var History = __webpack_require__(185);
	var Cancellation = __webpack_require__(200);
	var Match = __webpack_require__(202);
	var Route = __webpack_require__(169);
	var supportsHistory = __webpack_require__(203);
	var PathUtils = __webpack_require__(170);
	
	/**
	 * The default location for new routers.
	 */
	var DEFAULT_LOCATION = canUseDOM ? HashLocation : '/';
	
	/**
	 * The default scroll behavior for new routers.
	 */
	var DEFAULT_SCROLL_BEHAVIOR = canUseDOM ? ImitateBrowserBehavior : null;
	
	function hasProperties(object, properties) {
	  for (var propertyName in properties) if (properties.hasOwnProperty(propertyName) && object[propertyName] !== properties[propertyName]) {
	    return false;
	  }return true;
	}
	
	function hasMatch(routes, route, prevParams, nextParams, prevQuery, nextQuery) {
	  return routes.some(function (r) {
	    if (r !== route) return false;
	
	    var paramNames = route.paramNames;
	    var paramName;
	
	    // Ensure that all params the route cares about did not change.
	    for (var i = 0, len = paramNames.length; i < len; ++i) {
	      paramName = paramNames[i];
	
	      if (nextParams[paramName] !== prevParams[paramName]) return false;
	    }
	
	    // Ensure the query hasn't changed.
	    return hasProperties(prevQuery, nextQuery) && hasProperties(nextQuery, prevQuery);
	  });
	}
	
	function addRoutesToNamedRoutes(routes, namedRoutes) {
	  var route;
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    route = routes[i];
	
	    if (route.name) {
	      invariant(namedRoutes[route.name] == null, 'You may not have more than one route named "%s"', route.name);
	
	      namedRoutes[route.name] = route;
	    }
	
	    if (route.childRoutes) addRoutesToNamedRoutes(route.childRoutes, namedRoutes);
	  }
	}
	
	function routeIsActive(activeRoutes, routeName) {
	  return activeRoutes.some(function (route) {
	    return route.name === routeName;
	  });
	}
	
	function paramsAreActive(activeParams, params) {
	  for (var property in params) if (String(activeParams[property]) !== String(params[property])) {
	    return false;
	  }return true;
	}
	
	function queryIsActive(activeQuery, query) {
	  for (var property in query) if (String(activeQuery[property]) !== String(query[property])) {
	    return false;
	  }return true;
	}
	
	/**
	 * Creates and returns a new router using the given options. A router
	 * is a ReactComponent class that knows how to react to changes in the
	 * URL and keep the contents of the page in sync.
	 *
	 * Options may be any of the following:
	 *
	 * - routes           (required) The route config
	 * - location         The location to use. Defaults to HashLocation when
	 *                    the DOM is available, "/" otherwise
	 * - scrollBehavior   The scroll behavior to use. Defaults to ImitateBrowserBehavior
	 *                    when the DOM is available, null otherwise
	 * - onError          A function that is used to handle errors
	 * - onAbort          A function that is used to handle aborted transitions
	 *
	 * When rendering in a server-side environment, the location should simply
	 * be the URL path that was used in the request, including the query string.
	 */
	function createRouter(options) {
	  options = options || {};
	
	  if (isReactChildren(options)) options = { routes: options };
	
	  var mountedComponents = [];
	  var location = options.location || DEFAULT_LOCATION;
	  var scrollBehavior = options.scrollBehavior || DEFAULT_SCROLL_BEHAVIOR;
	  var state = {};
	  var nextState = {};
	  var pendingTransition = null;
	  var dispatchHandler = null;
	
	  if (typeof location === 'string') location = new StaticLocation(location);
	
	  if (location instanceof StaticLocation) {
	    warning(!canUseDOM || process.env.NODE_ENV === 'test', 'You should not use a static location in a DOM environment because ' + 'the router will not be kept in sync with the current URL');
	  } else {
	    invariant(canUseDOM || location.needsDOM === false, 'You cannot use %s without a DOM', location);
	  }
	
	  // Automatically fall back to full page refreshes in
	  // browsers that don't support the HTML history API.
	  if (location === HistoryLocation && !supportsHistory()) location = RefreshLocation;
	
	  var Router = React.createClass({
	
	    displayName: 'Router',
	
	    statics: {
	
	      isRunning: false,
	
	      cancelPendingTransition: function cancelPendingTransition() {
	        if (pendingTransition) {
	          pendingTransition.cancel();
	          pendingTransition = null;
	        }
	      },
	
	      clearAllRoutes: function clearAllRoutes() {
	        Router.cancelPendingTransition();
	        Router.namedRoutes = {};
	        Router.routes = [];
	      },
	
	      /**
	       * Adds routes to this router from the given children object (see ReactChildren).
	       */
	      addRoutes: function addRoutes(routes) {
	        if (isReactChildren(routes)) routes = createRoutesFromReactChildren(routes);
	
	        addRoutesToNamedRoutes(routes, Router.namedRoutes);
	
	        Router.routes.push.apply(Router.routes, routes);
	      },
	
	      /**
	       * Replaces routes of this router from the given children object (see ReactChildren).
	       */
	      replaceRoutes: function replaceRoutes(routes) {
	        Router.clearAllRoutes();
	        Router.addRoutes(routes);
	        Router.refresh();
	      },
	
	      /**
	       * Performs a match of the given path against this router and returns an object
	       * with the { routes, params, pathname, query } that match. Returns null if no
	       * match can be made.
	       */
	      match: function match(path) {
	        return Match.findMatch(Router.routes, path);
	      },
	
	      /**
	       * Returns an absolute URL path created from the given route
	       * name, URL parameters, and query.
	       */
	      makePath: function makePath(to, params, query) {
	        var path;
	        if (PathUtils.isAbsolute(to)) {
	          path = to;
	        } else {
	          var route = to instanceof Route ? to : Router.namedRoutes[to];
	
	          invariant(route instanceof Route, 'Cannot find a route named "%s"', to);
	
	          path = route.path;
	        }
	
	        return PathUtils.withQuery(PathUtils.injectParams(path, params), query);
	      },
	
	      /**
	       * Returns a string that may safely be used as the href of a link
	       * to the route with the given name, URL parameters, and query.
	       */
	      makeHref: function makeHref(to, params, query) {
	        var path = Router.makePath(to, params, query);
	        return location === HashLocation ? '#' + path : path;
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by pushing
	       * a new URL onto the history stack.
	       */
	      transitionTo: function transitionTo(to, params, query) {
	        var path = Router.makePath(to, params, query);
	
	        if (pendingTransition) {
	          // Replace so pending location does not stay in history.
	          location.replace(path);
	        } else {
	          location.push(path);
	        }
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by replacing
	       * the current URL in the history stack.
	       */
	      replaceWith: function replaceWith(to, params, query) {
	        location.replace(Router.makePath(to, params, query));
	      },
	
	      /**
	       * Transitions to the previous URL if one is available. Returns true if the
	       * router was able to go back, false otherwise.
	       *
	       * Note: The router only tracks history entries in your application, not the
	       * current browser session, so you can safely call this function without guarding
	       * against sending the user back to some other site. However, when using
	       * RefreshLocation (which is the fallback for HistoryLocation in browsers that
	       * don't support HTML5 history) this method will *always* send the client back
	       * because we cannot reliably track history length.
	       */
	      goBack: function goBack() {
	        if (History.length > 1 || location === RefreshLocation) {
	          location.pop();
	          return true;
	        }
	
	        warning(false, 'goBack() was ignored because there is no router history');
	
	        return false;
	      },
	
	      handleAbort: options.onAbort || function (abortReason) {
	        if (location instanceof StaticLocation) throw new Error('Unhandled aborted transition! Reason: ' + abortReason);
	
	        if (abortReason instanceof Cancellation) {
	          return;
	        } else if (abortReason instanceof Redirect) {
	          location.replace(Router.makePath(abortReason.to, abortReason.params, abortReason.query));
	        } else {
	          location.pop();
	        }
	      },
	
	      handleError: options.onError || function (error) {
	        // Throw so we don't silently swallow async errors.
	        throw error; // This error probably originated in a transition hook.
	      },
	
	      handleLocationChange: function handleLocationChange(change) {
	        Router.dispatch(change.path, change.type);
	      },
	
	      /**
	       * Performs a transition to the given path and calls callback(error, abortReason)
	       * when the transition is finished. If both arguments are null the router's state
	       * was updated. Otherwise the transition did not complete.
	       *
	       * In a transition, a router first determines which routes are involved by beginning
	       * with the current route, up the route tree to the first parent route that is shared
	       * with the destination route, and back down the tree to the destination route. The
	       * willTransitionFrom hook is invoked on all route handlers we're transitioning away
	       * from, in reverse nesting order. Likewise, the willTransitionTo hook is invoked on
	       * all route handlers we're transitioning to.
	       *
	       * Both willTransitionFrom and willTransitionTo hooks may either abort or redirect the
	       * transition. To resolve asynchronously, they may use the callback argument. If no
	       * hooks wait, the transition is fully synchronous.
	       */
	      dispatch: function dispatch(path, action) {
	        Router.cancelPendingTransition();
	
	        var prevPath = state.path;
	        var isRefreshing = action == null;
	
	        if (prevPath === path && !isRefreshing) {
	          return;
	        } // Nothing to do!
	
	        // Record the scroll position as early as possible to
	        // get it before browsers try update it automatically.
	        if (prevPath && action === LocationActions.PUSH) Router.recordScrollPosition(prevPath);
	
	        var match = Router.match(path);
	
	        warning(match != null, 'No route matches path "%s". Make sure you have <Route path="%s"> somewhere in your routes', path, path);
	
	        if (match == null) match = {};
	
	        var prevRoutes = state.routes || [];
	        var prevParams = state.params || {};
	        var prevQuery = state.query || {};
	
	        var nextRoutes = match.routes || [];
	        var nextParams = match.params || {};
	        var nextQuery = match.query || {};
	
	        var fromRoutes, toRoutes;
	        if (prevRoutes.length) {
	          fromRoutes = prevRoutes.filter(function (route) {
	            return !hasMatch(nextRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	
	          toRoutes = nextRoutes.filter(function (route) {
	            return !hasMatch(prevRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	        } else {
	          fromRoutes = [];
	          toRoutes = nextRoutes;
	        }
	
	        var transition = new Transition(path, Router.replaceWith.bind(Router, path));
	        pendingTransition = transition;
	
	        var fromComponents = mountedComponents.slice(prevRoutes.length - fromRoutes.length);
	
	        Transition.from(transition, fromRoutes, fromComponents, function (error) {
	          if (error || transition.abortReason) return dispatchHandler.call(Router, error, transition); // No need to continue.
	
	          Transition.to(transition, toRoutes, nextParams, nextQuery, function (error) {
	            dispatchHandler.call(Router, error, transition, {
	              path: path,
	              action: action,
	              pathname: match.pathname,
	              routes: nextRoutes,
	              params: nextParams,
	              query: nextQuery
	            });
	          });
	        });
	      },
	
	      /**
	       * Starts this router and calls callback(router, state) when the route changes.
	       *
	       * If the router's location is static (i.e. a URL path in a server environment)
	       * the callback is called only once. Otherwise, the location should be one of the
	       * Router.*Location objects (e.g. Router.HashLocation or Router.HistoryLocation).
	       */
	      run: function run(callback) {
	        invariant(!Router.isRunning, 'Router is already running');
	
	        dispatchHandler = function (error, transition, newState) {
	          if (error) Router.handleError(error);
	
	          if (pendingTransition !== transition) return;
	
	          pendingTransition = null;
	
	          if (transition.abortReason) {
	            Router.handleAbort(transition.abortReason);
	          } else {
	            callback.call(Router, Router, nextState = newState);
	          }
	        };
	
	        if (!(location instanceof StaticLocation)) {
	          if (location.addChangeListener) location.addChangeListener(Router.handleLocationChange);
	
	          Router.isRunning = true;
	        }
	
	        // Bootstrap using the current path.
	        Router.refresh();
	      },
	
	      refresh: function refresh() {
	        Router.dispatch(location.getCurrentPath(), null);
	      },
	
	      stop: function stop() {
	        Router.cancelPendingTransition();
	
	        if (location.removeChangeListener) location.removeChangeListener(Router.handleLocationChange);
	
	        Router.isRunning = false;
	      },
	
	      getLocation: function getLocation() {
	        return location;
	      },
	
	      getScrollBehavior: function getScrollBehavior() {
	        return scrollBehavior;
	      },
	
	      getRouteAtDepth: function getRouteAtDepth(routeDepth) {
	        var routes = state.routes;
	        return routes && routes[routeDepth];
	      },
	
	      setRouteComponentAtDepth: function setRouteComponentAtDepth(routeDepth, component) {
	        mountedComponents[routeDepth] = component;
	      },
	
	      /**
	       * Returns the current URL path + query string.
	       */
	      getCurrentPath: function getCurrentPath() {
	        return state.path;
	      },
	
	      /**
	       * Returns the current URL path without the query string.
	       */
	      getCurrentPathname: function getCurrentPathname() {
	        return state.pathname;
	      },
	
	      /**
	       * Returns an object of the currently active URL parameters.
	       */
	      getCurrentParams: function getCurrentParams() {
	        return state.params;
	      },
	
	      /**
	       * Returns an object of the currently active query parameters.
	       */
	      getCurrentQuery: function getCurrentQuery() {
	        return state.query;
	      },
	
	      /**
	       * Returns an array of the currently active routes.
	       */
	      getCurrentRoutes: function getCurrentRoutes() {
	        return state.routes;
	      },
	
	      /**
	       * Returns true if the given route, params, and query are active.
	       */
	      isActive: function isActive(to, params, query) {
	        if (PathUtils.isAbsolute(to)) {
	          return to === state.path;
	        }return routeIsActive(state.routes, to) && paramsAreActive(state.params, params) && (query == null || queryIsActive(state.query, query));
	      }
	
	    },
	
	    mixins: [ScrollHistory],
	
	    propTypes: {
	      children: PropTypes.falsy
	    },
	
	    childContextTypes: {
	      routeDepth: PropTypes.number.isRequired,
	      router: PropTypes.router.isRequired
	    },
	
	    getChildContext: function getChildContext() {
	      return {
	        routeDepth: 1,
	        router: Router
	      };
	    },
	
	    getInitialState: function getInitialState() {
	      return state = nextState;
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this.setState(state = nextState);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      Router.stop();
	    },
	
	    render: function render() {
	      var route = Router.getRouteAtDepth(0);
	      return route ? React.createElement(route.handler, this.props) : null;
	    }
	
	  });
	
	  Router.clearAllRoutes();
	
	  if (options.routes) Router.addRoutes(options.routes);
	
	  return Router;
	}
	
	module.exports = createRouter;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(16);
	var canUseDOM = __webpack_require__(60).canUseDOM;
	var getWindowScrollPosition = __webpack_require__(197);
	
	function shouldUpdateScroll(state, prevState) {
	  if (!prevState) {
	    return true;
	  } // Don't update scroll position when only the query has changed.
	  if (state.pathname === prevState.pathname) {
	    return false;
	  }var routes = state.routes;
	  var prevRoutes = prevState.routes;
	
	  var sharedAncestorRoutes = routes.filter(function (route) {
	    return prevRoutes.indexOf(route) !== -1;
	  });
	
	  return !sharedAncestorRoutes.some(function (route) {
	    return route.ignoreScrollBehavior;
	  });
	}
	
	/**
	 * Provides the router with the ability to manage window scroll position
	 * according to its scroll behavior.
	 */
	var ScrollHistory = {
	
	  statics: {
	
	    /**
	     * Records curent scroll position as the last known position for the given URL path.
	     */
	    recordScrollPosition: function recordScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      this.scrollHistory[path] = getWindowScrollPosition();
	    },
	
	    /**
	     * Returns the last known scroll position for the given URL path.
	     */
	    getScrollPosition: function getScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      return this.scrollHistory[path] || null;
	    }
	
	  },
	
	  componentWillMount: function componentWillMount() {
	    invariant(this.constructor.getScrollBehavior() == null || canUseDOM, 'Cannot use scroll behavior without a DOM');
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._updateScroll();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    this._updateScroll(prevState);
	  },
	
	  _updateScroll: function _updateScroll(prevState) {
	    if (!shouldUpdateScroll(this.state, prevState)) {
	      return;
	    }var scrollBehavior = this.constructor.getScrollBehavior();
	
	    if (scrollBehavior) scrollBehavior.updateScrollPosition(this.constructor.getScrollPosition(this.state.path), this.state.action);
	  }
	
	};
	
	module.exports = ScrollHistory;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(16);
	var canUseDOM = __webpack_require__(60).canUseDOM;
	
	/**
	 * Returns the current scroll position of the window as { x, y }.
	 */
	function getWindowScrollPosition() {
	  invariant(canUseDOM, 'Cannot get current scroll position without a DOM');
	
	  return {
	    x: window.pageXOffset || document.documentElement.scrollLeft,
	    y: window.pageYOffset || document.documentElement.scrollTop
	  };
	}
	
	module.exports = getWindowScrollPosition;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	function isValidChild(object) {
	  return object == null || React.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	module.exports = isReactChildren;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint -W058 */
	
	'use strict';
	
	var Cancellation = __webpack_require__(200);
	var Redirect = __webpack_require__(201);
	
	/**
	 * Encapsulates a transition to a given path.
	 *
	 * The willTransitionTo and willTransitionFrom handlers receive
	 * an instance of this class as their first argument.
	 */
	function Transition(path, retry) {
	  this.path = path;
	  this.abortReason = null;
	  // TODO: Change this to router.retryTransition(transition)
	  this.retry = retry.bind(this);
	}
	
	Transition.prototype.abort = function (reason) {
	  if (this.abortReason == null) this.abortReason = reason || 'ABORT';
	};
	
	Transition.prototype.redirect = function (to, params, query) {
	  this.abort(new Redirect(to, params, query));
	};
	
	Transition.prototype.cancel = function () {
	  this.abort(new Cancellation());
	};
	
	Transition.from = function (transition, routes, components, callback) {
	  routes.reduce(function (callback, route, index) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onLeave) {
	        try {
	          route.onLeave(transition, components[index], callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onLeave.length < 3) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	Transition.to = function (transition, routes, params, query, callback) {
	  routes.reduceRight(function (callback, route) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onEnter) {
	        try {
	          route.onEnter(transition, params, query, callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onEnter.length < 4) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	module.exports = Transition;

/***/ },
/* 200 */
/***/ function(module, exports) {

	/**
	 * Represents a cancellation caused by navigating away
	 * before the previous transition has fully resolved.
	 */
	"use strict";
	
	function Cancellation() {}
	
	module.exports = Cancellation;

/***/ },
/* 201 */
/***/ function(module, exports) {

	/**
	 * Encapsulates a redirect to the given route.
	 */
	"use strict";
	
	function Redirect(to, params, query) {
	  this.to = to;
	  this.params = params;
	  this.query = query;
	}
	
	module.exports = Redirect;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	/* jshint -W084 */
	var PathUtils = __webpack_require__(170);
	
	function deepSearch(route, pathname, query) {
	  // Check the subtree first to find the most deeply-nested match.
	  var childRoutes = route.childRoutes;
	  if (childRoutes) {
	    var match, childRoute;
	    for (var i = 0, len = childRoutes.length; i < len; ++i) {
	      childRoute = childRoutes[i];
	
	      if (childRoute.isDefault || childRoute.isNotFound) continue; // Check these in order later.
	
	      if (match = deepSearch(childRoute, pathname, query)) {
	        // A route in the subtree matched! Add this route and we're done.
	        match.routes.unshift(route);
	        return match;
	      }
	    }
	  }
	
	  // No child routes matched; try the default route.
	  var defaultRoute = route.defaultRoute;
	  if (defaultRoute && (params = PathUtils.extractParams(defaultRoute.path, pathname))) {
	    return new Match(pathname, params, query, [route, defaultRoute]);
	  } // Does the "not found" route match?
	  var notFoundRoute = route.notFoundRoute;
	  if (notFoundRoute && (params = PathUtils.extractParams(notFoundRoute.path, pathname))) {
	    return new Match(pathname, params, query, [route, notFoundRoute]);
	  } // Last attempt: check this route.
	  var params = PathUtils.extractParams(route.path, pathname);
	  if (params) {
	    return new Match(pathname, params, query, [route]);
	  }return null;
	}
	
	var Match = (function () {
	  function Match(pathname, params, query, routes) {
	    _classCallCheck(this, Match);
	
	    this.pathname = pathname;
	    this.params = params;
	    this.query = query;
	    this.routes = routes;
	  }
	
	  _createClass(Match, null, [{
	    key: 'findMatch',
	
	    /**
	     * Attempts to match depth-first a route in the given route's
	     * subtree against the given path and returns the match if it
	     * succeeds, null if no match can be made.
	     */
	    value: function findMatch(routes, path) {
	      var pathname = PathUtils.withoutQuery(path);
	      var query = PathUtils.extractQuery(path);
	      var match = null;
	
	      for (var i = 0, len = routes.length; match == null && i < len; ++i) match = deepSearch(routes[i], pathname, query);
	
	      return match;
	    }
	  }]);
	
	  return Match;
	})();
	
	module.exports = Match;

/***/ },
/* 203 */
/***/ function(module, exports) {

	'use strict';
	
	function supportsHistory() {
	  /*! taken from modernizr
	   * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	   * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	   * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	   */
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	module.exports = supportsHistory;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createRouter = __webpack_require__(195);
	
	/**
	 * A high-level convenience method that creates, configures, and
	 * runs a router in one shot. The method signature is:
	 *
	 *   Router.run(routes[, location ], callback);
	 *
	 * Using `window.location.hash` to manage the URL, you could do:
	 *
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 * 
	 * Using HTML5 history and a custom "cursor" prop:
	 * 
	 *   Router.run(routes, Router.HistoryLocation, function (Handler) {
	 *     React.render(<Handler cursor={cursor}/>, document.body);
	 *   });
	 *
	 * Returns the newly created router.
	 *
	 * Note: If you need to specify further options for your router such
	 * as error/abort handling or custom scroll behavior, use Router.create
	 * instead.
	 *
	 *   var router = Router.create(options);
	 *   router.run(function (Handler) {
	 *     // ...
	 *   });
	 */
	function runRouter(routes, location, callback) {
	  if (typeof location === 'function') {
	    callback = location;
	    location = null;
	  }
	
	  var router = createRouter({
	    routes: routes,
	    location: location
	  });
	
	  router.run(callback);
	
	  return router;
	}
	
	module.exports = runRouter;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var Router = __webpack_require__(166);
	var History = Router.History;
	var LocationActions = {
	    /**
	     * Indicates a new location is being pushed to the history stack.
	     */
	    PUSH: 'push',
	    /**
	     * Indicates the current location should be replaced.
	     */
	    REPLACE: 'replace',
	    /**
	     * Indicates the most recent entry should be removed from the history stack.
	     */
	    POP: 'pop'
	};
	
	var _listeners = [];
	var _isListening = false;
	
	function notifyChange(type) {
	    var change = {
	        path: HistoryLocation.getCurrentPath(),
	        type: type
	    };
	
	    _listeners.forEach(function (listener) {
	        /**
	        * [change.type = null]
	        * Triggers route reload, after navigating
	        * to an external route and returning back to react-router.
	        * This is because, the router state remains unchanged
	        * on visiting an external route.
	        **/
	        if (history && history.state && (typeof history.state.pathname === 'undefined' || history.state.pathname === location.pathname)) {
	            change.type = null;
	        }
	        listener.call(HistoryLocation, change);
	    });
	}
	
	function onPopState(event) {
	    if (event.state === undefined) {
	        return;
	    } // Ignore extraneous popstate events in WebKit.
	
	    notifyChange(LocationActions.POP);
	}
	
	/**
	 * A Location that uses HTML5 history.
	 */
	var HistoryLocation = {
	
	    addChangeListener: function addChangeListener(listener) {
	        _listeners.push(listener);
	
	        if (!_isListening) {
	            if (window.addEventListener) {
	                window.addEventListener('popstate', onPopState, false);
	            } else {
	                window.attachEvent('onpopstate', onPopState);
	            }
	
	            _isListening = true;
	        }
	    },
	
	    removeChangeListener: function removeChangeListener(listener) {
	        _listeners = _listeners.filter(function (l) {
	            return l !== listener;
	        });
	
	        if (_listeners.length === 0) {
	            if (window.addEventListener) {
	                window.removeEventListener('popstate', onPopState, false);
	            } else {
	                window.removeEvent('onpopstate', onPopState);
	            }
	
	            _isListening = false;
	        }
	    },
	
	    push: function push(path) {
	        try {
	            window.history.pushState({
	                url: location.href,
	                path: path,
	                pathname: window.location.pathname,
	                'router': 'react-router'
	            }, '', path);
	            History.length += 1;
	            notifyChange(LocationActions.PUSH);
	        } catch (e) {
	            window.location.href = path;
	        }
	    },
	
	    replace: function replace(path) {
	        window.history.replaceState({
	            url: location.href,
	            path: path,
	            pathname: window.location.pathname,
	            'router': 'react-router'
	        }, '', path);
	        notifyChange(LocationActions.REPLACE);
	    },
	
	    pop: History.back,
	
	    getCurrentPath: function getCurrentPath() {
	        return decodeURI(window.location.pathname + window.location.search);
	    },
	
	    toString: function toString() {
	        return '<HistoryLocation>';
	    }
	
	};
	
	module.exports = HistoryLocation;

/***/ },
/* 206 */
/***/ function(module, exports) {

	/* jshint node:true */
	"use strict";
	
	module.exports = (function () {
	
	    var uid = "reactApp";
	
	    return {
	        "uid": uid,
	        "appDir": "/app",
	        "port": 1377,
	        "host": "0.0.0.0",
	        "proxy": {
	            "port": 1378,
	            "host": "localhost",
	            "url": ""
	        },
	        "webpack": {
	            "bundler": {
	                "port": 1379,
	                "path": "/assets/js/",
	                "publicPath": "/assets/js/"
	            },
	            "config": {
	                "dev": "webpack.config",
	                "prod": "webpack.config.prod"
	            }
	        },
	        "auth": {
	            "user": "rearchitecture",
	            "password": "v1e2o3l4"
	        },
	        "dirs": {
	            "app": "app",
	            "views": "app/views",
	            "rev": "revved"
	        },
	        "cdn": {
	            "url": "http://cdn.url.prefix/path",
	            "revvedPath": "/revved"
	        },
	        "NODE_ENV": "dev"
	    };
	})();

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	module.exports = function (appUid) {
	
	    var Fluxible = __webpack_require__(208);
	
	    var app = new Fluxible({
	        component: __webpack_require__(247)
	    });
	
	    app.uid = appUid;
	
	    app.registerStore(__webpack_require__(414));
	    app.registerStore(__webpack_require__(427));
	    app.registerStore(__webpack_require__(428));
	    app.registerStore(__webpack_require__(429));
	    app.registerStore(__webpack_require__(430));
	    app.registerStore(__webpack_require__(431));
	
	    app.plug(__webpack_require__(432));
	
	    return app;
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var Fluxible = __webpack_require__(209);
	Fluxible.Fluxible = __webpack_require__(209);
	Fluxible.contextTypes = __webpack_require__(237);
	
	// DEPRECATIONS
	// @TODO(next minor): remove all deprecations
	Fluxible.FluxibleComponent = __webpack_require__(243);
	Fluxible.FluxibleMixin = __webpack_require__(245);
	
	module.exports = Fluxible;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/**
	 * Copyright 2014, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var debug = __webpack_require__(8)('Fluxible');
	var PromiseLib = global.Promise || __webpack_require__(211).Promise;
	var isPromise = __webpack_require__(215);
	var FluxibleContext = __webpack_require__(216);
	var dispatchr = __webpack_require__(239);
	
	/**
	 * Provides a structured way of registering an application's configuration and
	 * resources.
	 * @class Fluxible
	 * @param {Object} [options]
	 * @param {Object} [options.component] Stores your top level React component for access using `getComponent()`
	 * @param {Function} [options.componentActionHandler] App level component action handler
	 * @constructor
	 *
	 * @example
	 *      var app = new Fluxible({
	 *          component: require('./components/App.jsx')
	 *      });
	 */
	function Fluxible(options) {
	    debug('Fluxible instance instantiated', options);
	    options = options || {};
	
	    // Options
	    this._component = options.component;
	    this._componentActionHandler = options.componentActionHandler || this._defaultComponentActionHandler;
	    this._plugins = [];
	
	    // Initialize dependencies
	    this._dispatcher = dispatchr.createDispatcher(options);
	}
	
	Fluxible.Promise = PromiseLib;
	
	/**
	 * Creates an isolated context for a request/session
	 * @method createContext
	 * @param {Object} [options]
	 * @returns {FluxibleContext}
	 */
	Fluxible.prototype.createContext = function createContext(options) {
	    var self = this;
	    options = options || {};
	    options.app = self;
	    var context = new FluxibleContext(options);
	
	    // Plug context with app plugins that implement plugContext method
	    this._plugins.forEach(function eachPlugin(plugin) {
	        if (plugin.plugContext) {
	            var contextPlugin = plugin.plugContext(options, context, self) || {};
	            contextPlugin.name = contextPlugin.name || plugin.name;
	            context.plug(contextPlugin);
	        }
	    });
	
	    return context;
	};
	
	/**
	 * The default component action handler
	 * @method defaultComponentActionHandler
	 * @private
	 */
	Fluxible.prototype._defaultComponentActionHandler = function defaultComponentActionHandler(context, payload, done) {
	    if (payload.err) {
	        debug('Action returned error', payload.err);
	        throw payload.err;
	    }
	    done();
	};
	
	/**
	 * Creates a new dispatcher instance using the application's dispatchr class. Used by
	 * FluxibleContext to create new dispatcher instance
	 * @method createDispatcherInstance
	 * @param {Object} contextOptions The context options to be provided to each store instance
	 * @returns {Dispatcher}
	 */
	Fluxible.prototype.createDispatcherInstance = function createDispatcherInstance(contextOptions) {
	    return this._dispatcher.createContext(contextOptions);
	};
	
	/**
	 * Provides plugin mechanism for adding application level settings that are persisted
	 * between server/client and also modification of the FluxibleContext
	 * @method plug
	 * @param {Object} plugin
	 * @param {String} plugin.name Name of the plugin
	 * @param {Function} plugin.plugContext Method called after context is created to allow
	 *  dynamically plugging the context
	 * @param {Object} [plugin.dehydrate] Method called to serialize the plugin settings to be persisted
	 *  to the client
	 * @param {Object} [plugin.rehydrate] Method called to rehydrate the plugin settings from the server
	 */
	Fluxible.prototype.plug = function (plugin) {
	    if (!plugin.name) {
	        throw new Error('Application plugin must have a name');
	    }
	    this._plugins.push(plugin);
	};
	
	/**
	 * Provides access to a plugin instance by name
	 * @method getPlugin
	 * @param {String} pluginName The plugin name
	 * @returns {Object}
	 */
	Fluxible.prototype.getPlugin = function (pluginName) {
	    var plugin = null;
	    this._plugins.forEach(function (p) {
	        if (pluginName === p.name) {
	            plugin = p;
	        }
	    });
	    return plugin;
	};
	
	/**
	 * Getter for the top level react component for the application
	 * @method getComponent
	 * @returns {Object}
	 */
	Fluxible.prototype.getComponent = function getComponent() {
	    return this._component;
	};
	
	/**
	 * Registers a store to the dispatcher so it can listen for actions
	 * @method registerStore
	 */
	Fluxible.prototype.registerStore = function registerStore() {
	    debug(arguments[0].storeName + ' store registered');
	    this._dispatcher.registerStore.apply(this._dispatcher, arguments);
	};
	
	/**
	 * Creates a serializable state of the application and a given context for sending to the client
	 * @method dehydrate
	 * @param {FluxibleContext} context
	 * @returns {Object} Dehydrated state object
	 */
	Fluxible.prototype.dehydrate = function dehydrate(context) {
	    debug('dehydrate', context);
	    var self = this;
	    var state = {
	        context: context.dehydrate(),
	        plugins: {}
	    };
	
	    this._plugins.forEach(function (plugin) {
	        if ('function' === typeof plugin.dehydrate) {
	            // Use a namespace for storing plugin state and provide access to the application
	            state.plugins[plugin.name] = plugin.dehydrate(self);
	        }
	    });
	
	    return state;
	};
	
	/**
	 * Rehydrates the application and creates a new context with the state from the server
	 * @method rehydrate
	 * @param {Object} obj Raw object of dehydrated state
	 * @param {Object} obj.plugins Dehydrated app plugin state
	 * @param {Object} obj.context Dehydrated context state
	 * @param {Function} callback
	 * @async Rehydration may require more asset loading or async IO calls
	 */
	Fluxible.prototype.rehydrate = function rehydrate(obj, callback) {
	    debug('rehydrate', obj);
	    obj = obj || {};
	    var self = this;
	    var Promise = Fluxible.Promise;
	    obj.plugins = obj.plugins || {};
	    var pluginTasks = self._plugins.filter(function (plugin) {
	        return 'function' === typeof plugin.rehydrate
	            && obj.plugins[plugin.name];
	    }).map(function (plugin) {
	        return new Promise(function (resolve, reject) {
	            var result = plugin.rehydrate(obj.plugins[plugin.name], function (err) {
	                if (err) {
	                    reject(err);
	                } else {
	                    resolve();
	                }
	            });
	            if (isPromise(result)) {
	                result.then(resolve, reject);
	            } else if (plugin.rehydrate.length < 2) {
	                resolve();
	            }
	        });
	    });
	
	    var context = self.createContext();
	    var rehydratePromise = Promise.all(pluginTasks).then(function rehydratePluginTasks() {
	        return context.rehydrate(obj.context || {});
	    });
	
	    if (callback) {
	        rehydratePromise
	            .then(function(context) {
	                // Ensures that errors in callback are not swallowed by promise
	                setImmediate(callback, null, context);
	            }, function (err) {
	                // Ensures that errors in callback are not swallowed by promise
	                setImmediate(callback, err);
	            });
	    }
	
	    return rehydratePromise;
	};
	
	module.exports = Fluxible;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(210).setImmediate))

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(3).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(210).setImmediate, __webpack_require__(210).clearImmediate))

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var require;var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, setImmediate, global, module) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
	 * @version   2.3.0
	 */
	
	(function() {
	    "use strict";
	    function lib$es6$promise$utils$$objectOrFunction(x) {
	      return typeof x === 'function' || (typeof x === 'object' && x !== null);
	    }
	
	    function lib$es6$promise$utils$$isFunction(x) {
	      return typeof x === 'function';
	    }
	
	    function lib$es6$promise$utils$$isMaybeThenable(x) {
	      return typeof x === 'object' && x !== null;
	    }
	
	    var lib$es6$promise$utils$$_isArray;
	    if (!Array.isArray) {
	      lib$es6$promise$utils$$_isArray = function (x) {
	        return Object.prototype.toString.call(x) === '[object Array]';
	      };
	    } else {
	      lib$es6$promise$utils$$_isArray = Array.isArray;
	    }
	
	    var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
	    var lib$es6$promise$asap$$len = 0;
	    var lib$es6$promise$asap$$toString = {}.toString;
	    var lib$es6$promise$asap$$vertxNext;
	    var lib$es6$promise$asap$$customSchedulerFn;
	
	    var lib$es6$promise$asap$$asap = function asap(callback, arg) {
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
	      lib$es6$promise$asap$$len += 2;
	      if (lib$es6$promise$asap$$len === 2) {
	        // If len is 2, that means that we need to schedule an async flush.
	        // If additional callbacks are queued before the queue is flushed, they
	        // will be processed by this flush that we are scheduling.
	        if (lib$es6$promise$asap$$customSchedulerFn) {
	          lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
	        } else {
	          lib$es6$promise$asap$$scheduleFlush();
	        }
	      }
	    }
	
	    function lib$es6$promise$asap$$setScheduler(scheduleFn) {
	      lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
	    }
	
	    function lib$es6$promise$asap$$setAsap(asapFn) {
	      lib$es6$promise$asap$$asap = asapFn;
	    }
	
	    var lib$es6$promise$asap$$browserWindow = (typeof window !== 'undefined') ? window : undefined;
	    var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
	    var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
	    var lib$es6$promise$asap$$isNode = typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	    // test for web worker but not in IE10
	    var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' &&
	      typeof importScripts !== 'undefined' &&
	      typeof MessageChannel !== 'undefined';
	
	    // node
	    function lib$es6$promise$asap$$useNextTick() {
	      var nextTick = process.nextTick;
	      // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	      // setImmediate should be used instead instead
	      var version = process.versions.node.match(/^(?:(\d+)\.)?(?:(\d+)\.)?(\*|\d+)$/);
	      if (Array.isArray(version) && version[1] === '0' && version[2] === '10') {
	        nextTick = setImmediate;
	      }
	      return function() {
	        nextTick(lib$es6$promise$asap$$flush);
	      };
	    }
	
	    // vertx
	    function lib$es6$promise$asap$$useVertxTimer() {
	      return function() {
	        lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
	      };
	    }
	
	    function lib$es6$promise$asap$$useMutationObserver() {
	      var iterations = 0;
	      var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
	      var node = document.createTextNode('');
	      observer.observe(node, { characterData: true });
	
	      return function() {
	        node.data = (iterations = ++iterations % 2);
	      };
	    }
	
	    // web worker
	    function lib$es6$promise$asap$$useMessageChannel() {
	      var channel = new MessageChannel();
	      channel.port1.onmessage = lib$es6$promise$asap$$flush;
	      return function () {
	        channel.port2.postMessage(0);
	      };
	    }
	
	    function lib$es6$promise$asap$$useSetTimeout() {
	      return function() {
	        setTimeout(lib$es6$promise$asap$$flush, 1);
	      };
	    }
	
	    var lib$es6$promise$asap$$queue = new Array(1000);
	    function lib$es6$promise$asap$$flush() {
	      for (var i = 0; i < lib$es6$promise$asap$$len; i+=2) {
	        var callback = lib$es6$promise$asap$$queue[i];
	        var arg = lib$es6$promise$asap$$queue[i+1];
	
	        callback(arg);
	
	        lib$es6$promise$asap$$queue[i] = undefined;
	        lib$es6$promise$asap$$queue[i+1] = undefined;
	      }
	
	      lib$es6$promise$asap$$len = 0;
	    }
	
	    function lib$es6$promise$asap$$attemptVertex() {
	      try {
	        var r = require;
	        var vertx = __webpack_require__(213);
	        lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
	        return lib$es6$promise$asap$$useVertxTimer();
	      } catch(e) {
	        return lib$es6$promise$asap$$useSetTimeout();
	      }
	    }
	
	    var lib$es6$promise$asap$$scheduleFlush;
	    // Decide what async method to use to triggering processing of queued callbacks:
	    if (lib$es6$promise$asap$$isNode) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
	    } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
	    } else if (lib$es6$promise$asap$$isWorker) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
	    } else if (lib$es6$promise$asap$$browserWindow === undefined && "function" === 'function') {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertex();
	    } else {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
	    }
	
	    function lib$es6$promise$$internal$$noop() {}
	
	    var lib$es6$promise$$internal$$PENDING   = void 0;
	    var lib$es6$promise$$internal$$FULFILLED = 1;
	    var lib$es6$promise$$internal$$REJECTED  = 2;
	
	    var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	    function lib$es6$promise$$internal$$selfFullfillment() {
	      return new TypeError("You cannot resolve a promise with itself");
	    }
	
	    function lib$es6$promise$$internal$$cannotReturnOwn() {
	      return new TypeError('A promises callback cannot return that same promise.');
	    }
	
	    function lib$es6$promise$$internal$$getThen(promise) {
	      try {
	        return promise.then;
	      } catch(error) {
	        lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
	        return lib$es6$promise$$internal$$GET_THEN_ERROR;
	      }
	    }
	
	    function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	      try {
	        then.call(value, fulfillmentHandler, rejectionHandler);
	      } catch(e) {
	        return e;
	      }
	    }
	
	    function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
	       lib$es6$promise$asap$$asap(function(promise) {
	        var sealed = false;
	        var error = lib$es6$promise$$internal$$tryThen(then, thenable, function(value) {
	          if (sealed) { return; }
	          sealed = true;
	          if (thenable !== value) {
	            lib$es6$promise$$internal$$resolve(promise, value);
	          } else {
	            lib$es6$promise$$internal$$fulfill(promise, value);
	          }
	        }, function(reason) {
	          if (sealed) { return; }
	          sealed = true;
	
	          lib$es6$promise$$internal$$reject(promise, reason);
	        }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	        if (!sealed && error) {
	          sealed = true;
	          lib$es6$promise$$internal$$reject(promise, error);
	        }
	      }, promise);
	    }
	
	    function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
	      if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, thenable._result);
	      } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, thenable._result);
	      } else {
	        lib$es6$promise$$internal$$subscribe(thenable, undefined, function(value) {
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      }
	    }
	
	    function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable) {
	      if (maybeThenable.constructor === promise.constructor) {
	        lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
	      } else {
	        var then = lib$es6$promise$$internal$$getThen(maybeThenable);
	
	        if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
	        } else if (then === undefined) {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        } else if (lib$es6$promise$utils$$isFunction(then)) {
	          lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
	        } else {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        }
	      }
	    }
	
	    function lib$es6$promise$$internal$$resolve(promise, value) {
	      if (promise === value) {
	        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFullfillment());
	      } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
	        lib$es6$promise$$internal$$handleMaybeThenable(promise, value);
	      } else {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      }
	    }
	
	    function lib$es6$promise$$internal$$publishRejection(promise) {
	      if (promise._onerror) {
	        promise._onerror(promise._result);
	      }
	
	      lib$es6$promise$$internal$$publish(promise);
	    }
	
	    function lib$es6$promise$$internal$$fulfill(promise, value) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
	
	      promise._result = value;
	      promise._state = lib$es6$promise$$internal$$FULFILLED;
	
	      if (promise._subscribers.length !== 0) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
	      }
	    }
	
	    function lib$es6$promise$$internal$$reject(promise, reason) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
	      promise._state = lib$es6$promise$$internal$$REJECTED;
	      promise._result = reason;
	
	      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
	    }
	
	    function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
	      var subscribers = parent._subscribers;
	      var length = subscribers.length;
	
	      parent._onerror = null;
	
	      subscribers[length] = child;
	      subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
	      subscribers[length + lib$es6$promise$$internal$$REJECTED]  = onRejection;
	
	      if (length === 0 && parent._state) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
	      }
	    }
	
	    function lib$es6$promise$$internal$$publish(promise) {
	      var subscribers = promise._subscribers;
	      var settled = promise._state;
	
	      if (subscribers.length === 0) { return; }
	
	      var child, callback, detail = promise._result;
	
	      for (var i = 0; i < subscribers.length; i += 3) {
	        child = subscribers[i];
	        callback = subscribers[i + settled];
	
	        if (child) {
	          lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
	        } else {
	          callback(detail);
	        }
	      }
	
	      promise._subscribers.length = 0;
	    }
	
	    function lib$es6$promise$$internal$$ErrorObject() {
	      this.error = null;
	    }
	
	    var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	    function lib$es6$promise$$internal$$tryCatch(callback, detail) {
	      try {
	        return callback(detail);
	      } catch(e) {
	        lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
	        return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
	      }
	    }
	
	    function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
	      var hasCallback = lib$es6$promise$utils$$isFunction(callback),
	          value, error, succeeded, failed;
	
	      if (hasCallback) {
	        value = lib$es6$promise$$internal$$tryCatch(callback, detail);
	
	        if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
	          failed = true;
	          error = value.error;
	          value = null;
	        } else {
	          succeeded = true;
	        }
	
	        if (promise === value) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
	          return;
	        }
	
	      } else {
	        value = detail;
	        succeeded = true;
	      }
	
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	        // noop
	      } else if (hasCallback && succeeded) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      } else if (failed) {
	        lib$es6$promise$$internal$$reject(promise, error);
	      } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      } else if (settled === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, value);
	      }
	    }
	
	    function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
	      try {
	        resolver(function resolvePromise(value){
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function rejectPromise(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      } catch(e) {
	        lib$es6$promise$$internal$$reject(promise, e);
	      }
	    }
	
	    function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
	      var enumerator = this;
	
	      enumerator._instanceConstructor = Constructor;
	      enumerator.promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	      if (enumerator._validateInput(input)) {
	        enumerator._input     = input;
	        enumerator.length     = input.length;
	        enumerator._remaining = input.length;
	
	        enumerator._init();
	
	        if (enumerator.length === 0) {
	          lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
	        } else {
	          enumerator.length = enumerator.length || 0;
	          enumerator._enumerate();
	          if (enumerator._remaining === 0) {
	            lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
	          }
	        }
	      } else {
	        lib$es6$promise$$internal$$reject(enumerator.promise, enumerator._validationError());
	      }
	    }
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._validateInput = function(input) {
	      return lib$es6$promise$utils$$isArray(input);
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._validationError = function() {
	      return new Error('Array Methods must be provided an Array');
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._init = function() {
	      this._result = new Array(this.length);
	    };
	
	    var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function() {
	      var enumerator = this;
	
	      var length  = enumerator.length;
	      var promise = enumerator.promise;
	      var input   = enumerator._input;
	
	      for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	        enumerator._eachEntry(input[i], i);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function(entry, i) {
	      var enumerator = this;
	      var c = enumerator._instanceConstructor;
	
	      if (lib$es6$promise$utils$$isMaybeThenable(entry)) {
	        if (entry.constructor === c && entry._state !== lib$es6$promise$$internal$$PENDING) {
	          entry._onerror = null;
	          enumerator._settledAt(entry._state, i, entry._result);
	        } else {
	          enumerator._willSettleAt(c.resolve(entry), i);
	        }
	      } else {
	        enumerator._remaining--;
	        enumerator._result[i] = entry;
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function(state, i, value) {
	      var enumerator = this;
	      var promise = enumerator.promise;
	
	      if (promise._state === lib$es6$promise$$internal$$PENDING) {
	        enumerator._remaining--;
	
	        if (state === lib$es6$promise$$internal$$REJECTED) {
	          lib$es6$promise$$internal$$reject(promise, value);
	        } else {
	          enumerator._result[i] = value;
	        }
	      }
	
	      if (enumerator._remaining === 0) {
	        lib$es6$promise$$internal$$fulfill(promise, enumerator._result);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function(promise, i) {
	      var enumerator = this;
	
	      lib$es6$promise$$internal$$subscribe(promise, undefined, function(value) {
	        enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
	      }, function(reason) {
	        enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
	      });
	    };
	    function lib$es6$promise$promise$all$$all(entries) {
	      return new lib$es6$promise$enumerator$$default(this, entries).promise;
	    }
	    var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
	    function lib$es6$promise$promise$race$$race(entries) {
	      /*jshint validthis:true */
	      var Constructor = this;
	
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	      if (!lib$es6$promise$utils$$isArray(entries)) {
	        lib$es6$promise$$internal$$reject(promise, new TypeError('You must pass an array to race.'));
	        return promise;
	      }
	
	      var length = entries.length;
	
	      function onFulfillment(value) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      }
	
	      function onRejection(reason) {
	        lib$es6$promise$$internal$$reject(promise, reason);
	      }
	
	      for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	        lib$es6$promise$$internal$$subscribe(Constructor.resolve(entries[i]), undefined, onFulfillment, onRejection);
	      }
	
	      return promise;
	    }
	    var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
	    function lib$es6$promise$promise$resolve$$resolve(object) {
	      /*jshint validthis:true */
	      var Constructor = this;
	
	      if (object && typeof object === 'object' && object.constructor === Constructor) {
	        return object;
	      }
	
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$resolve(promise, object);
	      return promise;
	    }
	    var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
	    function lib$es6$promise$promise$reject$$reject(reason) {
	      /*jshint validthis:true */
	      var Constructor = this;
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$reject(promise, reason);
	      return promise;
	    }
	    var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;
	
	    var lib$es6$promise$promise$$counter = 0;
	
	    function lib$es6$promise$promise$$needsResolver() {
	      throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	    }
	
	    function lib$es6$promise$promise$$needsNew() {
	      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	    }
	
	    var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
	    /**
	      Promise objects represent the eventual result of an asynchronous operation. The
	      primary way of interacting with a promise is through its `then` method, which
	      registers callbacks to receive either a promise's eventual value or the reason
	      why the promise cannot be fulfilled.
	
	      Terminology
	      -----------
	
	      - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	      - `thenable` is an object or function that defines a `then` method.
	      - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	      - `exception` is a value that is thrown using the throw statement.
	      - `reason` is a value that indicates why a promise was rejected.
	      - `settled` the final resting state of a promise, fulfilled or rejected.
	
	      A promise can be in one of three states: pending, fulfilled, or rejected.
	
	      Promises that are fulfilled have a fulfillment value and are in the fulfilled
	      state.  Promises that are rejected have a rejection reason and are in the
	      rejected state.  A fulfillment value is never a thenable.
	
	      Promises can also be said to *resolve* a value.  If this value is also a
	      promise, then the original promise's settled state will match the value's
	      settled state.  So a promise that *resolves* a promise that rejects will
	      itself reject, and a promise that *resolves* a promise that fulfills will
	      itself fulfill.
	
	
	      Basic Usage:
	      ------------
	
	      ```js
	      var promise = new Promise(function(resolve, reject) {
	        // on success
	        resolve(value);
	
	        // on failure
	        reject(reason);
	      });
	
	      promise.then(function(value) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```
	
	      Advanced Usage:
	      ---------------
	
	      Promises shine when abstracting away asynchronous interactions such as
	      `XMLHttpRequest`s.
	
	      ```js
	      function getJSON(url) {
	        return new Promise(function(resolve, reject){
	          var xhr = new XMLHttpRequest();
	
	          xhr.open('GET', url);
	          xhr.onreadystatechange = handler;
	          xhr.responseType = 'json';
	          xhr.setRequestHeader('Accept', 'application/json');
	          xhr.send();
	
	          function handler() {
	            if (this.readyState === this.DONE) {
	              if (this.status === 200) {
	                resolve(this.response);
	              } else {
	                reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	              }
	            }
	          };
	        });
	      }
	
	      getJSON('/posts.json').then(function(json) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```
	
	      Unlike callbacks, promises are great composable primitives.
	
	      ```js
	      Promise.all([
	        getJSON('/posts'),
	        getJSON('/comments')
	      ]).then(function(values){
	        values[0] // => postsJSON
	        values[1] // => commentsJSON
	
	        return values;
	      });
	      ```
	
	      @class Promise
	      @param {function} resolver
	      Useful for tooling.
	      @constructor
	    */
	    function lib$es6$promise$promise$$Promise(resolver) {
	      this._id = lib$es6$promise$promise$$counter++;
	      this._state = undefined;
	      this._result = undefined;
	      this._subscribers = [];
	
	      if (lib$es6$promise$$internal$$noop !== resolver) {
	        if (!lib$es6$promise$utils$$isFunction(resolver)) {
	          lib$es6$promise$promise$$needsResolver();
	        }
	
	        if (!(this instanceof lib$es6$promise$promise$$Promise)) {
	          lib$es6$promise$promise$$needsNew();
	        }
	
	        lib$es6$promise$$internal$$initializePromise(this, resolver);
	      }
	    }
	
	    lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
	    lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
	    lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
	    lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
	    lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
	    lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
	    lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;
	
	    lib$es6$promise$promise$$Promise.prototype = {
	      constructor: lib$es6$promise$promise$$Promise,
	
	    /**
	      The primary way of interacting with a promise is through its `then` method,
	      which registers callbacks to receive either a promise's eventual value or the
	      reason why the promise cannot be fulfilled.
	
	      ```js
	      findUser().then(function(user){
	        // user is available
	      }, function(reason){
	        // user is unavailable, and you are given the reason why
	      });
	      ```
	
	      Chaining
	      --------
	
	      The return value of `then` is itself a promise.  This second, 'downstream'
	      promise is resolved with the return value of the first promise's fulfillment
	      or rejection handler, or rejected if the handler throws an exception.
	
	      ```js
	      findUser().then(function (user) {
	        return user.name;
	      }, function (reason) {
	        return 'default name';
	      }).then(function (userName) {
	        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	        // will be `'default name'`
	      });
	
	      findUser().then(function (user) {
	        throw new Error('Found user, but still unhappy');
	      }, function (reason) {
	        throw new Error('`findUser` rejected and we're unhappy');
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	      });
	      ```
	      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	
	      ```js
	      findUser().then(function (user) {
	        throw new PedagogicalException('Upstream error');
	      }).then(function (value) {
	        // never reached
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // The `PedgagocialException` is propagated all the way down to here
	      });
	      ```
	
	      Assimilation
	      ------------
	
	      Sometimes the value you want to propagate to a downstream promise can only be
	      retrieved asynchronously. This can be achieved by returning a promise in the
	      fulfillment or rejection handler. The downstream promise will then be pending
	      until the returned promise is settled. This is called *assimilation*.
	
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // The user's comments are now available
	      });
	      ```
	
	      If the assimliated promise rejects, then the downstream promise will also reject.
	
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // If `findCommentsByAuthor` fulfills, we'll have the value here
	      }, function (reason) {
	        // If `findCommentsByAuthor` rejects, we'll have the reason here
	      });
	      ```
	
	      Simple Example
	      --------------
	
	      Synchronous Example
	
	      ```javascript
	      var result;
	
	      try {
	        result = findResult();
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	
	      Errback Example
	
	      ```js
	      findResult(function(result, err){
	        if (err) {
	          // failure
	        } else {
	          // success
	        }
	      });
	      ```
	
	      Promise Example;
	
	      ```javascript
	      findResult().then(function(result){
	        // success
	      }, function(reason){
	        // failure
	      });
	      ```
	
	      Advanced Example
	      --------------
	
	      Synchronous Example
	
	      ```javascript
	      var author, books;
	
	      try {
	        author = findAuthor();
	        books  = findBooksByAuthor(author);
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	
	      Errback Example
	
	      ```js
	
	      function foundBooks(books) {
	
	      }
	
	      function failure(reason) {
	
	      }
	
	      findAuthor(function(author, err){
	        if (err) {
	          failure(err);
	          // failure
	        } else {
	          try {
	            findBoooksByAuthor(author, function(books, err) {
	              if (err) {
	                failure(err);
	              } else {
	                try {
	                  foundBooks(books);
	                } catch(reason) {
	                  failure(reason);
	                }
	              }
	            });
	          } catch(error) {
	            failure(err);
	          }
	          // success
	        }
	      });
	      ```
	
	      Promise Example;
	
	      ```javascript
	      findAuthor().
	        then(findBooksByAuthor).
	        then(function(books){
	          // found books
	      }).catch(function(reason){
	        // something went wrong
	      });
	      ```
	
	      @method then
	      @param {Function} onFulfilled
	      @param {Function} onRejected
	      Useful for tooling.
	      @return {Promise}
	    */
	      then: function(onFulfillment, onRejection) {
	        var parent = this;
	        var state = parent._state;
	
	        if (state === lib$es6$promise$$internal$$FULFILLED && !onFulfillment || state === lib$es6$promise$$internal$$REJECTED && !onRejection) {
	          return this;
	        }
	
	        var child = new this.constructor(lib$es6$promise$$internal$$noop);
	        var result = parent._result;
	
	        if (state) {
	          var callback = arguments[state - 1];
	          lib$es6$promise$asap$$asap(function(){
	            lib$es6$promise$$internal$$invokeCallback(state, child, callback, result);
	          });
	        } else {
	          lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
	        }
	
	        return child;
	      },
	
	    /**
	      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	      as the catch block of a try/catch statement.
	
	      ```js
	      function findAuthor(){
	        throw new Error('couldn't find that author');
	      }
	
	      // synchronous
	      try {
	        findAuthor();
	      } catch(reason) {
	        // something went wrong
	      }
	
	      // async with promises
	      findAuthor().catch(function(reason){
	        // something went wrong
	      });
	      ```
	
	      @method catch
	      @param {Function} onRejection
	      Useful for tooling.
	      @return {Promise}
	    */
	      'catch': function(onRejection) {
	        return this.then(null, onRejection);
	      }
	    };
	    function lib$es6$promise$polyfill$$polyfill() {
	      var local;
	
	      if (typeof global !== 'undefined') {
	          local = global;
	      } else if (typeof self !== 'undefined') {
	          local = self;
	      } else {
	          try {
	              local = Function('return this')();
	          } catch (e) {
	              throw new Error('polyfill failed because global object is unavailable in this environment');
	          }
	      }
	
	      var P = local.Promise;
	
	      if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
	        return;
	      }
	
	      local.Promise = lib$es6$promise$promise$$default;
	    }
	    var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;
	
	    var lib$es6$promise$umd$$ES6Promise = {
	      'Promise': lib$es6$promise$promise$$default,
	      'polyfill': lib$es6$promise$polyfill$$default
	    };
	
	    /* global define:true module:true window: true */
	    if ("function" === 'function' && __webpack_require__(214)['amd']) {
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return lib$es6$promise$umd$$ES6Promise; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined' && module['exports']) {
	      module['exports'] = lib$es6$promise$umd$$ES6Promise;
	    } else if (typeof this !== 'undefined') {
	      this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
	    }
	
	    lib$es6$promise$polyfill$$default();
	}).call(this);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(210).setImmediate, (function() { return this; }()), __webpack_require__(212)(module)))

/***/ },
/* 212 */,
/* 213 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 214 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 215 */
/***/ function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, console, setImmediate) {/**
	 * Copyright 2014, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var debug = __webpack_require__(8)('Fluxible:Context');
	var objectAssign = __webpack_require__(217);
	var isPromise = __webpack_require__(215);
	var PromiseLib = global.Promise || __webpack_require__(211).Promise;
	var React = __webpack_require__(11);
	var FluxibleComponent = __webpack_require__(218);
	__webpack_require__(238);
	
	/**
	 * A request or browser-session context
	 * @class FluxibleContext
	 * @param {Object} options
	 * @param {Fluxible} options.app The Fluxible instance used to create the context
	 * @constructor
	 */
	function FluxContext(options) {
	    options = options || {};
	
	    // Options
	    this._app = options.app;
	
	    // To be created on demand
	    this._dispatcher = null;
	
	    // Plugins
	    this._plugins = [];
	
	    // Set up contexts
	    this._actionContext = null;
	    this._componentContext = null;
	    this._storeContext = null;
	}
	
	// Provied a way to override Promise only for FluxContext
	FluxContext.Promise = PromiseLib;
	
	/**
	 * Creates an instance of the app level component with given props and a proper component
	 * context.
	 * @param {Object} props
	 * @return {ReactElement}
	 */
	FluxContext.prototype.createElement = function createElement(props) {
	    var Component = this._app.getComponent();
	    if (!Component) {
	        throw new Error('A component was not specified.');
	    }
	    if ('ContextProvider' === Component.displayName) {
	        return React.createElement(Component, objectAssign({}, {
	            context: this.getComponentContext()
	        }, props))
	    }
	    var componentInstance;
	    if (!Component.hasOwnProperty('prototype')) {
	        // TODO: remove factory support
	        if ('production' !== process.env.NODE_ENV) {
	            console.warn('When using context.createFactory(), it is no longer ' +
	                'necessary to wrap your component with `React.createFactory` when ' +
	                'instantiating Fluxible. Support for factories will be removed ' +
	                'in the next version of Fluxible.');
	        }
	        componentInstance = Component(props);
	    } else {
	        componentInstance = React.createElement(Component, props);
	    }
	    return React.createElement(FluxibleComponent, {
	        context: this.getComponentContext()
	    }, componentInstance);
	};
	
	/**
	 * Getter for store from dispatcher
	 * @method getStore
	 * @returns {Object}
	 */
	FluxContext.prototype.getStore = function getStore(store) {
	    if (!this._dispatcher) {
	        this._initializeDispatcher();
	    }
	    return this._dispatcher.getStore(store);
	};
	
	/**
	 * Provides plugin mechanism for adding application level settings that are persisted
	 * between server/client and also modification of the FluxibleContext
	 * @method plug
	 * @param {Object} plugin
	 * @param {String} plugin.name Name of the plugin
	 * @param {Function} [plugin.plugActionContext] Method called after action context is created to allow
	 *  dynamically modifying the action context
	 * @param {Function} [plugin.plugComponentContext] Method called after component context is created to
	 *  allow dynamically modifying the component context
	 * @param {Function} [plugin.plugStoreContext] Method called after store context is created to allow
	 *  dynamically modifying the store context
	 * @param {Object} [plugin.dehydrate] Method called to serialize the plugin settings to be persisted
	 *  to the client
	 * @param {Object} [plugin.rehydrate] Method called to rehydrate the plugin settings from the server
	 */
	FluxContext.prototype.plug = function (plugin) {
	    if (!plugin.name) {
	        throw new Error('Context plugin must have a name');
	    }
	    this._plugins.push(plugin);
	};
	
	/**
	 * Executes an action passing an action interface to as the first parameter
	 * If a promise is returned by the action, it will wait for its resolution or rejection
	 * If the action has less than three parameters, the returned promise
	 * will be resolved with the return value
	 * If the action throws an error, the promise will be rejected with the thrown value
	 * @param {Function} action An action creator function that receives actionContext, payload,
	 *  and done as parameters
	 * @param {Object} payload The action payload
	 * @param {Function} [done] Method to be called once action execution has completed
	 * @return {Promise} executeActionPromise Resolved with action result or rejected with action error
	 */
	FluxContext.prototype.executeAction = function executeAction(action, payload, done) {
	    var self = this;
	    payload = (undefined !== payload) ? payload : {};
	    var displayName = action.displayName || action.name;
	    var Promise = FluxContext.Promise;
	    if (process.env.NODE_ENV !== 'production') {
	        if (this._dispatcher && this._dispatcher.currentAction) {
	            var currentActionDisplayName = this._dispatcher.currentAction.displayName ||
	                this._dispatcher.currentAction.name;
	
	            console.warn('Warning: executeAction for `' + displayName + '` was called, but `' +
	                currentActionDisplayName + '` is currently being dispatched. This could mean ' +
	                'there are cascading updates, which should be avoided. `' + displayName +
	                '` will only start after `' + currentActionDisplayName + '` is complete.');
	        }
	    }
	
	    var executeActionPromise = new Promise(function executeActionPromise(resolve, reject) {
	        debug('Executing action ' + displayName + ' with payload', payload);
	        setImmediate(function () {
	            try {
	                executeActionInternal(self, action, payload, resolve, reject);
	            } catch (err) {
	                reject(err);
	            }
	        });
	    });
	
	    if (done) {
	        executeActionPromise
	            .then(function(result) {
	                // Ensures that errors in callback are not swallowed by promise
	                setImmediate(done, null, result);
	            }, function (err) {
	                // Ensures that errors in callback are not swallowed by promise
	                setImmediate(done, err);
	            });
	    }
	
	    return executeActionPromise;
	};
	
	/**
	 * Executes an action, and calls either resolve or reject based on the callback result
	 * This is extracted from FluxContext.prototype.executeAction to prevent this method de-optimising
	 * due to the try/catch
	 * @param {Object} context FluxContext object
	 * @param {Function} action Action to call
	 * @param {Object} payload Payload for the action
	 * @param {Function} resolve function to call on success
	 * @param {Function} reject function to call on failure
	 * @private
	 */
	function executeActionInternal(context, action, payload, resolve, reject) {
	    var result = action(context.getActionContext(), payload, function (err, result) {
	        if (err) {
	            reject(err);
	        } else {
	            resolve(result);
	        }
	    });
	    if (isPromise(result)) {
	        result.then(resolve, reject);
	    } else if (action.length < 3) {
	        resolve(result);
	    }
	}
	
	
	/**
	 * Sets up the dispatcher with access to the store context
	 * @method _initializeDispatcher
	 * @private
	 */
	FluxContext.prototype._initializeDispatcher = function initializeDispatcher() {
	    this._dispatcher = this._app.createDispatcherInstance(this.getStoreContext());
	};
	
	/**
	 * Returns the context for action controllers
	 * @method getActionContext
	 * @return {Object} Action context information
	 */
	FluxContext.prototype.getActionContext = function getActionContext() {
	    if (this._actionContext) {
	        return this._actionContext;
	    }
	    var self = this;
	
	    if (!self._dispatcher) {
	        self._initializeDispatcher();
	    }
	
	    var actionContext = {
	        dispatch: this._dispatcher.dispatch.bind(this._dispatcher),
	        executeAction: this.executeAction.bind(this),
	        getStore: this._dispatcher.getStore.bind(this._dispatcher)
	    };
	
	    self._plugins.forEach(function pluginsEach(plugin) {
	        var actionContextPlugin = plugin.plugActionContext;
	        if (actionContextPlugin) {
	            actionContextPlugin(actionContext, self, self._app);
	        }
	    });
	
	    self._actionContext = actionContext;
	
	    return self._actionContext;
	};
	
	/**
	 * Returns the context for action controllers
	 * @method getComponentContext
	 * @return {Object} Component context information
	 */
	FluxContext.prototype.getComponentContext = function getComponentContext() {
	    if (this._componentContext) {
	        return this._componentContext;
	    }
	    var self = this;
	    if (!self._dispatcher) {
	        self._initializeDispatcher();
	    }
	
	    var componentContext = {
	        getStore: this._dispatcher.getStore.bind(this._dispatcher),
	        // Prevents components from directly handling the callback for an action
	        executeAction: function componentExecuteAction(action, payload) {
	            self.executeAction(action, payload)
	            ['catch'](function actionHandlerWrapper(err) {
	                return self.executeAction(self._app._componentActionHandler, { err: err });
	            })
	            ['catch'](function unhandledError(err) {
	                setImmediate(function () {
	                    throw err;
	                });
	            });
	        }
	    };
	
	    self._plugins.forEach(function pluginsEach(plugin) {
	        var componentPlugin = plugin.plugComponentContext;
	        if (componentPlugin) {
	            componentPlugin(componentContext, self, self._app);
	        }
	    });
	
	    self._componentContext = componentContext;
	    return self._componentContext;
	};
	
	/**
	 * Returns the context for stores
	 * @method getStoreContext
	 * @return {Object} Store context information
	 */
	FluxContext.prototype.getStoreContext = function getStoreContext() {
	    if (this._storeContext) {
	        return this._storeContext;
	    }
	    var self = this;
	    var storeContext = {};
	
	    self._plugins.forEach(function pluginsEach(plugin) {
	        var storeContextPlugin = plugin.plugStoreContext;
	        if (storeContextPlugin) {
	            storeContextPlugin(storeContext, self, self._app);
	        }
	    });
	
	    self._storeContext = storeContext;
	    return self._storeContext;
	};
	
	/**
	 * Returns a serializable context state
	 * @method dehydrate
	 * @return {Object} See rehydrate method for properties
	 */
	FluxContext.prototype.dehydrate = function dehydrate() {
	    var self = this;
	    var state = {
	        dispatcher: (this._dispatcher && this._dispatcher.dehydrate()) || {},
	        plugins: {}
	    };
	
	    self._plugins.forEach(function pluginsEach(plugin) {
	        if ('function' === typeof plugin.dehydrate) {
	            // Use a namespace for storing plugin state and provide access to the application
	            state.plugins[plugin.name] = plugin.dehydrate(self);
	        }
	    });
	
	    return state;
	};
	
	/**
	 * Rehydrates the context state
	 * @method rehydrate
	 * @param {Object} obj Configuration
	 * @param {Object} obj.plugins Dehydrated context plugin state
	 * @param {Object} obj.dispatcher Dehydrated dispatcher state
	 */
	FluxContext.prototype.rehydrate = function rehydrate(obj) {
	    var self = this;
	    var Promise = FluxContext.Promise;
	    obj.plugins = obj.plugins || {};
	    var pluginTasks = self._plugins.filter(function (plugin) {
	        return 'function' === typeof plugin.rehydrate
	            && obj.plugins[plugin.name];
	    }).map(function (plugin) {
	        return new Promise(function (resolve, reject) {
	            var result = plugin.rehydrate(obj.plugins[plugin.name], function (err) {
	                if (err) {
	                    reject(err);
	                } else {
	                    resolve();
	                }
	            });
	            if (isPromise(result)) {
	                result.then(resolve, reject);
	            } else if (plugin.rehydrate.length < 2) {
	                resolve();
	            }
	        });
	    });
	
	    return Promise.all(pluginTasks).then(function rehydratePluginTasks() {
	        self._dispatcher = self._app.createDispatcherInstance(self.getStoreContext());
	        self._dispatcher.rehydrate(obj.dispatcher || {});
	        return self;
	    });
	};
	
	module.exports = FluxContext;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(3), __webpack_require__(1), __webpack_require__(210).setImmediate))

/***/ },
/* 217 */
/***/ function(module, exports) {

	'use strict';
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = Object.keys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var React = __webpack_require__(219);
	var contextTypes = __webpack_require__(237);
	
	var FluxibleComponent = React.createClass({
	    displayName: 'FluxibleComponent',
	    propTypes: {
	        context: React.PropTypes.object.isRequired
	    },
	
	    childContextTypes: contextTypes,
	
	    /**
	     * Provides the current context as a child context
	     * @method getChildContext
	     */
	    getChildContext: function () {
	        return {
	            getStore: this.props.context.getStore,
	            executeAction: this.props.context.executeAction
	        };
	    },
	
	    render: function () {
	        return React.addons.cloneWithProps(this.props.children, {
	            context: this.props.context
	        });
	    }
	});
	
	module.exports = FluxibleComponent;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(220);


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactWithAddons
	 */
	
	/**
	 * This module exists purely in the open source project, and is meant as a way
	 * to create a separate standalone build of React. This build has "addons", or
	 * functionality we've built and think might be useful but doesn't have a good
	 * place to live inside React core.
	 */
	
	'use strict';
	
	var LinkedStateMixin = __webpack_require__(221);
	var React = __webpack_require__(12);
	var ReactComponentWithPureRenderMixin =
	  __webpack_require__(224);
	var ReactCSSTransitionGroup = __webpack_require__(225);
	var ReactFragment = __webpack_require__(19);
	var ReactTransitionGroup = __webpack_require__(226);
	var ReactUpdates = __webpack_require__(35);
	
	var cx = __webpack_require__(234);
	var cloneWithProps = __webpack_require__(228);
	var update = __webpack_require__(235);
	
	React.addons = {
	  CSSTransitionGroup: ReactCSSTransitionGroup,
	  LinkedStateMixin: LinkedStateMixin,
	  PureRenderMixin: ReactComponentWithPureRenderMixin,
	  TransitionGroup: ReactTransitionGroup,
	
	  batchedUpdates: ReactUpdates.batchedUpdates,
	  classSet: cx,
	  cloneWithProps: cloneWithProps,
	  createFragment: ReactFragment.create,
	  update: update
	};
	
	if ("production" !== process.env.NODE_ENV) {
	  React.addons.Perf = __webpack_require__(159);
	  React.addons.TestUtils = __webpack_require__(236);
	}
	
	module.exports = React;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedStateMixin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactLink = __webpack_require__(222);
	var ReactStateSetters = __webpack_require__(223);
	
	/**
	 * A simple mixin around ReactLink.forState().
	 */
	var LinkedStateMixin = {
	  /**
	   * Create a ReactLink that's linked to part of this component's state. The
	   * ReactLink will have the current value of this.state[key] and will call
	   * setState() when a change is requested.
	   *
	   * @param {string} key state key to update. Note: you may want to use keyOf()
	   * if you're using Google Closure Compiler advanced mode.
	   * @return {ReactLink} ReactLink instance linking to the state.
	   */
	  linkState: function(key) {
	    return new ReactLink(
	      this.state[key],
	      ReactStateSetters.createStateKeySetter(this, key)
	    );
	  }
	};
	
	module.exports = LinkedStateMixin;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactLink
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactLink encapsulates a common pattern in which a component wants to modify
	 * a prop received from its parent. ReactLink allows the parent to pass down a
	 * value coupled with a callback that, when invoked, expresses an intent to
	 * modify that value. For example:
	 *
	 * React.createClass({
	 *   getInitialState: function() {
	 *     return {value: ''};
	 *   },
	 *   render: function() {
	 *     var valueLink = new ReactLink(this.state.value, this._handleValueChange);
	 *     return <input valueLink={valueLink} />;
	 *   },
	 *   this._handleValueChange: function(newValue) {
	 *     this.setState({value: newValue});
	 *   }
	 * });
	 *
	 * We have provided some sugary mixins to make the creation and
	 * consumption of ReactLink easier; see LinkedValueUtils and LinkedStateMixin.
	 */
	
	var React = __webpack_require__(12);
	
	/**
	 * @param {*} value current value of the link
	 * @param {function} requestChange callback to request a change
	 */
	function ReactLink(value, requestChange) {
	  this.value = value;
	  this.requestChange = requestChange;
	}
	
	/**
	 * Creates a PropType that enforces the ReactLink API and optionally checks the
	 * type of the value being passed inside the link. Example:
	 *
	 * MyComponent.propTypes = {
	 *   tabIndexLink: ReactLink.PropTypes.link(React.PropTypes.number)
	 * }
	 */
	function createLinkTypeChecker(linkType) {
	  var shapes = {
	    value: typeof linkType === 'undefined' ?
	      React.PropTypes.any.isRequired :
	      linkType.isRequired,
	    requestChange: React.PropTypes.func.isRequired
	  };
	  return React.PropTypes.shape(shapes);
	}
	
	ReactLink.PropTypes = {
	  link: createLinkTypeChecker
	};
	
	module.exports = ReactLink;


/***/ },
/* 223 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactStateSetters
	 */
	
	'use strict';
	
	var ReactStateSetters = {
	  /**
	   * Returns a function that calls the provided function, and uses the result
	   * of that to set the component's state.
	   *
	   * @param {ReactCompositeComponent} component
	   * @param {function} funcReturningState Returned callback uses this to
	   *                                      determine how to update state.
	   * @return {function} callback that when invoked uses funcReturningState to
	   *                    determined the object literal to setState.
	   */
	  createStateSetter: function(component, funcReturningState) {
	    return function(a, b, c, d, e, f) {
	      var partialState = funcReturningState.call(component, a, b, c, d, e, f);
	      if (partialState) {
	        component.setState(partialState);
	      }
	    };
	  },
	
	  /**
	   * Returns a single-argument callback that can be used to update a single
	   * key in the component's state.
	   *
	   * Note: this is memoized function, which makes it inexpensive to call.
	   *
	   * @param {ReactCompositeComponent} component
	   * @param {string} key The key in the state that you should update.
	   * @return {function} callback of 1 argument which calls setState() with
	   *                    the provided keyName and callback argument.
	   */
	  createStateKeySetter: function(component, key) {
	    // Memoize the setters.
	    var cache = component.__keySetters || (component.__keySetters = {});
	    return cache[key] || (cache[key] = createStateKeySetter(component, key));
	  }
	};
	
	function createStateKeySetter(component, key) {
	  // Partial state is allocated outside of the function closure so it can be
	  // reused with every call, avoiding memory allocation when this function
	  // is called.
	  var partialState = {};
	  return function stateKeySetter(value) {
	    partialState[key] = value;
	    component.setState(partialState);
	  };
	}
	
	ReactStateSetters.Mixin = {
	  /**
	   * Returns a function that calls the provided function, and uses the result
	   * of that to set the component's state.
	   *
	   * For example, these statements are equivalent:
	   *
	   *   this.setState({x: 1});
	   *   this.createStateSetter(function(xValue) {
	   *     return {x: xValue};
	   *   })(1);
	   *
	   * @param {function} funcReturningState Returned callback uses this to
	   *                                      determine how to update state.
	   * @return {function} callback that when invoked uses funcReturningState to
	   *                    determined the object literal to setState.
	   */
	  createStateSetter: function(funcReturningState) {
	    return ReactStateSetters.createStateSetter(this, funcReturningState);
	  },
	
	  /**
	   * Returns a single-argument callback that can be used to update a single
	   * key in the component's state.
	   *
	   * For example, these statements are equivalent:
	   *
	   *   this.setState({x: 1});
	   *   this.createStateKeySetter('x')(1);
	   *
	   * Note: this is memoized function, which makes it inexpensive to call.
	   *
	   * @param {string} key The key in the state that you should update.
	   * @return {function} callback of 1 argument which calls setState() with
	   *                    the provided keyName and callback argument.
	   */
	  createStateKeySetter: function(key) {
	    return ReactStateSetters.createStateKeySetter(this, key);
	  }
	};
	
	module.exports = ReactStateSetters;


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule ReactComponentWithPureRenderMixin
	*/
	
	'use strict';
	
	var shallowEqual = __webpack_require__(146);
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this Mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function(nextProps, nextState) {
	    return !shallowEqual(this.props, nextProps) ||
	           !shallowEqual(this.state, nextState);
	  }
	};
	
	module.exports = ReactComponentWithPureRenderMixin;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(12);
	
	var assign = __webpack_require__(22);
	
	var ReactTransitionGroup = React.createFactory(
	  __webpack_require__(226)
	);
	var ReactCSSTransitionGroupChild = React.createFactory(
	  __webpack_require__(231)
	);
	
	var ReactCSSTransitionGroup = React.createClass({
	  displayName: 'ReactCSSTransitionGroup',
	
	  propTypes: {
	    transitionName: React.PropTypes.string.isRequired,
	    transitionAppear: React.PropTypes.bool,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool
	  },
	
	  getDefaultProps: function() {
	    return {
	      transitionAppear: false,
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },
	
	  _wrapChild: function(child) {
	    // We need to provide this childFactory so that
	    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	    // leave while it is leaving.
	    return ReactCSSTransitionGroupChild(
	      {
	        name: this.props.transitionName,
	        appear: this.props.transitionAppear,
	        enter: this.props.transitionEnter,
	        leave: this.props.transitionLeave
	      },
	      child
	    );
	  },
	
	  render: function() {
	    return (
	      ReactTransitionGroup(
	        assign({}, this.props, {childFactory: this._wrapChild})
	      )
	    );
	  }
	});
	
	module.exports = ReactCSSTransitionGroup;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(12);
	var ReactTransitionChildMapping = __webpack_require__(227);
	
	var assign = __webpack_require__(22);
	var cloneWithProps = __webpack_require__(228);
	var emptyFunction = __webpack_require__(25);
	
	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },
	
	  getDefaultProps: function() {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },
	
	  componentWillMount: function() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },
	
	  componentDidMount: function() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(
	      nextProps.children
	    );
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(
	        prevChildMapping,
	        nextChildMapping
	      )
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev &&
	          !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext &&
	          !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	
	  performAppear: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(
	        this._handleDoneAppearing.bind(this, key)
	      );
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillEnter) {
	      component.componentWillEnter(
	        this._handleDoneEntering.bind(this, key)
	      );
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },
	
	  _handleDoneEntering: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performLeave: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },
	
	  _handleDoneLeaving: function(key) {
	    var component = this.refs[key];
	
	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      var newChildren = assign({}, this.state.children);
	      delete newChildren[key];
	      this.setState({children: newChildren});
	    }
	  },
	
	  render: function() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(cloneWithProps(
	          this.props.childFactory(child),
	          {ref: key, key: key}
	        ));
	      }
	    }
	    return React.createElement(
	      this.props.component,
	      this.props,
	      childrenToRender
	    );
	  }
	});
	
	module.exports = ReactTransitionGroup;


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactTransitionChildMapping
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(17);
	var ReactFragment = __webpack_require__(19);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around ReactChildren.map().
	   *
	   * @param {*} children `this.props.children`
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function(children) {
	    if (!children) {
	      return children;
	    }
	    return ReactFragment.extract(ReactChildren.map(children, function(child) {
	      return child;
	    }));
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function(prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(
	            pendingNextKey
	          );
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule cloneWithProps
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(20);
	var ReactPropTransferer = __webpack_require__(229);
	
	var keyOf = __webpack_require__(48);
	var warning = __webpack_require__(24);
	
	var CHILDREN_PROP = keyOf({children: null});
	
	/**
	 * Sometimes you want to change the props of a child passed to you. Usually
	 * this is to add a CSS class.
	 *
	 * @param {ReactElement} child child element you'd like to clone
	 * @param {object} props props you'd like to modify. className and style will be
	 * merged automatically.
	 * @return {ReactElement} a clone of child with props merged in.
	 */
	function cloneWithProps(child, props) {
	  if ("production" !== process.env.NODE_ENV) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      !child.ref,
	      'You are calling cloneWithProps() on a child with a ref. This is ' +
	      'dangerous because you\'re creating a new child which will not be ' +
	      'added as a ref to its parent.'
	    ) : null);
	  }
	
	  var newProps = ReactPropTransferer.mergeProps(props, child.props);
	
	  // Use `child.props.children` if it is provided.
	  if (!newProps.hasOwnProperty(CHILDREN_PROP) &&
	      child.props.hasOwnProperty(CHILDREN_PROP)) {
	    newProps.children = child.props.children;
	  }
	
	  // The current API doesn't retain _owner and _context, which is why this
	  // doesn't use ReactElement.cloneAndReplaceProps.
	  return ReactElement.createElement(child.type, newProps);
	}
	
	module.exports = cloneWithProps;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTransferer
	 */
	
	'use strict';
	
	var assign = __webpack_require__(22);
	var emptyFunction = __webpack_require__(25);
	var joinClasses = __webpack_require__(230);
	
	/**
	 * Creates a transfer strategy that will merge prop values using the supplied
	 * `mergeStrategy`. If a prop was previously unset, this just sets it.
	 *
	 * @param {function} mergeStrategy
	 * @return {function}
	 */
	function createTransferStrategy(mergeStrategy) {
	  return function(props, key, value) {
	    if (!props.hasOwnProperty(key)) {
	      props[key] = value;
	    } else {
	      props[key] = mergeStrategy(props[key], value);
	    }
	  };
	}
	
	var transferStrategyMerge = createTransferStrategy(function(a, b) {
	  // `merge` overrides the first object's (`props[key]` above) keys using the
	  // second object's (`value`) keys. An object's style's existing `propA` would
	  // get overridden. Flip the order here.
	  return assign({}, b, a);
	});
	
	/**
	 * Transfer strategies dictate how props are transferred by `transferPropsTo`.
	 * NOTE: if you add any more exceptions to this list you should be sure to
	 * update `cloneWithProps()` accordingly.
	 */
	var TransferStrategies = {
	  /**
	   * Never transfer `children`.
	   */
	  children: emptyFunction,
	  /**
	   * Transfer the `className` prop by merging them.
	   */
	  className: createTransferStrategy(joinClasses),
	  /**
	   * Transfer the `style` prop (which is an object) by merging them.
	   */
	  style: transferStrategyMerge
	};
	
	/**
	 * Mutates the first argument by transferring the properties from the second
	 * argument.
	 *
	 * @param {object} props
	 * @param {object} newProps
	 * @return {object}
	 */
	function transferInto(props, newProps) {
	  for (var thisKey in newProps) {
	    if (!newProps.hasOwnProperty(thisKey)) {
	      continue;
	    }
	
	    var transferStrategy = TransferStrategies[thisKey];
	
	    if (transferStrategy && TransferStrategies.hasOwnProperty(thisKey)) {
	      transferStrategy(props, thisKey, newProps[thisKey]);
	    } else if (!props.hasOwnProperty(thisKey)) {
	      props[thisKey] = newProps[thisKey];
	    }
	  }
	  return props;
	}
	
	/**
	 * ReactPropTransferer are capable of transferring props to another component
	 * using a `transferPropsTo` method.
	 *
	 * @class ReactPropTransferer
	 */
	var ReactPropTransferer = {
	
	  /**
	   * Merge two props objects using TransferStrategies.
	   *
	   * @param {object} oldProps original props (they take precedence)
	   * @param {object} newProps new props to merge in
	   * @return {object} a new object containing both sets of props merged.
	   */
	  mergeProps: function(oldProps, newProps) {
	    return transferInto(assign({}, oldProps), newProps);
	  }
	
	};
	
	module.exports = ReactPropTransferer;


/***/ },
/* 230 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule joinClasses
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} classes
	 * @return {string}
	 */
	function joinClasses(className/*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroupChild
	 */
	
	'use strict';
	
	var React = __webpack_require__(12);
	
	var CSSCore = __webpack_require__(232);
	var ReactTransitionEvents = __webpack_require__(233);
	
	var onlyChild = __webpack_require__(165);
	var warning = __webpack_require__(24);
	
	// We don't remove the element from the DOM until we receive an animationend or
	// transitionend event. If the user screws up and forgets to add an animation
	// their node will be stuck in the DOM forever, so we detect if an animation
	// does not start and if it doesn't, we just call the end listener immediately.
	var TICK = 17;
	var NO_EVENT_TIMEOUT = 5000;
	
	var noEventListener = null;
	
	
	if ("production" !== process.env.NODE_ENV) {
	  noEventListener = function() {
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'transition(): tried to perform an animation without ' +
	      'an animationend or transitionend event after timeout (' +
	      '%sms). You should either disable this ' +
	      'transition in JS or add a CSS animation/transition.',
	      NO_EVENT_TIMEOUT
	    ) : null);
	  };
	}
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  transition: function(animationType, finishCallback) {
	    var node = this.getDOMNode();
	    var className = this.props.name + '-' + animationType;
	    var activeClassName = className + '-active';
	    var noEventTimeout = null;
	
	    var endListener = function(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	      if ("production" !== process.env.NODE_ENV) {
	        clearTimeout(noEventTimeout);
	      }
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    ReactTransitionEvents.addEndEventListener(node, endListener);
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClass(activeClassName);
	
	    if ("production" !== process.env.NODE_ENV) {
	      noEventTimeout = setTimeout(noEventListener, NO_EVENT_TIMEOUT);
	    }
	  },
	
	  queueClass: function(className) {
	    this.classNameQueue.push(className);
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameQueue, TICK);
	    }
	  },
	
	  flushClassNameQueue: function() {
	    if (this.isMounted()) {
	      this.classNameQueue.forEach(
	        CSSCore.addClass.bind(CSSCore, this.getDOMNode())
	      );
	    }
	    this.classNameQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function() {
	    this.classNameQueue = [];
	  },
	
	  componentWillUnmount: function() {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	  },
	
	  componentWillAppear: function(done) {
	    if (this.props.appear) {
	      this.transition('appear', done);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function(done) {
	    if (this.props.enter) {
	      this.transition('enter', done);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function(done) {
	    if (this.props.leave) {
	      this.transition('leave', done);
	    } else {
	      done();
	    }
	  },
	
	  render: function() {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSCore
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(16);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function(element, className) {
	    ("production" !== process.env.NODE_ENV ? invariant(
	      !/\s/.test(className),
	      'CSSCore.addClass takes only a single class name. "%s" contains ' +
	      'multiple classes.', className
	    ) : invariant(!/\s/.test(className)));
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function(element, className) {
	    ("production" !== process.env.NODE_ENV ? invariant(
	      !/\s/.test(className),
	      'CSSCore.removeClass takes only a single class name. "%s" contains ' +
	      'multiple classes.', className
	    ) : invariant(!/\s/.test(className)));
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className
	          .replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1')
	          .replace(/\s+/g, ' ') // multiple spaces to one
	          .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function(element, className) {
	    ("production" !== process.env.NODE_ENV ? invariant(
	      !/\s/.test(className),
	      'CSS.hasClass takes only a single class name.'
	    ) : invariant(!/\s/.test(className)));
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  }
	
	};
	
	module.exports = CSSCore;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(60);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function(endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function(endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule cx
	 */
	
	/**
	 * This function is used to mark string literals representing CSS class names
	 * so that they can be transformed statically. This allows for modularization
	 * and minification of CSS class names.
	 *
	 * In static_upstream, this function is actually implemented, but it should
	 * eventually be replaced with something more descriptive, and the transform
	 * that is used in the main stack should be ported for use elsewhere.
	 *
	 * @param string|object className to modularize, or an object of key/values.
	 *                      In the object case, the values are conditions that
	 *                      determine if the className keys should be included.
	 * @param [string ...]  Variable list of classNames in the string case.
	 * @return string       Renderable space-separated CSS className.
	 */
	
	'use strict';
	var warning = __webpack_require__(24);
	
	var warned = false;
	
	function cx(classNames) {
	  if ("production" !== process.env.NODE_ENV) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      warned,
	      'React.addons.classSet will be deprecated in a future version. See ' +
	      'http://fb.me/react-addons-classset'
	    ) : null);
	    warned = true;
	  }
	
	  if (typeof classNames == 'object') {
	    return Object.keys(classNames).filter(function(className) {
	      return classNames[className];
	    }).join(' ');
	  } else {
	    return Array.prototype.join.call(arguments, ' ');
	  }
	}
	
	module.exports = cx;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule update
	 */
	
	 /* global hasOwnProperty:true */
	
	'use strict';
	
	var assign = __webpack_require__(22);
	var keyOf = __webpack_require__(48);
	var invariant = __webpack_require__(16);
	var hasOwnProperty = {}.hasOwnProperty;
	
	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}
	
	var COMMAND_PUSH = keyOf({$push: null});
	var COMMAND_UNSHIFT = keyOf({$unshift: null});
	var COMMAND_SPLICE = keyOf({$splice: null});
	var COMMAND_SET = keyOf({$set: null});
	var COMMAND_MERGE = keyOf({$merge: null});
	var COMMAND_APPLY = keyOf({$apply: null});
	
	var ALL_COMMANDS_LIST = [
	  COMMAND_PUSH,
	  COMMAND_UNSHIFT,
	  COMMAND_SPLICE,
	  COMMAND_SET,
	  COMMAND_MERGE,
	  COMMAND_APPLY
	];
	
	var ALL_COMMANDS_SET = {};
	
	ALL_COMMANDS_LIST.forEach(function(command) {
	  ALL_COMMANDS_SET[command] = true;
	});
	
	function invariantArrayCase(value, spec, command) {
	  ("production" !== process.env.NODE_ENV ? invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  ) : invariant(Array.isArray(value)));
	  var specValue = spec[command];
	  ("production" !== process.env.NODE_ENV ? invariant(
	    Array.isArray(specValue),
	    'update(): expected spec of %s to be an array; got %s. ' +
	    'Did you forget to wrap your parameter in an array?',
	    command,
	    specValue
	  ) : invariant(Array.isArray(specValue)));
	}
	
	function update(value, spec) {
	  ("production" !== process.env.NODE_ENV ? invariant(
	    typeof spec === 'object',
	    'update(): You provided a key path to update() that did not contain one ' +
	    'of %s. Did you forget to include {%s: ...}?',
	    ALL_COMMANDS_LIST.join(', '),
	    COMMAND_SET
	  ) : invariant(typeof spec === 'object'));
	
	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    ("production" !== process.env.NODE_ENV ? invariant(
	      Object.keys(spec).length === 1,
	      'Cannot have more than one key in an object with %s',
	      COMMAND_SET
	    ) : invariant(Object.keys(spec).length === 1));
	
	    return spec[COMMAND_SET];
	  }
	
	  var nextValue = shallowCopy(value);
	
	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    ("production" !== process.env.NODE_ENV ? invariant(
	      mergeObj && typeof mergeObj === 'object',
	      'update(): %s expects a spec of type \'object\'; got %s',
	      COMMAND_MERGE,
	      mergeObj
	    ) : invariant(mergeObj && typeof mergeObj === 'object'));
	    ("production" !== process.env.NODE_ENV ? invariant(
	      nextValue && typeof nextValue === 'object',
	      'update(): %s expects a target of type \'object\'; got %s',
	      COMMAND_MERGE,
	      nextValue
	    ) : invariant(nextValue && typeof nextValue === 'object'));
	    assign(nextValue, spec[COMMAND_MERGE]);
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function(item) {
	      nextValue.push(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function(item) {
	      nextValue.unshift(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    ("production" !== process.env.NODE_ENV ? invariant(
	      Array.isArray(value),
	      'Expected %s target to be an array; got %s',
	      COMMAND_SPLICE,
	      value
	    ) : invariant(Array.isArray(value)));
	    ("production" !== process.env.NODE_ENV ? invariant(
	      Array.isArray(spec[COMMAND_SPLICE]),
	      'update(): expected spec of %s to be an array of arrays; got %s. ' +
	      'Did you forget to wrap your parameters in an array?',
	      COMMAND_SPLICE,
	      spec[COMMAND_SPLICE]
	    ) : invariant(Array.isArray(spec[COMMAND_SPLICE])));
	    spec[COMMAND_SPLICE].forEach(function(args) {
	      ("production" !== process.env.NODE_ENV ? invariant(
	        Array.isArray(args),
	        'update(): expected spec of %s to be an array of arrays; got %s. ' +
	        'Did you forget to wrap your parameters in an array?',
	        COMMAND_SPLICE,
	        spec[COMMAND_SPLICE]
	      ) : invariant(Array.isArray(args)));
	      nextValue.splice.apply(nextValue, args);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    ("production" !== process.env.NODE_ENV ? invariant(
	      typeof spec[COMMAND_APPLY] === 'function',
	      'update(): expected spec of %s to be a function; got %s.',
	      COMMAND_APPLY,
	      spec[COMMAND_APPLY]
	    ) : invariant(typeof spec[COMMAND_APPLY] === 'function'));
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }
	
	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }
	
	  return nextValue;
	}
	
	module.exports = update;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTestUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(14);
	var EventPluginHub = __webpack_require__(78);
	var EventPropagators = __webpack_require__(102);
	var React = __webpack_require__(12);
	var ReactElement = __webpack_require__(20);
	var ReactEmptyComponent = __webpack_require__(85);
	var ReactBrowserEventEmitter = __webpack_require__(77);
	var ReactCompositeComponent = __webpack_require__(93);
	var ReactInstanceHandles = __webpack_require__(28);
	var ReactInstanceMap = __webpack_require__(34);
	var ReactMount = __webpack_require__(76);
	var ReactUpdates = __webpack_require__(35);
	var SyntheticEvent = __webpack_require__(106);
	
	var assign = __webpack_require__(22);
	var emptyObject = __webpack_require__(23);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function Event(suffix) {}
	
	/**
	 * @class ReactTestUtils
	 */
	
	/**
	 * Todo: Support the entire DOM.scry query syntax. For now, these simple
	 * utilities will suffice for testing purposes.
	 * @lends ReactTestUtils
	 */
	var ReactTestUtils = {
	  renderIntoDocument: function(instance) {
	    var div = document.createElement('div');
	    // None of our tests actually require attaching the container to the
	    // DOM, and doing so creates a mess that we rely on test isolation to
	    // clean up, so we're going to stop honoring the name of this method
	    // (and probably rename it eventually) if no problems arise.
	    // document.documentElement.appendChild(div);
	    return React.render(instance, div);
	  },
	
	  isElement: function(element) {
	    return ReactElement.isValidElement(element);
	  },
	
	  isElementOfType: function(inst, convenienceConstructor) {
	    return (
	      ReactElement.isValidElement(inst) &&
	      inst.type === convenienceConstructor
	    );
	  },
	
	  isDOMComponent: function(inst) {
	    // TODO: Fix this heuristic. It's just here because composites can currently
	    // pretend to be DOM components.
	    return !!(inst && inst.tagName && inst.getDOMNode);
	  },
	
	  isDOMComponentElement: function(inst) {
	    return !!(inst &&
	              ReactElement.isValidElement(inst) &&
	              !!inst.tagName);
	  },
	
	  isCompositeComponent: function(inst) {
	    return typeof inst.render === 'function' &&
	           typeof inst.setState === 'function';
	  },
	
	  isCompositeComponentWithType: function(inst, type) {
	    return !!(ReactTestUtils.isCompositeComponent(inst) &&
	             (inst.constructor === type));
	  },
	
	  isCompositeComponentElement: function(inst) {
	    if (!ReactElement.isValidElement(inst)) {
	      return false;
	    }
	    // We check the prototype of the type that will get mounted, not the
	    // instance itself. This is a future proof way of duck typing.
	    var prototype = inst.type.prototype;
	    return (
	      typeof prototype.render === 'function' &&
	      typeof prototype.setState === 'function'
	    );
	  },
	
	  isCompositeComponentElementWithType: function(inst, type) {
	    return !!(ReactTestUtils.isCompositeComponentElement(inst) &&
	             (inst.constructor === type));
	  },
	
	  getRenderedChildOfCompositeComponent: function(inst) {
	    if (!ReactTestUtils.isCompositeComponent(inst)) {
	      return null;
	    }
	    var internalInstance = ReactInstanceMap.get(inst);
	    return internalInstance._renderedComponent.getPublicInstance();
	  },
	
	  findAllInRenderedTree: function(inst, test) {
	    if (!inst) {
	      return [];
	    }
	    var ret = test(inst) ? [inst] : [];
	    if (ReactTestUtils.isDOMComponent(inst)) {
	      var internalInstance = ReactInstanceMap.get(inst);
	      var renderedChildren = internalInstance
	        ._renderedComponent
	        ._renderedChildren;
	      var key;
	      for (key in renderedChildren) {
	        if (!renderedChildren.hasOwnProperty(key)) {
	          continue;
	        }
	        if (!renderedChildren[key].getPublicInstance) {
	          continue;
	        }
	        ret = ret.concat(
	          ReactTestUtils.findAllInRenderedTree(
	            renderedChildren[key].getPublicInstance(),
	            test
	          )
	        );
	      }
	    } else if (ReactTestUtils.isCompositeComponent(inst)) {
	      ret = ret.concat(
	        ReactTestUtils.findAllInRenderedTree(
	          ReactTestUtils.getRenderedChildOfCompositeComponent(inst),
	          test
	        )
	      );
	    }
	    return ret;
	  },
	
	  /**
	   * Finds all instance of components in the rendered tree that are DOM
	   * components with the class name matching `className`.
	   * @return an array of all the matches.
	   */
	  scryRenderedDOMComponentsWithClass: function(root, className) {
	    return ReactTestUtils.findAllInRenderedTree(root, function(inst) {
	      var instClassName = inst.props.className;
	      return ReactTestUtils.isDOMComponent(inst) && (
	        (instClassName && (' ' + instClassName + ' ').indexOf(' ' + className + ' ') !== -1)
	      );
	    });
	  },
	
	  /**
	   * Like scryRenderedDOMComponentsWithClass but expects there to be one result,
	   * and returns that one result, or throws exception if there is any other
	   * number of matches besides one.
	   * @return {!ReactDOMComponent} The one match.
	   */
	  findRenderedDOMComponentWithClass: function(root, className) {
	    var all =
	      ReactTestUtils.scryRenderedDOMComponentsWithClass(root, className);
	    if (all.length !== 1) {
	      throw new Error('Did not find exactly one match ' +
	        '(found: ' + all.length + ') for class:' + className
	      );
	    }
	    return all[0];
	  },
	
	
	  /**
	   * Finds all instance of components in the rendered tree that are DOM
	   * components with the tag name matching `tagName`.
	   * @return an array of all the matches.
	   */
	  scryRenderedDOMComponentsWithTag: function(root, tagName) {
	    return ReactTestUtils.findAllInRenderedTree(root, function(inst) {
	      return ReactTestUtils.isDOMComponent(inst) &&
	            inst.tagName === tagName.toUpperCase();
	    });
	  },
	
	  /**
	   * Like scryRenderedDOMComponentsWithTag but expects there to be one result,
	   * and returns that one result, or throws exception if there is any other
	   * number of matches besides one.
	   * @return {!ReactDOMComponent} The one match.
	   */
	  findRenderedDOMComponentWithTag: function(root, tagName) {
	    var all = ReactTestUtils.scryRenderedDOMComponentsWithTag(root, tagName);
	    if (all.length !== 1) {
	      throw new Error('Did not find exactly one match for tag:' + tagName);
	    }
	    return all[0];
	  },
	
	
	  /**
	   * Finds all instances of components with type equal to `componentType`.
	   * @return an array of all the matches.
	   */
	  scryRenderedComponentsWithType: function(root, componentType) {
	    return ReactTestUtils.findAllInRenderedTree(root, function(inst) {
	      return ReactTestUtils.isCompositeComponentWithType(
	        inst,
	        componentType
	      );
	    });
	  },
	
	  /**
	   * Same as `scryRenderedComponentsWithType` but expects there to be one result
	   * and returns that one result, or throws exception if there is any other
	   * number of matches besides one.
	   * @return {!ReactComponent} The one match.
	   */
	  findRenderedComponentWithType: function(root, componentType) {
	    var all = ReactTestUtils.scryRenderedComponentsWithType(
	      root,
	      componentType
	    );
	    if (all.length !== 1) {
	      throw new Error(
	        'Did not find exactly one match for componentType:' + componentType
	      );
	    }
	    return all[0];
	  },
	
	  /**
	   * Pass a mocked component module to this method to augment it with
	   * useful methods that allow it to be used as a dummy React component.
	   * Instead of rendering as usual, the component will become a simple
	   * <div> containing any provided children.
	   *
	   * @param {object} module the mock function object exported from a
	   *                        module that defines the component to be mocked
	   * @param {?string} mockTagName optional dummy root tag name to return
	   *                              from render method (overrides
	   *                              module.mockTagName if provided)
	   * @return {object} the ReactTestUtils object (for chaining)
	   */
	  mockComponent: function(module, mockTagName) {
	    mockTagName = mockTagName || module.mockTagName || "div";
	
	    module.prototype.render.mockImplementation(function() {
	      return React.createElement(
	        mockTagName,
	        null,
	        this.props.children
	      );
	    });
	
	    return this;
	  },
	
	  /**
	   * Simulates a top level event being dispatched from a raw event that occured
	   * on an `Element` node.
	   * @param topLevelType {Object} A type from `EventConstants.topLevelTypes`
	   * @param {!Element} node The dom to simulate an event occurring on.
	   * @param {?Event} fakeNativeEvent Fake native event to use in SyntheticEvent.
	   */
	  simulateNativeEventOnNode: function(topLevelType, node, fakeNativeEvent) {
	    fakeNativeEvent.target = node;
	    ReactBrowserEventEmitter.ReactEventListener.dispatchEvent(
	      topLevelType,
	      fakeNativeEvent
	    );
	  },
	
	  /**
	   * Simulates a top level event being dispatched from a raw event that occured
	   * on the `ReactDOMComponent` `comp`.
	   * @param topLevelType {Object} A type from `EventConstants.topLevelTypes`.
	   * @param comp {!ReactDOMComponent}
	   * @param {?Event} fakeNativeEvent Fake native event to use in SyntheticEvent.
	   */
	  simulateNativeEventOnDOMComponent: function(
	      topLevelType,
	      comp,
	      fakeNativeEvent) {
	    ReactTestUtils.simulateNativeEventOnNode(
	      topLevelType,
	      comp.getDOMNode(),
	      fakeNativeEvent
	    );
	  },
	
	  nativeTouchData: function(x, y) {
	    return {
	      touches: [
	        {pageX: x, pageY: y}
	      ]
	    };
	  },
	
	  createRenderer: function() {
	    return new ReactShallowRenderer();
	  },
	
	  Simulate: null,
	  SimulateNative: {}
	};
	
	/**
	 * @class ReactShallowRenderer
	 */
	var ReactShallowRenderer = function() {
	  this._instance = null;
	};
	
	ReactShallowRenderer.prototype.getRenderOutput = function() {
	  return (
	    (this._instance && this._instance._renderedComponent &&
	     this._instance._renderedComponent._renderedOutput)
	    || null
	  );
	};
	
	var NoopInternalComponent = function(element) {
	  this._renderedOutput = element;
	  this._currentElement = element === null || element === false ?
	    ReactEmptyComponent.emptyElement :
	    element;
	};
	
	NoopInternalComponent.prototype = {
	
	  mountComponent: function() {
	  },
	
	  receiveComponent: function(element) {
	    this._renderedOutput = element;
	    this._currentElement = element === null || element === false ?
	      ReactEmptyComponent.emptyElement :
	      element;
	  },
	
	  unmountComponent: function() {
	  }
	
	};
	
	var ShallowComponentWrapper = function() { };
	assign(
	  ShallowComponentWrapper.prototype,
	  ReactCompositeComponent.Mixin, {
	    _instantiateReactComponent: function(element) {
	      return new NoopInternalComponent(element);
	    },
	    _replaceNodeWithMarkupByID: function() {},
	    _renderValidatedComponent:
	      ReactCompositeComponent.Mixin.
	        _renderValidatedComponentWithoutOwnerOrContext
	  }
	);
	
	ReactShallowRenderer.prototype.render = function(element, context) {
	  if (!context) {
	    context = emptyObject;
	  }
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled();
	  this._render(element, transaction, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	};
	
	ReactShallowRenderer.prototype.unmount = function() {
	  if (this._instance) {
	    this._instance.unmountComponent();
	  }
	};
	
	ReactShallowRenderer.prototype._render = function(element, transaction, context) {
	  if (!this._instance) {
	    var rootID = ReactInstanceHandles.createReactRootID();
	    var instance = new ShallowComponentWrapper(element.type);
	    instance.construct(element);
	
	    instance.mountComponent(rootID, transaction, context);
	
	    this._instance = instance;
	  } else {
	    this._instance.receiveComponent(element, transaction, context);
	  }
	};
	
	/**
	 * Exports:
	 *
	 * - `ReactTestUtils.Simulate.click(Element/ReactDOMComponent)`
	 * - `ReactTestUtils.Simulate.mouseMove(Element/ReactDOMComponent)`
	 * - `ReactTestUtils.Simulate.change(Element/ReactDOMComponent)`
	 * - ... (All keys from event plugin `eventTypes` objects)
	 */
	function makeSimulator(eventType) {
	  return function(domComponentOrNode, eventData) {
	    var node;
	    if (ReactTestUtils.isDOMComponent(domComponentOrNode)) {
	      node = domComponentOrNode.getDOMNode();
	    } else if (domComponentOrNode.tagName) {
	      node = domComponentOrNode;
	    }
	
	    var fakeNativeEvent = new Event();
	    fakeNativeEvent.target = node;
	    // We don't use SyntheticEvent.getPooled in order to not have to worry about
	    // properly destroying any properties assigned from `eventData` upon release
	    var event = new SyntheticEvent(
	      ReactBrowserEventEmitter.eventNameDispatchConfigs[eventType],
	      ReactMount.getID(node),
	      fakeNativeEvent
	    );
	    assign(event, eventData);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	
	    ReactUpdates.batchedUpdates(function() {
	      EventPluginHub.enqueueEvents(event);
	      EventPluginHub.processEventQueue();
	    });
	  };
	}
	
	function buildSimulators() {
	  ReactTestUtils.Simulate = {};
	
	  var eventType;
	  for (eventType in ReactBrowserEventEmitter.eventNameDispatchConfigs) {
	    /**
	     * @param {!Element || ReactDOMComponent} domComponentOrNode
	     * @param {?object} eventData Fake event data to use in SyntheticEvent.
	     */
	    ReactTestUtils.Simulate[eventType] = makeSimulator(eventType);
	  }
	}
	
	// Rebuild ReactTestUtils.Simulate whenever event plugins are injected
	var oldInjectEventPluginOrder = EventPluginHub.injection.injectEventPluginOrder;
	EventPluginHub.injection.injectEventPluginOrder = function() {
	  oldInjectEventPluginOrder.apply(this, arguments);
	  buildSimulators();
	};
	var oldInjectEventPlugins = EventPluginHub.injection.injectEventPluginsByName;
	EventPluginHub.injection.injectEventPluginsByName = function() {
	  oldInjectEventPlugins.apply(this, arguments);
	  buildSimulators();
	};
	
	buildSimulators();
	
	/**
	 * Exports:
	 *
	 * - `ReactTestUtils.SimulateNative.click(Element/ReactDOMComponent)`
	 * - `ReactTestUtils.SimulateNative.mouseMove(Element/ReactDOMComponent)`
	 * - `ReactTestUtils.SimulateNative.mouseIn/ReactDOMComponent)`
	 * - `ReactTestUtils.SimulateNative.mouseOut(Element/ReactDOMComponent)`
	 * - ... (All keys from `EventConstants.topLevelTypes`)
	 *
	 * Note: Top level event types are a subset of the entire set of handler types
	 * (which include a broader set of "synthetic" events). For example, onDragDone
	 * is a synthetic event. Except when testing an event plugin or React's event
	 * handling code specifically, you probably want to use ReactTestUtils.Simulate
	 * to dispatch synthetic events.
	 */
	
	function makeNativeSimulator(eventType) {
	  return function(domComponentOrNode, nativeEventData) {
	    var fakeNativeEvent = new Event(eventType);
	    assign(fakeNativeEvent, nativeEventData);
	    if (ReactTestUtils.isDOMComponent(domComponentOrNode)) {
	      ReactTestUtils.simulateNativeEventOnDOMComponent(
	        eventType,
	        domComponentOrNode,
	        fakeNativeEvent
	      );
	    } else if (!!domComponentOrNode.tagName) {
	      // Will allow on actual dom nodes.
	      ReactTestUtils.simulateNativeEventOnNode(
	        eventType,
	        domComponentOrNode,
	        fakeNativeEvent
	      );
	    }
	  };
	}
	
	var eventType;
	for (eventType in topLevelTypes) {
	  // Event type is stored as 'topClick' - we transform that to 'click'
	  var convenienceName = eventType.indexOf('top') === 0 ?
	    eventType.charAt(3).toLowerCase() + eventType.substr(4) : eventType;
	  /**
	   * @param {!Element || ReactDOMComponent} domComponentOrNode
	   * @param {?Event} nativeEventData Fake native event to use in SyntheticEvent.
	   */
	  ReactTestUtils.SimulateNative[convenienceName] =
	    makeNativeSimulator(eventType);
	}
	
	module.exports = ReactTestUtils;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var React = __webpack_require__(11);
	
	module.exports = {
	    executeAction: React.PropTypes.func.isRequired,
	    getStore: React.PropTypes.func.isRequired
	};


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(clearImmediate, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var setImmediate;
	
	    function addFromSetImmediateArguments(args) {
	        tasksByHandle[nextHandle] = partiallyApplied.apply(undefined, args);
	        return nextHandle++;
	    }
	
	    // This function accepts the same arguments as setImmediate, but
	    // returns a function that requires no arguments.
	    function partiallyApplied(handler) {
	        var args = [].slice.call(arguments, 1);
	        return function() {
	            if (typeof handler === "function") {
	                handler.apply(undefined, args);
	            } else {
	                (new Function("" + handler))();
	            }
	        };
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(partiallyApplied(runIfPresent, handle), 0);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    task();
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function installNextTickImplementation() {
	        setImmediate = function() {
	            var handle = addFromSetImmediateArguments(arguments);
	            process.nextTick(partiallyApplied(runIfPresent, handle));
	            return handle;
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        setImmediate = function() {
	            var handle = addFromSetImmediateArguments(arguments);
	            global.postMessage(messagePrefix + handle, "*");
	            return handle;
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        setImmediate = function() {
	            var handle = addFromSetImmediateArguments(arguments);
	            channel.port2.postMessage(handle);
	            return handle;
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        setImmediate = function() {
	            var handle = addFromSetImmediateArguments(arguments);
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	            return handle;
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        setImmediate = function() {
	            var handle = addFromSetImmediateArguments(arguments);
	            setTimeout(partiallyApplied(runIfPresent, handle), 0);
	            return handle;
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(new Function("return this")()));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(210).clearImmediate, __webpack_require__(3)))

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	module.exports = __webpack_require__(240);


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, console) {/**
	 * Copyright 2014, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var Action = __webpack_require__(241);
	var DEFAULT = 'default';
	var DispatcherContext = __webpack_require__(242);
	
	/**
	 * @class Dispatcher
	 * @param {Object} options Dispatcher options
	 * @param {Array} options.stores Array of stores to register
	 * @constructor
	 */
	function Dispatcher (options) {
	    options = options || {};
	    options.stores = options.stores || [];
	    this.stores = {};
	    this.handlers = {};
	    this.handlers[DEFAULT] = [];
	    this.hasWarnedAboutNameProperty = false;
	    options.stores.forEach(function (store) {
	        this.registerStore(store);
	    }, this);
	
	}
	
	Dispatcher.prototype.createContext = function createContext(context) {
	    return new DispatcherContext(this, context);
	};
	
	/**
	 * Registers a store so that it can handle actions.
	 * @method registerStore
	 * @static
	 * @param {Object} store A store class to be registered. The store should have a static
	 *      `name` property so that it can be loaded later.
	 * @throws {Error} if store is invalid
	 * @throws {Error} if store is already registered
	 */
	Dispatcher.prototype.registerStore = function registerStore(store) {
	    if ('function' !== typeof store) {
	        throw new Error('registerStore requires a constructor as first parameter');
	    }
	    var storeName = this.getStoreName(store);
	    if (!storeName) {
	        throw new Error('Store is required to have a `storeName` property.');
	    }
	    if (this.stores[storeName]) {
	        if (this.stores[storeName] === store) {
	            // Store is already registered, nothing to do
	            return;
	        }
	        throw new Error('Store with name `' + storeName + '` has already been registered.');
	    }
	    this.stores[storeName] = store;
	    if (store.handlers) {
	        Object.keys(store.handlers).forEach(function storeHandlersEach(action) {
	            var handler = store.handlers[action];
	            this._registerHandler(action, storeName, handler);
	        }, this);
	    }
	};
	
	/**
	 * Method to discover if a storeName has been registered
	 * @method isRegistered
	 * @static
	 * @param {Object|String} store The store to check
	 * @returns {boolean}
	 */
	Dispatcher.prototype.isRegistered = function isRegistered(store) {
	    var storeName = this.getStoreName(store),
	        storeInstance = this.stores[storeName];
	
	    if (!storeInstance) {
	        return false;
	    }
	
	    if ('function' === typeof store) {
	        if (store !== storeInstance) {
	            return false;
	        }
	    }
	    return true;
	};
	
	/**
	 * Gets a name from a store
	 * @method getStoreName
	 * @static
	 * @param {String|Object} store The store name or class from which to extract
	 *      the name
	 * @returns {String}
	 */
	Dispatcher.prototype.getStoreName = function getStoreName(store) {
	    if ('string' === typeof store) {
	        return store;
	    }
	    if (store.storeName) {
	        return store.storeName;
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	        if (store.name && !this.hasWarnedAboutNameProperty) {
	            console.warn('A store has been registered that relies on the ' +
	                'constructor\'s name property. This name may change when you ' +
	                'minify your stores during build time and could break string ' +
	                'references to your store. It is advised that you add a ' +
	                'static `storeName` property to your store to ensure the ' +
	                'store name does not change during your build.');
	            this.hasWarnedAboutNameProperty = true;
	        }
	    }
	    return store.name;
	};
	
	/**
	 * Adds a handler function to be called for the given action
	 * @method registerHandler
	 * @private
	 * @static
	 * @param {String} action Name of the action
	 * @param {String} name Name of the store that handles the action
	 * @param {String|Function} handler The function or name of the method that handles the action
	 * @returns {number}
	 */
	Dispatcher.prototype._registerHandler = function registerHandler(action, name, handler) {
	    this.handlers[action] = this.handlers[action] || [];
	    this.handlers[action].push({
	        name: this.getStoreName(name),
	        handler: handler
	    });
	    return this.handlers.length - 1;
	};
	
	module.exports = {
	    createDispatcher: function (options) {
	        return new Dispatcher(options);
	    }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(1)))

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	var debug = __webpack_require__(8)('Dispatchr:Action');
	
	function Action(name, payload) {
	    this.name = name;
	    this.payload = payload;
	    this._handlers = null;
	    this._isExecuting = false;
	    this._isCompleted = null;
	}
	
	/**
	 * Gets a name from a store
	 * @method getStoreName
	 * @param {String|Object} store The store name or class from which to extract
	 *      the name
	 * @returns {String}
	 */
	Action.prototype.getStoreName = function getStoreName(store) {
	    if ('string' === typeof store) {
	        return store;
	    }
	    return store.storeName;
	};
	
	/**
	 * Executes all handlers for the action
	 * @method execute
	 * @param {Function[]} handlers A mapping of store names to handler function
	 * @throws {Error} if action has already been executed
	 */
	Action.prototype.execute = function execute(handlers) {
	    if (this._isExecuting) {
	        throw new Error('Action is already dispatched');
	    }
	    var self = this;
	    this._handlers = handlers;
	    this._isExecuting = true;
	    this._isCompleted = {};
	    Object.keys(handlers).forEach(function handlersEach(storeName) {
	        self._callHandler(storeName);
	    });
	};
	
	/**
	 * Calls an individual store's handler function
	 * @method _callHandler
	 * @param {String} storeName
	 * @private
	 * @throws {Error} if handler does not exist for storeName
	 */
	Action.prototype._callHandler = function callHandler(storeName) {
	    var self = this,
	        handlerFn = self._handlers[storeName];
	    if (!handlerFn) {
	        throw new Error(storeName + ' does not have a handler for action ' + self.name);
	    }
	    if (self._isCompleted[storeName]) {
	        return;
	    }
	    self._isCompleted[storeName] = false;
	    debug('executing handler for ' + storeName);
	    handlerFn(self.payload, self.name);
	    self._isCompleted[storeName] = true;
	};
	
	/**
	 * Waits until all stores have finished handling an action and then calls
	 * the callback
	 * @method waitFor
	 * @param {String|String[]|Constructor|Constructor[]} stores An array of stores as strings or constructors to wait for
	 * @param {Function} callback Called after all stores have completed handling their actions
	 * @throws {Error} if the action is not being executed
	 */
	Action.prototype.waitFor = function waitFor(stores, callback) {
	    var self = this;
	    if (!self._isExecuting) {
	        throw new Error('waitFor called even though there is no action being executed!');
	    }
	    if (!Array.isArray(stores)) {
	        stores = [stores];
	    }
	
	    debug('waiting on ' + stores.join(', '));
	    stores.forEach(function storesEach(storeName) {
	        storeName = self.getStoreName(storeName);
	        if (self._handlers[storeName]) {
	            self._callHandler(storeName);
	        }
	    });
	
	    callback();
	};
	
	module.exports = Action;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var Action = __webpack_require__(241);
	var DEFAULT = 'default';
	var debug = __webpack_require__(8)('Dispatchr:DispatcherContext');
	
	/**
	 * @class Dispatcher
	 * @param {Object} context The context to be used for store instances
	 * @constructor
	 */
	function DispatcherContext (dispatcher, context) {
	    this.dispatcher = dispatcher;
	    this.storeInstances = {};
	    this.currentAction = null;
	    this.dispatcherInterface = {
	        getContext: function getContext() { return context; },
	        getStore: this.getStore.bind(this),
	        waitFor: this.waitFor.bind(this)
	    };
	}
	
	/**
	 * Returns a single store instance and creates one if it doesn't already exist
	 * @method getStore
	 * @param {String} name The name of the instance
	 * @returns {Object} The store instance
	 * @throws {Error} if store is not registered
	 */
	DispatcherContext.prototype.getStore = function getStore(name) {
	    var storeName = this.dispatcher.getStoreName(name);
	    if (!this.storeInstances[storeName]) {
	        var Store = this.dispatcher.stores[storeName];
	        if (!Store) {
	            throw new Error('Store ' + storeName + ' was not registered.');
	        }
	        this.storeInstances[storeName] = new (this.dispatcher.stores[storeName])(this.dispatcherInterface);
	    }
	    return this.storeInstances[storeName];
	};
	
	/**
	 * Dispatches a new action or queues it up if one is already in progress
	 * @method dispatch
	 * @param {String} actionName Name of the action to be dispatched
	 * @param {Object} payload Parameters to describe the action
	 * @throws {Error} if store has handler registered that does not exist
	 */
	DispatcherContext.prototype.dispatch = function dispatch(actionName, payload) {
	    if (!actionName) {
	        throw new Error('actionName parameter `' + actionName + '` is invalid.');
	    }
	    if (this.currentAction) {
	        throw new Error('Cannot call dispatch while another dispatch is executing. Attempted to execute \'' + actionName + '\' but \'' + this.currentAction.name + '\' is already executing.');
	    }
	    var actionHandlers = this.dispatcher.handlers[actionName] || [],
	        defaultHandlers = this.dispatcher.handlers[DEFAULT] || [];
	    if (!actionHandlers.length && !defaultHandlers.length) {
	        debug(actionName + ' does not have any registered handlers');
	        return;
	    }
	    debug('dispatching ' + actionName, payload);
	    this.currentAction = new Action(actionName, payload);
	    var self = this,
	        allHandlers = actionHandlers.concat(defaultHandlers),
	        handlerFns = {};
	
	    try {
	        allHandlers.forEach(function actionHandlersEach(store) {
	            if (handlerFns[store.name]) {
	                // Don't call the default if the store has an explicit action handler
	                return;
	            }
	            var storeInstance = self.getStore(store.name);
	            if ('function' === typeof store.handler) {
	                handlerFns[store.name] = store.handler.bind(storeInstance);
	            } else {
	                if (!storeInstance[store.handler]) {
	                    throw new Error(store.name + ' does not have a method called ' + store.handler);
	                }
	                handlerFns[store.name] = storeInstance[store.handler].bind(storeInstance);
	            }
	        });
	        this.currentAction.execute(handlerFns);
	    } catch (e) {
	        throw e;
	    } finally {
	        debug('finished ' + actionName);
	        this.currentAction = null;
	    }
	};
	
	/**
	 * Returns a raw data object representation of the current state of the
	 * dispatcher and all store instances. If the store implements a shouldDehdyrate
	 * function, then it will be called and only dehydrate if the method returns `true`
	 * @method dehydrate
	 * @returns {Object} dehydrated dispatcher data
	 */
	DispatcherContext.prototype.dehydrate = function dehydrate() {
	    var self = this,
	        stores = {};
	    Object.keys(self.storeInstances).forEach(function storeInstancesEach(storeName) {
	        var store = self.storeInstances[storeName];
	        if (!store.dehydrate || (store.shouldDehydrate && !store.shouldDehydrate())) {
	            return;
	        }
	        stores[storeName] = store.dehydrate();
	    });
	    return {
	        stores: stores
	    };
	};
	
	/**
	 * Takes a raw data object and rehydrates the dispatcher and store instances
	 * @method rehydrate
	 * @param {Object} dispatcherState raw state typically retrieved from `dehydrate`
	 *      method
	 */
	DispatcherContext.prototype.rehydrate = function rehydrate(dispatcherState) {
	    var self = this;
	    if (dispatcherState.stores) {
	        Object.keys(dispatcherState.stores).forEach(function storeStateEach(storeName) {
	            var state = dispatcherState.stores[storeName],
	                store = self.getStore(storeName);
	            if (store.rehydrate) {
	                store.rehydrate(state);
	            }
	        });
	    }
	};
	
	/**
	 * Waits until all stores have finished handling an action and then calls
	 * the callback
	 * @method waitFor
	 * @param {String|String[]} stores An array of stores as strings to wait for
	 * @param {Function} callback Called after all stores have completed handling their actions
	 * @throws {Error} if there is no action dispatching
	 */
	DispatcherContext.prototype.waitFor = function waitFor(stores, callback) {
	    if (!this.currentAction) {
	        throw new Error('waitFor called even though there is no action dispatching');
	    }
	    this.currentAction.waitFor(stores, callback);
	};
	
	module.exports = DispatcherContext;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	//@TODO(next minor) remove this file
	var FluxibleComponent = __webpack_require__(218);
	
	if ('production' !== process.env.NODE_ENV) {
	    var deprecateComponent = __webpack_require__(244);
	    FluxibleComponent = deprecateComponent(
	        FluxibleComponent,
	        "require('fluxible').FluxibleComponent has been moved out of the " +
	        "default exports for Fluxible. Please use " +
	        "require('fluxible/addons/FluxibleComponent') instead."
	    );
	}
	
	module.exports = FluxibleComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {/**
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var React = __webpack_require__(11);
	
	/**
	 * Deprecates a component by logging a warning message when used
	 * @method deprecateComponent
	 * @param {React.Component} Component component to wrap
	 * @param {string} warningMessage Custom contextTypes to add
	 * @returns {React.Component}
	 */
	module.exports = function deprecateComponent(Component, warningMessage) {
	    var DeprecationComponent = React.createClass({
	        displayName: 'DeprecationComponent',
	
	        componentWillMount: function () {
	            console.warn(warningMessage);
	        },
	
	        render: function () {
	            return React.createElement(Component, this.props);
	        }
	    });
	
	    return DeprecationComponent;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, console) {/**
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	//@TODO(next minor) remove this file
	var FluxibleMixin = __webpack_require__(246);
	
	if ('production' !== process.env.NODE_ENV) {
	    var objectAssign = __webpack_require__(217);
	    FluxibleMixin = objectAssign({}, FluxibleMixin, {
	        componentWillMount: function () {
	            console.warn(
	                "require('fluxible').FluxibleMixin has been moved out of the " +
	                "default exports for Fluxible. Please use " +
	                "require('fluxible/addons/FluxibleMixin') instead."
	            );
	        }
	    });
	}
	
	module.exports = FluxibleMixin;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(1)))

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	/**
	 * React mixin for staticly declaring and add/remove-ing listeners for Store events.
	 * @class FluxibleMixin
	 * @example
	 * // Register listener default handler function name
	 * var Component = React.createClass({
	 *     mixins: [FluxibleMixin],
	 *     statics: {
	 *         storeListeners: [FooStore]
	 *     },
	 *     onChange: function () {
	 *         this.setState(this.context.getStore(FooStore).getState());
	 *     },
	 *     ...
	 * });
	 * @example
	 * // Register listener with custom named handler
	 * var Component = React.createClass({
	 *     mixins: [FluxibleMixin],
	 *     statics: {
	 *         storeListeners: {
	 *             'onChange2': [FooStore]
	 *         }
	 *     },
	 *     onChange2: function () {
	 *         this.setState(this.context.getStore(FooStore).getState());
	 *     },
	 *     ...
	 * });
	 */
	var DEFAULT_CHANGE_HANDLER = 'onChange';
	var React = __webpack_require__(11);
	
	var FluxibleMixin = {
	
	    contextTypes: {
	        getStore: React.PropTypes.func,
	        executeAction: React.PropTypes.func
	    },
	
	    /**
	     * Registers staticly declared listeners
	     * @method componentDidMount
	     */
	    componentDidMount: function componentDidMount() {
	        this.listeners = [];
	        var self = this;
	
	        // Register static listeners
	        this.getListeners().forEach(function(listener) {
	            self._attachStoreListener(listener);
	        });
	    },
	
	    /**
	     * Calls an action
	     * @method executeAction
	     */
	    executeAction: function executeAction() {
	        var context = this.props.context || this.context;
	        if (!context || !context.executeAction) {
	            throw new Error('executeAction was called but no context was provided. Pass the fluxible' +
	            'context via a `context` prop or via React\'s context.');
	        }
	        return context.executeAction.apply(context, arguments);
	    },
	
	    /**
	     * Gets a store instance from the context
	     * @param {Function|String} store The store to get
	     * @returns {Object}
	     * @method getStore
	     */
	    getStore: function (store) {
	        var storeInstance = store;
	        if ('object' !== typeof storeInstance) {
	            var context = this.props.context || this.context;
	            if (!context) {
	                throw new Error('storeListener mixin was called but no context was provided for getting the store.' +
	                'Pass the fluxible context via a `context` prop or via React\'s context.');
	            }
	            storeInstance = context.getStore(store);
	        }
	        return storeInstance;
	    },
	
	    /**
	     * Gets from the context all store instances required by this component
	     * @returns {Object}
	     * @method getStores
	     */
	    getStores: function() {
	        var storesByName = this.getListeners().reduce(function (accum, listener) {
	            accum[listener.store.constructor.storeName] = listener.store;
	            return accum;
	        }, {});
	        return Object.keys(storesByName).map(function(storeName) {
	            return storesByName[storeName];
	        });
	    },
	
	    /**
	     * Gets a store-change handler from the component
	     * @param {Function|String} handler The handler to get
	     * @returns {Function}
	     * @method getHandler
	     */
	    getHandler: function (handler) {
	        if ('string' === typeof handler) {
	            handler = this[handler];
	        }
	
	        if (!handler) {
	            throw new Error('storeListener attempted to add undefined handler. Make sure handlers are actually exist.');
	        }
	
	        return handler;
	    },
	
	    /**
	     * Gets a listener descriptor for a store and store-change handler
	     * @param {Function|String} store Store
	     * @param {Function|String} handler The handler function or method name
	     * @returns {Object}
	     * @method getListener
	     */
	    getListener: function(store, handler) {
	        handler = this.getHandler(handler);
	        var storeInstance = this.getStore(store);
	
	        return {
	            store: storeInstance,
	            handler: handler
	        };
	    },
	
	    /**
	     * Gets all store-change listener descriptors from the component
	     * @returns {Object}
	     * @method getListeners
	     */
	    getListeners: function() {
	        var self = this;
	        var storeListeners = self.constructor.storeListeners; // Static property on component
	
	        // get static listeners
	        if (storeListeners) {
	            if (Array.isArray(storeListeners)) {
	                return storeListeners.map(function(store) {
	                    return self.getListener(store, DEFAULT_CHANGE_HANDLER);
	                });
	            } else {
	                return Object.keys(storeListeners).reduce(function (accum, handlerName) {
	                    var stores = storeListeners[handlerName];
	                    if (!Array.isArray(stores)) {
	                        stores = [stores];
	                    }
	                    return accum.concat(stores.map(function (store) {
	                        return self.getListener(store, handlerName);
	                    }));
	                }, []);
	            }
	        }
	
	        return [];
	    },
	
	    /**
	     * If provided with events, will attach listeners to events on EventEmitter objects(i.e. Stores)
	     * If the component isn't mounted, events aren't attached.
	     * @param {Object} listener
	     * @param {Object} listener.store Store instance
	     * @param {Object} listener.handler Handler function or method name
	     * @method _attachStoreListener
	     * @private
	     */
	    _attachStoreListener: function _attachStoreListener(listener) {
	        if (this.isMounted && !this.isMounted()) {
	            throw new Error('storeListener mixin called listen when component wasn\'t mounted.');
	        }
	
	        listener.store.addChangeListener(listener.handler);
	        this.listeners.push(listener);
	    },
	
	    /**
	     * Removes all listeners
	     * @method componentWillUnmount
	     */
	    componentWillUnmount: function componentWillUnmount() {
	        this.listeners.forEach(function (listener) {
	            listener.store.removeChangeListener(listener.handler);
	        });
	        this.listeners = [];
	    }
	};
	
	module.exports = FluxibleMixin;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Router = __webpack_require__(166);
	var Route = Router.Route;
	var DefaultRoute = Router.DefaultRoute;
	var handlers = {
	    Application: __webpack_require__(248),
	    Home: __webpack_require__(250),
	    Scoreboard: __webpack_require__(341),
	    Gamecast: __webpack_require__(375)
	};
	
	var routes = React.createElement(
	    Route,
	    { name: 'app', path: '/?', handler: handlers.Application },
	    React.createElement(Route, { name: 'gamecast', handler: handlers.Gamecast }),
	    React.createElement(Route, { name: 'scoreboard', path: ':league/scoreboard?', handler: handlers.Scoreboard }),
	    React.createElement(Route, { name: 'match', path: '/rugby/:section/?', handler: handlers.Gamecast }),
	    React.createElement(DefaultRoute, { name: 'home', handler: handlers.Gamecast })
	);
	
	module.exports = routes;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	var Router = __webpack_require__(166);
	var Link = __webpack_require__(166).Link;
	var FluxibleMixin = __webpack_require__(246);
	var RouteHandler = __webpack_require__(166).RouteHandler;
	var Navbar = __webpack_require__(249);
	
	var Application = React.createClass({
	    displayName: 'Application',
	
	    mixins: [Router.State, FluxibleMixin],
	
	    getInitialState: function getInitialState() {
	        return {};
	    },
	
	    onChange: function onChange() {},
	
	    render: function render() {
	
	        // Query params to test app w/o ESPN shell
	        var nav = React.createElement(Navbar, null);
	        var query = this.getQuery();
	        var shell = query.shell || 'true';
	        if (shell === 'true' && !window.__noShell) {
	            nav = null;
	        }
	
	        return React.createElement(
	            'div',
	            null,
	            nav,
	            React.createElement(RouteHandler, { shell: nav ? false : true, context: this.props.context }),
	            React.createElement('div', { dangerouslySetInnerHTML: { __html: "<style>*{-webkit-tap-highlight-color: rgba(0,0,0,0)}*:focus{outline:none}</style>" } })
	        );
	    }
	});
	
	module.exports = Application;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	var React = __webpack_require__(11);
	var Link = __webpack_require__(166).Link;
	
	var Navbar = React.createClass({
	    displayName: 'Navbar',
	
	    getInitialState: function getInitialState() {
	        return {};
	    },
	    onChange: function onChange() {},
	    render: function render() {
	        var spacers = React.createElement(
	            'span',
	            null,
	            ' | '
	        );
	
	        return React.createElement(
	            'nav',
	            null,
	            React.createElement(
	                Link,
	                { to: '/', 'data-route': 'false' },
	                'Home'
	            ),
	            spacers,
	            React.createElement(
	                Link,
	                { to: '/rugby/match?gameId=267953&league=267979', 'data-route': 'false' },
	                'Match'
	            ),
	            spacers,
	            React.createElement(
	                Link,
	                { to: '/rugby/report?gameId=267953&league=267979', 'data-route': 'false' },
	                'Report'
	            ),
	            spacers,
	            React.createElement(
	                Link,
	                { to: '/rugby/match?gameId=276525&league=242041&iaas=true', 'data-route': 'false' },
	                '[ Match IAAS API\'s ]'
	            ),
	            spacers,
	            React.createElement(
	                Link,
	                { to: '/rugby/match?gameId=267951&league=267979&useqa=true', 'data-route': 'false' },
	                '[ Match QA API\'s ]'
	            ),
	            spacers,
	            React.createElement(
	                Link,
	                { to: '/football/scoreboard', 'data-route': 'false' },
	                'Football Scoreboard'
	            ),
	            spacers,
	            React.createElement(
	                Link,
	                { to: '/rugby/scoreboard', 'data-route': 'false' },
	                'Rugby Scoreboard'
	            )
	        );
	    }
	});
	module.exports = Navbar;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	var React = __webpack_require__(11);
	var Router = __webpack_require__(166);
	var ESPNhelpersMixin = __webpack_require__(251);
	
	var Home = React.createClass({
	    displayName: 'Home',
	    mixins: [Router.State, ESPNhelpersMixin],
	    getInitialState: function getInitialState() {
	        return {};
	    },
	    onChange: function onChange() {},
	    render: function render() {
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'p',
	                null,
	                'Welcome to the awesome rugby site!'
	            )
	        );
	    }
	});
	
	module.exports = Home;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var browser = __webpack_require__(252);
	var appConfig = __webpack_require__(206);
	var Path = __webpack_require__(253);
	var moment = __webpack_require__(254);
	var config = {
	    animationTimeout: 750, //ms,
	    containerSelector: '#' + appConfig.uid,
	    adPlaceholderSelector: '.react-ad'
	};
	
	function endLoadProgress() {
	    setTimeout(function () {
	        browser.call('espn_ui.Helpers.load_progress.stop');
	    }, config.animationTimeout);
	}
	
	function capitalizeFirstLetter(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	/**
	 * Updates Page Meta Data
	 * @param  {Object} meta
	 */
	function updateMetaData(meta) {
	    var title = meta.title;
	    var description = meta.description;
	    var keywords = meta.keywords;
	    var root = meta.root;
	    var label = meta.label;
	    try {
	        jQuery("title").html(title);
	        jQuery('meta[property="og:title"]').attr("content", title);
	        jQuery('meta[name="twitter:title"]').attr("content", title);
	
	        jQuery('meta[name="description"]').attr("content", description);
	        jQuery('meta[property="og:description"]').attr("content", description);
	        jQuery('meta[name="twitter:description"]').attr("content", description);
	
	        jQuery('meta[name="keywords"]').attr("content", keywords);
	        if (root && label) {
	            jQuery('meta[name="root"]').attr("content", root);
	            jQuery('meta[name="label"]').attr("content", label);
	        } else {
	            jQuery('meta[name="root"]').attr("content", null);
	            jQuery('meta[name="label"]').attr("content", null);
	        }
	    } catch (e) {}
	}
	
	/**
	 * Generates a Meta Data object
	 * TODO: Use logic from Tea templates
	 * @param  {String} sport  
	 * @param  {String} page  
	 * @param  {Object} meta
	 * @return {Object}       
	 */
	function generateMetaData(sport, page, meta) {
	
	    meta = meta || {};
	
	    var league = meta.leagueName || '';
	    var metaHash = {
	        scoreboard: {
	            title: function title() {
	                return meta.title || (league ? league + ' ' : '') + 'Rugby Scores - ' + league + ' Scoreboard - ESPN';
	            },
	            description: function description() {
	                return meta.description || "Real-time " + league + " Rugby scores on ESPN.com.";
	            }
	        },
	        match: {
	            title: function title() {
	                var home = meta.home || '';
	                var away = meta.away || '';
	                var vs = ' vs ';
	                var activeTab = '- ' + getSEOString(meta.activeTab);
	                var league = '- ' + (meta.league || '');
	                var date = ' - ' + (moment(meta.date).format("MMMM Do, YYYY") || '');
	                var suffix = ' - ESPN UK';
	                return [home, vs, away, activeTab, league + date + suffix].join(' ');
	            },
	            description: function description() {
	                var prefix = getSEODescriptonPrefix(meta.activeTab);
	                return prefix + " " + (meta.home || '') + " vs " + (meta.away || '') + " " + (meta.league || '') + " rugby match.";
	            }
	        }
	    };
	
	    function getSEODescriptonPrefix(activeTab) {
	        var str = "Follow live coverage of the";
	        switch (activeTab) {
	            case 'commentary':
	                str = 'Follow commentary of the';
	                break;
	            case 'matchstats':
	                str = 'Get comprehensive statistics for the';
	                break;
	            case 'playerstats':
	                str = 'Get player statistics for the';
	                break;
	            case 'lineups':
	                str = 'Get Line-ups for the';
	                break;
	            case 'conversation':
	                str = 'Join the conversation around the';
	                break;
	        }
	        return str;
	    }
	
	    function getSEOString(str) {
	        str = str || 'Summary';
	
	        switch (str) {
	            case 'matchstats':
	                str = 'Match Statistics';
	                break;
	            case 'playerstats':
	                str = 'Player Statistics';
	                break;
	            case 'lineups':
	                str = 'Line-up';
	                break;
	        }
	        return capitalizeFirstLetter(str);
	    }
	
	    var matchTypes = {
	        'match': 'gamepackage',
	        'summary': 'gamepackage',
	        'matchstats': 'gamepackage',
	        'playerstats': 'gamepackage',
	        'conversation': 'gamepackage',
	        'lineups': 'gamepackage',
	        'commentary': 'gamepackage'
	    };
	
	    var type = matchTypes[page] || page;
	    var pageType = matchTypes[page] ? 'match' : page;
	
	    return {
	        type: type,
	        title: metaHash[pageType].title(),
	        description: metaHash[pageType].description(),
	        keywords: "ESPN, ESPNscrum, ESPN rugby, scrum, rugby, news, results, rugby world cup, rugby union, rugby, rugby rules, rugby history, rugby photos, rugby pictures, live rugby scores, rugby tickets"
	    };
	}
	
	/**
	 * Loops through all ad placeholders
	 * having class `react-ad` and initializes them
	 * @return {undefined}
	 */
	function initAds() {
	    try {
	        var ads = jQuery(config.adPlaceholderSelector);
	        for (var i = 0, len = ads.length; i < len; i++) {
	            admgr.initSlot(ads[i], espn.ads.config);
	        }
	    } catch (e) {}
	}
	
	/**
	 * Updates container classNames
	 * @param  {Object} React component
	 */
	function updateClassNames(component) {
	    var classNames = {
	        'ScoreboardHandler': {
	            add: [],
	            remove: ['page-container']
	        },
	        Standings: {
	            add: ['page-container'],
	            remove: []
	        },
	        Home: {
	            add: ['page-container'],
	            remove: []
	        },
	        Gamecast: {
	            add: [],
	            remove: ['page-container']
	        }
	    };
	    try {
	        jQuery(config.containerSelector).addClass(classNames[component.constructor.displayName].add.join(' ')).removeClass(classNames[component.constructor.displayName].remove.join(' '));
	    } catch (e) {}
	}
	
	/**
	 * Updates History state
	 * @param  {Object} meta
	 */
	function updateHistoryState(meta, page) {
	    try {
	        var content = {
	            html: '<div class="main-content layout-bc"><div id="reactApp"></div></div>'
	        };
	        espn_ui.Helpers.history.updateState("url", location.href);
	        espn_ui.Helpers.history.updateState("router", "react-router");
	        espn_ui.Helpers.history.updateState("meta", meta);
	        espn_ui.Helpers.history.updateState("content", content);
	        if (page == 'scoreboard') {
	            espn_ui.Helpers.history.updateState("customStyleSheet", 'scoreboards-rugby');
	        }
	    } catch (e) {}
	}
	
	/**
	 * Updates Navigation based on sport and page
	 * @param  {String} sport
	 */
	function updateNavigation(sport) {
	    try {
	        jQuery('body').attr('data-sport', sport);
	        espn_ui.Helpers.page.setContext(sport);
	        jQuery(document).trigger('nav.sportChange');
	    } catch (e) {}
	}
	
	/**
	 * Callback to be called after route render
	 */
	function postRouteRender() {
	    try {
	        var pathname = this.context.router.getCurrentPathname();
	        var request = Path.decode(pathname);
	
	        if (request.page && request.sport) {
	            var page = request.page;
	            var sport = request.sport;
	            var meta;
	
	            if (page === 'fixtures') {
	                page = 'schedule';
	            } else if (page === 'table') {
	                page = 'standings';
	            }
	
	            meta = generateMetaData(request.sport, page, this._meta);
	
	            updateNavigation(sport);
	            updateHistoryState(meta, page);
	            updateMetaData(meta || history.state.meta);
	        }
	    } catch (e) {}
	}
	
	module.exports = {
	    componentDidMount: function componentDidMount() {
	        updateClassNames(this);
	        endLoadProgress();
	    },
	    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	        endLoadProgress();
	    },
	    componentWillMount: function componentWillMount() {
	        postRouteRender.call(this);
	    },
	    componentWillUpdate: function componentWillUpdate() {
	        // TODO: Reset ad container if it mutates
	        postRouteRender.call(this);
	    },
	    _meta: {
	        leagueName: '',
	        description: '',
	        title: ''
	    }
	};

/***/ },
/* 252 */
/***/ function(module, exports) {

	/* jshint node:true */
	
	/**
	 * browser.js
	 * A small utility to interact with the browser APIs
	 * @author: Nihar Kabinittal
	 */
	
	/**
	 * Gets a particular key / variable
	 * from a given path in an Object
	 * @param  {String} path
	 * @param  {Object} scope
	 * @return       
	 */
	'use strict';
	
	function get(path, scope) {
	    try {
	        var cur = scope || window;
	        var parts = path.split('.');
	
	        for (var part; parts.length && (part = parts.shift());) {
	            if (!parts.length || cur[part]) {
	                cur = cur[part] || null;
	            }
	        }
	        return cur;
	    } catch (e) {}
	    return null;
	}
	
	/**
	 * Sets a property to an Object
	 * @param {String} path  Path of the Object
	 * @param {String} prop  Property to be set
	 * @param value to be set
	 */
	function set(path, prop, value) {
	    try {
	        var cur = get(path);
	        cur[prop] = value;
	        return cur[prop];
	    } catch (e) {}
	    return false;
	}
	
	/**
	 * Executes the method with a set of arguments
	 * @param  {String} path Path to the method
	 * @param  {Array} args Arguments to be passed
	 * @return {Function/Boolean}      True if function executes
	 */
	function call(path, args) {
	    try {
	        var cur = get(path);
	        if (typeof cur === 'function') {
	            return cur.apply(this, args);
	        }
	    } catch (e) {}
	    return false;
	}
	
	/**
	 * Expose the module
	 * @type {Object}
	 */
	module.exports = {
	    get: get,
	    set: set,
	    call: call
	};

/***/ },
/* 253 */
/***/ function(module, exports) {

	/*
	    Action:     manipulates the URL for espn.com
	    Orginator:  ben.hobden@espn.com
	*/
	
	'use strict';
	
	var rootIndexToSport = {
	    'nba': 'basketball',
	    'womenbb': 'basketball',
	    'sports/womenbb': 'basketball',
	    'ncb': 'basketball',
	    'nfl': 'football',
	    'ncf': 'football',
	    'nhl': 'hockey',
	    'mlb': 'baseball',
	    'atp': 'tennis',
	    'wtp': 'tennis',
	    'tennis': 'tennis',
	    'pga': 'golf',
	    'golf': 'golf',
	    'rpm': 'racing',
	    'football': 'soccer',
	    'soccer': 'soccer',
	    'rugby': 'rugby',
	    'college-sports': 'ncaa'
	};
	
	var rootIndexToLeague = {
	    'womenbb': 'wnba',
	    'sports/womenbb': 'wnba',
	    'ncf': 'college-football',
	    'ncb': 'mens-college-basketball',
	    'ncw': 'womens-college-basketball',
	    'tennis': 'atp',
	    'golf': 'pga',
	    'rpm': 'sprint',
	    'soccer': 'eng.1',
	    'rugby': '231649',
	    'college-sports': 'ncaa'
	};
	
	var Path = {
	
	    encode: function encode(sBaseUrl, oParams, oDefaults) {
	
	        /* remove any unwanted slashes */
	        sBaseUrl = sBaseUrl.replace(/^\/|\/$/g, '');
	
	        /* loop each param */
	        var aUrl = [],
	            sUrl = '/' + sBaseUrl;
	
	        for (var sKey in oParams) {
	            if (typeof oDefaults[sKey] !== undefined && oDefaults[sKey] === oParams[sKey] || !oParams[sKey]) {
	                //if(sKey === 'dir'){
	                /* special case for sort due to being tied to direction */
	                //    if(typeof oParams['sort'] !== undefined && typeof oDefaults['sort'] !== undefined && oDefaults['sort'] === oParams['sort']){
	                //        continue;
	                //    }
	                //}else{
	                continue; /* this is a default value so no need for it */
	                //}
	            }
	            aUrl.push(sKey);
	            aUrl.push(oParams[sKey]);
	        }
	
	        if (aUrl.length > 0) {
	            sUrl = sUrl + '/_/' + aUrl.join('/');
	        }
	
	        return sUrl;
	    },
	
	    /**
	    * Deconstruct the url to determine what the user wanted
	    **/
	    decode: function decode(sPath, oParams) {
	
	        /* remove the params */
	        var aUrl = decodeURIComponent(sPath).split(/\?(.*)/);
	        var aPath = aUrl[0].split(/\/_\//);
	
	        /* default it to an object */
	        oParams = oParams || {};
	
	        /* remove unwanted slashes*/
	        if (typeof aPath[0] !== "undefined") {
	            aPath[0] = aPath[0].replace(/^\/|\/$/g, '');
	        } else {
	            aPath[0] = "";
	        }
	
	        if (typeof aPath[1] !== "undefined") {
	            aPath[1] = aPath[1].replace(/^\/|\/$/g, '');
	        } else {
	            aPath[1] = "";
	        }
	
	        var aSport = aPath[0].split(/\//);
	        var aParams = aPath[1].split(/\//);
	        var sRoot = aSport[0] || null;
	        var sPage = aSport[1] || null;
	
	        /* TODO validate sport */
	
	        /* split the last section into key value pairs  */
	        var iLim = aParams.length;
	        for (var i = 0; i < iLim; i = i + 2) {
	            if (aParams[i] === '') {
	                continue;
	            }
	            oParams[aParams[i]] = aParams[i + 1] || null;
	        }
	
	        /* determine sport and league */
	        var sCurrSport = this._rootToSport(sRoot);
	        var sCurrLeague = oParams.league || this._sportToLeague(sCurrSport) || sRoot;
	
	        var oReturn = {
	            'root': sRoot,
	            'page': sPage,
	            'sport': sCurrSport,
	            'league': sCurrLeague,
	            'isCollege': this._isCollege(sCurrLeague),
	            'params': oParams
	        };
	
	        //console.log(oReturn);
	
	        return oReturn;
	    },
	
	    _isCollege: function _isCollege(sLeague) {
	        if (sLeague == 'ncf' || sLeague == 'ncb' || sLeague == 'ncw') {
	            return true;
	        }
	        return false;
	    },
	
	    _rootToSport: function _rootToSport(sRoot) {
	        return rootIndexToSport[sRoot] || '';
	    },
	
	    _sportToLeague: function _sportToLeague(sSport) {
	        return rootIndexToLeague[sSport];
	    }
	
	};
	
	module.exports = Path;

/***/ },
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var debug = __webpack_require__(8)('app:component:Scoreboard');
	var React = __webpack_require__(11);
	var Router = __webpack_require__(166);
	var StoreMixin = __webpack_require__(246);
	var ESPNhelpersMixin = __webpack_require__(251);
	var loadScoreboard = __webpack_require__(342);
	var Path = __webpack_require__(253);
	var Utils = __webpack_require__(346);
	var browser = __webpack_require__(252);
	var ScoreBoard = __webpack_require__(353);
	var pollInterval = 30000;
	
	var ScoreboardHandler = React.createClass({
	
	    displayName: 'ScoreboardHandler',
	
	    mixins: [Router.State, StoreMixin, ESPNhelpersMixin],
	
	    statics: {
	        loadAction: loadScoreboard,
	        storeListeners: ['ScoreboardStore', 'HomeStore']
	    },
	
	    componentDidMount: function componentDidMount() {},
	
	    getInitialState: function getInitialState() {
	        return this.getStateFromStores();
	    },
	
	    getStateFromStores: function getStateFromStores() {
	        var scoreBoardStore = this.props.context.getStore('ScoreboardStore');
	        var homeStore = this.props.context.getStore('HomeStore');
	        var rightColumn = homeStore.getColumn('rightcolumn');
	        var scoreboard = scoreBoardStore.getScoreboard();
	        var rhs = {
	            rhs: {
	                modules: rightColumn.items
	            }
	        };
	        var leagueName;
	        if (scoreboard.aggregated) {
	            leagueName = '';
	        } else {
	            leagueName = scoreboard.leagues[0].name;
	        }
	        this._meta.leagueName = leagueName;
	        return Utils.Object.assign(scoreboard, rhs);
	    },
	
	    onChange: function onChange(store) {
	        this.setState(this.getStateFromStores());
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.timer = setInterval(this.poll, pollInterval);
	    },
	
	    timer: null,
	
	    poll: function poll() {
	        var self = this;
	        if (location.pathname + location.search === self.getPath()) {
	            self.props.context.executeAction(loadScoreboard, {
	                pathname: self.getPathname(),
	                query: self.getQuery(),
	                ignoreRHS: true,
	                ignoreLeagues: true
	            });
	        } else {
	            clearInterval(self.timer);
	            self.timer = null;
	        }
	    },
	
	    render: function render() {
	
	        var props = {
	            request: Path.decode(this.getPathname()),
	            leagues: this.state.leagues,
	            aggregated: this.state.aggregated,
	            formattedDates: this.state.formattedDates,
	            context: this.props.context,
	            rhs: this.state.rhs,
	            shell: this.props.shell
	        };
	
	        return React.createElement(ScoreBoard, props);
	    }
	});
	
	module.exports = ScoreboardHandler;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var debug = __webpack_require__(8)('app:action:loadScoreboard');
	var loadLeagues = __webpack_require__(343);
	var loadHome = __webpack_require__(345);
	var moment = __webpack_require__(254);
	var Path = __webpack_require__(253);
	var apiHost = __webpack_require__(344);
	//var rugbyAPIHost = 'http://site.api.espn.com';
	
	module.exports = function (context, payload, _done) {
	
	    debug('loading scoreboard %s', JSON.stringify([payload]));
	
	    var query = payload.query || {};
	    var league = query.league || 'eng.1';
	    var dates = query.date ? query.date : null;
	    var request = Path.decode(payload.pathname, payload.query);
	    var url = '';
	    var sAPIHost = apiHost.get(payload);
	
	    if (!payload.ignoreLeagues) {
	        context.executeAction(loadLeagues, { sport: request.sport });
	    }
	
	    // TODO: Add condition to exec this action only for Rugby scoreboard - 3rd column
	    if (!payload.ignoreRHS) {
	        context.executeAction(loadHome, payload);
	    }
	
	    // TODO: add cleaner way to build query params
	    if (request.sport === 'rugby') {
	        if (payload && payload.query && (payload.query.league || payload.query.date)) {
	            var rugbyLeague = payload.query.league;
	            url = sAPIHost + '/apis/site/v2/sports/rugby/' + (rugbyLeague ? rugbyLeague + '/' : '') + (rugbyLeague ? 'scoreboard' : 'scorepanel') + (payload.query.date ? '?dates=' + payload.query.date : '');
	        } else {
	            // TODO: remove the dates param (currently being used as the API throws an error without it)
	            url = sAPIHost + '/apis/site/v2/sports/rugby/scorepanel';
	        }
	    } else {
	        url = sAPIHost + '/apis/site/v2/sports/' + request.sport + '/' + request.league + '/scoreboard?calendartype=whitelist&&foo' + (dates ? '&dates=' + dates : '');
	    }
	
	    context.service.get({
	        url: url,
	        done: function done(data) {
	            data.sport = request.sport;
	            context.dispatch('RECEIVED_SCOREBOARD', data);
	            _done();
	        }
	    });
	};

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var debug = __webpack_require__(8)('app:action:loadLeagues');
	var apiHost = __webpack_require__(344);
	
	module.exports = function (context, payload, _done) {
	
	    /* build api based on sport */
	    var sAPIHost = apiHost.get(payload);
	    var sUrl = sAPIHost + '/apis/site/v2/leagues/dropdown';
	    var aApiParams = [];
	
	    if (payload.sport === 'soccer') {
	        aApiParams.push('ceId=' + 12032789);
	    } else {
	        aApiParams.push('sport=' + payload.sport);
	    }
	
	    /* add params if found */
	    if (aApiParams.length > 0) {
	        sUrl = sUrl + '?' + aApiParams.join('&');
	    }
	
	    debug('sUrl %s', sUrl);
	
	    context.service.get({
	        url: sUrl,
	        done: function done(data) {
	
	            var oData = {
	                data: data
	            };
	
	            context.dispatch('RECEIVED_LEAGUES', oData);
	            _done();
	        }
	    });
	};

/***/ },
/* 344 */
/***/ function(module, exports) {

	/* jshint node:true */
	
	/**
	 * Single point to return API host for data requests to enable
	 * @return {Object}     Utility functions to get and modify API host
	**/
	
	'use strict';
	
	var liveAPIHost = 'http://site.api.espn.com',
	    qaAPIHost = 'http://site.api.qa.espn.com',
	    iaasAPIHost = 'http://10.42.47.50:9003';
	//iaasAPIHost2    = 'http://10.42.47.50:9003',
	
	/**
	 * Gets a particular key / variable
	 * from a given path in an Object
	 * @param  {Object} scope
	 * @return
	**/
	function get(payload) {
	
	    if (typeof payload === 'undefined') {
	        payload = {};
	    }
	    if (typeof payload.query === 'undefined') {
	        payload.query = {};
	    }
	
	    var oQuery = payload.query,
	        sHost = liveAPIHost;
	
	    if (oQuery.qa || oQuery.useqa) {
	        sHost = qaAPIHost;
	    } else if (oQuery.iaas) {
	        sHost = iaasAPIHost;
	    }
	
	    return sHost;
	}
	
	module.exports = {
	    get: get
	};

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var debug = __webpack_require__(8)('app:action:loadHome');
	var apiHost = __webpack_require__(344);
	
	module.exports = function (context, payload, _done) {
	
	    debug('loading home %s', JSON.stringify([payload]));
	    var sAPIHost = apiHost.get(payload);
	
	    context.service.get({
	        url: sAPIHost + '/apis/v2/flex?headlinestack=true&insider=false&pubkey=espnuk-en-rugby-index',
	        done: function done(data) {
	            context.dispatch('RECEIVED_HOME', data);
	            _done();
	        }
	    });
	};

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ip = __webpack_require__(347);
	
	/**
	 * Shim for Object.assign
	 * @param  {Object} target
	 * @param  {Object} source
	 * @return {Object}       
	 */
	var assign = Object.assign || function (target, source) {
	    var keys = Object.keys(Object(source));
	    for (var i = 0; i < keys.length; i++) {
	        target[keys[i]] = source[keys[i]];
	    }
	    return target;
	};
	
	/**
	 * Returns the client IP address from request headers
	 * @param  {Object} req Express request object
	 * @return {String}     client IP address
	 */
	function getClientIP(req) {
	    return req.headers['True-Client-IP'] || req.headers['x-forwarded-for'] || req.connection.remoteAddress;
	}
	
	/**
	 * Checks if the IP address is private, ex: 127.0.0.1 etc
	 * @param  {String}  address IP address
	 * @return {Boolean}    private or public
	 */
	function isPrivateIP(address) {
	    return ip.isPrivate(address);
	}
	
	/**
	 * Returns the 3 letter month name
	 * @param  {Number} monthNumber Month number
	 * @return {String}             Month name
	 */
	function getMonthName(monthNumber) {
	    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	    return months[monthNumber || months[0]];
	}
	
	/**
	 * Get .png mugshot of author
	 * If default image url is not a png, then look for the image urls in
	 * peers object. Override default image url If the image width & height
	 * is 70, if image type is 1/2 and if image extension is .png.
	 *
	 * @param  {String} mugshot     Default image url (authors.images[0].url)
	 * @param  {Object} authorImage Images object (authors.images[0])
	 * @return {String}             .png url if found else mugshot
	 */
	function getAuthorMugshot(mugshot, authorImage) {
	    if (mugshot.indexOf('.png') === -1) {
	        //console.log('original mugshot is not png');
	        if (authorImage.hasOwnProperty('peers')) {
	            var allImages = authorImage.peers;
	            for (var i = 0; i < allImages.length; i++) {
	                var imgDetails = allImages[i];
	                var imgDetails_type = imgDetails.type === "1" || imgDetails.type === "2";
	                var imgDetails_png = false;
	                // Check if url key is present and has value, then check if it's a png image
	                if (imgDetails.hasOwnProperty('url') && typeof imgDetails.url === 'string') {
	                    imgDetails_png = imgDetails.url.indexOf('.png') > -1;
	                }
	                if (imgDetails.height === 70 && imgDetails.width === 70 && imgDetails_type && imgDetails_png) {
	                    mugshot = imgDetails.url;
	                    //console.log('mugshot overwritten to', mugshot);
	                }
	            }
	        }
	    }
	    return mugshot;
	}
	
	/**
	 * Find and get the correct story image
	 *
	 * @param  {Object} images Images object (news.images[0])
	 * @return {String/null} image url
	 */
	function getStoryImage(images) {
	    var image = null;
	    if (images.hasOwnProperty('peers')) {
	        var peerImages = images.peers;
	        for (var i = 0; i < peerImages.length; i++) {
	            var imgDetails = peerImages[i];
	            if (imgDetails.width === 900 && imgDetails.type === "4") {
	                image = imgDetails.url;
	            }
	        }
	    }
	    return image;
	}
	
	/**
	 * Get video object's thumbnail url.
	 * For video blogs, If imageUrl is not found, Check if video thumbnail url can
	 * be found.
	 * @param  {Object}     Video object from feed
	 * @return {String/undefined}
	 */
	function getVideoImageUrl(videoObj) {
	    var imageUrl;
	    // Return if video key is missing
	    if (typeof videoObj === 'undefined') {
	        return imageUrl;
	    }
	
	    // Proceed only if videoObj array is not empty
	    if (videoObj.length > 0) {
	        var video = videoObj[0] || {};
	        if (video.hasOwnProperty('thumbnail') && typeof video.thumbnail === 'string') {
	            imageUrl = 'http://a.espncdn.com/combiner/i?img=' + video.thumbnail;
	        }
	    }
	    //console.log('getVideoImageUrl', imageUrl);
	    return imageUrl;
	}
	
	/**
	 * Returns the absolute image url
	 * @param  {String} imgUrl 
	 * @return {String}        
	 */
	function getImageUrl(imgUrl) {
	
	    var isDefaultImage = /espncdn.com\/combiner|default-team-logo-500|PICTURES\/CMS\//.test(imgUrl);
	    var imgPath = '';
	
	    if (!isDefaultImage) {
	        if (imgUrl) {
	            imgPath = imgUrl.split('.com')[1];
	            return "http://a.espncdn.com/combiner/i?img=" + imgPath + "?w=100&amp;h=100&amp;transparent=true";
	        } else {
	            return imgPath;
	        }
	    } else {
	        return imgUrl;
	    }
	}
	
	var utils = {
	    ip: {
	        get: getClientIP,
	        isPrivate: isPrivateIP
	    },
	    date: {
	        getMonthName: getMonthName
	    },
	    blogs: {
	        getStoryImage: getStoryImage,
	        getAuthorMugshot: getAuthorMugshot,
	        getVideoImageUrl: getVideoImageUrl
	    },
	    Object: {
	        assign: assign
	    },
	    getImageUrl: getImageUrl
	};
	
	module.exports = utils;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var ip = exports,
	    Buffer = __webpack_require__(348).Buffer,
	    os = __webpack_require__(352);
	
	ip.toBuffer = function toBuffer(ip, buff, offset) {
	  offset = ~~offset;
	
	  var result;
	
	  if (/^(\d{1,3}\.){3,3}\d{1,3}$/.test(ip)) {
	    result = buff || new Buffer(offset + 4);
	    ip.split(/\./g).map(function(byte) {
	      result[offset++] = parseInt(byte, 10) & 0xff;
	    });
	  } else if (/^[a-f0-9:]+$/.test(ip)) {
	    var s = ip.split(/::/g, 2),
	        head = (s[0] || '').split(/:/g, 8),
	        tail = (s[1] || '').split(/:/g, 8);
	
	    if (tail.length === 0) {
	      // xxxx::
	      while (head.length < 8) head.push('0000');
	    } else if (head.length === 0) {
	      // ::xxxx
	      while (tail.length < 8) tail.unshift('0000');
	    } else {
	      // xxxx::xxxx
	      while (head.length + tail.length < 8) head.push('0000');
	    }
	
	    result = buff || new Buffer(offset + 16);
	    head.concat(tail).map(function(word) {
	      word = parseInt(word, 16);
	      result[offset++] = (word >> 8) & 0xff;
	      result[offset++] = word & 0xff;
	    });
	  } else {
	    throw Error('Invalid ip address: ' + ip);
	  }
	
	  return result;
	};
	
	ip.toString = function toString(buff, offset, length) {
	  offset = ~~offset;
	  length = length || (buff.length - offset);
	
	  var result = [];
	  if (length === 4) {
	    // IPv4
	    for (var i = 0; i < length; i++) {
	      result.push(buff[offset + i]);
	    }
	    result = result.join('.');
	  } else if (length === 16) {
	    // IPv6
	    for (var i = 0; i < length; i += 2) {
	      result.push(buff.readUInt16BE(offset + i).toString(16));
	    }
	    result = result.join(':');
	    result = result.replace(/(^|:)0(:0)*:0(:|$)/, '$1::$3');
	    result = result.replace(/:{3,4}/, '::');
	  }
	
	  return result;
	};
	
	ip.fromPrefixLen = function fromPrefixLen(prefixlen, family) {
	  if (prefixlen > 32) {
	    family = 'ipv6';
	  } else {
	    family = _normalizeFamily(family);
	  }
	
	  var len = 4;
	  if (family === 'ipv6') {
	    len = 16;
	  }
	  var buff = new Buffer(len);
	
	  for (var i = 0, n = buff.length; i < n; ++i) {
	    var bits = 8;
	    if (prefixlen < 8) {
	      bits = prefixlen;
	    }
	    prefixlen -= bits;
	
	    buff[i] = ~(0xff >> bits);
	  }
	
	  return ip.toString(buff);
	};
	
	ip.mask = function mask(addr, mask) {
	  addr = ip.toBuffer(addr);
	  mask = ip.toBuffer(mask);
	
	  var result = new Buffer(Math.max(addr.length, mask.length));
	
	  // Same protocol - do bitwise and
	  if (addr.length === mask.length) {
	    for (var i = 0; i < addr.length; i++) {
	      result[i] = addr[i] & mask[i];
	    }
	  } else if (mask.length === 4) {
	    // IPv6 address and IPv4 mask
	    // (Mask low bits)
	    for (var i = 0; i < mask.length; i++) {
	      result[i] = addr[addr.length - 4  + i] & mask[i];
	    }
	  } else {
	    // IPv6 mask and IPv4 addr
	    for (var i = 0; i < result.length - 6; i++) {
	      result[i] = 0;
	    }
	
	    // ::ffff:ipv4
	    result[10] = 0xff;
	    result[11] = 0xff;
	    for (var i = 0; i < addr.length; i++) {
	      result[i + 12] = addr[i] & mask[i + 12];
	    }
	  }
	
	  return ip.toString(result);
	};
	
	ip.cidr = function cidr(cidrString) {
	  var cidrParts = cidrString.split('/');
	
	  if (cidrParts.length != 2)
	    throw new Error('invalid CIDR subnet: ' + addr);
	
	  var addr = cidrParts[0];
	  var mask = ip.fromPrefixLen(parseInt(cidrParts[1], 10));
	
	  return ip.mask(addr, mask);
	}
	
	ip.subnet = function subnet(addr, mask) {
	  var networkAddress = ip.toLong(ip.mask(addr, mask));
	
	  // Calculate the mask's length.
	  var maskBuffer = ip.toBuffer(mask);
	  var maskLength = 0;
	
	  for (var i = 0; i < maskBuffer.length; i++) {
	    if (maskBuffer[i] == 0xff) {
	      maskLength += 8;
	    } else {
	      var octet = maskBuffer[i] & 0xff;
	      while (octet) {
	        octet = (octet << 1) & 0xff;
	        maskLength++;
	      }
	    }
	  }
	
	  var numberOfAddresses = Math.pow(2, 32 - maskLength);
	
	  return {
	    networkAddress: ip.fromLong(networkAddress),
	    firstAddress: numberOfAddresses <= 2 ?
	                    ip.fromLong(networkAddress) :
	                    ip.fromLong(networkAddress + 1),
	    lastAddress: numberOfAddresses <= 2 ?
	                    ip.fromLong(networkAddress + numberOfAddresses - 1) :
	                    ip.fromLong(networkAddress + numberOfAddresses - 2),
	    broadcastAddress: ip.fromLong(networkAddress + numberOfAddresses - 1),
	    subnetMask: mask,
	    subnetMaskLength: maskLength,
	    numHosts: numberOfAddresses <= 2 ?
	                numberOfAddresses : numberOfAddresses - 2,
	    length: numberOfAddresses
	  };
	}
	
	ip.cidrSubnet = function cidrSubnet(cidrString) {
	  var cidrParts = cidrString.split('/');
	
	  if (cidrParts.length !== 2)
	    throw new Error('invalid CIDR subnet: ' + addr);
	
	  var addr = cidrParts[0];
	  var mask = ip.fromPrefixLen(parseInt(cidrParts[1], 10));
	
	  return ip.subnet(addr, mask);
	}
	
	ip.not = function not(addr) {
	  var buff = ip.toBuffer(addr);
	  for (var i = 0; i < buff.length; i++) {
	    buff[i] = 0xff ^ buff[i];
	  }
	  return ip.toString(buff);
	};
	
	ip.or = function or(a, b) {
	  a = ip.toBuffer(a);
	  b = ip.toBuffer(b);
	
	  // same protocol
	  if (a.length == b.length) {
	    for (var i = 0; i < a.length; ++i) {
	      a[i] |= b[i];
	    }
	    return ip.toString(a);
	
	  // mixed protocols
	  } else {
	    var buff = a;
	    var other = b;
	    if (b.length > a.length) {
	      buff = b;
	      other = a;
	    }
	
	    var offset = buff.length - other.length;
	    for (var i = offset; i < buff.length; ++i) {
	      buff[i] |= other[i - offset];
	    }
	
	    return ip.toString(buff);
	  }
	};
	
	ip.isEqual = function isEqual(a, b) {
	  a = ip.toBuffer(a);
	  b = ip.toBuffer(b);
	
	  // Same protocol
	  if (a.length === b.length) {
	    for (var i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	
	  // Swap
	  if (b.length === 4) {
	    var t = b;
	    b = a;
	    a = t;
	  }
	
	  // a - IPv4, b - IPv6
	  for (var i = 0; i < 10; i++) {
	    if (b[i] !== 0) return false;
	  }
	
	  var word = b.readUInt16BE(10);
	  if (word !== 0 && word !== 0xffff) return false;
	
	  for (var i = 0; i < 4; i++) {
	    if (a[i] !== b[i + 12]) return false;
	  }
	
	  return true;
	};
	
	ip.isPrivate = function isPrivate(addr) {
	  return addr.match(/^10\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})/) != null ||
	    addr.match(/^192\.168\.([0-9]{1,3})\.([0-9]{1,3})/) != null ||
	    addr.match(
	        /^172\.(1[6-9]|2\d|30|31)\.([0-9]{1,3})\.([0-9]{1,3})/) != null ||
	    addr.match(/^127\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})/) != null ||
	    addr.match(/^169\.254\.([0-9]{1,3})\.([0-9]{1,3})/) != null ||
	    addr.match(/^fc00:/) != null || addr.match(/^fe80:/) != null ||
	    addr.match(/^::1$/) != null || addr.match(/^::$/) != null;
	};
	
	ip.isPublic = function isPublic(addr) {
	  return !ip.isPrivate(addr);
	}
	
	ip.isLoopback = function isLoopback(addr) {
	  return /^127\.0\.0\.1$/.test(addr)
	    || /^fe80::1$/.test(addr)
	    || /^::1$/.test(addr)
	    || /^::$/.test(addr);
	};
	
	ip.loopback = function loopback(family) {
	  //
	  // Default to `ipv4`
	  //
	  family = _normalizeFamily(family);
	
	  if (family !== 'ipv4' && family !== 'ipv6') {
	    throw new Error('family must be ipv4 or ipv6');
	  }
	
	  return family === 'ipv4'
	    ? '127.0.0.1'
	    : 'fe80::1';
	};
	
	//
	// ### function address (name, family)
	// #### @name {string|'public'|'private'} **Optional** Name or security
	//      of the network interface.
	// #### @family {ipv4|ipv6} **Optional** IP family of the address (defaults
	//      to ipv4).
	//
	// Returns the address for the network interface on the current system with
	// the specified `name`:
	//   * String: First `family` address of the interface.
	//             If not found see `undefined`.
	//   * 'public': the first public ip address of family.
	//   * 'private': the first private ip address of family.
	//   * undefined: First address with `ipv4` or loopback addres `127.0.0.1`.
	//
	ip.address = function address(name, family) {
	  var interfaces = os.networkInterfaces(),
	      all;
	
	  //
	  // Default to `ipv4`
	  //
	  family = _normalizeFamily(family);
	
	  //
	  // If a specific network interface has been named,
	  // return the address.
	  //
	  if (name && !~['public', 'private'].indexOf(name)) {
	    return interfaces[name].filter(function (details) {
	      details.family = details.family.toLowerCase();
	      return details.family === family;
	    })[0].address;
	  }
	
	  var all = Object.keys(interfaces).map(function (nic) {
	    //
	    // Note: name will only be `public` or `private`
	    // when this is called.
	    //
	    var addresses = interfaces[nic].filter(function (details) {
	      details.family = details.family.toLowerCase();
	      if (details.family !== family || ip.isLoopback(details.address)) {
	        return false;
	      }
	      else if (!name) {
	        return true;
	      }
	
	      return name === 'public'
	        ? !ip.isPrivate(details.address)
	        : ip.isPrivate(details.address)
	    });
	
	    return addresses.length
	      ? addresses[0].address
	      : undefined;
	  }).filter(Boolean);
	
	  return !all.length
	    ? ip.loopback(family)
	    : all[0];
	};
	
	ip.toLong = function toInt(ip){
	  var ipl=0;
	  ip.split('.').forEach(function( octet ) {
	      ipl<<=8;
	      ipl+=parseInt(octet);
	  });
	  return(ipl >>>0);
	};
	
	ip.fromLong = function fromInt(ipl){
	  return ( (ipl>>>24) +'.' +
	      (ipl>>16 & 255) +'.' +
	      (ipl>>8 & 255) +'.' +
	      (ipl & 255) );
	};
	
	function _normalizeFamily(family) {
	  return family ? family.toLowerCase() : 'ipv4';
	}


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, console) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	
	var base64 = __webpack_require__(349)
	var ieee754 = __webpack_require__(350)
	var isArray = __webpack_require__(351)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	Buffer.poolSize = 8192 // not used by this implementation
	
	var rootParent = {}
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Safari 5-7 lacks support for changing the `Object.prototype.constructor` property
	 *     on objects.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = (function () {
	  function Bar () {}
	  try {
	    var arr = new Uint8Array(1)
	    arr.foo = function () { return 42 }
	    arr.constructor = Bar
	    return arr.foo() === 42 && // typed array instances can be augmented
	        arr.constructor === Bar && // constructor can be set
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	})()
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	/**
	 * Class: Buffer
	 * =============
	 *
	 * The Buffer constructor returns instances of `Uint8Array` that are augmented
	 * with function properties for all the node `Buffer` API functions. We use
	 * `Uint8Array` so that square bracket notation works as expected -- it returns
	 * a single octet.
	 *
	 * By augmenting the instances, we can avoid modifying the `Uint8Array`
	 * prototype.
	 */
	function Buffer (arg) {
	  if (!(this instanceof Buffer)) {
	    // Avoid going through an ArgumentsAdaptorTrampoline in the common case.
	    if (arguments.length > 1) return new Buffer(arg, arguments[1])
	    return new Buffer(arg)
	  }
	
	  this.length = 0
	  this.parent = undefined
	
	  // Common case.
	  if (typeof arg === 'number') {
	    return fromNumber(this, arg)
	  }
	
	  // Slightly less common case.
	  if (typeof arg === 'string') {
	    return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8')
	  }
	
	  // Unusual.
	  return fromObject(this, arg)
	}
	
	function fromNumber (that, length) {
	  that = allocate(that, length < 0 ? 0 : checked(length) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < length; i++) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8'
	
	  // Assumption: byteLength() return value is always < kMaxLength.
	  var length = byteLength(string, encoding) | 0
	  that = allocate(that, length)
	
	  that.write(string, encoding)
	  return that
	}
	
	function fromObject (that, object) {
	  if (Buffer.isBuffer(object)) return fromBuffer(that, object)
	
	  if (isArray(object)) return fromArray(that, object)
	
	  if (object == null) {
	    throw new TypeError('must start with number, buffer, array or string')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined') {
	    if (object.buffer instanceof ArrayBuffer) {
	      return fromTypedArray(that, object)
	    }
	    if (object instanceof ArrayBuffer) {
	      return fromArrayBuffer(that, object)
	    }
	  }
	
	  if (object.length) return fromArrayLike(that, object)
	
	  return fromJsonObject(that, object)
	}
	
	function fromBuffer (that, buffer) {
	  var length = checked(buffer.length) | 0
	  that = allocate(that, length)
	  buffer.copy(that, 0, 0, length)
	  return that
	}
	
	function fromArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	// Duplicate of fromArray() to keep fromArray() monomorphic.
	function fromTypedArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  // Truncating the elements is probably not what people expect from typed
	  // arrays with BYTES_PER_ELEMENT > 1 but it's compatible with the behavior
	  // of the old Buffer constructor.
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    array.byteLength
	    that = Buffer._augment(new Uint8Array(array))
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromTypedArray(that, new Uint8Array(array))
	  }
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	// Deserialize { type: 'Buffer', data: [1,2,3,...] } into a Buffer object.
	// Returns a zero-length buffer for inputs that don't conform to the spec.
	function fromJsonObject (that, object) {
	  var array
	  var length = 0
	
	  if (object.type === 'Buffer' && isArray(object.data)) {
	    array = object.data
	    length = checked(array.length) | 0
	  }
	  that = allocate(that, length)
	
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function allocate (that, length) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = Buffer._augment(new Uint8Array(length))
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that.length = length
	    that._isBuffer = true
	  }
	
	  var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1
	  if (fromPool) that.parent = rootParent
	
	  return that
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (subject, encoding) {
	  if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding)
	
	  var buf = new Buffer(subject, encoding)
	  delete buf.parent
	  return buf
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  var i = 0
	  var len = Math.min(x, y)
	  while (i < len) {
	    if (a[i] !== b[i]) break
	
	    ++i
	  }
	
	  if (i !== len) {
	    x = a[i]
	    y = b[i]
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'binary':
	    case 'base64':
	    case 'raw':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.')
	
	  if (list.length === 0) {
	    return new Buffer(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; i++) {
	      length += list[i].length
	    }
	  }
	
	  var buf = new Buffer(length)
	  var pos = 0
	  for (i = 0; i < list.length; i++) {
	    var item = list[i]
	    item.copy(buf, pos)
	    pos += item.length
	  }
	  return buf
	}
	
	function byteLength (string, encoding) {
	  if (typeof string !== 'string') string = '' + string
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'binary':
	      // Deprecated
	      case 'raw':
	      case 'raws':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	// pre-set for values that may exist in the future
	Buffer.prototype.length = undefined
	Buffer.prototype.parent = undefined
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  start = start | 0
	  end = end === undefined || end === Infinity ? this.length : end | 0
	
	  if (!encoding) encoding = 'utf8'
	  if (start < 0) start = 0
	  if (end > this.length) end = this.length
	  if (end <= start) return ''
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'binary':
	        return binarySlice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return 0
	  return Buffer.compare(this, b)
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset) {
	  if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff
	  else if (byteOffset < -0x80000000) byteOffset = -0x80000000
	  byteOffset >>= 0
	
	  if (this.length === 0) return -1
	  if (byteOffset >= this.length) return -1
	
	  // Negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0)
	
	  if (typeof val === 'string') {
	    if (val.length === 0) return -1 // special case: looking for empty string always fails
	    return String.prototype.indexOf.call(this, val, byteOffset)
	  }
	  if (Buffer.isBuffer(val)) {
	    return arrayIndexOf(this, val, byteOffset)
	  }
	  if (typeof val === 'number') {
	    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
	      return Uint8Array.prototype.indexOf.call(this, val, byteOffset)
	    }
	    return arrayIndexOf(this, [ val ], byteOffset)
	  }
	
	  function arrayIndexOf (arr, val, byteOffset) {
	    var foundIndex = -1
	    for (var i = 0; byteOffset + i < arr.length; i++) {
	      if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex
	      } else {
	        foundIndex = -1
	      }
	    }
	    return -1
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	// `get` is deprecated
	Buffer.prototype.get = function get (offset) {
	  console.log('.get() is deprecated. Access using array indexes instead.')
	  return this.readUInt8(offset)
	}
	
	// `set` is deprecated
	Buffer.prototype.set = function set (v, offset) {
	  console.log('.set() is deprecated. Access using array indexes instead.')
	  return this.writeUInt8(v, offset)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new Error('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; i++) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) throw new Error('Invalid hex string')
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function binaryWrite (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    var swap = encoding
	    encoding = offset
	    offset = length | 0
	    length = swap
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'binary':
	        return binaryWrite(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  var res = ''
	  var tmp = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    if (buf[i] <= 0x7F) {
	      res += decodeUtf8Char(tmp) + String.fromCharCode(buf[i])
	      tmp = ''
	    } else {
	      tmp += '%' + buf[i].toString(16)
	    }
	  }
	
	  return res + decodeUtf8Char(tmp)
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function binarySlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; i++) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = Buffer._augment(this.subarray(start, end))
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; i++) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  if (newBuf.length) newBuf.parent = this.parent || this
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = value
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = value
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = value
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = value
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = value
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = value
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = value
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	  if (offset < 0) throw new RangeError('index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; i--) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; i++) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    target._set(this.subarray(start, start + len), targetStart)
	  }
	
	  return len
	}
	
	// fill(value, start=0, end=buffer.length)
	Buffer.prototype.fill = function fill (value, start, end) {
	  if (!value) value = 0
	  if (!start) start = 0
	  if (!end) end = this.length
	
	  if (end < start) throw new RangeError('end < start')
	
	  // Fill 0 bytes; we're done
	  if (end === start) return
	  if (this.length === 0) return
	
	  if (start < 0 || start >= this.length) throw new RangeError('start out of bounds')
	  if (end < 0 || end > this.length) throw new RangeError('end out of bounds')
	
	  var i
	  if (typeof value === 'number') {
	    for (i = start; i < end; i++) {
	      this[i] = value
	    }
	  } else {
	    var bytes = utf8ToBytes(value.toString())
	    var len = bytes.length
	    for (i = start; i < end; i++) {
	      this[i] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	/**
	 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
	 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
	 */
	Buffer.prototype.toArrayBuffer = function toArrayBuffer () {
	  if (typeof Uint8Array !== 'undefined') {
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      return (new Buffer(this)).buffer
	    } else {
	      var buf = new Uint8Array(this.length)
	      for (var i = 0, len = buf.length; i < len; i += 1) {
	        buf[i] = this[i]
	      }
	      return buf.buffer
	    }
	  } else {
	    throw new TypeError('Buffer.toArrayBuffer not supported in this browser')
	  }
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var BP = Buffer.prototype
	
	/**
	 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
	 */
	Buffer._augment = function _augment (arr) {
	  arr.constructor = Buffer
	  arr._isBuffer = true
	
	  // save reference to original Uint8Array set method before overwriting
	  arr._set = arr.set
	
	  // deprecated
	  arr.get = BP.get
	  arr.set = BP.set
	
	  arr.write = BP.write
	  arr.toString = BP.toString
	  arr.toLocaleString = BP.toString
	  arr.toJSON = BP.toJSON
	  arr.equals = BP.equals
	  arr.compare = BP.compare
	  arr.indexOf = BP.indexOf
	  arr.copy = BP.copy
	  arr.slice = BP.slice
	  arr.readUIntLE = BP.readUIntLE
	  arr.readUIntBE = BP.readUIntBE
	  arr.readUInt8 = BP.readUInt8
	  arr.readUInt16LE = BP.readUInt16LE
	  arr.readUInt16BE = BP.readUInt16BE
	  arr.readUInt32LE = BP.readUInt32LE
	  arr.readUInt32BE = BP.readUInt32BE
	  arr.readIntLE = BP.readIntLE
	  arr.readIntBE = BP.readIntBE
	  arr.readInt8 = BP.readInt8
	  arr.readInt16LE = BP.readInt16LE
	  arr.readInt16BE = BP.readInt16BE
	  arr.readInt32LE = BP.readInt32LE
	  arr.readInt32BE = BP.readInt32BE
	  arr.readFloatLE = BP.readFloatLE
	  arr.readFloatBE = BP.readFloatBE
	  arr.readDoubleLE = BP.readDoubleLE
	  arr.readDoubleBE = BP.readDoubleBE
	  arr.writeUInt8 = BP.writeUInt8
	  arr.writeUIntLE = BP.writeUIntLE
	  arr.writeUIntBE = BP.writeUIntBE
	  arr.writeUInt16LE = BP.writeUInt16LE
	  arr.writeUInt16BE = BP.writeUInt16BE
	  arr.writeUInt32LE = BP.writeUInt32LE
	  arr.writeUInt32BE = BP.writeUInt32BE
	  arr.writeIntLE = BP.writeIntLE
	  arr.writeIntBE = BP.writeIntBE
	  arr.writeInt8 = BP.writeInt8
	  arr.writeInt16LE = BP.writeInt16LE
	  arr.writeInt16BE = BP.writeInt16BE
	  arr.writeInt32LE = BP.writeInt32LE
	  arr.writeInt32BE = BP.writeInt32BE
	  arr.writeFloatLE = BP.writeFloatLE
	  arr.writeFloatBE = BP.writeFloatBE
	  arr.writeDoubleLE = BP.writeDoubleLE
	  arr.writeDoubleBE = BP.writeDoubleBE
	  arr.fill = BP.fill
	  arr.inspect = BP.inspect
	  arr.toArrayBuffer = BP.toArrayBuffer
	
	  return arr
	}
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	  var i = 0
	
	  for (; i < length; i++) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (leadSurrogate) {
	        // 2 leads in a row
	        if (codePoint < 0xDC00) {
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          leadSurrogate = codePoint
	          continue
	        } else {
	          // valid surrogate pair
	          codePoint = leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00 | 0x10000
	          leadSurrogate = null
	        }
	      } else {
	        // no lead yet
	
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else {
	          // valid lead
	          leadSurrogate = codePoint
	          continue
	        }
	      }
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	      leadSurrogate = null
	    }
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x200000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; i++) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function decodeUtf8Char (str) {
	  try {
	    return decodeURIComponent(str)
	  } catch (err) {
	    return String.fromCharCode(0xFFFD) // UTF 8 invalid char
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(348).Buffer, __webpack_require__(1)))

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	;(function (exports) {
		'use strict';
	
	  var Arr = (typeof Uint8Array !== 'undefined')
	    ? Uint8Array
	    : Array
	
		var PLUS   = '+'.charCodeAt(0)
		var SLASH  = '/'.charCodeAt(0)
		var NUMBER = '0'.charCodeAt(0)
		var LOWER  = 'a'.charCodeAt(0)
		var UPPER  = 'A'.charCodeAt(0)
		var PLUS_URL_SAFE = '-'.charCodeAt(0)
		var SLASH_URL_SAFE = '_'.charCodeAt(0)
	
		function decode (elt) {
			var code = elt.charCodeAt(0)
			if (code === PLUS ||
			    code === PLUS_URL_SAFE)
				return 62 // '+'
			if (code === SLASH ||
			    code === SLASH_URL_SAFE)
				return 63 // '/'
			if (code < NUMBER)
				return -1 //no match
			if (code < NUMBER + 10)
				return code - NUMBER + 26 + 26
			if (code < UPPER + 26)
				return code - UPPER
			if (code < LOWER + 26)
				return code - LOWER + 26
		}
	
		function b64ToByteArray (b64) {
			var i, j, l, tmp, placeHolders, arr
	
			if (b64.length % 4 > 0) {
				throw new Error('Invalid string. Length must be a multiple of 4')
			}
	
			// the number of equal signs (place holders)
			// if there are two placeholders, than the two characters before it
			// represent one byte
			// if there is only one, then the three characters before it represent 2 bytes
			// this is just a cheap hack to not do indexOf twice
			var len = b64.length
			placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0
	
			// base64 is 4/3 + up to two characters of the original data
			arr = new Arr(b64.length * 3 / 4 - placeHolders)
	
			// if there are placeholders, only get up to the last complete 4 chars
			l = placeHolders > 0 ? b64.length - 4 : b64.length
	
			var L = 0
	
			function push (v) {
				arr[L++] = v
			}
	
			for (i = 0, j = 0; i < l; i += 4, j += 3) {
				tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
				push((tmp & 0xFF0000) >> 16)
				push((tmp & 0xFF00) >> 8)
				push(tmp & 0xFF)
			}
	
			if (placeHolders === 2) {
				tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
				push(tmp & 0xFF)
			} else if (placeHolders === 1) {
				tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
				push((tmp >> 8) & 0xFF)
				push(tmp & 0xFF)
			}
	
			return arr
		}
	
		function uint8ToBase64 (uint8) {
			var i,
				extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
				output = "",
				temp, length
	
			function encode (num) {
				return lookup.charAt(num)
			}
	
			function tripletToBase64 (num) {
				return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
			}
	
			// go through the array every three bytes, we'll deal with trailing stuff later
			for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
				temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
				output += tripletToBase64(temp)
			}
	
			// pad the end with zeros, but make sure to not forget the extra bytes
			switch (extraBytes) {
				case 1:
					temp = uint8[uint8.length - 1]
					output += encode(temp >> 2)
					output += encode((temp << 4) & 0x3F)
					output += '=='
					break
				case 2:
					temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
					output += encode(temp >> 10)
					output += encode((temp >> 4) & 0x3F)
					output += encode((temp << 2) & 0x3F)
					output += '='
					break
			}
	
			return output
		}
	
		exports.toByteArray = b64ToByteArray
		exports.fromByteArray = uint8ToBase64
	}( false ? (this.base64js = {}) : exports))


/***/ },
/* 350 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 351 */
/***/ function(module, exports) {

	
	/**
	 * isArray
	 */
	
	var isArray = Array.isArray;
	
	/**
	 * toString
	 */
	
	var str = Object.prototype.toString;
	
	/**
	 * Whether or not the given `val`
	 * is an array.
	 *
	 * example:
	 *
	 *        isArray([]);
	 *        // > true
	 *        isArray(arguments);
	 *        // > false
	 *        isArray('');
	 *        // > false
	 *
	 * @param {mixed} val
	 * @return {bool}
	 */
	
	module.exports = isArray || function (val) {
	  return !! val && '[object Array]' == str.call(val);
	};


/***/ },
/* 352 */
/***/ function(module, exports) {

	exports.endianness = function () { return 'LE' };
	
	exports.hostname = function () {
	    if (typeof location !== 'undefined') {
	        return location.hostname
	    }
	    else return '';
	};
	
	exports.loadavg = function () { return [] };
	
	exports.uptime = function () { return 0 };
	
	exports.freemem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.totalmem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.cpus = function () { return [] };
	
	exports.type = function () { return 'Browser' };
	
	exports.release = function () {
	    if (typeof navigator !== 'undefined') {
	        return navigator.appVersion;
	    }
	    return '';
	};
	
	exports.networkInterfaces
	= exports.getNetworkInterfaces
	= function () { return {} };
	
	exports.arch = function () { return 'javascript' };
	
	exports.platform = function () { return 'browser' };
	
	exports.tmpdir = exports.tmpDir = function () {
	    return '/tmp';
	};
	
	exports.EOL = '\n';


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Router = __webpack_require__(166);
	var GameStrip = __webpack_require__(354);
	var Link = __webpack_require__(166).Link;
	var LeagueList = __webpack_require__(360);
	var DateSlider = __webpack_require__(363);
	var moment = __webpack_require__(254);
	var RHS = __webpack_require__(370);
	var DateFormatMixin = __webpack_require__(365);
	
	var ScoreBoard = React.createClass({
	    displayName: 'ScoreBoard',
	
	    getInitialState: function getInitialState() {
	        return {
	            date: new Date().setHours(0, 0, 0, 0),
	            dropdownTriggered: false,
	            activeDates: {}
	        };
	    },
	
	    mixins: [DateFormatMixin, Router.Navigation],
	
	    componentWillMount: function componentWillMount() {
	        this.setState(this.getDateParams());
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps() {
	        this.setState(this.getDateParams());
	    },
	
	    getDateParams: function getDateParams() {
	        var dateQuery = this.context.router.getCurrentQuery().date;
	        var events = this.props.leagues && this.props.leagues[0] && this.props.leagues[0].events;
	        var eventDate = events && events.length && events[0].date || null;
	
	        if (dateQuery) {
	            dateQuery = [dateQuery.substr(0, 4), dateQuery.substr(4, 2), dateQuery.substr(6, 2)].join('/');
	            dateQuery = new Date(dateQuery).setHours(0, 0, 0, 0);
	        }
	
	        return {
	            activeDates: this._getActiveDates(),
	            date: dateQuery || (eventDate ? moment(eventDate).utcOffset(0).startOf('day').toDate() : new Date()).setHours(0, 0, 0, 0)
	        };
	    },
	
	    onDateSelected: function onDateSelected(dateObject) {
	        var request = this.props.request;
	        var leagueQuery = this.context.router.getCurrentQuery().league;
	        var query = {
	            date: this.dateToKey(dateObject)
	        };
	
	        if (leagueQuery || !this.props.aggregated) {
	            query.league = leagueQuery || request.league;
	        }
	
	        this.state.date = dateObject;
	
	        this.transitionTo(request.page, {
	            league: request.root
	        }, query);
	    },
	
	    _getActiveDates: function _getActiveDates() {
	        var formattedDates = this.props.formattedDates || [];
	        var activeDates = {};
	
	        formattedDates.map(function (date, i) {
	            activeDates[date] = 1;
	        });
	        return activeDates;
	    },
	
	    getMatchLink: function getMatchLink(gameLinks) {
	        gameLinks = gameLinks || [];
	        for (var i = 0, len = gameLinks.length; i < len; i++) {
	            var link = gameLinks[i];
	            if (link.text === "Match") {
	                return link.href;
	            }
	        }
	        return '';
	    },
	
	    render: function render() {
	        var leagues = this.props.leagues;
	        var request = this.props.request;
	        var aggregatedScores = this.props.aggregated || false;
	        var leagueName = leagues && leagues[0] && leagues[0].name;
	        var heading = (aggregatedScores || !leagueName ? 'Rugby' : leagueName) + ' Scores';
	        var spacers = React.createElement(
	            'span',
	            null,
	            ' | '
	        );
	        var noEventsString = React.createElement(
	            'div',
	            { className: 'strip-size-lg', style: { clear: 'left' } },
	            'No games on this date.'
	        );
	        var dateParams = this.getDateParams();
	        var activeDates = dateParams.activeDates;
	        var eventsList = [];
	        var league = this.context.router.getCurrentQuery().league || request.league;
	
	        if (request.sport === 'soccer' || request.sport === 'rugby') {
	
	            /* set up league dropdown */
	            var leagueProps = {
	                id: 'conference-drop',
	                context: this.props.context,
	                root: request.root,
	                page: request.page,
	                sport: request.sport,
	                league: aggregatedScores ? 'aggregated' : league,
	                preventLeagueAction: true,
	                label: aggregatedScores ? 'All Leagues' : leagueName,
	                urlFormatter: (function (baseUrl, params) {
	                    return params.league == 1 ? baseUrl : baseUrl + '?league=' + params.league;
	                }).bind(this)
	            };
	        }
	
	        leagues.map((function (league, i) {
	            var groupedEvents = [];
	            if (aggregatedScores) {
	                groupedEvents.push(React.createElement(
	                    'h2',
	                    { key: league.name },
	                    league.name
	                ));
	            }
	            league.events.map((function (event, j) {
	                event.key = event.id;
	                event.anchor = this.getMatchLink(event.gameLinks);
	                event.league = league.name;
	                event.sport = request.sport === 'football' ? 'soccer' : request.sport;
	                groupedEvents.push(React.createElement(GameStrip, event));
	            }).bind(this));
	
	            if (groupedEvents.length) {
	                eventsList.push(React.createElement(
	                    'div',
	                    { key: i, className: 'strip-size-lg', style: { clear: 'left' } },
	                    groupedEvents
	                ));
	            }
	        }).bind(this));
	
	        return React.createElement(
	            'div',
	            { className: this.props.shell ? '' : "main-content layout-bc" },
	            React.createElement(
	                'section',
	                { className: 'col-b' },
	                React.createElement(
	                    'div',
	                    { className: 'scoreboards', 'data-date-data': 'null', 'data-is-default-group': 'true', id: 'scoreboard-page' },
	                    React.createElement(
	                        'header',
	                        { className: 'automated-header' },
	                        React.createElement(
	                            'h1',
	                            { style: { padding: '0px' } },
	                            heading
	                        ),
	                        React.createElement(LeagueList, leagueProps)
	                    ),
	                    React.createElement(DateSlider, { league: league, centered: 'true', date: dateParams.date, callback: this.onDateSelected, activeDates: activeDates }),
	                    React.createElement(
	                        'div',
	                        { className: 'carousel-day' },
	                        React.createElement(
	                            'span',
	                            { id: 'sbpDate', className: 'date' },
	                            'Scores for ' + moment(dateParams.date).format("MMM Do, YYYY")
	                        )
	                    ),
	                    eventsList.length ? eventsList : noEventsString
	                )
	            ),
	            React.createElement(RHS, { modules: this.props.rhs.modules })
	        );
	    }
	});
	
	module.exports = ScoreBoard;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var GamePackageLinks = __webpack_require__(355);
	var ScorecardStrip = __webpack_require__(356);
	var GameFooter = __webpack_require__(357);
	
	var GameStripIndex = React.createClass({
	    displayName: 'GameStripIndex',
	
	    render: function render() {
	
	        var sport = this.props.sport;
	        var league = this.props.league;
	        var classMap = {
	            'pregame': 'pre',
	            'live': 'live',
	            'final': 'post'
	        };
	        var GameStripProps = {
	            scores: this.props.scores,
	            teams: this.props.teams,
	            time: this.props.time,
	            formattedDate: this.props.formattedDate,
	            gameStatus: this.props.gameStatus,
	            winnerClass: this.props.winnerClass,
	            broadcasts: this.props.broadcasts,
	            footer: this.props.footer,
	            gameDetails: this.props.gameDetails,
	            sport: this.props.sport,
	            anchor: this.props.anchor
	        };
	        var articleStyles = {
	            'backgroundColor': '#fff',
	            'border': '1px solid #ccc',
	            'marginBottom': '18px',
	            'position': 'relative',
	            'width': '100%'
	        };
	
	        return React.createElement(
	            'article',
	            { style: articleStyles, id: this.props.id, 'data-awayid': this.props.teams.home.id, 'data-homeid': this.props.teams.away.id },
	            React.createElement(
	                'div',
	                { className: "scoreboard-top " + (this.props.gameStatus === 'pregame' ? "no-tabs" : "") },
	                React.createElement(
	                    'div',
	                    { className: 'scoreboard-wrapper' },
	                    React.createElement(ScorecardStrip, GameStripProps),
	                    React.createElement(GameFooter, { summary: this.props.gameDetails, text: this.props.footer, gameStatus: classMap[this.props.gameStatus], sport: sport })
	                ),
	                React.createElement(GamePackageLinks, { gameStatus: classMap[this.props.gameStatus], links: this.props.gameLinks, sport: sport, league: league })
	            ),
	            React.createElement('div', { style: { clear: 'both' } })
	        );
	    }
	});
	
	module.exports = GameStripIndex;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	var GamePackageLinks = React.createClass({
	    displayName: 'GamePackageLinks',
	
	    linksToShow: {
	        soccer: {
	            'Report': 1,
	            'Statistics': 1,
	            'Match': 1
	        },
	        rugby: {
	            'Match': 1,
	            'Report': 1
	        }
	    },
	    render: function render() {
	        var league = this.props.league;
	        var sport = this.props.sport;
	        var linksToShow = this.linksToShow[sport];
	        var links = this.props.links || [];
	        var linksMarkup = [];
	
	        links.map(function (link, i) {
	            var rels = link.rel.join(' ');
	
	            // if(linksToShow[link.text]){
	            linksMarkup.push(React.createElement(
	                'a',
	                { 'data-route': 'false', key: link.text + '.' + i, name: "&lpos=" + sport + ":scoreboard:" + link.text.toLowerCase(), className: 'button-alt sm', href: link.href, rel: league + " " + rels },
	                link.text
	            ));
	            // }
	        });
	
	        return React.createElement(
	            'section',
	            { className: 'sb-actions', style: { paddingBottom: '10px' } },
	            linksMarkup
	        );
	    }
	});
	
	module.exports = GamePackageLinks;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(11);
	
	var GameStatus = React.createClass({
	    displayName: "GameStatus",
	
	    render: function render() {
	
	        var broadcasts = this.props.broadcasts || {};
	        var broadcastLink;
	
	        if (broadcasts.url && broadcasts.name) {
	            broadcastLink = React.createElement(
	                "span",
	                { className: "network" },
	                React.createElement(
	                    "a",
	                    { href: broadcasts.url, className: broadcasts.external === true ? "external" : '' },
	                    broadcasts.name
	                )
	            );
	        }
	
	        return React.createElement(
	            "div",
	            { className: "game-status" },
	            broadcastLink,
	            React.createElement(
	                "span",
	                { className: "game-date" },
	                this.props.status == 'pregame' ? this.props.date : ''
	            ),
	            React.createElement(
	                "span",
	                { className: "game-time" },
	                (this.props.time || '').toUpperCase()
	            ),
	            React.createElement("span", { className: "game-play" })
	        );
	    }
	});
	
	var GameHeader = React.createClass({
	    displayName: "GameHeader",
	
	    render: function render() {
	        var text = this.props.text;
	        var details = React.createElement(
	            "div",
	            { className: "game-details header" },
	            text
	        );
	
	        return text ? details : null;
	    }
	});
	
	var Competitor = React.createClass({
	    displayName: "Competitor",
	
	    render: function render() {
	
	        var team = this.props.team;
	        var isHomeTeam = this.props.team.home;
	        var scoreContainer = React.createElement(
	            "div",
	            { key: "score.container" + (this.props.team.home ? 'h' : 'a'), className: "score-container" },
	            React.createElement(
	                "span",
	                { className: "score icon-font-" + (!isHomeTeam ? 'before' : 'after') },
	                this.props.score
	            )
	        );
	        var teamForm = '';
	        var teamInfoStyle = {};
	
	        if (team.form && this.props.status === 'pregame') {
	            teamForm = "Form: " + team.form;
	        } else {
	            teamInfoStyle = { top: '27px' };
	        }
	
	        var teamContainer = [React.createElement(
	            "div",
	            { key: "team.container", className: "team-container" },
	            React.createElement(
	                "div",
	                { className: "logo" },
	                React.createElement(
	                    "picture",
	                    null,
	                    React.createElement("source", { srcSet: team.logo }),
	                    React.createElement("img", { "data-default-src": team.logo, className: "team-logo", src: team.logo })
	                )
	            ),
	            React.createElement(
	                "div",
	                { className: "team-info", style: teamInfoStyle },
	                React.createElement("span", { className: "rank" }),
	                React.createElement(
	                    "span",
	                    { className: "team-name" },
	                    React.createElement(
	                        "span",
	                        { className: "long-name" },
	                        team.name
	                    ),
	                    React.createElement(
	                        "span",
	                        { className: "short-name" },
	                        team.name
	                    ),
	                    React.createElement(
	                        "span",
	                        { className: "abbrev" },
	                        team.abbreviation
	                    )
	                ),
	                React.createElement(
	                    "span",
	                    { className: "record" },
	                    teamForm
	                )
	            )
	        )];
	
	        if (isHomeTeam) {
	            teamContainer.push(scoreContainer);
	        } else {
	            teamContainer.unshift(scoreContainer);
	        }
	
	        return React.createElement(
	            "div",
	            { className: "team " + (!isHomeTeam ? 'home' : 'away') },
	            React.createElement(
	                "div",
	                { className: "content" },
	                teamContainer
	            )
	        );
	    }
	});
	
	var ScorecardStrip = React.createClass({
	    displayName: "ScorecardStrip",
	
	    render: function render() {
	        var classMap = {
	            'pregame': 'pre',
	            'live': 'live',
	            'final': 'post'
	        };
	        var headerClasses = ['game-strip'];
	
	        headerClasses.push(this.props.sport || 'rugby', this.props.winnerClass || '', classMap[this.props.gameStatus] || '');
	
	        return React.createElement(
	            "header",
	            { style: this.props.styles, className: headerClasses.join(' ') },
	            React.createElement(GameHeader, { text: this.props.heading }),
	            React.createElement(
	                "a",
	                { "data-route": "false", href: this.props.anchor || '#', className: "competitors sm-score" },
	                React.createElement(Competitor, { team: this.props.teams.home, score: this.props.scores.home, status: this.props.gameStatus }),
	                React.createElement(GameStatus, { broadcasts: this.props.broadcasts, status: this.props.gameStatus, date: this.props.formattedDate, time: this.props.time }),
	                React.createElement(Competitor, { team: this.props.teams.away, score: this.props.scores.away, status: this.props.gameStatus })
	            )
	        );
	    }
	});
	
	module.exports = ScorecardStrip;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var GameSummary = __webpack_require__(358);
	
	var GameFooter = React.createClass({
	    displayName: 'GameFooter',
	
	    hasValidSummary: function hasValidSummary(summary, sport) {
	        // Return false if summary is not defined (usually happens for future games)
	        if (typeof summary === 'undefined') {
	            return false;
	        }
	        var summaryPresent = false;
	        try {
	            var homeSummaryPresent;
	            var awaySummaryPresent;
	            if (sport === 'soccer') {
	                summaryPresent = summary.home.discipline.length || summary.home.goals.length || summary.away.discipline.length || summary.away.goals.length;
	            } else if (sport === 'rugby') {
	                homeSummaryPresent = summary.home.tries.length || summary.home.cons.length || summary.home.pens.length;
	                awaySummaryPresent = summary.away.tries.length || summary.away.cons.length || summary.away.pens.length;
	                //console.info('homeSummaryPresent', homeSummaryPresent);
	                //console.info('awaySummaryPresent', awaySummaryPresent);
	                summaryPresent = homeSummaryPresent > 0 || awaySummaryPresent > 0;
	            }
	        } catch (e) {}
	        return summaryPresent;
	    },
	    render: function render() {
	        var text = this.props.text;
	        var gameStatus = null;
	        var gameStatusMobile = null;
	        var gameSummaryWrapper = null;
	        if (!!text) {
	            gameStatus = React.createElement(
	                'div',
	                { className: 'game-status' },
	                text
	            );
	            gameStatusMobile = React.createElement(
	                'div',
	                { className: 'game-status mobile' },
	                text
	            );
	        }
	        if (this.hasValidSummary(this.props.summary, this.props.sport) || gameStatus || gameStatusMobile) {
	            gameSummaryWrapper = React.createElement(
	                'div',
	                { className: 'wrap' },
	                React.createElement(GameSummary, { summary: this.props.summary, sport: this.props.sport }),
	                gameStatus,
	                gameStatusMobile
	            );
	        }
	
	        return React.createElement(
	            'div',
	            { style: this.props.styles || { borderBottom: 'none' }, className: (this.props.classNames || "game-details footer" + (this.props.sport ? ' ' + this.props.sport : '')) + (this.props.gameStatus ? " " + this.props.gameStatus : "") },
	            gameSummaryWrapper
	        );
	    }
	});
	
	module.exports = GameFooter;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var gameStripUtils = __webpack_require__(359);
	var eventTypeStyle = { paddingRight: '5px' };
	//console.info('gameStripUtils', gameStripUtils);
	
	/**
	 * Get scorers for a particular game
	 */
	var Scorers = React.createClass({
	    displayName: 'Scorers',
	
	    render: function render() {
	        var goals = this.props.goals || [];
	        // Return if game has no goals
	        if (goals.length === 0) {
	            return null;
	        }
	
	        //console.info('goals', goals);
	        var scorerNodes = goals.map(function (goal, i) {
	            //console.info('goal', goal);
	            var details = gameStripUtils.getPlayerNameLink(goal);
	            var clock = gameStripUtils.getFormattedClock(goal);
	            //console.info('details', details);
	            //console.info('clock', clock);
	            return React.createElement(
	                'li',
	                { key: clock + '-' + i },
	                React.createElement(
	                    'a',
	                    { href: details.link },
	                    details.name
	                ),
	                React.createElement(
	                    'span',
	                    null,
	                    '(',
	                    clock,
	                    ')'
	                )
	            );
	        });
	
	        return React.createElement(
	            'ul',
	            { className: this.props.sport == 'rugby' ? "goal icon-font-before icon-rugby-solid-before icon-rugby-solid" : 'goal icon-font-before icon-soccer-ball-before icon-soccerball' },
	            scorerNodes
	        );
	    }
	});
	
	/**
	 * Get red/yellow card information for a particular game
	 */
	var DisciplineCards = React.createClass({
	    displayName: 'DisciplineCards',
	
	    render: function render() {
	        var cards = this.props.cards || [];
	        // Return if game has no cards
	        if (cards.length === 0) {
	            return null;
	        }
	
	        // Get card type and create the class name string
	        var cardtype = this.props.cardtype;
	        var cssClasses = ['icon-font-before', 'icon-soccer-card02-solid-before'];
	        var cardClass = cardtype === 'yellow' ? 'icon-yellowcard' : 'icon-redcard';
	        cssClasses.push(cardClass);
	        var classString = cssClasses.join(' ');
	
	        // Get card related details
	        var cardNodes = cards.map(function (card, i) {
	            var details = gameStripUtils.getPlayerNameLink(card);
	            var clock = gameStripUtils.getFormattedClock(card);
	            return React.createElement(
	                'li',
	                { key: clock + '-' + i },
	                React.createElement(
	                    'a',
	                    { href: details.link },
	                    details.name
	                ),
	                React.createElement(
	                    'span',
	                    null,
	                    '(',
	                    clock,
	                    ')'
	                )
	            );
	        });
	
	        return React.createElement(
	            'ul',
	            { className: classString },
	            cardNodes
	        );
	    }
	});
	
	/**
	 * Render goalscorers and cards related information for a team
	 */
	var TeamSummary = React.createClass({
	    displayName: 'TeamSummary',
	
	    render: function render() {
	        var team = this.props.team;
	
	        var goals = team.goals;
	        var cards = team.discipline;
	        //console.info('TeamSummary: goals', this.props.how, goals);
	        //console.info('TeamSummary: cards', this.props.how, cards);
	
	        /**
	         * Create separate containers for red and yellow cards
	         */
	        var yellowCards = [];
	        var redCards = [];
	        for (var i = 0; i < cards && cards.length; i++) {
	            var card = cards[i];
	            if (card.redCard === true) {
	                redCards.push(card);
	            }
	            if (card.yellowCard === true) {
	                yellowCards.push(card);
	            }
	        }
	
	        //console.info('TeamSummary: yellow cards', yellowCards);
	        //console.info('TeamSummary: red cards', redCards);
	
	        return React.createElement(
	            'div',
	            { className: 'team-info players' },
	            React.createElement(Scorers, { goals: goals, sports: this.props.sport }),
	            React.createElement(DisciplineCards, { cards: redCards, cardtype: 'red' }),
	            React.createElement(DisciplineCards, { cards: yellowCards, cardtype: 'yellow' })
	        );
	    }
	});
	
	var TryDetails = React.createClass({
	    displayName: 'TryDetails',
	
	    render: function render() {
	        var tries = this.props.tries;
	        var tryNodes = [];
	        // Return if game has no cards
	        if (tries.length === 0) {
	            return null;
	        }
	
	        var classString = 'trylist';
	
	        tries.map(function (tri, i) {
	            //console.info('tri', tri);
	            var details = gameStripUtils.getPlayerNameLink(tri);
	            var clock = gameStripUtils.getFormattedClock(tri);
	            //console.info('details', details);
	            //console.info('clock', clock);
	            tryNodes.push(React.createElement(
	                'li',
	                { key: clock + '-' + i },
	                React.createElement(
	                    'a',
	                    { href: details.link },
	                    details.name
	                ),
	                React.createElement(
	                    'span',
	                    null,
	                    '(',
	                    clock,
	                    ')'
	                )
	            ), ' ');
	        });
	
	        return React.createElement(
	            'ul',
	            { className: classString },
	            React.createElement(
	                'li',
	                null,
	                React.createElement(
	                    'b',
	                    { style: eventTypeStyle },
	                    'Tries'
	                )
	            ),
	            tryNodes
	        );
	    }
	});
	
	var ConvDetails = React.createClass({
	    displayName: 'ConvDetails',
	
	    render: function render() {
	        var cons = this.props.cons;
	        var convNodes = [];
	        // Return if game has no cards
	        if (cons.length === 0) {
	            return null;
	        }
	
	        var classString = 'goal icon-font-before icon-rugby-conversion-solid-before icon-rugby-conversion-solid';
	
	        cons.map(function (conv, i) {
	            //console.info('conv', conv);
	            var details = gameStripUtils.getPlayerNameLink(conv);
	            var clock = gameStripUtils.getFormattedClock(conv);
	            //console.info('details', details);
	            //console.info('clock', clock);
	            convNodes.push(React.createElement(
	                'li',
	                { key: clock + '-' + i },
	                React.createElement(
	                    'a',
	                    { href: details.link },
	                    details.name
	                ),
	                React.createElement(
	                    'span',
	                    null,
	                    '(',
	                    clock,
	                    ')'
	                )
	            ), ' ');
	        });
	
	        return React.createElement(
	            'ul',
	            { className: classString },
	            convNodes
	        );
	    }
	});
	
	var PenDetails = React.createClass({
	    displayName: 'PenDetails',
	
	    render: function render() {
	        var pens = this.props.pens;
	        var penNodes = [];
	        // Return if game has no cards
	        if (pens.length === 0) {
	            return null;
	        }
	
	        var classString = 'goal icon-font-before icon-rugby-penalty-solid-before icon-rugby-penalty-solid';
	
	        pens.map(function (pen, i) {
	            //console.info('pen', pen);
	            var details = gameStripUtils.getPlayerNameLink(pen);
	            var clock = gameStripUtils.getFormattedClock(pen);
	            //console.info('details', details);
	            //console.info('clock', clock);
	            penNodes.push(React.createElement(
	                'li',
	                { key: clock + '-' + i },
	                React.createElement(
	                    'a',
	                    { href: details.link },
	                    details.name
	                ),
	                React.createElement(
	                    'span',
	                    null,
	                    '(',
	                    clock,
	                    ')'
	                )
	            ), ' ');
	        });
	
	        return React.createElement(
	            'ul',
	            { className: classString },
	            penNodes
	        );
	    }
	});
	
	var RedDetails = React.createClass({
	    displayName: 'RedDetails',
	
	    render: function render() {
	        var reds = this.props.reds;
	        // Return if game has no cards
	        if (reds.length === 0) {
	            return null;
	        }
	
	        var classString = 'icon-font-before icon-soccer-card02-solid-before icon-redcard';
	
	        var redNodes = reds.map(function (red, i) {
	            //console.info('red', red);
	            var details = gameStripUtils.getPlayerNameLink(red);
	            var clock = gameStripUtils.getFormattedClock(red);
	            //console.info('details', details);
	            //console.info('clock', clock);
	            return React.createElement(
	                'li',
	                { key: clock + '-' + i },
	                React.createElement(
	                    'a',
	                    { href: details.link },
	                    details.name
	                ),
	                React.createElement(
	                    'span',
	                    null,
	                    '(',
	                    clock,
	                    ')'
	                )
	            );
	        });
	
	        return React.createElement(
	            'ul',
	            { className: classString },
	            redNodes
	        );
	    }
	});
	
	var DropDetails = React.createClass({
	    displayName: 'DropDetails',
	
	    render: function render() {
	        var drops = this.props.drops;
	        var dropNodes = [];
	        // Return if game has no cards
	        if (drops.length === 0) {
	            return null;
	        }
	
	        var classString = 'goal icon-font-before icon-rugby-drop-goal-solid-before icon-rugby-drop-goal-solid';
	
	        drops.map(function (drop, i) {
	            //console.info('drop', drop);
	            var details = gameStripUtils.getPlayerNameLink(drop);
	            var clock = gameStripUtils.getFormattedClock(drop);
	            //console.info('details', details);
	            //console.info('clock', clock);
	            dropNodes.push(React.createElement(
	                'li',
	                { key: clock + '-' + i },
	                React.createElement(
	                    'a',
	                    { href: details.link },
	                    details.name
	                ),
	                React.createElement(
	                    'span',
	                    null,
	                    '(',
	                    clock,
	                    ')'
	                )
	            ), ' ');
	        });
	
	        return React.createElement(
	            'ul',
	            { className: classString },
	            dropNodes
	        );
	    }
	});
	
	/**
	 * Component to display rugby stats
	 */
	var RugbyStat = React.createClass({
	    displayName: 'RugbyStat',
	
	    render: function render() {
	        var stats = this.props.stats;
	        var statname = this.props.statname;
	
	        // whitelist of stats and related lookup details
	        var statsMap = {
	            'tries': {
	                displayText: 'Tries',
	                classString: 'goal icon-font-before icon-rugby-solid-before icon-rugby-solid'
	            },
	            'cons': {
	                displayText: 'Cons',
	                classString: 'goal icon-font-before icon-rugby-conversion-solid-before icon-rugby-conversion-solid'
	            },
	            'pens': {
	                displayText: 'Pens',
	                classString: 'goal icon-font-before icon-rugby-penalty-solid-before icon-rugby-penalty-solid'
	            },
	            'reds': {
	                displayText: 'Reds',
	                classString: 'icon-font-before icon-soccer-card02-solid-before icon-redcard'
	            },
	            'drops': {
	                displayText: 'Drops',
	                classString: 'goal icon-font-before icon-rugby-drop-goal-solid-before icon-rugby-drop-goal-solid'
	            }
	        };
	
	        // Return if this side has no stats available
	        if (stats.length === 0 || statsMap.hasOwnProperty(statname) === false) {
	            return null;
	        }
	
	        // Cache lookup from statsMap
	        var config = statsMap[statname];
	        var allstats = stats[0];
	        //console.info('stats', stats);
	        //console.info('statname', statname, 'stats', allstats);
	
	        // Store formatted stats. Each object will corrospond to single player.
	        var formattedStats = [];
	
	        // Iterate over each player id in stat. Build data in required format.
	        for (var playerId in allstats) {
	            //console.info('playerId', playerId);
	            var playerStat = allstats[playerId];
	            //console.info('playerStat', playerStat);
	
	            // Set defaults data format
	            var stat = {
	                playerId: playerId,
	                displayClock: '',
	                playerName: '',
	                playerLink: ''
	            };
	
	            // Lookup and set times, name and link
	            if (playerStat.hasOwnProperty('times')) {
	                stat.displayClock = playerStat.times.join(', ');
	            }
	            if (playerStat.hasOwnProperty('name')) {
	                stat.playerName = playerStat.name;
	            }
	            if (playerStat.hasOwnProperty('link')) {
	                stat.playerLink = playerStat.link;
	            }
	            if (playerStat.hasOwnProperty('rawClock')) {
	                stat.rawClock = playerStat.rawClock;
	            }
	            //console.info(stat);
	
	            // Append to stats
	            formattedStats.push(stat);
	        }
	        //console.info('formattedStats', formattedStats);
	
	        // Sort the events on rawclock ascending value
	        formattedStats.sort(function (a, b) {
	            try {
	                return a.rawClock - b.rawClock;
	            } catch (e) {
	                return 0;
	            }
	        });
	
	        // Loop over formattedStats and build html nodes
	        var statNodesMarkup = '';
	
	        formattedStats.map(function (stat, i) {
	            // Return only if valid player id is found.
	            if ('playerId' in stat) {
	                statNodesMarkup += '<li><a target="_blank" href="' + stat.playerLink + '">' + stat.playerName + '</a><span>(' + stat.displayClock + ')</span></li> ';
	            }
	        });
	
	        // Return stats in a ul.
	        return React.createElement('ul', { className: config.classString, dangerouslySetInnerHTML: { __html: statNodesMarkup } });
	    }
	});
	
	/**
	 * Render rugby details for a team
	 */
	var RugbySummary = React.createClass({
	    displayName: 'RugbySummary',
	
	    render: function render() {
	        var team = this.props.team;
	
	        var tries = team.tries;
	        var cons = team.cons;
	        var pens = team.pens;
	        var reds = team.reds;
	        var drops = team.drops;
	
	        return React.createElement(
	            'div',
	            { className: 'team-info players' },
	            React.createElement(RugbyStat, { stats: tries, statname: 'tries' }),
	            React.createElement(RugbyStat, { stats: cons, statname: 'cons' }),
	            React.createElement(RugbyStat, { stats: pens, statname: 'pens' }),
	            React.createElement(RugbyStat, { stats: reds, statname: 'reds' }),
	            React.createElement(RugbyStat, { stats: drops, statname: 'drops' })
	        );
	    }
	});
	
	/**
	 * Render game summary for home and away teams
	 */
	var GameSummary = React.createClass({
	    displayName: 'GameSummary',
	
	    render: function render() {
	        var summary = this.props.summary;
	        var homeSummary = summary.home;
	        var awaySummary = summary.away;
	        var homeSummaryComponent = null;
	        var awaySummaryComponent = null;
	
	        if (this.props.sport === 'rugby') {
	            homeSummaryComponent = React.createElement(RugbySummary, { team: homeSummary, how: 'home' });
	            awaySummaryComponent = React.createElement(RugbySummary, { team: awaySummary, how: 'away' });
	        } else {
	            homeSummaryComponent = React.createElement(TeamSummary, { team: homeSummary, how: 'home' });
	            awaySummaryComponent = React.createElement(TeamSummary, { team: awaySummary, how: 'away' });
	        }
	        //console.info('\nGameSummary:', summary);
	
	        /**
	         * Swap home, away teams since for domestic, home team appears on right
	         * For football, home team should be on left.
	         */
	
	        return React.createElement(
	            'div',
	            { className: 'competitors' },
	            React.createElement(
	                'div',
	                { className: 'team away' },
	                homeSummaryComponent
	            ),
	            React.createElement(
	                'div',
	                { className: 'team home' },
	                awaySummaryComponent
	            )
	        );
	    }
	});
	
	module.exports = GameSummary;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Utilities for scoreboard game strip.
	 * @return {Object}     Utility functions to extract game strip information
	 */
	
	'use strict';
	
	var browser = __webpack_require__(252);
	var moment = __webpack_require__(254);
	var api = {};
	
	// map for all default logos
	var defaultLogos = {
	    soccer: "http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/default-team-logo-500.png"
	};
	
	/**
	 * Get logo for a sport
	 * @param  {String} sport
	 * @return {String}       url if found in defaultLogos object
	 */
	function getLogo(sport) {
	    var logo = '';
	    sport = sport || 'soccer';
	    if (sport in defaultLogos) {
	        logo = defaultLogos[sport];
	    }
	    //console.log('getLogo', logo);
	    return logo;
	}
	
	function isOEmpty(input) {
	    for (var prop in input) {
	        if (input.hasOwnProperty(prop)) {
	            return false;
	        }
	    }
	    return true;
	}
	
	/**
	 * Get gamestatus from state
	 * @param  {String} state pre/in/post
	 * @return {String}       pregame/live/final/empty string
	 */
	api.getGameStatus = function (state) {
	    // var state =
	    var gameStatus = '';
	    if (state === 'pre') {
	        gameStatus = 'pregame';
	    } else if (state === 'in') {
	        gameStatus = 'live';
	    } else if (state === 'post') {
	        gameStatus = 'final';
	    }
	    return gameStatus;
	};
	
	/**
	 * Get localtime from string.
	 * On error, pass return dateString as is.
	 */
	api.getLocalTime = function (dateString) {
	    try {
	        api.utcOffset = api.utcOffset || moment.parseZone(new Date()).utcOffset();
	        var timeZone = browser.call('espn_ui.Helpers.timezones.getCurrentTimezone') || '';
	        return moment(dateString).utcOffset(api.utcOffset).format('h:mm a') + ' ' + timeZone;
	    } catch (e) {
	        return dateString;
	    }
	};
	
	/**
	 * From team object, get URL to team page.
	 */
	api.getTeamUrl = function (team) {
	    var url = '';
	    try {
	        url = team.links[0].href;
	    } catch (e) {}
	    return url;
	};
	
	/**
	 * Get team's logo if found else return default logo
	 */
	api.getTeamLogo = function (team, sport) {
	    sport = sport || 'soccer';
	    var teamLogo = team && team.logo || team && team.logos && team.logos[0] && team.logos[0].href || getLogo(sport);
	    //console.info('teamLogo', teamLogo);
	    return teamLogo;
	};
	
	/**
	 * Get home and away team's information
	 */
	api.getTeamsInfo = function (homeTeam, awayTeam) {
	    homeTeam = homeTeam || {};
	    awayTeam = awayTeam || {};
	    var teams = {
	        home: {
	            home: true,
	            id: homeTeam.id,
	            name: homeTeam.name,
	            url: api.getTeamUrl(homeTeam),
	            abbreviation: (homeTeam.abbreviation || '').slice(0, 3),
	            color: homeTeam.color ? '#' + homeTeam.color : '',
	            links: (homeTeam.links && homeTeam.links || []).slice(1),
	            logo: api.getTeamLogo(homeTeam),
	            form: homeTeam && homeTeam.form
	        },
	        away: {
	            home: false,
	            id: awayTeam.id,
	            name: awayTeam.name,
	            url: api.getTeamUrl(awayTeam),
	            abbreviation: (awayTeam.abbreviation || '').slice(0, 3),
	            color: awayTeam.color ? '#' + awayTeam.color : '',
	            links: (awayTeam.links && awayTeam.links || []).slice(1),
	            logo: api.getTeamLogo(awayTeam),
	            form: awayTeam && awayTeam.form
	        }
	    };
	    //console.info('getTeamsInfo', teams);
	    return teams;
	};
	
	/**
	 * Get scores of home and away teams
	 */
	api.getScores = function (home, away, showLinescores) {
	    var homeLinescore = home.linescores && home.linescores[0] && home.linescores[0].displayValue;
	    var awayLinescore = away.linescores && away.linescores[0] && away.linescores[0].displayValue;
	
	    var homeScore = home.score ? home.score + (homeLinescore && showLinescores ? '(' + homeLinescore + ')' : '') : '';
	    var awayScore = away.score ? away.score + (awayLinescore && showLinescores ? '(' + awayLinescore + ')' : '') : '';
	    //console.info('homeScore, awayScore', homeScore, awayScore);
	    return {
	        home: homeScore,
	        away: awayScore
	    };
	};
	
	/**
	 * Returns home-winner/away-winner class
	 */
	api.getWinnerClass = function (home, away) {
	    var classSuffix = '-winner';
	    // reversed the classNames, following the toolkit
	    return home.winner ? 'away' + classSuffix : away.winner ? 'home' + classSuffix : '';
	};
	
	/**
	 * Get details for a game (goals, cards, clock, shotout)
	 * @param  {Object} competitionDetails
	 * @param  {Number} homeId             home team ID
	 */
	api.getGameDetails = function (competitionDetails, homeId) {
	    var gameDetails = {
	        home: {
	            goals: [],
	            discipline: []
	        },
	        away: {
	            goals: [],
	            discipline: []
	        }
	    };
	    for (var i = 0, len = competitionDetails && competitionDetails.length; i < len; i++) {
	        var detail = competitionDetails[i];
	        //console.info('\ndetail', detail);
	        var key = detail && detail.team && detail.team.id == homeId ? 'home' : 'away';
	        if (detail.scoreValue === 1) {
	            gameDetails[key].goals.push({
	                athletesInvolved: detail.athletesInvolved,
	                clock: detail.clock,
	                ownGoal: detail.ownGoal,
	                shootout: detail.shootout,
	                penaltyKick: detail.penaltyKick
	            });
	        } else {
	            gameDetails[key].discipline.push({
	                redCard: detail.redCard,
	                yellowCard: detail.yellowCard,
	                clock: detail.clock,
	                athletesInvolved: detail.athletesInvolved
	            });
	        }
	    }
	    return gameDetails;
	};
	
	/**
	 * Get information for penalty tries. Penalty tries are displayed under tries.
	 * There is no player name associated so use 'Penalty Try'.
	 */
	function getPenTries(e) {
	    var info;
	    if (e.hasOwnProperty('type') && e.type.description === 'penalty try') {
	        //console.info('getPenTries', e);
	        if (e.hasOwnProperty('clock') && e.clock.value) {
	            info = {
	                link: '',
	                name: 'Penalty Try',
	                rawClock: e.clock.value,
	                times: []
	            };
	            var displayable = e.clock.displayValue || '';
	            info.times.push(displayable);
	        }
	    }
	    return info;
	}
	
	// Group stats for a player for an event type
	function formattedRugbyStats(gameDetails) {
	
	    // Template for data that will be returned
	    var updated = {
	        home: {
	            tries: [],
	            cons: [],
	            pens: [],
	            reds: [],
	            drops: []
	        },
	        away: {
	            tries: [],
	            cons: [],
	            pens: [],
	            reds: [],
	            drops: []
	        }
	    };
	
	    // Iterate over home and away sides, side is home/away
	    for (var side in gameDetails) {
	        // side details is an object with 5 keys
	        var sideDetails = gameDetails[side];
	        // event type will be tries/cons/pens/reds/drops
	        for (var eventType in sideDetails) {
	            // List of events in that game
	            var eventList = sideDetails[eventType];
	            //console.info('eventList', eventList);
	
	            /**
	             * Iterate over all events of a type and build a data structure
	             * d = { player name : {event details}}
	             */
	
	            var d = {};
	            for (var j = 0; j < eventList.length; j++) {
	                var currentEvent = eventList[j];
	                //console.info(currentEvent.clock.displayValue, currentEvent);
	                // Continue to next event if clock and athetes involved are missing
	                if (currentEvent.hasOwnProperty('athletesInvolved') === false && currentEvent.hasOwnProperty('participants') === false || currentEvent.hasOwnProperty('clock') === false) {
	                    // Check if it was a penalty try
	                    var pt = getPenTries(currentEvent);
	                    //console.info('pt', pt);
	                    /**
	                     * If it's a valid penalty try, associate with dummy
	                     * player id.
	                     */
	                    //console.info('after getPenTries', pt);
	                    /**
	                     * For the first penalty try, assign it to d.pt.
	                     * For subsequent penalty tries, append the penalty
	                     * try time to an array in d.pt.times.
	                     */
	                    if (typeof pt !== 'undefined') {
	                        if (d.hasOwnProperty('pt') && d.pt !== 'undefined') {
	                            if (d.pt.hasOwnProperty('times') && pt.times && pt.times.length > 0) {
	                                d.pt.times.push(pt.times[0]);
	                            }
	                        } else {
	                            d.pt = pt;
	                        }
	                    }
	                    continue;
	                }
	
	                // Get player details
	                var playerDetails = api.getPlayerNameLink(currentEvent);
	                // Create aempty array to store references of clocks
	                playerDetails.times = [];
	                var playersInvolved = currentEvent.athletesInvolved || currentEvent.participants;
	                var displayClock = currentEvent.clock.displayValue;
	                var rawClock = currentEvent.clock.value;
	
	                if (playersInvolved.length > 0 && typeof displayClock === 'string') {
	                    var player = playersInvolved[0] && playersInvolved[0].athlete || playersInvolved[0];
	                    // Proceed only if id and display name are present
	                    if (player.hasOwnProperty('id') && player.hasOwnProperty('displayName')) {
	                        //console.info('player', player);
	                        if (d.hasOwnProperty(player.id) === false) {
	                            d[player.id] = playerDetails;
	                        }
	                        d[player.id].times.push(displayClock);
	                        d[player.id].rawClock = rawClock;
	                        //console.info('d', d);
	                    }
	                }
	            }
	            // Push to array only if not empty
	            if (isOEmpty(d) === false) {
	                updated[side][eventType].push(d);
	            }
	        }
	    }
	
	    //console.info('\nupdated', updated);
	    return updated;
	}
	
	// Get details for rugby
	api.getRugbyDetails = function (details, homeId) {
	    // @todo - may not be required after api update, remove later.
	    var pickStats = {
	        'try': {
	            aname: 'tries'
	        },
	        'conversion': {
	            aname: 'cons'
	        },
	        'penalty goal': {
	            aname: 'pens'
	        },
	        'red card': {
	            aname: 'reds'
	        },
	        'drop goal': {
	            aname: 'drops'
	        },
	        'penalty try': {
	            aname: 'tries'
	        }
	    };
	    var gameDetails = {
	        home: {
	            tries: [],
	            cons: [],
	            pens: [],
	            reds: [],
	            drops: []
	        },
	        away: {
	            tries: [],
	            cons: [],
	            pens: [],
	            reds: [],
	            drops: []
	        }
	    };
	
	    for (var i = 0; i < details.length; i++) {
	        var detail = details[i];
	        if (detail.hasOwnProperty('team') === false) {
	            //console.info('team missing so continuing to next detail');
	            continue;
	        }
	        //console.info('detail', detail);
	        var key = detail && detail.team.id == homeId ? 'home' : 'away';
	        //console.info('key', key);
	        // @todo - append to respective arrays based on event type
	        if (detail.hasOwnProperty("type")) {
	            var etype = detail.type;
	            if (etype.hasOwnProperty('description')) {
	                var desc = etype.description;
	                /**
	                 * If the desc was found in pickStats object, cache lookup
	                 * object. Use the aname property to append to respective array
	                 * name in home/away.
	                 */
	                if (desc in pickStats) {
	                    var config = pickStats[desc];
	                    var aname = config.aname;
	                    //console.info('key', key, 'desc', desc, 'aname', aname);
	                    gameDetails[key][aname].push(detail);
	                }
	            }
	
	            // Forward compatibility
	            if (etype.hasOwnProperty('text')) {
	                var desc = etype.text;
	                /**
	                 * If the desc was found in pickStats object, cache lookup
	                 * object. Use the aname property to append to respective array
	                 * name in home/away.
	                 */
	                if (desc in pickStats) {
	                    var config = pickStats[desc];
	                    var aname = config.aname;
	                    //console.info('key', key, 'desc', desc, 'aname', aname);
	                    gameDetails[key][aname].push(detail);
	                }
	            }
	        }
	    }
	    //console.info('gameDetails', gameDetails);
	
	    // Group events for a player
	    var updated = formattedRugbyStats(gameDetails);
	
	    return updated;
	};
	
	/**
	 * Get venue from competition
	 * @return {Object} name and country of venue
	 */
	api.getVenueDetails = function (competition) {
	    // Pick venue object
	    var venue = competition && competition.venue || {};
	    // Return name and country
	    return {
	        name: venue.fullName,
	        country: venue.address && venue.address.country
	    };
	};
	
	/**
	 * Get note(description) in case game was settled on a 2 legged tie or
	 * penalties.
	 */
	api.getGameNotes = function (competition, home, away) {
	    //console.info('\ncompetition', competition);
	    //console.info('home', home);
	    //console.info('away', away);
	    var note = competition && competition.leg && competition.leg.displayValue || '';
	    // Get name of winner team
	    var winnerName = home.winner ? home.team.displayName : away.team && away.team.displayName || null;
	    // Declare winner/r'up score
	    var winScore;
	    var rupScore;
	    if (home.aggregateScore !== away.aggregateScore) {
	        winScore = home.winner ? home.aggregateScore : away.aggregateScore;
	        rupScore = home.winner ? away.aggregateScore : home.aggregateScore;
	        note = note + ' - ' + winnerName + ' win ' + winScore + '-' + rupScore + ' on aggregate';
	    }
	    if (home.shootoutScore !== away.shootoutScore) {
	        winScore = home.winner ? home.shootoutScore : away.shootoutScore;
	        rupScore = home.winner ? away.shootoutScore : home.shootoutScore;
	        note = winnerName + ' win ' + winScore + '-' + rupScore + ' on penalties';
	    }
	    return note;
	};
	
	/**
	 * Are home and away stats available?
	 */
	api.isStatsAvailable = function (home, away) {
	    var homeStats = home.statistics || [];
	    var awayStats = away.statistics || [];
	    var available = false;
	    if (homeStats.length && homeStats.length === awayStats.length) {
	        for (var i = 0; i < homeStats.length; i++) {
	            if (Number(homeStats[i].displayValue) > 0 || Number(awayStats[i].displayValue) > 0) {
	                available = true;
	                return available;
	            }
	        }
	    }
	    return available;
	};
	
	/**
	 * Get home and away stats
	 */
	api.getStatsTableData = function (home, away) {
	
	    var homeStats = home.statistics;
	    var awayStats = away.statistics;
	
	    var dataSet = {};
	
	    for (var i = 0; i < homeStats.length; i++) {
	        var homeStat = homeStats[i];
	        var awayStat = awayStats[i];
	        if (homeStat.abbreviation === awayStat.abbreviation) {
	            dataSet[homeStat.abbreviation] = dataSet[homeStat.abbreviation] || {};
	            dataSet[homeStat.abbreviation].name = homeStat.name;
	            dataSet[homeStat.abbreviation].home = homeStat.displayValue;
	            dataSet[homeStat.abbreviation].away = awayStat.displayValue;
	        }
	    }
	
	    return dataSet;
	};
	
	/**
	 * Returns date in DD/MM format
	 * @param  {String} dateString
	 * @return {String}
	 */
	api.getFormattedDate = function (dateString) {
	    try {
	        api.utcOffset = api.utcOffset || moment.parseZone(new Date()).utcOffset();
	        return moment(dateString).utcOffset(api.utcOffset).format('DD/MM');
	    } catch (e) {}
	    return '';
	};
	
	/**
	 * get Broadcasters
	 * @return {Object}
	 */
	api.getBroadcasts = function () {
	    // TODO
	    return {
	        external: true,
	        url: '',
	        name: ''
	    };
	};
	
	// Get player's name and hyperlink
	api.getPlayerNameLink = function (input) {
	    // Default return value
	    var playerDetails = {
	        name: '',
	        link: ''
	    };
	    //console.info('getPlayerNameLink', input);
	
	    // Get scorer name and hyperlink
	    if ('athletesInvolved' in input || 'participants' in input) {
	        var playersInvolved = input.athletesInvolved || input.participants;
	        if (playersInvolved.length > 0) {
	            // Extract player name
	            var player = playersInvolved[0].athlete || playersInvolved[0];
	            if ('displayName' in player) {
	                playerDetails.name = player.displayName;
	            }
	            // Extract player hyperlink
	            if ('links' in player) {
	                var links = player.links;
	                if (links.length > 0) {
	                    var link = links[0];
	                    if ('href' in link) {
	                        playerDetails.link = link.href;
	                    }
	                }
	            }
	        }
	    }
	    return playerDetails;
	};
	
	// Get formatted clock - number'
	api.getFormattedClock = function (input) {
	    // Set defaults
	    var clock = '';
	    // Get clock info for the goal
	    if ('clock' in input) {
	        if ('displayValue' in input.clock) {
	            clock = input.clock.displayValue;
	        }
	    }
	    return clock;
	};
	
	api.getHeading = function (event) {
	    var name = event && event.league && event.league.name || '';
	    var year = event && event.season && event.season.year || '';
	
	    return name ? name + ' ' + event.season.year : '';
	};
	
	/**
	 * Gets the active game status/time for the game strip
	 * @param  {String} gameStatus
	 * @param  {Object} status
	 * @param  {Boolean} timeValid
	 * @return {String}
	 */
	api.getActiveGameStatus = function (gameStatus, status, timeValid) {
	
	    var time = '';
	    var iTypeId = 0;
	
	    // Not a valid time and game is not over so TBD
	    if (typeof timeValid !== 'undefined' && !timeValid && gameStatus !== 'final') {
	        return 'TBD';
	    }
	
	    // No status data so no time
	    if (typeof status === 'undefined') {
	        return '';
	    }
	
	    // Validate status id is available
	    if (typeof status.type !== 'undefined' && typeof status.type.id !== 'undefined') {
	        iTypeId = status.type.id;
	    }
	
	    // Probably not the place for this but set the short display text.
	    // should be an API value for translation.
	    switch (iTypeId) {
	        case "3":
	            //'final':
	            time = 'FT';
	            break;
	        case "6":
	            //' 'postponed':
	            time = 'POST';
	            break;
	        case "23":
	            //' 'halftime':
	            time = 'HT';
	            break;
	        case "27":
	            //' 'abandoned':
	            time = 'ABD';
	            break;
	        case "40":
	            //' 'walkover':
	            time = 'WALK';
	            break;
	        case "48":
	            //' 'fulltime':
	            time = 'FT';
	            break;
	        default:
	            // default status get the time of the event.
	            if (typeof status.displayClock !== 'undefined') {
	                time = status.displayClock.replace(/'$/, '') + "'";
	            }
	    }
	
	    return time;
	};
	
	api.getDefaultLogo = function () {
	    return getLogo();
	};
	
	module.exports = api;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    Action:     Draws the league dropdown. The component has its own store and own set of logic
	                so is an independent component to its parent
	    Orginator:  ben.hobden@espn.com
	*/
	
	'use strict';
	
	var React = __webpack_require__(11);
	var Router = __webpack_require__(166);
	var Link = __webpack_require__(166).Link;
	var classNames = __webpack_require__(361);
	var StoreMixin = __webpack_require__(246);
	var DropDown = __webpack_require__(362);
	var loadLeagues = __webpack_require__(343);
	var Path = __webpack_require__(253);
	
	var Tabs = React.createClass({
	
	    displayName: 'LeagueList',
	
	    mixins: [StoreMixin],
	
	    statics: {
	        storeListeners: ['LeagueStore']
	    },
	
	    getInitialState: function getInitialState() {
	        return this.getStateFromStores();
	    },
	
	    getStateFromStores: function getStateFromStores() {
	        var oLeaguesStore = this.props.context.getStore('LeagueStore');
	        return oLeaguesStore.getLeagues();
	    },
	
	    onChange: function onChange() {
	        this.setState(this.getStateFromStores());
	    },
	
	    componentWillMount: function componentWillMount() {
	        if (!this.props.preventLeagueAction) {
	            this.props.context.executeAction(loadLeagues, { sport: this.props.sport });
	        }
	    },
	
	    render: function render() {
	
	        var sRoot = this.props.root || '';
	        var sPage = this.props.page || '';
	        var sSport = this.props.sport || '';
	        var sLeague = this.props.league || '';
	        var sLabel = this.props.label || '';
	
	        var aLeagues = this.state.leagues || [];
	        var sBaseUrl = '/' + sRoot + '/' + sPage;
	        var aItems = [];
	
	        var iLen = aLeagues && aLeagues.length;
	        for (var i = 0; i < iLen; ++i) {
	            var oLeague = aLeagues[i];
	
	            if (sPage === 'standings' || sPage === 'table') {
	                if (typeof oLeague.season === "undefined" || typeof oLeague.season.type === "undefined" || oLeague.season.type.hasStandings === false) {
	                    //console.log(oLeague.season.type.hasStandings);
	                    continue;
	                }
	            }
	
	            var sCurrLeague = oLeague.midsizeName.toLowerCase();
	            if (sLeague === sCurrLeague) {
	                sLabel = oLeague.name;
	            }
	
	            var oParams = {
	                'league': sCurrLeague
	            };
	
	            //oParams['season'] = oSeason.year;
	            var sURL = typeof this.props.urlFormatter == 'function' ? this.props.urlFormatter(sBaseUrl, oParams) : Path.encode(sBaseUrl, oParams, {});
	
	            var oTmpLink = {
	                name: oLeague.name,
	                url: sURL,
	                trackVar: sLeague + ":" + sPage + ":filter:league",
	                reactURL: true
	            };
	            aItems.push(oTmpLink);
	        }
	
	        var oDDConfig = {
	            name: sLabel,
	            items: aItems
	        };
	
	        if (this.props.id) {
	            oDDConfig.id = this.props.id;
	        }
	
	        return React.createElement(DropDown, oDDConfig);
	    }
	
	});
	
	module.exports = Tabs;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	
	(function () {
		'use strict';
	
		function classNames () {
	
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if ('string' === argType || 'number' === argType) {
					classes += ' ' + arg;
	
				} else if (Array.isArray(arg)) {
					classes += ' ' + classNames.apply(null, arg);
	
				} else if ('object' === argType) {
					for (var key in arg) {
						if (arg.hasOwnProperty(key) && arg[key]) {
							classes += ' ' + key;
						}
					}
				}
			}
	
			return classes.substr(1);
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true){
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	
	}());


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    Action:     Draws a dropdown module
	    Orginator:  ben.hobden@espn.com
	*/
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var classNames = __webpack_require__(361);
	var Link = __webpack_require__(166).Link;
	
	var DropDown = React.createClass({
	    displayName: 'DropDown',
	
	    getInitialState: function getInitialState() {
	        return {
	            open: false,
	            name: ''
	        };
	    },
	
	    /* is the a replacement for espn_ui.Behaviors.button_dropdown */
	    onMouseLeave: function onMouseLeave(e) {
	        // Hides the <ul>, else an empty rectangle appears below the dropdown button
	        this.refs.ul.getDOMNode().setAttribute('style', 'display:none');
	        this.setState({ open: false });
	    },
	
	    onMouseEnter: function onMouseEnter(e) {
	        this._removeStyleAttr();
	        this.setState({ open: true });
	    },
	
	    /**
	     * Removes the style attr from the <ul>
	     * so that the show-dropdown class gets applied
	     */
	    _removeStyleAttr: function _removeStyleAttr() {
	        var ul = this.refs.ul.getDOMNode();
	        if (ul.getAttribute('style') !== null) {
	            ul.removeAttribute('style');
	        }
	    },
	
	    onClick: function onClick(e) {
	        this.refs.ul.getDOMNode().setAttribute('style', 'display:none');
	        this.setState({
	            name: e.currentTarget.textContent || e.currentTarget.innerText,
	            open: false
	        });
	    },
	
	    componentDidMount: function componentDidMount() {
	        var self = this;
	        try {
	            /**
	             * If the blur event does not trigger,
	             * switch to the closed state
	             */
	            $('.scoreboards').on('click', function () {
	                var ul = self.refs.ul.getDOMNode();
	                if (!$(ul).is(':visible')) {
	                    self.setState({
	                        open: false
	                    });
	                }
	            });
	        } catch (e) {}
	    },
	
	    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	        // At times the 'show-dropdown' class doesn't get applied to the DOM
	        // so re-adding it back on component update
	        // TODO: Fix the root issue
	        if (this.state.open) {
	            var div = this.refs.div;
	            div.getDOMNode().setAttribute('class', div.props.className);
	        }
	    },
	
	    render: function render() {
	
	        var aItems = this.props.items || [];
	        var sDDName = this.state.name || this.props.name;
	        var bAutoWidth = this.props.autoWidth || false;
	        var bDropLeft = this.props.dropLeft || false;
	        var bMobileOnly = this.props.mobileOnly || false;
	
	        /* Check items are an array */
	        if (Object.prototype.toString.call(aItems) !== '[object Array]') {
	            /* log error? */
	            return null;
	        }
	
	        var iItemsLength = aItems.length;
	        var i = 0;
	        var aListItems = [];
	        var aDDClasses = ['dropdown-wrapper'];
	        var sDDULClasses = ['dropdown-menu', 'med'];
	
	        for (i = 0; i < iItemsLength; ++i) {
	
	            var oItem = aItems[i];
	            var sUrl = oItem.url || '#';
	            var sName = oItem.name || '-';
	            var sTrackLink = oItem.trackLink || '';
	            var bReactURL = oItem.reactURL || false;
	            var bExternal = oItem.external || false;
	
	            var props = {
	                itemProp: 'url',
	                to: sUrl,
	                href: sUrl,
	                target: '_top'
	            };
	
	            /* Need to convert this */
	            //call util.trackLink(trackParams)
	            props.name = sTrackLink;
	
	            if (bExternal) {
	                target.name = '_newWin';
	            }
	
	            if (bReactURL) {
	                props['data-route'] = 'false';
	                aListItems.push(React.createElement(
	                    'li',
	                    { key: i, onClick: this.onClick },
	                    React.createElement(
	                        Link,
	                        props,
	                        sName
	                    )
	                ));
	            } else {
	                aListItems.push(React.createElement(
	                    'li',
	                    { key: i, onClick: this.onClick },
	                    React.createElement(
	                        'a',
	                        props,
	                        sName
	                    )
	                ));
	            }
	        }
	
	        if (bAutoWidth) {
	            aDDClasses.push('width-auto');
	        }
	
	        if (bMobileOnly) {
	            aDDClasses.push('mobile-only');
	        }
	
	        if (bDropLeft) {
	            sDDULClasses.push('drop-left');
	        }
	
	        if (this.state.open) {
	            aDDClasses.push('show-dropdown');
	        }
	
	        var divProps = {
	            ref: "div",
	            onMouseLeave: this.onMouseLeave,
	            style: { display: 'inline-block', position: 'relative' },
	            className: classNames(aDDClasses)
	        };
	
	        //'data-behavior':    'button_dropdown' /* NOT required as i'll let react deal with this */
	        if (this.props.id) {
	            divProps.id = this.props.id;
	        }
	
	        return React.createElement(
	            'div',
	            _extends({}, divProps, { onMouseLeave: this.onMouseLeave, onMouseEnter: this.onMouseEnter }),
	            React.createElement(
	                'button',
	                { className: 'button-filter med dropdown-toggle', type: 'button', onTouchStart: this.onMouseEnter },
	                sDDName
	            ),
	            React.createElement(
	                'ul',
	                { ref: 'ul', className: classNames(sDDULClasses), role: 'menu' },
	                aListItems
	            )
	        );
	    }
	});
	
	module.exports = DropDown;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	/*
	    Action:     Output dynamic date selector
	    Original:   ---
	                https://github.com/akiran/react-slick cut down version of this slider functionality
	    Orginator:  ben.hobden@espn.com
	    Returns:    The JavaScript date iobject in the callback function
	*/
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var classNames = __webpack_require__(361);
	var DatePicker = __webpack_require__(364);
	var DateFormatMixin = __webpack_require__(365);
	
	var DateSlider = React.createClass({
	
	    displayName: 'DateSelect',
	
	    mixins: [DateFormatMixin],
	
	    getInitialState: function getInitialState() {
	
	        var iDayRange = 7;
	        var iItemWidth = 36;
	        var iStartPos = 0 - iDayRange * iItemWidth;
	        return {
	            activeDate: null,
	            displayDate: null,
	            oneDay: 86400000, // 1 day in milliseconds
	            dayRange: iDayRange,
	            itemWidth: iItemWidth,
	            touchObject: {
	                startX: null,
	                startY: null,
	                curX: null,
	                curY: null,
	                swipeLength: null
	            },
	            didSwipe: false,
	            dragging: false,
	            animate: false,
	            currentPos: iStartPos
	        };
	    },
	
	    /**
	    * Intial load so add the date to the state for use and manipulation
	    **/
	    componentWillMount: function componentWillMount() {
	        var oDate = this.dateToObject(this.props.date) || new Date();
	        var iDate = oDate.setHours(0, 0, 0, 0);
	        this.setState({
	            activeDate: iDate,
	            displayDate: iDate
	        });
	    },
	
	    /**
	    * Parent may have changed date property so lets compare and reset
	    * state if required. As this has mounted already we have state so
	    * check to see if it is possible to animate to the required state.
	    **/
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var oDate = this.dateToObject(nextProps.date) || new Date();
	        var iDate = oDate.setHours(0, 0, 0, 0);
	        var iActiveDate = this.state.activeDate;
	
	        if (iActiveDate !== iDate && nextProps.league !== this.props.league) {
	            this.animateToDate(iDate);
	            this.setState({
	                activeDate: iDate,
	                didSwipe: false
	            });
	        }
	    },
	
	    /**
	    * Captures the date of the node clicked and sets the state to that. If
	    * a swipe was tracked the click is ignored and the swipe tracker reset
	    **/
	    selectDate: function selectDate(iDate, iItemPos, e) {
	        if (e && e.stopPropagation) {
	            e.stopPropagation();
	        }
	        if (e && e.preventDefault) {
	            e.preventDefault();
	        }
	        iDate = typeof iDate === 'object' ? iDate.setHours(0, 0, 0, 0) : iDate;
	        if (typeof this.state.touchObject.swipeLength !== 'number') {
	            this.setState({
	                activeDate: iDate
	            });
	            this.animateToDate(iDate);
	            this.dateSelected(iDate);
	        }
	    },
	
	    /**
	    * Subtracts 7 days from the current date and then forces a redraw
	    **/
	    previous: function previous() {
	        var iNewDate = this.state.displayDate - this.state.oneDay * this.state.dayRange;
	        this.animateToDate(iNewDate);
	    },
	
	    /**
	    * Adds 7 days to the current date and then forces a redraw
	    **/
	    next: function next() {
	        var iNewDate = this.state.displayDate + this.state.oneDay * this.state.dayRange;
	        this.animateToDate(iNewDate);
	    },
	
	    /**
	    * Redraws the page to last know good state
	    **/
	    reset: function reset() {
	        this.setState({});
	    },
	
	    /**
	    * Capture the start position of the mouse/touch so that we can
	    * determine the direction and size of the interaction later.
	    **/
	    swipeStart: function swipeStart(e) {
	
	        var posX, posY;
	
	        posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	        posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	
	        this.setState({
	            dragging: true,
	            touchObject: {
	                startX: posX,
	                startY: posY,
	                curX: posX,
	                curY: posY
	            }
	        });
	
	        e.preventDefault();
	    },
	
	    /**
	    * Captures the current mouse/finger movement and stores the value to
	    * allow the position of the slider to be updated.
	    **/
	    swipeMove: function swipeMove(e) {
	
	        if (!this.state.dragging) {
	            return;
	        }
	
	        var touchObject = this.state.touchObject;
	
	        var iCurrX = e.touches ? e.touches[0].pageX : e.clientX;
	        touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	        touchObject.swipeLength = touchObject.curX - touchObject.startX;
	        var iMoved = iCurrX - this.state.touchObject.curX;
	        touchObject.curX = iCurrX;
	        this.setState({
	            touchObject: touchObject,
	            currentPos: this.state.currentPos + iMoved
	        });
	
	        e.preventDefault();
	    },
	
	    /**
	    * Capture end event and then calculate the action desired by the user
	    **/
	    swipeEnd: function swipeEnd(e) {
	
	        e.preventDefault();
	
	        if (!this.state.dragging) {
	            return;
	        }
	
	        var touchObject = this.state.touchObject;
	        var minSwipe = this.state.listWidth / this.props.touchThreshold;
	        var swipeDirection = this.swipeDirection(touchObject);
	
	        // reset the state of touch related state variables.
	        this.setState({
	            dragging: false,
	            touchObject: {},
	            swipeLength: 0
	        });
	
	        if (swipeDirection === 'left' && Math.abs(touchObject.swipeLength) > 30) {
	            this.setState({ didSwipe: true });
	            this.previous();
	        } else if (swipeDirection === 'right' && Math.abs(touchObject.swipeLength) > 30) {
	            this.setState({ didSwipe: true });
	            this.next();
	        } else if (Math.abs(touchObject.swipeLength) > 1) {
	            // micro swipe, not really a click.
	            this.reset();
	        } else {
	            this.reset();
	        }
	    },
	
	    /**
	    * Determines whether the swipe was within a certain angle range and
	    * therefore a horizontal swipe rather than a verticle one.
	    **/
	    swipeDirection: function swipeDirection(touchObject) {
	
	        var xDist = touchObject.startX - touchObject.curX;
	        var yDist = touchObject.startY - touchObject.curY;
	        var r = Math.atan2(yDist, xDist);
	        var swipeAngle = Math.round(r * 180 / Math.PI);
	
	        if (swipeAngle < 0) {
	            swipeAngle = 360 - Math.abs(swipeAngle);
	        }
	        if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	            return this.props.rtl === false ? 'left' : 'right';
	        }
	        if (swipeAngle >= 135 && swipeAngle <= 225) {
	            return this.props.rtl === false ? 'right' : 'left';
	        }
	
	        return 'vertical';
	    },
	
	    /**
	    * for performance reasons provide a facility to throttle the updates
	    * triggered by mousemove
	    **/
	    _throttle: function _throttle(delay, callback) {
	        var previousCall = new Date().getTime();
	        return function () {
	            var time = new Date().getTime();
	            if (time - previousCall >= delay) {
	                previousCall = time;
	                callback.apply(null, arguments);
	            }
	        };
	    },
	
	    render: function render() {
	
	        var oActiveDates = this.props.activeDates || {};
	        var iDisplayDate = this.state.displayDate;
	        var iActiveDate = this.state.activeDate;
	        var iOneDay = this.state.oneDay;
	        var iDayRange = this.state.dayRange;
	        var iItemWidth = this.state.itemWidth;
	        var iSwipeLen = this.state.touchObject.swipeLength || 0;
	        var aDayNames = this.dateDayNamesMedium();
	        var iStartDate = iDisplayDate - iOneDay * iDayRange;
	        var iEndDate = iDisplayDate + (iDayRange - 1) * iOneDay;
	        var aOptNodes = [];
	
	        /**
	        * Build the date list for the carousel, take the date and build
	        * an item for each day X days either side
	        **/
	        for (var i = 0; i < iDayRange * 3; i++) {
	
	            var iOptDate = iStartDate + iOneDay * i;
	            var iItemPos = iItemWidth * i;
	            var sActiveClass = '';
	
	            var props = {
	                'data-id': this.dateToKey(iOptDate),
	                className: 'day slick-slide', //slick-active
	                index: i,
	                style: { width: iItemWidth + 'px' },
	                key: i
	            };
	
	            if (!oActiveDates[iOptDate]) {
	                sActiveClass = 'inactive';
	            }
	
	            if (iActiveDate === iOptDate) {
	                sActiveClass = 'active';
	            }
	
	            /* react will add a span round the first value and the css dosn't want that */
	            var oOptDate = this.dateToObject(iOptDate);
	            var sDisplayValue = aDayNames[oOptDate.getDay()] + ' <span>' + oOptDate.getDate() + '</span>';
	
	            aOptNodes.push(React.createElement(
	                'div',
	                _extends({}, props, { onClick: this.selectDate.bind(this, iOptDate, iItemPos) }),
	                React.createElement('a', { key: 'item' + this.dateToKey(iOptDate), className: sActiveClass, dangerouslySetInnerHTML: { __html: sDisplayValue } })
	            ));
	        }
	
	        var oSliderprops = {
	            onMouseDown: this.swipeStart,
	            onMouseMove: this.state.dragging ? this._throttle(50, this.swipeMove) : null,
	            onMouseUp: this.swipeEnd,
	            onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	            onTouchStart: this.swipeStart,
	            onTouchMove: this.state.dragging ? this._throttle(50, this.swipeMove) : null,
	            onTouchEnd: this.swipeEnd,
	            onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	            className: 'slick-list draggable',
	            tabIndex: 0
	        };
	
	        var oSliderStyle = {
	            width: iItemWidth * (iDayRange * 3) + 'px',
	            left: this.state.currentPos + (this.props.centered ? iItemWidth * Math.floor(iDayRange / 2) : 0) + 'px'
	        };
	
	        if (this.state.animate) {
	            oSliderStyle.transition = 'left 0.5s'; //'all 1s ease-in-out'
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'carousel-wrap' },
	            React.createElement(
	                'div',
	                { className: 'carousel-week' },
	                React.createElement(
	                    'span',
	                    { key: 'firstDay', className: 'firstDay' },
	                    this.dateFormat(iDisplayDate - iOneDay * 3, 'date13'),
	                    ' - '
	                ),
	                React.createElement(
	                    'span',
	                    { key: 'lastDay', className: 'lastDay' },
	                    this.dateFormat(iEndDate - iOneDay * 3, 'date13')
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'date-picker-carousel slick-initialized slick-slider' },
	                React.createElement(
	                    'div',
	                    oSliderprops,
	                    React.createElement(
	                        'div',
	                        { className: 'slick-track', style: oSliderStyle },
	                        aOptNodes
	                    )
	                ),
	                React.createElement('button', { type: 'button', 'data-role': 'none', className: 'slick-prev slice-arrow', style: { display: 'block' }, onClick: this.previous }),
	                React.createElement('button', { type: 'button', 'data-role': 'none', className: 'slick-next slice-arrow', style: { display: 'block' }, onClick: this.next })
	            ),
	            React.createElement(DatePicker, { date: iDisplayDate, callback: this.selectDate }),
	            React.createElement(
	                'div',
	                { className: 'carousel-day' },
	                React.createElement('span', { id: 'sbpDate', className: 'date' })
	            )
	        );
	    },
	
	    /**
	    * Calculates the position of the original display date within the
	    * new range of dates so it can create the animation effect
	    **/
	    animateToDate: function animateToDate(iNewDate) {
	
	        // get the visible range of dates.
	        var iDisplayDate = this.state.displayDate;
	        var iOneDay = this.state.oneDay;
	        var iDayRange = this.state.dayRange;
	        var iMinDate = iNewDate - iOneDay * iDayRange;
	        var iMaxDate = iMinDate + iDayRange * 3 * iOneDay;
	        var iItemWidth = this.state.itemWidth;
	        var iMoveTo = 0;
	
	        if (iDisplayDate >= iMinDate && iDisplayDate <= iMaxDate) {
	            // is the original date within the visible range?
	            var iDiff = iDisplayDate - iMinDate;
	            iMoveTo = 0 - iDiff / iOneDay * iItemWidth;
	        } else if (iDisplayDate > iMaxDate) {
	            // is it bigger then set moveto to last
	            iMoveTo = 0 - iItemWidth * (iDayRange * 3);
	        } else if (iDisplayDate < iMinDate) {
	            // is it smaller then set moveto to first
	            iMoveTo = 0;
	        }
	
	        this.setState({
	            displayDate: iNewDate,
	            currentPos: iMoveTo,
	            animate: false
	        });
	    },
	
	    /**
	    * Call once we have selected a date
	    **/
	    dateSelected: function dateSelected(iDate) {
	        if (typeof this.props.callback !== 'undefined') {
	            this.props.callback(this.dateToObject(iDate));
	        }
	    },
	
	    /**
	    * After the component has drawn reset the position of the slider
	    * this will cause the css animation to trigger. The timeout is to
	    * force react to re-render else it trys to group the changes into 1
	    * update and you won't see the animation
	    **/
	    componentDidUpdate: function componentDidUpdate() {
	
	        var iDayRange = this.state.dayRange;
	        var iItemWidth = this.state.itemWidth;
	        var iNewPos = 0 - iDayRange * iItemWidth;
	
	        if (iNewPos !== this.state.currentPos) {
	            setTimeout((function () {
	                this.setState({
	                    currentPos: iNewPos,
	                    animate: true
	                });
	            }).bind(this), 1);
	        }
	    }
	
	});
	
	module.exports = DateSlider;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	/*
	    Action:     Mimic the jquery UI date picker
	    Original:   ---
	    Orginator:  ben.hobden@espn.com
	    Returns:    The JavaScript date iobject in the callback function
	*/
	
	var React = __webpack_require__(11);
	var classNames = __webpack_require__(361);
	var DateFormatMixin = __webpack_require__(365);
	
	var DatePicker = React.createClass({
	
	    displayName: 'DatePicker',
	
	    mixins: [DateFormatMixin],
	
	    getInitialState: function getInitialState() {
	
	        return {
	            date: null,
	            today: null,
	            month: null,
	            open: false,
	            monthOpen: false,
	            yearOpen: false,
	            oneDay: 86400000 };
	    },
	
	    // 1 day in milliseconds
	    /**
	    * Intial load so add the date to the state for use and manipulation
	    **/
	    componentWillMount: function componentWillMount() {
	        this.updateState(this.props);
	    },
	
	    /**
	    * Parent may have changed date propertyso lets compare and set state
	    * if required
	    **/
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var oDate = this.dateToObject(nextProps.date) || new Date();
	        var iDate = oDate.setHours(0, 0, 0, 0);
	        if (this.props.date !== nextProps.date) {
	            this.updateState(nextProps);
	        }
	    },
	
	    /**
	    * Checks the prop for a date, if none found it sets it to today, also
	    * sets the current month and year. Makes sure all dates are set to
	    * midnight
	    **/
	    updateState: function updateState(oProps) {
	        var oDate = this.dateToObject(oProps.date) || new Date();
	        var iDate = oDate.setHours(0, 0, 0, 0);
	        var iMonth = new Date(iDate).setDate(1);
	        var iToday = new Date().setHours(0, 0, 0, 0);
	
	        this.setState({
	            date: iDate,
	            today: iToday,
	            month: iMonth
	        });
	    },
	
	    /**
	    * Toggles the state to show or hide the calendar dropdown.
	    **/
	    showCalendar: function showCalendar() {
	        if (this.state.open) {
	            this.hide();
	        } else {
	            this.show();
	        }
	    },
	
	    show: function show() {
	        document.addEventListener("click", this.hide);
	        this.setState({
	            open: true,
	            monthOpen: false,
	            yearOpen: false
	        });
	    },
	
	    hide: function hide() {
	        document.removeEventListener("click", this.hide);
	        this.setState({
	            open: false,
	            monthOpen: false,
	            yearOpen: false
	        });
	    },
	
	    /**
	    * Moves the current view month forward by 1
	    **/
	    nextMonth: function nextMonth(e) {
	
	        e.stopPropagation();
	        e.nativeEvent.stopImmediatePropagation();
	
	        var oMonth = this.dateToObject(this.state.month);
	        var iMonth = oMonth.getMonth() + 1;
	        var iYear = oMonth.getFullYear();
	        if (iMonth > 11) {
	            iMonth = 0;
	            iYear++;
	        }
	        var oMonth = new Date(iYear, iMonth, 1);
	        this.setState({
	            month: oMonth.getTime()
	        });
	    },
	
	    /**
	    * Moves the current view month back by 1
	    **/
	    prevMonth: function prevMonth(e) {
	
	        e.stopPropagation();
	        e.nativeEvent.stopImmediatePropagation();
	
	        var oMonth = this.dateToObject(this.state.month);
	        var iMonth = oMonth.getMonth() - 1;
	        var iYear = oMonth.getFullYear();
	        if (iMonth < 0) {
	            iMonth = 11;
	            iYear--;
	        }
	        var oMonth = new Date(iYear, iMonth, 1);
	        this.setState({
	            month: oMonth.getTime()
	        });
	    },
	
	    selectDate: function selectDate(iDate) {
	        if (typeof this.props.callback !== 'undefined') {
	            this.props.callback(this.dateToObject(iDate));
	        }
	    },
	
	    /**
	    * Helper function to build all the dates for the calendar
	    **/
	    buildDates: function buildDates() {
	
	        var iDate = this.state.date;
	        var iToday = this.state.today;
	        var iMonth = this.state.month;
	        var oActiveDates = this.props.activeDates || {};
	
	        /* Calculate first date */
	        var iStartDay = iMonth - this.dateToObject(iMonth).getDay() * this.state.oneDay;
	
	        var aRows = [];
	        for (var iWeeks = 0; iWeeks < 6; iWeeks++) {
	            var aDays = [];
	            //today old new active
	            for (var iDays = 0; iDays < 7; iDays++) {
	
	                var aDayClass = ['day'];
	                var props = {
	                    key: iDays,
	                    onClick: this.selectDate.bind(this, iStartDay)
	                };
	
	                if (iToday === iStartDay) {
	                    aDayClass.push('today');
	                }
	
	                if (iDate === iStartDay) {
	                    aDayClass.push('active');
	                }
	
	                // TODO: Highlight active game dates when available in the future
	                if (!oActiveDates[iStartDay]) {
	                    // aDayClass.push('inactive');
	                }
	
	                if (this.dateToObject(iMonth).getMonth() !== this.dateToObject(iStartDay).getMonth()) {
	                    aDayClass.push('old');
	                }
	
	                props.className = classNames(aDayClass);
	                aDays.push(React.createElement(
	                    'td',
	                    props,
	                    this.dateToObject(iStartDay).getDate()
	                ));
	
	                iStartDay = iStartDay + this.state.oneDay;
	            }
	            aRows.push(React.createElement(
	                'tr',
	                { key: iWeeks },
	                aDays
	            ));
	        }
	
	        return aRows;
	    },
	
	    onClickToday: function onClickToday() {
	        this.selectDate(this.state.today);
	    },
	
	    render: function render() {
	
	        var oMonth = this.state.month;
	
	        var propsPicker = {
	            className: "datepicker datepicker-dropdown datepicker-orient-left datepicker-orient-top",
	            style: { top: '36px', left: '0px', display: 'none' },
	            autoFocus: true,
	            tabIndex: "-1"
	        };
	
	        if (this.state.open) {
	            propsPicker.style.display = 'block';
	        }
	
	        var aDates = this.buildDates();
	
	        return React.createElement(
	            'div',
	            { className: 'calendar-container', 'data-thisdate': '20150710', 'data-startdate': '2002-10-10', ref: 'calendarContainer' },
	            React.createElement('span', { className: 'datepicker date icon', onClick: this.showCalendar }),
	            React.createElement(
	                'div',
	                propsPicker,
	                React.createElement(
	                    'div',
	                    { className: 'datepicker-days', style: { display: 'block' } },
	                    React.createElement(
	                        'table',
	                        { className: 'table-condensed' },
	                        React.createElement(
	                            'thead',
	                            null,
	                            React.createElement(
	                                'tr',
	                                { className: 'top-nav' },
	                                React.createElement('th', { className: 'prev', style: { visibility: 'visible' }, onClick: this.prevMonth }),
	                                React.createElement(
	                                    'th',
	                                    { colSpan: '5', className: 'datepicker-switch' },
	                                    this.dateFormat(oMonth, 'date11')
	                                ),
	                                React.createElement('th', { className: 'next', style: { visibility: 'visible' }, onClick: this.nextMonth })
	                            ),
	                            React.createElement(
	                                'tr',
	                                null,
	                                React.createElement(
	                                    'th',
	                                    { className: 'dow' },
	                                    'Su'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { className: 'dow' },
	                                    'Mo'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { className: 'dow' },
	                                    'Tu'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { className: 'dow' },
	                                    'We'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { className: 'dow' },
	                                    'Th'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { className: 'dow' },
	                                    'Fr'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { className: 'dow' },
	                                    'Sa'
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            'tbody',
	                            null,
	                            aDates
	                        ),
	                        React.createElement(
	                            'tfoot',
	                            null,
	                            React.createElement(
	                                'tr',
	                                null,
	                                React.createElement(
	                                    'th',
	                                    { colSpan: '7', className: 'today', onClick: this.onClickToday, style: { display: 'table-cell' } },
	                                    'View Today'
	                                )
	                            )
	                        )
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'datepicker-months', style: { display: 'none' } },
	                    React.createElement(
	                        'table',
	                        { className: 'table-condensed' },
	                        React.createElement(
	                            'thead',
	                            null,
	                            React.createElement(
	                                'tr',
	                                { className: 'top-nav' },
	                                React.createElement('th', { className: 'prev', style: { visibility: 'visible' } }),
	                                React.createElement(
	                                    'th',
	                                    { colSpan: '5', className: 'datepicker-switch' },
	                                    '2015'
	                                ),
	                                React.createElement('th', { className: 'next', style: { visibility: 'visible' } })
	                            )
	                        ),
	                        React.createElement(
	                            'tbody',
	                            null,
	                            React.createElement(
	                                'tr',
	                                null,
	                                React.createElement(
	                                    'td',
	                                    { colSpan: '7' },
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'Jan'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'Feb'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'Mar'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'Apr'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'May'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'Jun'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'Jul'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'Aug'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'Sep'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'Oct'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'Nov'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'month' },
	                                        'Dec'
	                                    )
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            'tfoot',
	                            null,
	                            React.createElement(
	                                'tr',
	                                null,
	                                React.createElement(
	                                    'th',
	                                    { colSpan: '7', className: 'today', onClick: this.onClickToday, style: { display: 'table-cell' } },
	                                    'View Today'
	                                )
	                            ),
	                            React.createElement(
	                                'tr',
	                                null,
	                                React.createElement(
	                                    'th',
	                                    { colSpan: '7', className: 'clear', style: { display: 'none' } },
	                                    'Clear'
	                                )
	                            )
	                        )
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'datepicker-years', style: { display: 'none' } },
	                    React.createElement(
	                        'table',
	                        { className: 'table-condensed' },
	                        React.createElement(
	                            'thead',
	                            null,
	                            React.createElement(
	                                'tr',
	                                { className: 'top-nav' },
	                                React.createElement('th', { className: 'prev', style: { visibility: 'visible' } }),
	                                React.createElement(
	                                    'th',
	                                    { colSpan: '5', className: 'datepicker-switch' },
	                                    '2009-2020'
	                                ),
	                                React.createElement('th', { className: 'next', style: { visibility: 'visible' } })
	                            )
	                        ),
	                        React.createElement(
	                            'tbody',
	                            null,
	                            React.createElement(
	                                'tr',
	                                null,
	                                React.createElement(
	                                    'td',
	                                    { colSpan: '7' },
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year old' },
	                                        '2009'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year' },
	                                        '2010'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year' },
	                                        '2011'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year' },
	                                        '2012'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year' },
	                                        '2013'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year' },
	                                        '2014'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year' },
	                                        '2015'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year' },
	                                        '2016'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year disabled' },
	                                        '2017'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year disabled' },
	                                        '2018'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year disabled' },
	                                        '2019'
	                                    ),
	                                    React.createElement(
	                                        'span',
	                                        { className: 'year new disabled' },
	                                        '2020'
	                                    )
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            'tfoot',
	                            null,
	                            React.createElement(
	                                'tr',
	                                null,
	                                React.createElement(
	                                    'th',
	                                    { colSpan: '7', className: 'today', onClick: this.onClickToday, style: { display: 'table-cell' } },
	                                    'View Today'
	                                )
	                            ),
	                            React.createElement(
	                                'tr',
	                                null,
	                                React.createElement(
	                                    'th',
	                                    { colSpan: '7', className: 'clear', style: { display: 'none' } },
	                                    'Clear'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    }
	
	});
	
	module.exports = DatePicker;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	// Date comparison taken from
	// http://stackoverflow.com/questions/492994/compare-two-dates-with-javascript
	
	var dateTime = __webpack_require__(366);
	var moment = __webpack_require__(367);
	
	module.exports = {
	
	    dateToKey: function dateToKey(oDate) {
	        return this.dateFormat(oDate, 'date12');
	    },
	
	    paramToDate: function paramToDate(sParam) {
	
	        if (typeof sParam === 'undefined' || sParam === null || !sParam) {
	            return null;
	        }
	        var iYear = sParam.substr(0, 4);
	        var iMonth = sParam.substr(4, 2);
	        var iDay = sParam.substr(6, 2);
	
	        return this.dateToObject(iYear + '-' + iMonth + '-' + iDay);
	    },
	
	    dateDayNamesMedium: function dateDayNamesMedium() {
	        return dateTime.dayNamesMedium;
	    },
	
	    dateFormat: function dateFormat(ISODate, _dateFormat, showTimezone) {
	
	        if (ISODate === undefined) {
	            return ISODate;
	        }
	
	        if (_dateFormat === undefined) {
	            _dateFormat = 'date6';
	        }
	
	        showTimezone = showTimezone || false;
	
	        var formatsMap = dateTime.dateFormats;
	        var utcMoment = moment(ISODate); //, moment.ISO_8601
	        var localMoment = moment(utcMoment.utc().toDate());
	
	        _dateFormat = formatsMap[_dateFormat];
	        var dateString = localMoment.format(_dateFormat);
	        //console.log(localMoment.format('z'));
	        //window.moment().tz(window.jstz.determine().name()).format("z");
	        //if ($(element).hasClass("time") && showTimezone === "true") {
	        //    var currentTimezone = espn_ui.Helpers.timezones.getCurrentTimezone();
	        //    dateString += " " + espn_ui.Behaviors.date_timezone.replace(currentTimezone);
	        //}
	
	        return dateString;
	    },
	
	    /**
	    * Converts the date in d to a date-object using moment
	    **/
	    dateToObject: function dateToObject(d) {
	        return moment(d).toDate();
	    },
	
	    /**
	    * Compare two dates (could be of any type supported by the convert
	    * function above) and returns:
	    *  -1 : if a < b
	    *   0 : if a = b
	    *   1 : if a > b
	    * NaN : if a or b is an illegal date
	    * NOTE: The code inside isFinite does an assignment (=).
	    **/
	    dateCompare: function dateCompare(a, b) {
	        return isFinite(a = this.dateToObject(a).valueOf()) && isFinite(b = this.dateToObject(b).valueOf()) ? (a > b) - (a < b) : NaN;
	    },
	
	    /**
	    * Checks if date in d is between dates in start and end.
	    * Returns a boolean or NaN:
	    *    true  : if d is between start and end (inclusive)
	    *    false : if d is before start or after end
	    *    NaN   : if one or more of the dates is illegal.
	    * NOTE: The code inside isFinite does an assignment (=).
	    **/
	    dateInRange: function dateInRange(d, start, end) {
	        return isFinite(d = this.dateToObject(d).valueOf()) && isFinite(start = this.dateToObject(start).valueOf()) && isFinite(end = this.dateToObject(end).valueOf()) ? start <= d && d <= end : NaN;
	    }
	
	};

/***/ },
/* 366 */
/***/ function(module, exports) {

	"use strict";
	
	var dateTime = {
		"dateFormats": {
			"time1": "",
			"date1": "D MMM, YYYY",
			"date2": "D/M/YYYY",
			"date3": "DD/MM/YYYY",
			"date4": "DDMMYYYY",
			"date5": "Do MMMM YYYY",
			"date6": "dddd, Do MMMM YYYY",
			"date7": "ddd, D MMM YYYY",
			"date8": "D/M",
			"date9": "ddd",
			"date10": "dddd, MMMM Do",
			"date11": "MMMM YYYY",
			"date12": "YYYYMMDD",
			"date13": "MMMM Do, YYYY",
			"dateTime1": "h:mm A, MMMM D, YYYY"
		},
		"dayNamesLong": 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday'.split(' '),
		"dayNamesMedium": 'Sun Mon Tue Wed Thu Fri Sat'.split(' '),
		"dayNamesShort": 'Su Mo Tu We Th Fr Sa'.split(' '),
		"monthNamesLong": 'January February March April May June July August September October November December'.split(' '),
		"monthNamesShort": 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ')
	};
	
	module.exports = dateTime;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(368);
	moment.tz.load(__webpack_require__(369));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(console) {//! moment-timezone.js
	//! version : 0.4.0
	//! author : Tim Wood
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(254)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else if (typeof exports === 'object') {
			module.exports = factory(require('moment')); // Node
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		if (moment.tz !== undefined) {
			logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
			return moment;
		}
	
		var VERSION = "0.4.0",
			zones = {},
			links = {},
			names = {},
	
			momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name    : data[0],
				abbrs   : mapIndices(data[1].split(' '), indices),
				offsets : mapIndices(offsets, indices),
				untils  : untils
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name    = unpacked.name;
				this.abbrs   = unpacked.abbrs;
				this.untils  = unpacked.untils;
				this.offsets = unpacked.offsets;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				name = packed[i].split('|')[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
			}
		}
	
		function getZone (name, caller) {
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
			
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			return !!(m._a && (m._tzm === undefined));
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.offset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					mom.utcOffset(-offset, keepTime);
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name) {
			if (name) {
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName = abbrWrap(fn.zoneName);
		fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
		fn.utc      = resetZoneWrap(fn.utc);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 369 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2015d",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q",
			"Africa/Accra|LMT GMT GHST|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE",
			"Africa/Addis_Ababa|LMT EAT BEAT BEAUT|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ",
			"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0",
			"Africa/Bangui|LMT WAT|-d.A -10|01|-22y0d.A",
			"Africa/Bissau|LMT WAT GMT|12.k 10 0|012|-2ldWV.E 2xonV.E",
			"Africa/Blantyre|LMT CAT|-2a.k -20|01|-2GJea.k",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0",
			"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|012121212121212121312121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uo0 e00 DA0 11A0 rA0 e00 Jc0 WM0 m00 gM0 M00 WM0 jc0 e00 RA0 11A0 dA0 e00 Uo0 11A0 800 gM0 Xc0 11A0 5c0 e00 17A0 WM0 2o0 e00 1ao0 19A0 1g00 16M0 1iM0 1400 1lA0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qo0 1200 1kM0 14M0 1i00",
			"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1y7p0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Africa/El_Aaiun|LMT WAT WET WEST|Q.M 10 0 -10|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uo0 e00 DA0 11A0 rA0 e00 Jc0 WM0 m00 gM0 M00 WM0 jc0 e00 RA0 11A0 dA0 e00 Uo0 11A0 800 gM0 Xc0 11A0 5c0 e00 17A0 WM0 2o0 e00 1ao0 19A0 1g00 16M0 1iM0 1400 1lA0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qo0 1200 1kM0 14M0 1i00",
			"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0",
			"Africa/Juba|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0",
			"Africa/Monrovia|MMT LRT GMT|H.8 I.u 0|012|-23Lzg.Q 29s01.m",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00",
			"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00",
			"Africa/Windhoek|SWAT SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0",
			"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Anchorage|CAT CAWT CAPT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Anguilla|LMT AST|46.4 40|01|-2kNvR.U",
			"America/Araguaina|LMT BRT BRST|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0",
			"America/Argentina/Buenos_Aires|CMT ART ARST ART ARST|4g.M 40 30 30 20|0121212121212121212121212121212121212121213434343434343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0",
			"America/Argentina/Catamarca|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Cordoba|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0",
			"America/Argentina/Jujuy|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 g0p0 10M0 j3c0 uL0",
			"America/Argentina/La_Rioja|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Mendoza|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|0121212121212121212121212121212121212121213434345656543235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 g0p0 10M0 agM0 Op0 7TX0 uL0",
			"America/Argentina/Rio_Gallegos|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Salta|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0",
			"America/Argentina/San_Juan|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ak00 m10 8lb0 uL0",
			"America/Argentina/San_Luis|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456536353465653|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 kin0 10M0 ak00 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
			"America/Argentina/Tucuman|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|012121212121212121212121212121212121212121343434345434323534343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 4N0 8BX0 uL0 1qN0 WL0",
			"America/Argentina/Ushuaia|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ajA0 8p0 8zb0 uL0",
			"America/Aruba|LMT ANT AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d",
			"America/Asuncion|AMT PYT PYT PYST|3O.E 40 30 30|012131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0",
			"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0",
			"America/Bahia|LMT BRT BRST|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0",
			"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0",
			"America/Belem|LMT BRT BRST|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0",
			"America/Belize|LMT CST CHDT CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0",
			"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0",
			"America/Boa_Vista|LMT AMT AMST|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0",
			"America/Bogota|BMT COT COST|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0",
			"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Cambridge_Bay|zzz MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Campo_Grande|LMT AMT AMST|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0",
			"America/Caracas|CMT VET VET|4r.E 4u 40|0121|-2kV7w.k 28KM2.k 1IwOu",
			"America/Cayenne|LMT GFT GFT|3t.k 40 30|012|-2mrwu.E 2gWou.E",
			"America/Cayman|CMT EST|5j.A 50|01|-2uduE.o",
			"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0",
			"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0",
			"America/Creston|MST PST|70 80|010|-29DR0 43B0",
			"America/Cuiaba|LMT AMT AMST|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0",
			"America/Danmarkshavn|LMT WGT WGST GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0",
			"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0",
			"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Eirunepe|LMT ACT ACST AMT|4D.s 50 40 40|0121212121212121212121212121212131|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0",
			"America/Ensenada|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOP0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Fortaleza|LMT BRT BRST|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Godthab|LMT WGT WGST|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0",
			"America/Guayaquil|QMT ECT|5e 50|01|-1yVSK",
			"America/Guyana|LMT GBGT GYT GYT GYT|3Q.E 3J 3J 30 40|01234|-2dvU7.k 24JzQ.k mlc0 Bxbf",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0",
			"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Inuvik|zzz PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Iqaluit|zzz EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0",
			"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/La_Paz|CMT BOST BOT|4w.A 3w.A 40|012|-1x37r.o 13b0",
			"America/Lima|LMT PET PEST|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0",
			"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp0 1Vb0 3dB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Maceio|LMT BRT BRST|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0",
			"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0",
			"America/Manaus|LMT AMT AMST|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0",
			"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0",
			"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0",
			"America/Metlakatla|PST PWT PPT PDT|80 70 70 70|0120303030303030303030303030303030|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0",
			"America/Miquelon|LMT AST PMST PMDT|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0",
			"America/Montevideo|MMT UYT UYHST UYST UYT UYHST|3I.I 3u 30 20 30 2u|012121212121212121212121213434343434345454543453434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10",
			"America/Montreal|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Noronha|LMT FNT FNST|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0",
			"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Pangnirtung|zzz AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Paramaribo|LMT PMT PMT NEGT SRT SRT|3E.E 3E.Q 3E.A 3u 3u 30|012345|-2nDUj.k Wqo0.c qanX.I 1dmLN.o lzc0",
			"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0",
			"America/Port-au-Prince|PPMT EST EDT|4N 50 40|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Porto_Acre|LMT ACT ACST AMT|4v.c 50 40 40|01212121212121212121212121212131|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0",
			"America/Porto_Velho|LMT AMT AMST|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0",
			"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0",
			"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Rankin_Inlet|zzz CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Recife|LMT BRT BRST|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0",
			"America/Resolute|zzz CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Santa_Isabel|LMT MST PST PDT PWT PPT|7D.s 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOP0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0",
			"America/Santarem|LMT AMT AMST BRT|3C.M 40 30 30|0121212121212121212121212121213|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0",
			"America/Santiago|SMT CLT CLT CLST CLST CLT|4G.K 50 40 40 30 30|01020313131313121242124242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424245|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 1wn0",
			"America/Santo_Domingo|SDMT EST EDT EHDT AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00",
			"America/Sao_Paulo|LMT BRT BRST|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0",
			"America/Scoresbysund|LMT CGT CGST EGST EGT|1r.Q 20 10 0 10|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Yellowknife|zzz MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Antarctica/Casey|zzz AWST CAST|0 -80 -b0|012121|-2q00 1DjS0 T90 40P0 KL0",
			"Antarctica/Davis|zzz DAVT DAVT|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0",
			"Antarctica/DumontDUrville|zzz PMT DDUT|0 -a0 -a0|0102|-U0o0 cfq0 bFm0",
			"Antarctica/Macquarie|AEST AEDT zzz MIST|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0",
			"Antarctica/Mawson|zzz MAWT MAWT|0 -60 -50|012|-CEo0 2fyk0",
			"Antarctica/McMurdo|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00",
			"Antarctica/Palmer|zzz ARST ART ART ARST CLT CLST CLT|0 30 40 30 20 40 30 30|012121212123435656565656565656565656565656565656565656565656565656565656565656567|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 1wn0",
			"Antarctica/Rothera|zzz ROTT|0 30|01|gOo0",
			"Antarctica/Syowa|zzz SYOT|0 -30|01|-vs00",
			"Antarctica/Troll|zzz UTC CEST|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Antarctica/Vostok|zzz VOST|0 -60|01|-tjA0",
			"Arctic/Longyearbyen|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Asia/Aden|LMT AST|-36.Q -30|01|-TvD6.Q",
			"Asia/Almaty|LMT ALMT ALMT ALMST|-57.M -50 -60 -70|0123232323232323232323232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3Cl0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0",
			"Asia/Anadyr|LMT ANAT ANAT ANAST ANAST ANAST ANAT|-bN.U -c0 -d0 -e0 -d0 -c0 -b0|01232414141414141414141561414141414141414141414141414141414141561|-1PcbN.U eUnN.U 23CL0 1db0 1cN0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0",
			"Asia/Aqtau|LMT FORT FORT SHET SHET SHEST AQTT AQTST AQTST AQTT|-3l.4 -40 -50 -50 -60 -60 -50 -60 -50 -40|012345353535353535353536767676898989898989898989896|-1Pc3l.4 eUnl.4 1jcL0 JDc0 1cL0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2UK0 Fz0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cN0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 RW0",
			"Asia/Aqtobe|LMT AKTT AKTT AKTST AKTT AQTT AQTST|-3M.E -40 -50 -60 -60 -50 -60|01234323232323232323232565656565656565656565656565|-1Pc3M.E eUnM.E 23CL0 1db0 1cM0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2UK0 Fz0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0",
			"Asia/Ashgabat|LMT ASHT ASHT ASHST ASHST TMT TMT|-3R.w -40 -50 -60 -50 -40 -50|012323232323232323232324156|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 ba0 xC0",
			"Asia/Baghdad|BMT AST ADT|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0",
			"Asia/Bahrain|LMT GST AST|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8",
			"Asia/Baku|LMT BAKT BAKT BAKST BAKST AZST AZT AZT AZST|-3j.o -30 -40 -50 -40 -40 -30 -40 -50|0123232323232323232323245657878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 10K0 c30 1cJ0 1cL0 8wu0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Asia/Bangkok|BMT ICT|-6G.4 -70|01|-218SG.4",
			"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0",
			"Asia/Bishkek|LMT FRUT FRUT FRUST FRUST KGT KGST KGT|-4W.o -50 -60 -70 -60 -50 -60 -60|01232323232323232323232456565656565656565656565656567|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11c0 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 T8u",
			"Asia/Brunei|LMT BNT BNT|-7D.E -7u -80|012|-1KITD.E gDc9.E",
			"Asia/Calcutta|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0",
			"Asia/Chita|LMT YAKT YAKT YAKST YAKST YAKT IRKT|-7x.Q -80 -90 -a0 -90 -a0 -80|012323232323232323232324123232323232323232323232323232323232323256|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Asia/Choibalsan|LMT ULAT ULAT CHOST CHOT CHOT CHOST|-7C -70 -80 -a0 -90 -80 -90|0123434343434343434343434343434343434343434343456565656565656565656565656565656565656565656565|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0",
			"Asia/Chongqing|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0",
			"Asia/Colombo|MMT IST IHST IST LKT LKT|-5j.w -5u -60 -6u -6u -60|01231451|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu",
			"Asia/Dacca|HMT BURT IST DACT BDT BDST|-5R.k -6u -5u -60 -60 -70|01213454|-18LFR.k 1unn.k HB0 m6n0 LqMu 1x6n0 1i00",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0",
			"Asia/Dili|LMT TLT JST TLT WITA|-8m.k -80 -90 -90 -80|012343|-2le8m.k 1dnXm.k 8HA0 1ew00 Xld0",
			"Asia/Dubai|LMT GST|-3F.c -40|01|-21JfF.c",
			"Asia/Dushanbe|LMT DUST DUST DUSST DUSST TJT|-4z.c -50 -60 -70 -60 -50|0123232323232323232323245|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 14N0",
			"Asia/Gaza|EET EET EEST IST IDT|-20 -30 -30 -20 -30|010101010102020202020202020202023434343434343434343434343430202020202020202020202020202020202020202020202020202020202020202020202020202020202020|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0",
			"Asia/Hebron|EET EET EEST IST IDT|-20 -30 -30 -20 -30|01010101010202020202020202020202343434343434343434343434343020202020202020202020202020202020202020202020202020202020202020202020202020202020202020|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0",
			"Asia/Ho_Chi_Minh|LMT PLMT ICT IDT JST|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0",
			"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0",
			"Asia/Hovd|LMT HOVT HOVT HOVST|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0",
			"Asia/Irkutsk|IMT IRKT IRKT IRKST IRKST IRKT|-6V.5 -70 -80 -90 -80 -90|012323232323232323232324123232323232323232323232323232323232323252|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Asia/Istanbul|IMT EET EEST TRST TRT|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1df0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Asia/Jakarta|BMT JAVT WIB JST WIB WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu",
			"Asia/Jayapura|LMT WIT ACST|-9m.M -90 -9u|0121|-1uu9m.M sMMm.M L4nu",
			"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0",
			"Asia/Kabul|AFT AFT|-40 -4u|01|-10Qs0",
			"Asia/Kamchatka|LMT PETT PETT PETST PETST|-ay.A -b0 -c0 -d0 -c0|01232323232323232323232412323232323232323232323232323232323232412|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0",
			"Asia/Karachi|LMT IST IST KART PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy01 1cL0 dK0X 11b0 1610 1jX0",
			"Asia/Kashgar|LMT XJT|-5O.k -60|01|-1GgtO.k",
			"Asia/Kathmandu|LMT IST NPT|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g",
			"Asia/Khandyga|LMT YAKT YAKT YAKST YAKST VLAT VLAST VLAT YAKT|-92.d -80 -90 -a0 -90 -a0 -b0 -b0 -a0|01232323232323232323232412323232323232323232323232565656565656565782|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0",
			"Asia/Krasnoyarsk|LMT KRAT KRAT KRAST KRAST KRAT|-6b.q -60 -70 -80 -70 -80|012323232323232323232324123232323232323232323232323232323232323252|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Asia/Kuala_Lumpur|SMT MALT MALST MALT MALT JST MYT|-6T.p -70 -7k -7k -7u -90 -80|01234546|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu 1so1u",
			"Asia/Kuching|LMT BORT BORT BORTST JST MYT|-7l.k -7u -80 -8k -90 -80|01232323232323232425|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0 1so10",
			"Asia/Macao|LMT MOT MOST CST|-7y.k -80 -90 -80|0121212121212121212121212121212121212121213|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0 KEp0",
			"Asia/Magadan|LMT MAGT MAGT MAGST MAGST MAGT|-a3.c -a0 -b0 -c0 -b0 -c0|012323232323232323232324123232323232323232323232323232323232323251|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Asia/Makassar|LMT MMT WITA JST|-7V.A -7V.A -80 -90|01232|-21JjV.A vfc0 myLV.A 8ML0",
			"Asia/Manila|PHT PHST JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Asia/Novokuznetsk|LMT KRAT KRAT KRAST KRAST NOVST NOVT NOVT|-5M.M -60 -70 -80 -70 -70 -60 -70|012323232323232323232324123232323232323232323232323232323232325672|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0 8Hz0",
			"Asia/Novosibirsk|LMT NOVT NOVT NOVST NOVST|-5v.E -60 -70 -80 -70|0123232323232323232323241232341414141414141414141414141414141414121|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Asia/Omsk|LMT OMST OMST OMSST OMSST OMST|-4R.u -50 -60 -70 -60 -70|012323232323232323232324123232323232323232323232323232323232323252|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Asia/Oral|LMT URAT URAT URAST URAT URAST ORAT ORAST ORAT|-3p.o -40 -50 -60 -60 -50 -40 -50 -50|012343232323232323251516767676767676767676767676768|-1Pc3p.o eUnp.o 23CL0 1db0 1cM0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 2UK0 Fz0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 RW0",
			"Asia/Pontianak|LMT PMT WIB JST WIB WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu",
			"Asia/Pyongyang|LMT KST JCST JST KST|-8n -8u -90 -90 -90|01234|-2um8n 97XR 12FXu jdA0",
			"Asia/Qyzylorda|LMT KIZT KIZT KIZST KIZT QYZT QYZT QYZST|-4l.Q -40 -50 -60 -60 -50 -60 -70|012343232323232323232325676767676767676767676767676|-1Pc4l.Q eUol.Q 23CL0 1db0 1cM0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2UK0 dC0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0",
			"Asia/Rangoon|RMT BURT JST MMT|-6o.E -6u -90 -6u|0123|-21Jio.E SmnS.E 7j9u",
			"Asia/Sakhalin|LMT JCST JST SAKT SAKST SAKST SAKT|-9u.M -90 -90 -b0 -c0 -b0 -a0|0123434343434343434343435634343434343565656565656565656565656565636|-2AGVu.M 1iaMu.M je00 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o10 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Asia/Samarkand|LMT SAMT SAMT SAMST TAST UZST UZT|-4r.R -40 -50 -60 -60 -60 -50|01234323232323232323232356|-1Pc4r.R eUor.R 23CL0 1db0 1cM0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11x0 bf0",
			"Asia/Seoul|LMT KST JCST JST KST KDT KDT|-8r.Q -8u -90 -90 -90 -9u -a0|01234151515151515146464|-2um8r.Q 97XV.Q 12FXu jjA0 kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0",
			"Asia/Singapore|SMT MALT MALST MALT MALT JST SGT SGT|-6T.p -70 -7k -7k -7u -90 -7u -80|012345467|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu Mspu DTA0",
			"Asia/Srednekolymsk|LMT MAGT MAGT MAGST MAGST MAGT SRET|-ae.Q -a0 -b0 -c0 -b0 -c0 -b0|012323232323232323232324123232323232323232323232323232323232323256|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Asia/Taipei|JWST JST CST CDT|-80 -90 -80 -90|01232323232323232323232323232323232323232|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0",
			"Asia/Tashkent|LMT TAST TAST TASST TASST UZST UZT|-4B.b -50 -60 -70 -60 -60 -50|01232323232323232323232456|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11y0 bf0",
			"Asia/Tbilisi|TBMT TBIT TBIT TBIST TBIST GEST GET GET GEST|-2X.b -30 -40 -50 -40 -40 -30 -40 -50|0123232323232323232323245656565787878787878787878567|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 3y0 19f0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cM0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0",
			"Asia/Tehran|LMT TMT IRST IRST IRDT IRDT|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0",
			"Asia/Thimbu|LMT IST BTT|-5W.A -5u -60|012|-Su5W.A 1BGMs.A",
			"Asia/Tokyo|JCST JST JDT|-90 -90 -a0|0121212121|-1iw90 pKq0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0",
			"Asia/Ulaanbaatar|LMT ULAT ULAT ULAST|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0",
			"Asia/Ust-Nera|LMT YAKT YAKT MAGST MAGT MAGST MAGT MAGT VLAT VLAT|-9w.S -80 -90 -c0 -b0 -b0 -a0 -c0 -b0 -a0|0123434343434343434343456434343434343434343434343434343434343434789|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0",
			"Asia/Vladivostok|LMT VLAT VLAT VLAST VLAST VLAT|-8L.v -90 -a0 -b0 -a0 -b0|012323232323232323232324123232323232323232323232323232323232323252|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Asia/Yakutsk|LMT YAKT YAKT YAKST YAKST YAKT|-8C.W -80 -90 -a0 -90 -a0|012323232323232323232324123232323232323232323232323232323232323252|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Asia/Yekaterinburg|LMT PMT SVET SVET SVEST SVEST YEKT YEKST YEKT|-42.x -3J.5 -40 -50 -60 -50 -50 -60 -60|0123434343434343434343435267676767676767676767676767676767676767686|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Asia/Yerevan|LMT YERT YERT YERST YERST AMST AMT AMT AMST|-2W -30 -40 -50 -40 -40 -30 -40 -50|0123232323232323232323245656565657878787878787878787878787878787|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1am0 2r0 1cJ0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fb0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0",
			"Atlantic/Azores|HMT AZOT AZOST AZOMT AZOT AZOST WET|1S.w 20 10 0 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545456545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Atlantic/Canary|LMT CANT WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Atlantic/Cape_Verde|LMT CVT CVST CVT|1y.4 20 10 10|01213|-2xomp.U 1qOMp.U 7zX0 1djf0",
			"Atlantic/Faeroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Atlantic/Madeira|FMT MADT MADST MADMT WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Atlantic/Reykjavik|LMT IST ISST GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0",
			"Atlantic/South_Georgia|GST|20|0|",
			"Atlantic/Stanley|SMT FKT FKST FKT FKST|3P.o 40 30 30 20|0121212121212134343212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 U10 1qM0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10",
			"Australia/ACT|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0",
			"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0",
			"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0",
			"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0",
			"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0",
			"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0",
			"Australia/Eucla|ACWST ACWDT|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0",
			"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0",
			"Australia/LHI|AEST LHST LHDT LHDT|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu",
			"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0",
			"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0",
			"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Chile/EasterIsland|EMT EAST EASST EAST EASST EAST|7h.s 70 60 60 50 50|012121212121212121212121212123434343434343434343434343434343434343434343434343434343434343434345|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 1wn0",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"EST|EST|50|0|",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Eire|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Etc/GMT+0|GMT|0|0|",
			"Etc/GMT+1|GMT+1|10|0|",
			"Etc/GMT+10|GMT+10|a0|0|",
			"Etc/GMT+11|GMT+11|b0|0|",
			"Etc/GMT+12|GMT+12|c0|0|",
			"Etc/GMT+2|GMT+2|20|0|",
			"Etc/GMT+3|GMT+3|30|0|",
			"Etc/GMT+4|GMT+4|40|0|",
			"Etc/GMT+5|GMT+5|50|0|",
			"Etc/GMT+6|GMT+6|60|0|",
			"Etc/GMT+7|GMT+7|70|0|",
			"Etc/GMT+8|GMT+8|80|0|",
			"Etc/GMT+9|GMT+9|90|0|",
			"Etc/GMT-1|GMT-1|-10|0|",
			"Etc/GMT-10|GMT-10|-a0|0|",
			"Etc/GMT-11|GMT-11|-b0|0|",
			"Etc/GMT-12|GMT-12|-c0|0|",
			"Etc/GMT-13|GMT-13|-d0|0|",
			"Etc/GMT-14|GMT-14|-e0|0|",
			"Etc/GMT-2|GMT-2|-20|0|",
			"Etc/GMT-3|GMT-3|-30|0|",
			"Etc/GMT-4|GMT-4|-40|0|",
			"Etc/GMT-5|GMT-5|-50|0|",
			"Etc/GMT-6|GMT-6|-60|0|",
			"Etc/GMT-7|GMT-7|-70|0|",
			"Etc/GMT-8|GMT-8|-80|0|",
			"Etc/GMT-9|GMT-9|-90|0|",
			"Etc/UCT|UCT|0|0|",
			"Etc/UTC|UTC|0|0|",
			"Europe/Amsterdam|AMT NST NEST NET CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Belfast|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Bratislava|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Busingen|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|0123232323232323232345454676767676767676767623232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1ty0 2bD0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET FET|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454545454676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1cJ0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|01010101010101010101010121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-28dd0 11A0 1go0 19A0 1co0 1dA0 b1A0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 iyo0 Rc0 18o0 1hc0 1io0 1a00 14o0 5aL0 MM0 1vc0 17A0 1i00 1bc0 1eo0 17d0 1in0 17A0 6hA0 10N0 XIL0 1a10 1in0 17d0 19X0 1cN0 1fz0 1a10 1fX0 1cp0 1cO0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2as10 M00 1cM0 1cM0 14o0 1o00 WM0 1qM0 17c0 1cM0 M3A0 5M20 WM0 1fA0 1cM0 1cM0 1cM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 Lz0 1C10 Lz0 1EN0 Lz0 1C10 Lz0 1zd0 Oo0 1C00 On0 1cp0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Minsk|MMT EET MSK CEST CET MSD EEST FET|-1O -20 -30 -20 -10 -40 -30 -30|012343432525252525252525252616161616161616161616161616161616161616172|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cK0 1cM0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hy0",
			"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Moscow|MMT MMT MST MDST MSD MSK MSM EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c20 imv.j 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2as10 M00 1cM0 1cM0 14o0 1o00 WM0 1qM0 17c0 1cM0 M3A0 5M20 WM0 1fA0 1cM0 16K0 1iO0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 Lz0 1C10 Lz0 1EN0 Lz0 1C10 Lz0 1zd0 Oo0 1C00 On0 1C10 Lz0 1zd0 On0 1C10 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Samara|LMT SAMT SAMT KUYT KUYST MSD MSK EEST KUYT SAMST SAMST|-3k.k -30 -40 -40 -50 -40 -30 -30 -30 -50 -40|012343434343434343435656782929292929292929292929292929292929292a12|-22WNk.k qHak.k bcn0 1Qqo0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cN0 8o0 14j0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0",
			"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0",
			"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646464647373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Volgograd|LMT TSAT STAT STAT VOLT VOLST VOLST VOLT MSD MSK MSK|-2V.E -30 -30 -40 -40 -50 -40 -30 -40 -30 -40|0123454545454545454546767489898989898989898989898989898989898989a9|-21IqV.E cLXV.E cEM0 1gqn0 Lco0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cJ0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0",
			"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Europe/Zaporozhye|CUT EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"HST|HST|a0|0|",
			"Indian/Chagos|LMT IOT IOT|-4N.E -50 -60|012|-2xosN.E 3AGLN.E",
			"Indian/Christmas|CXT|-70|0|",
			"Indian/Cocos|CCT|-6u|0|",
			"Indian/Kerguelen|zzz TFT|0 -50|01|-MG00",
			"Indian/Mahe|LMT SCT|-3F.M -40|01|-2yO3F.M",
			"Indian/Maldives|MMT MVT|-4S -50|01|-olgS",
			"Indian/Mauritius|LMT MUT MUST|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0",
			"Indian/Reunion|LMT RET|-3F.Q -40|01|-2mDDF.Q",
			"Kwajalein|MHT KWAT MHT|-b0 c0 -c0|012|-AX0 W9X0",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"MST|MST|70|0|",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"NZ-CHAT|CHAST CHAST CHADT|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Apia|LMT WSST SST SDT WSDT WSST|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00",
			"Pacific/Bougainville|PGT JST BST|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0",
			"Pacific/Chuuk|CHUT|-a0|0|",
			"Pacific/Efate|LMT VUT VUST|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0",
			"Pacific/Enderbury|PHOT PHOT PHOT|c0 b0 -d0|012|nIc0 B8n0",
			"Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0",
			"Pacific/Fiji|LMT FJT FJST|-bT.I -c0 -d0|012121212121212121212121212121212121212121212121212121212121212|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 xA0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1SM0 xA0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1SM0 xA0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1SM0",
			"Pacific/Funafuti|TVT|-c0|0|",
			"Pacific/Galapagos|LMT ECT GALT|5W.o 50 60|012|-1yVS1.A 2dTz1.A",
			"Pacific/Gambier|LMT GAMT|8X.M 90|01|-2jof0.c",
			"Pacific/Guadalcanal|LMT SBT|-aD.M -b0|01|-2joyD.M",
			"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0",
			"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0",
			"Pacific/Kiritimati|LINT LINT LINT|aE a0 -e0|012|nIaE B8nk",
			"Pacific/Kosrae|KOST KOST|-b0 -c0|010|-AX0 1bdz0",
			"Pacific/Majuro|MHT MHT|-b0 -c0|01|-AX0",
			"Pacific/Marquesas|LMT MART|9i 9u|01|-2joeG",
			"Pacific/Midway|LMT NST BST SST|bm.M b0 b0 b0|0123|-2nDMB.c 2gVzB.c EyM0",
			"Pacific/Nauru|LMT NRT JST NRT|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu",
			"Pacific/Niue|NUT NUT NUT|bk bu b0|012|-KfME 17y0a",
			"Pacific/Norfolk|NMT NFT|-bc -bu|01|-Kgbc",
			"Pacific/Noumea|LMT NCT NCST|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0",
			"Pacific/Palau|PWT|-90|0|",
			"Pacific/Pitcairn|PNT PST|8u 80|01|18Vku",
			"Pacific/Pohnpei|PONT|-b0|0|",
			"Pacific/Port_Moresby|PGT|-a0|0|",
			"Pacific/Rarotonga|CKT CKHST CKT|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu",
			"Pacific/Tahiti|LMT TAHT|9W.g a0|01|-2joe1.I",
			"Pacific/Tarawa|GILT|-c0|0|",
			"Pacific/Tongatapu|TOT TOT TOST|-ck -d0 -e0|01212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0",
			"Pacific/Wake|WAKT|-c0|0|",
			"Pacific/Wallis|WFT|-c0|0|",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"
		],
		"links": [
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Sao_Tome",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Addis_Ababa|Africa/Asmara",
			"Africa/Addis_Ababa|Africa/Asmera",
			"Africa/Addis_Ababa|Africa/Dar_es_Salaam",
			"Africa/Addis_Ababa|Africa/Djibouti",
			"Africa/Addis_Ababa|Africa/Kampala",
			"Africa/Addis_Ababa|Africa/Mogadishu",
			"Africa/Addis_Ababa|Africa/Nairobi",
			"Africa/Addis_Ababa|Indian/Antananarivo",
			"Africa/Addis_Ababa|Indian/Comoro",
			"Africa/Addis_Ababa|Indian/Mayotte",
			"Africa/Bangui|Africa/Brazzaville",
			"Africa/Bangui|Africa/Douala",
			"Africa/Bangui|Africa/Kinshasa",
			"Africa/Bangui|Africa/Lagos",
			"Africa/Bangui|Africa/Libreville",
			"Africa/Bangui|Africa/Luanda",
			"Africa/Bangui|Africa/Malabo",
			"Africa/Bangui|Africa/Niamey",
			"Africa/Bangui|Africa/Porto-Novo",
			"Africa/Blantyre|Africa/Bujumbura",
			"Africa/Blantyre|Africa/Gaborone",
			"Africa/Blantyre|Africa/Harare",
			"Africa/Blantyre|Africa/Kigali",
			"Africa/Blantyre|Africa/Lubumbashi",
			"Africa/Blantyre|Africa/Lusaka",
			"Africa/Blantyre|Africa/Maputo",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Juba|Africa/Khartoum",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Anguilla|America/Antigua",
			"America/Anguilla|America/Dominica",
			"America/Anguilla|America/Grenada",
			"America/Anguilla|America/Guadeloupe",
			"America/Anguilla|America/Marigot",
			"America/Anguilla|America/Montserrat",
			"America/Anguilla|America/Port_of_Spain",
			"America/Anguilla|America/St_Barthelemy",
			"America/Anguilla|America/St_Kitts",
			"America/Anguilla|America/St_Lucia",
			"America/Anguilla|America/St_Thomas",
			"America/Anguilla|America/St_Vincent",
			"America/Anguilla|America/Tortola",
			"America/Anguilla|America/Virgin",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Aruba|America/Curacao",
			"America/Aruba|America/Kralendijk",
			"America/Aruba|America/Lower_Princes",
			"America/Atikokan|America/Coral_Harbour",
			"America/Cayman|America/Panama",
			"America/Chicago|US/Central",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Ensenada|America/Tijuana",
			"America/Ensenada|Mexico/BajaNorte",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/Montreal|America/Toronto",
			"America/Montreal|Canada/Eastern",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Phoenix|US/Arizona",
			"America/Porto_Acre|America/Rio_Branco",
			"America/Porto_Acre|Brazil/Acre",
			"America/Regina|Canada/East-Saskatchewan",
			"America/Regina|Canada/Saskatchewan",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Antarctica/McMurdo|Antarctica/South_Pole",
			"Antarctica/McMurdo|NZ",
			"Antarctica/McMurdo|Pacific/Auckland",
			"Arctic/Longyearbyen|Atlantic/Jan_Mayen",
			"Arctic/Longyearbyen|Europe/Oslo",
			"Asia/Aden|Asia/Kuwait",
			"Asia/Aden|Asia/Riyadh",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bahrain|Asia/Qatar",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Calcutta|Asia/Kolkata",
			"Asia/Chongqing|Asia/Chungking",
			"Asia/Chongqing|Asia/Harbin",
			"Asia/Chongqing|Asia/Shanghai",
			"Asia/Chongqing|PRC",
			"Asia/Dacca|Asia/Dhaka",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Istanbul|Europe/Istanbul",
			"Asia/Istanbul|Turkey",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kashgar|Asia/Urumqi",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Macao|Asia/Macau",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Seoul|ROK",
			"Asia/Singapore|Singapore",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimbu|Asia/Thimphu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Atlantic/Faeroe|Atlantic/Faroe",
			"Atlantic/Reykjavik|Iceland",
			"Australia/ACT|Australia/Canberra",
			"Australia/ACT|Australia/NSW",
			"Australia/ACT|Australia/Sydney",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/LHI|Australia/Lord_Howe",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Chile/EasterIsland|Pacific/Easter",
			"Eire|Europe/Dublin",
			"Etc/GMT+0|Etc/GMT",
			"Etc/GMT+0|Etc/GMT-0",
			"Etc/GMT+0|Etc/GMT0",
			"Etc/GMT+0|Etc/Greenwich",
			"Etc/GMT+0|GMT",
			"Etc/GMT+0|GMT+0",
			"Etc/GMT+0|GMT-0",
			"Etc/GMT+0|GMT0",
			"Etc/GMT+0|Greenwich",
			"Etc/UCT|UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belfast|Europe/Guernsey",
			"Europe/Belfast|Europe/Isle_of_Man",
			"Europe/Belfast|Europe/Jersey",
			"Europe/Belfast|Europe/London",
			"Europe/Belfast|GB",
			"Europe/Belfast|GB-Eire",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Bratislava|Europe/Prague",
			"Europe/Busingen|Europe/Vaduz",
			"Europe/Busingen|Europe/Zurich",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Lisbon|Portugal",
			"Europe/Moscow|W-SU",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Kwajalein|Pacific/Kwajalein",
			"NZ-CHAT|Pacific/Chatham",
			"Pacific/Chuuk|Pacific/Truk",
			"Pacific/Chuuk|Pacific/Yap",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Midway|Pacific/Pago_Pago",
			"Pacific/Midway|Pacific/Samoa",
			"Pacific/Midway|US/Samoa",
			"Pacific/Pohnpei|Pacific/Ponape"
		]
	}

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Advert = __webpack_require__(371);
	var EditorialModule = __webpack_require__(372);
	
	var AdModule = React.createClass({
	    displayName: 'AdModule',
	
	    componentDidMount: function componentDidMount() {
	        if (!this.inited) {
	            this.initAds();
	            this.inited = true;
	        }
	    },
	    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {},
	    inited: false,
	    initAds: function initAds() {
	        try {
	            var ads = jQuery('.col-c .react-ad');
	            for (var i = 0, len = ads.length; i < len; i++) {
	                admgr.initSlot(ads[i], espn.ads.config);
	            }
	        } catch (e) {}
	    },
	    render: function render() {
	        return React.createElement(
	            'article',
	            { className: 'ad-300' },
	            React.createElement(
	                'div',
	                { className: 'ad-center' },
	                React.createElement(Advert, { id: 'rhs.mpu', className: 'ad-slot-incontent ad-wrapper', slotType: 'incontent' })
	            )
	        );
	    }
	});
	
	var RHS = React.createClass({
	    displayName: 'RHS',
	
	    render: function render() {
	
	        var modules = this.props.modules || [];
	        var modulesMarkup = [];
	
	        modules.map(function (module, i) {
	            if (module.type === 'editorial') {
	                modulesMarkup.push(React.createElement(EditorialModule, { key: module.moduleType + '.' + i, title: module.moduleTitle, links: module.feed }));
	            } else if (module.type === 'adincontent') {
	                modulesMarkup.push(React.createElement(AdModule, { key: 'rhs.mpu' }));
	            }
	        });
	
	        return React.createElement(
	            'section',
	            { className: 'col-c chk-height' },
	            modulesMarkup
	        );
	    }
	});
	
	module.exports = RHS;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	/*
	    Action:     Output the desired div placeholder for the adverts
	    Original:   /tea/core-tea/redesign/src/main/tea/format/modules/ads/ad.tea
	    Orginator:  ben.hobden@espn.com
	*/
	
	var React = __webpack_require__(11);
	var classNames = __webpack_require__(361);
	
	var Advert = React.createClass({
	
	    displayName: 'Advert',
	
	    count: 1,
	
	    render: function render() {
	
	        var sInview = this.props.inView || null;
	        var sClassName = this.props.className || null;
	        var bCollapseBeforeLoad = this.props.collapseBeforeLoad === true ? true : false;
	        var bRefreshIfVisible = this.props.refreshIfVisible === true ? true : false;
	        var bIsOutOfPage = this.props.isOutOfPage === true ? true : false;
	        var sSlotType = this.props.slotType || null;
	        var aInclude = this.props.include || [];
	        var aExclude = this.props.exclude || [];
	        var hKVPs = this.props.kvps || {};
	        var props = { id: this.props.id || 'react-ad_' + this.count++ };
	        var aClasses = ['react-ad'];
	        var aSlotKvps = [];
	        var bAddDefault = true;
	
	        /* TODO: add in ad block module see related tea file. */
	
	        /* no type no advert */
	        if (sSlotType === null) {
	            return null;
	        }
	
	        if (sInview === null) {
	            aClasses.push('ad-slot');
	        }
	
	        if (sClassName !== null) {
	            aClasses.push(sClassName);
	        }
	
	        /* default if pos not specified */
	        if (typeof hKVPs.pos === "undefined") {
	            hKVPs.pos = sSlotType;
	        }
	
	        /* build key value pair string */
	        for (var sKey in hKVPs) {
	            if (sKey !== null && hKVPs.sKey !== null) {
	                aSlotKvps.push(sKey + "=" + hKVPs[sKey]);
	            }
	        }
	
	        /* build up the div properties */
	        props.className = classNames(aClasses);
	        props['data-slot-type'] = sSlotType;
	
	        if (bIsOutOfPage === true) {
	            props['data-out-of-page'] = "true";
	        }
	
	        if (bRefreshIfVisible === true) {
	            props['data-refresh-if-visible'] = "true";
	        }
	
	        if (bCollapseBeforeLoad === true) {
	            props['data-collapse-before-load'] = "true";
	        }
	
	        if (aInclude.length > 0) {
	            var sIncludeStr = aInclude.join(",");
	            props['data-include-bp'] = sIncludeStr;
	        }
	
	        if (aExclude.length > 0) {
	            var sExcludeStr = aExclude.join(",");
	            props['data-exclude-bp'] = sExcludeStr;
	        }
	
	        if (aSlotKvps.length > 0) {
	            var sKvpsStr = aSlotKvps.join(",");
	            props['data-slot-kvps'] = sKvpsStr;
	        }
	
	        return React.createElement('div', props);
	    }
	});
	
	module.exports = Advert;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ResponsiveImage = __webpack_require__(373);
	var Video = __webpack_require__(374);
	
	var EditorialModule = React.createClass({
	    displayName: 'EditorialModule',
	
	    getRelativeTime: function getRelativeTime(dateString) {
	
	        var timeToShow;
	        var wordToShow;
	        var timeInMilli;
	        var displayTime = '';
	
	        try {
	            timeInMilli = moment.utc().diff(moment.utc(dateString));
	            timeToShow = timeInMilli / 60000;
	            wordToShow = 'm';
	            if (timeToShow <= 0) {
	                timeToShow = 1;
	            }
	            if (timeToShow >= 60) {
	                timeToShow = Math.round(timeToShow / 60.0);
	                if (timeToShow < 24) {
	                    wordToShow = 'h';
	                } else {
	                    timeToShow = Math.round(timeToShow / 24.0);
	                    wordToShow = 'd';
	                }
	            }
	            displayTime = displayTime + Math.round(timeToShow) + wordToShow;
	        } catch (e) {}
	        return displayTime;
	    },
	    render: function render() {
	
	        var links = this.props.links || [];
	        var title = this.props.title;
	        var getRelativeTime = this.getRelativeTime;
	        var list = [];
	
	        links.map(function (link, i) {
	            var links = link.links || { web: { href: '' } };
	            var author = link.byline || '';
	            var timestamp = getRelativeTime(link.lastModified);
	            var mediaHeadline = '';
	            var originalHref = '';
	            var meta = null;
	
	            if (!!author) {
	                meta = React.createElement(
	                    'div',
	                    { className: 'item-meta' },
	                    React.createElement(
	                        'span',
	                        { className: 'timestamp' },
	                        timestamp ? timestamp + ' - ' : ''
	                    ),
	                    React.createElement(
	                        'span',
	                        { className: 'author' },
	                        author
	                    )
	                );
	            }
	
	            if (link.video && link.video.length) {
	                originalHref = '' + links.web.href;
	                mediaHeadline = link.headline || link.video[0].headline;
	                links.web.href = links.web.href.replace('http://espn.go.com', 'http://espn.co.uk');
	                list.push(React.createElement(
	                    'li',
	                    { key: link.linkText + '.vid' },
	                    React.createElement(Video, { href: originalHref, headline: mediaHeadline, duration: link.video[0].duration, thumbnail: link.video[0].images[0].url })
	                ));
	            } else if (link.images && link.images.length) {
	                list.push(React.createElement(
	                    'li',
	                    { key: (link.linkText || link.headline) + '.img' },
	                    React.createElement(ResponsiveImage, { url: links.web.href, image: link.images[0] })
	                ));
	            }
	            list.push(React.createElement(
	                'li',
	                { key: (link.linkText || link.headline) + '.txt', className: 'text-container' },
	                React.createElement(
	                    'h2',
	                    null,
	                    React.createElement(
	                        'a',
	                        { target: '_blank', className: /espn.co.uk/.test(links.web.href) ? '' : 'external', href: links.web.href },
	                        mediaHeadline || link.linkText
	                    )
	                ),
	                meta,
	                React.createElement(
	                    'p',
	                    null,
	                    link.description
	                )
	            ));
	        });
	
	        return React.createElement(
	            'article',
	            { className: 'sub-module' },
	            React.createElement(
	                'header',
	                null,
	                React.createElement(
	                    'h1',
	                    null,
	                    title
	                )
	            ),
	            React.createElement(
	                'ul',
	                { className: 'content' },
	                list
	            )
	        );
	    }
	});
	
	module.exports = EditorialModule;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	var ResponsiveImage = React.createClass({
	    displayName: 'ResponsiveImage',
	
	    render: function render() {
	        var url = this.props.url || '#';
	        var image = this.props.image || {};
	        var imageUrl = image.url || '';
	        var imgPath = imageUrl.split('http://a.espncdn.com')[1];
	        var credit = image.credit || '';
	
	        var html = '<a name="&amp;lpos=" class="img-wrap" href="' + url + '" data-sport="rugby">' + '<picture>' + '<!--[if IE 9]><video style="display: none;"><![endif]-->' + '<source srcset="http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=78&amp;h=78&amp;scale=crop&amp;cquality=90&amp;location=center, http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=156&amp;h=156&amp;scale=crop&amp;cquality=90&amp;location=center 2x" data-srcset="http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=78&amp;h=78&amp;scale=crop&amp;cquality=90&amp;location=center, http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=156&amp;h=156&amp;scale=crop&amp;cquality=90&amp;location=center 2x" media="(max-width: 413px)">' + '<source srcset="http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=272&amp;h=153&amp;scale=crop&amp;cquality=90&amp;location=origin, http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin 2x" data-srcset="http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=272&amp;h=153&amp;scale=crop&amp;cquality=90&amp;location=origin, http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin 2x" media="(min-width: 414px)">' + '<!--[if IE 9]></video><![endif]-->' + '<img src="http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin" data-default-src="' + imageUrl + '" class=" imageLoaded lazyloaded" data-image-container=".feed-item-figure" width="272">' + '</picture>' + '</a>' + '<span class="credit">' + credit + '</span>';
	
	        return React.createElement('figure', { className: 'feed-item-figure ', dangerouslySetInnerHTML: { __html: html } });
	    }
	});
	
	module.exports = ResponsiveImage;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	var Video = React.createClass({
	    displayName: 'Video',
	
	    getThumbnailPath: function getThumbnailPath(thumbnailUrl) {
	        var thumbnailPath = '';
	
	        if (typeof thumbnailUrl === 'string') {
	            thumbnailPath = '/media/motion/';
	            thumbnailPath += thumbnailUrl.split('http://media.video-cdn.espn.com/images/')[1];
	        }
	        return thumbnailPath;
	    },
	
	    formatDuration: function formatDuration(duration) {
	        var mins = duration / 60;
	        var secs = duration % 60;
	
	        return Math.floor(mins) + ':' + secs;
	    },
	
	    render: function render() {
	
	        var thumbnailPath = this.getThumbnailPath(this.props.thumbnail);
	        var duration = this.formatDuration(this.props.duration);
	
	        var videoHtml = '<!--[if IE 9]><video style="display: none;"><![endif]-->' + '<source srcset="http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=375&h=150&scale=crop&location=origin, http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=944&h=377&scale=crop&location=origin 2x" data-srcset="http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=375&h=150&scale=crop&location=origin, http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=944&h=377&scale=crop&location=origin 2x" media="(max-width: 375px)"/>' + '<source srcset="http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=944&h=377&scale=crop&location=origin, http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=1888&h=754&scale=crop&location=origin 2x" data-srcset="http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=944&h=377&scale=crop&location=origin, http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=1888&h=754&scale=crop&location=origin 2x" media="(min-width: 376px)"/>' + '<!--[if IE 9]></video><![endif]-->' + '<img src="http://a.espncdn.com/combiner/i?img=' + thumbnailPath + '&w=1888&h=754&scale=crop&location=origin" data-default-src="http://a.espncdn.com' + thumbnailPath + '" className=" imageLoaded lazyloaded" data-image-container=".feed-item-figure" width="944"/>';
	
	        videoHtml = '<!--[if IE 9]><video style="display: none;"><![endif]-->' + '<source srcset="http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=78&amp;h=78&amp;scale=crop&amp;cquality=90&amp;location=center, http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=156&amp;h=156&amp;scale=crop&amp;cquality=90&amp;location=center 2x" data-srcset="http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=78&amp;h=78&amp;scale=crop&amp;cquality=90&amp;location=center, http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=156&amp;h=156&amp;scale=crop&amp;cquality=90&amp;location=center 2x" media="(max-width: 413px)" />' + '<source srcset="http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=272&amp;h=153&amp;scale=crop&amp;cquality=90&amp;location=origin, http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin 2x" data-srcset="http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=272&amp;h=153&amp;scale=crop&amp;cquality=90&amp;location=origin, http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin 2x" media="(min-width: 414px)" />' + '<!--[if IE 9]></video><![endif]--><img src="http://a2.espncdn.com/combiner/i?img=' + thumbnailPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin" data-default-src="http://a.espncdn.com' + thumbnailPath + '" class=" imageLoaded lazyloaded" data-image-container=".feed-item-figure" width="272" />';
	
	        return React.createElement(
	            'figure',
	            { className: 'feed-item-figure video ', 'data-source': 'espn', 'data-video': 'native,640,360,13572065' },
	            React.createElement(
	                'div',
	                { className: 'img-wrap' },
	                React.createElement(
	                    'a',
	                    { name: '&lpos=', href: this.props.href ? this.props.href + "&ex_cid=espnapi_internal" : '#', 'data-sport': 'rugby' },
	                    React.createElement('picture', { dangerouslySetInnerHTML: { __html: videoHtml } })
	                ),
	                React.createElement(
	                    'span',
	                    { className: 'video-play-button ' },
	                    'Play',
	                    React.createElement(
	                        'span',
	                        { className: 'video-length' },
	                        duration
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = Video;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	var React = __webpack_require__(11);
	var Router = __webpack_require__(166);
	var Game = __webpack_require__(376);
	var StoreMixin = __webpack_require__(246);
	var ESPNhelpersMixin = __webpack_require__(251);
	var loadScores = __webpack_require__(377);
	var TabLinks = __webpack_require__(378);
	var GameFooter = __webpack_require__(357);
	var GameStrip = __webpack_require__(413);
	var Advert = __webpack_require__(371);
	var AdReloaderMixin = __webpack_require__(396);
	var pollInterval = 30000;
	var hValidView = {
	    summary: 1,
	    report: 1,
	    preview: 1,
	    commentary: 1,
	    matchstats: 1,
	    playerstats: 1,
	    lineups: 1,
	    table: 1,
	    conversation: 1
	};
	
	var Gamecast = React.createClass({
	
	    displayName: 'Gamecast',
	
	    mixins: [Router.State, StoreMixin, ESPNhelpersMixin, AdReloaderMixin, Router.Navigation, Router.IsActive],
	
	    statics: {
	        loadAction: loadScores,
	        storeListeners: ['ScoreStore']
	    },
	
	    getInitialState: function getInitialState() {
	        return this.getStateFromStores();
	    },
	
	    timer: null,
	
	    poll: function poll() {
	        var self = this;
	        var isActiveGamecastRoute = this.isActive('match', this.getParams(), this.getQuery());
	        var isGamepackage = /\/rugby\/match|commentary|lineups|matchstats|playerstats|conversation/.test(location.pathname);
	        // Is it the home route that points to the gamecast handler for local testing?
	        var isFudgedHomeRoute = this.isActive('home', this.getParams(), this.getQuery()) && /local/.test(location.host);
	        if (isActiveGamecastRoute && isGamepackage || isFudgedHomeRoute) {
	            self.props.context.executeAction(loadScores, {
	                pathname: self.getPathname(),
	                query: self.getQuery()
	            });
	        } else {
	            clearInterval(self.timer);
	            self.timer = null;
	        }
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.timer = setInterval(this.poll, pollInterval);
	    },
	
	    componentWillUpdate: function componentWillUpdate(prevProps, prevState) {
	        try {
	            if (this.props.params.section != prevProps.params.section) {
	                var bannerAd = this.getAd('banner');
	                if (bannerAd !== null) {
	                    admgr.refresh([bannerAd]);
	                }
	            }
	        } catch (e) {}
	    },
	
	    getAd: function getAd(type) {
	        try {
	            var arr = admgr.getGPTArray();
	            for (var i = 0, len = arr.length; i < len; i++) {
	                if (arr[i].type === type) {
	                    return arr[i];
	                }
	            }
	        } catch (e) {}
	        return null;
	    },
	
	    getStateFromStores: function getStateFromStores() {
	        var store = this.props.context.getStore('ScoreStore');
	        var gameStripProps = store.getGameStripDetails();
	        var section = this.getParams().section;
	
	        this.setMetaData(gameStripProps, section);
	        var aStandings = store.getLeagueTable();
	        var bHasStandings = false;
	        if (aStandings.length >= 1) {
	            bHasStandings = true;
	        }
	
	        return {
	            gameStripProps: gameStripProps,
	            matchState: store.getMatchState(),
	            matchView: this.state && this.state.matchView || section || 'summary',
	            tableLink: store.getTableLink(),
	            hasCommentary: store.hasCommentary(),
	            hasStandings: bHasStandings,
	            hasStats: store.hasStats(),
	            hasReport: store.hasReport(),
	            hasPreview: store.hasPreview(),
	            adWrapSelector: '#game-banner'
	        };
	    },
	
	    setMetaData: function setMetaData(gameStripProps, section) {
	        try {
	            this._meta.activeTab = this.state && this.state.matchView || section || 'summary';
	            this._meta.home = gameStripProps.teams.home.name;
	            this._meta.away = gameStripProps.teams.away.name;
	            this._meta.date = gameStripProps.date;
	            this._meta.league = gameStripProps.heading;
	        } catch (e) {}
	    },
	
	    onChange: function onChange() {
	        this.setState(this.getStateFromStores());
	    },
	
	    changeView: function changeView(sView) {
	        var query = this.getQuery();
	        if (hValidView[sView] === 1) {
	            this.setState({ matchView: sView });
	        }
	        this.transitionTo('/rugby/' + (sView === 'summary' ? 'match' : sView), {}, query);
	    },
	
	    render: function render() {
	
	        if (this.state.matchState == 'post') {
	            clearInterval(this.timer);
	        }
	
	        var gameStripProps = this.state.gameStripProps;
	        var query = this.getQuery() || {};
	        var classMap = {
	            'pregame': 'pre',
	            'live': 'live',
	            'final': 'post'
	        };
	
	        return React.createElement(
	            'div',
	            { style: this.props.shell ? {} : { marginTop: '190px' }, 'data-pagetype': 'gamepackage' },
	            React.createElement(
	                'div',
	                { id: 'custom-nav' },
	                React.createElement(GameStrip, gameStripProps),
	                React.createElement(GameFooter, {
	                    styles: { marginBottom: '1px', borderBottom: 'none' },
	                    classNames: 'game-details footer rugby',
	                    summary: gameStripProps.gameDetails,
	                    text: gameStripProps.footer,
	                    gameStatus: classMap[gameStripProps.gameStatus],
	                    sport: 'rugby'
	                }),
	                React.createElement(
	                    'div',
	                    { id: 'gamepackage-links-wrap' },
	                    React.createElement(TabLinks, {
	                        tableHref: this.state.tableLink,
	                        selected: this.state.matchView,
	                        matchState: this.state.matchState,
	                        changeView: this.changeView,
	                        commentaryLink: this.state.hasCommentary,
	                        standingsLink: this.state.hasStandings,
	                        statsLink: this.state.hasStats,
	                        reportLink: this.state.hasReport,
	                        previewLink: this.state.hasPreview
	                    })
	                )
	            ),
	            React.createElement(Advert, { id: 'game-banner', className: 'ad-slot ad-slot-banner ad-wrapper', slotType: 'banner', 'data-slot-kvps': 'pos=banner' }),
	            React.createElement(
	                'section',
	                { id: 'main-container' },
	                React.createElement(Game, { query: query, tableHref: this.state.tableLink, matchView: this.state.matchView, changeView: this.changeView, context: this.props.context, gameProps: this.state, matchState: this.state.matchState })
	            )
	        );
	    }
	
	});
	
	module.exports = Gamecast;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	var Router = __webpack_require__(166);
	var StoreMixin = __webpack_require__(246);
	var loadScores = __webpack_require__(377);
	
	//var GameHeader = require('./header.jsx');
	//var GameStats = require('./stats.jsx');
	//var GameInfo = require('./info.jsx');
	//var GameTeamTable = require('./teamTable.jsx');
	
	var TabLinks = __webpack_require__(378);
	var TabSummary = __webpack_require__(380);
	var TabMatchStats = __webpack_require__(397);
	var TabPlayerStats = __webpack_require__(405);
	var TabTable = __webpack_require__(407);
	var TabLineup = __webpack_require__(408);
	var TabConversation = __webpack_require__(409);
	var TabCommentary = __webpack_require__(410);
	var TabArticle = __webpack_require__(411);
	var GameStrip = __webpack_require__(413);
	
	var Game = React.createClass({
	
	    displayName: 'Game',
	
	    getInitialState: function getInitialState() {
	        return {
	            matchView: 'summary', // report, commentary, matchstats, playerstats, lineups, table, conversation
	            width: this.getWidth()
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        window.addEventListener('resize', this.throttle(this.handleResize, 150));
	        this.handleResize();
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        window.removeEventListener('resize', this.handleResize);
	    },
	
	    getWidth: function getWidth() {
	        return jQuery(window).outerWidth();
	    },
	
	    handleResize: function handleResize() {
	        this.setState({
	            width: this.getWidth()
	        });
	    },
	
	    throttle: function throttle(callback, limit) {
	        var wait = false;
	        return function () {
	            if (!wait) {
	                callback.call();
	                wait = true;
	                setTimeout(function () {
	                    wait = false;
	                }, limit);
	            }
	        };
	    },
	
	    render: function render() {
	
	        var rMatchView = null;
	        var sState = this.props.matchState;
	
	        //var node = React.findDOMNode (this.refs.scrollbar)
	        //node.scrollHeight - this.scrollHeight
	
	        var oStandingsStore = this.props.context.getStore('ScoreStore');
	
	        if (this.props.matchView === 'commentary') {
	            rMatchView = React.createElement(TabCommentary, { tableHref: this.props.tableHref, store: oStandingsStore, matchState: sState, width: this.state.width });
	        } else if (this.props.matchView === 'matchstats') {
	            rMatchView = React.createElement(TabMatchStats, { tableHref: this.props.tableHref, store: oStandingsStore, matchState: sState, width: this.state.width });
	        } else if (this.props.matchView === 'playerstats') {
	            rMatchView = React.createElement(TabPlayerStats, { tableHref: this.props.tableHref, store: oStandingsStore, matchState: sState, width: this.state.width });
	        } else if (this.props.matchView === 'lineups') {
	            rMatchView = React.createElement(TabLineup, { tableHref: this.props.tableHref, store: oStandingsStore, matchState: sState, width: this.state.width });
	        } else if (this.props.matchView === 'table') {
	            rMatchView = React.createElement(TabTable, { store: oStandingsStore, matchState: sState, width: this.state.width });
	        } else if (this.props.matchView === 'conversation') {
	            rMatchView = React.createElement(TabConversation, { query: this.props.query, tableHref: this.props.tableHref, store: oStandingsStore, width: this.state.width });
	        } else if (this.props.matchView === 'report' || this.props.matchView === 'recap' || this.props.matchView === 'preview') {
	            rMatchView = React.createElement(TabArticle, { query: this.props.query, tableHref: this.props.tableHref, store: oStandingsStore, width: this.state.width });
	        } else {
	            rMatchView = React.createElement(TabSummary, { query: this.props.query, tableHref: this.props.tableHref, store: oStandingsStore, matchState: sState, changeView: this.props.changeView, width: this.state.width });
	        }
	
	        return React.createElement(
	            'section',
	            { id: 'reactContainer' },
	            rMatchView
	        );
	    }
	});
	
	module.exports = Game;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var apiHost = __webpack_require__(344);
	var DEFAULT_HOST = 'www.espn.co.uk';
	
	module.exports = function (context, payload, _done) {
	
		payload.query = payload.query || {};
	
		var sAPIHost = apiHost.get(payload);
		var leagueId = payload.query.league || payload.query.leagueId || 242041;
		var eventId = payload.query.gameId || payload.query.eventId || 276523;
		var url = '';
	
		if (leagueId && eventId) {
			url = sAPIHost + '/apis/site/v2/sports/rugby/' + leagueId + '/summary?event=' + eventId;
		}
	
		context.service.get({
			url: url,
			done: function done(data) {
				context.dispatch('RECEIVE_SCORES', data);
	
				/* hack to load pre-formated HTML for reports and previews */
				if (typeof data !== 'undefined' && typeof data.article !== 'undefined' && data.article !== null && typeof data.article.id !== 'undefined') {
					var aPath = typeof payload.pathname !== 'undefined' ? payload.pathname.split('/') : [];
					if (aPath[2] === 'report' || aPath[2] === 'preview' || aPath[2] === 'recap') {
	
						// set the gamepackage league and sport to allow video to work.
						try {
							if (typeof window.espn.gamepackage === null) {
								window.espn.gamepackage = {};
							}
							if (typeof window.espn.gamepackage.league === null) {
								window.espn.gamepackage.league = payload.query.league;
							}
							if (typeof window.espn.gamepackage.sport === null) {
								window.espn.gamepackage.sport = 'rugby';
							}
						} catch (e) {}
	
						var editionsHost = window ? window.location.hostname : 'www.espn.co.uk';
						if (editionsHost.indexOf('local.') === 0) {
							editionsHost = editionsHost.replace('local.', 'www.');
						} else if (editionsHost.indexOf('localhost') === 0) {
							editionsHost = DEFAULT_HOST;
						}
						context.service.get({
							url: 'http://' + editionsHost + '/rugby/story/_/id/' + data.article.id + '?render=true&partial=article&xhr=1',
							done: function done(data) {
								context.dispatch('RECEIVED_ARTICLE', data);
								_done();
							}
						});
					} else {
						_done();
					}
				} else {
					_done();
				}
			}
		});
	};

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	var jQuery = __webpack_require__(379);
	
	var TabLinks = React.createClass({
	
	    displayName: 'TabLinks',
	
	    tabSelect: function tabSelect(sTab, oEvent) {
	        if (this.props.changeView && sTab) {
	            if (sTab != 'table') {
	                this.props.changeView(sTab);
	                this.setState({
	                    selected: sTab
	                });
	            } else {
	                jQuery(".first-group a:contains('" + this.map[this.state.selected].label + "')").parent().addClass('active');
	            }
	            this.hideMoreLinks();
	        }
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            selected: this.props.selected && this.props.selected !== 'match' ? this.props.selected : 'summary',
	            availableTabCount: 0
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        window.addEventListener('resize', this.throttle(this.handleResize, 150));
	        window.addEventListener('orientationchange', this.throttle(this.handleResize, 150));
	        this.handleResize();
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        window.removeEventListener('resize', this.handleResize);
	        window.removeEventListener('orientationchange', this.handleResize);
	    },
	
	    handleResize: function handleResize() {
	        this.hideMoreLinks();
	        var count = this.calcLinks();
	        this.setState({
	            availableTabCount: count
	        });
	    },
	
	    calcLinks: function calcLinks() {
	        var lis = jQuery('.first-group li');
	        var totalWidth = 0;
	        var windowWidth = jQuery(window).outerWidth();
	
	        for (var i = 0, len = lis.length; i < len; i++) {
	            var outerWidth = jQuery(lis[i]).outerWidth();
	            if (totalWidth + outerWidth + 100 > windowWidth) {
	                //return i;
	                return 8;
	            } else {
	                totalWidth += outerWidth;
	            }
	        }
	        return 8;
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.selected) {
	            this.setState({
	                selected: nextProps.selected !== 'match' ? nextProps.selected : 'summary'
	            });
	        }
	    },
	
	    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	        // If game status has changed, re-render tabs
	        if (prevProps.matchState !== this.props.matchState) {
	            this.handleResize();
	        }
	    },
	
	    getLiClassName: function getLiClassName(current) {
	        var liClassName = "sub";
	        if (this.state.selected === current) {
	            liClassName += " active";
	        }
	        return liClassName;
	    },
	
	    availableTabs: {
	        pre: ['summary', 'preview', 'commentary', 'lineups', 'table', 'conversation'],
	        live: ['summary', 'commentary', 'matchstats', 'playerstats', 'lineups', 'table', 'conversation'],
	        post: ['summary', 'report', 'commentary', 'matchstats', 'playerstats', 'lineups', 'table', 'conversation']
	    },
	
	    map: {
	        summary: {
	            label: 'Summary'
	        },
	        commentary: {
	            label: 'Commentary'
	        },
	        matchstats: {
	            label: 'Match Stats'
	        },
	        playerstats: {
	            label: 'Player Stats'
	        },
	        lineups: {
	            label: 'Line-ups'
	        },
	        table: {
	            label: 'Table'
	        },
	        report: {
	            label: 'Report'
	        },
	        preview: {
	            label: 'Preview'
	        },
	        conversation: {
	            label: 'Conversation'
	        }
	    },
	
	    throttle: function throttle(callback, limit) {
	        var wait = false;
	        return function () {
	            if (!wait) {
	                callback.call();
	                wait = true;
	                setTimeout(function () {
	                    wait = false;
	                }, limit);
	            }
	        };
	    },
	
	    toggleMoreLinks: function toggleMoreLinks(e) {
	        try {
	            if (jQuery('.has-sub .sub-content').is(':visible')) {
	                jQuery('.tertiary-nav-container').attr('style', '');
	                jQuery('.has-sub .sub-content').hide();
	            } else {
	                jQuery('.tertiary-nav-container').attr('style', 'overflow:visible');
	                jQuery('.has-sub .sub-content').attr('style', 'display: block; height: 210px; width: 195px; left: -80px!important');
	            }
	        } catch (ex) {}
	    },
	
	    hideMoreLinks: function hideMoreLinks() {
	        jQuery('.has-sub .sub-content').hide();
	    },
	
	    buildLinks: function buildLinks(links) {
	
	        var sState = this.props.matchState || 'pre'; //pre,post,live
	        var bCommentaryLink = this.props.commentaryLink || false;
	        var bStandingsLink = this.props.standingsLink || false;
	        var bStatsLink = this.props.statsLink || false;
	        var bReportLink = this.props.reportLink || false;
	        var bPreviewLink = this.props.previewLink || false;
	        var tabs = [];
	
	        for (var i = 0, len = links.length; i < len; i++) {
	            var link = links[i];
	            var extLink = this.map[link].href || this.props.tableHref;
	            var anchorProps = {};
	
	            if (link === 'report' && bReportLink === false) {
	                continue;
	            } else if (link === 'preview' && bPreviewLink === false) {
	                continue;
	            }
	
	            if ((link === 'matchstats' || link === 'playerstats') && bStatsLink === false || link === 'commentary' && bCommentaryLink === false || link === 'table' && bStandingsLink === false) {
	                continue;
	            }
	
	            if (link === 'table' && extLink) {
	                anchorProps.href = extLink;
	                anchorProps.style = { color: '#000' };
	                //anchorProps.target = "_blank";
	                anchorProps['data-route'] = 'false';
	            }
	
	            anchorProps.onClick = this.tabSelect.bind(this, link);
	
	            var sLabel = this.map[link].label || '';
	            if (link === 'summary' && sState == 'live') {
	                sLabel = 'Live';
	            }
	            tabs.push(React.createElement(
	                'li',
	                { key: link, className: "sub" + (this.state.selected == link ? ' active' : '') },
	                React.createElement(
	                    'a',
	                    anchorProps,
	                    React.createElement(
	                        'span',
	                        { className: 'link-text' },
	                        sLabel
	                    ),
	                    React.createElement(
	                        'span',
	                        { className: 'link-text-short' },
	                        sLabel
	                    )
	                )
	            ));
	        }
	        return tabs;
	    },
	
	    render: function render() {
	
	        var sState = this.props.matchState || 'pre'; //pre,post,live
	        var links = this.availableTabs[sState] || [];
	        var availableTabCount = this.state.availableTabCount || links.length;
	        var tabs = [];
	        var visibleLinks = links.slice(0, availableTabCount);
	        var moreLinks = visibleLinks === availableTabCount ? [] : links.slice(availableTabCount);
	
	        tabs = this.buildLinks(visibleLinks);
	
	        if (moreLinks.length) {
	            tabs.push(React.createElement(
	                'li',
	                { key: 'more.links', className: 'has-sub', itemProp: 'name', style: { display: "inline-block" } },
	                React.createElement(
	                    'a',
	                    { itemProp: 'url', onClick: this.toggleMoreLinks },
	                    React.createElement(
	                        'span',
	                        { className: 'link-text' },
	                        'More'
	                    ),
	                    React.createElement(
	                        'span',
	                        { className: 'link-text-short' },
	                        'More'
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'sub-content' },
	                    React.createElement(
	                        'ul',
	                        null,
	                        this.buildLinks(moreLinks)
	                    )
	                )
	            ));
	        }
	
	        return React.createElement(
	            'nav',
	            { id: 'global-nav-tertiary', className: 'game-package-nav', style: { display: 'block' } },
	            React.createElement(
	                'div',
	                { className: 'tertiary-nav-container' },
	                React.createElement(
	                    'ul',
	                    { className: 'first-group focused' },
	                    tabs
	                )
	            )
	        );
	    }
	});
	
	module.exports = TabLinks;

/***/ },
/* 379 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	
	/* Components */
	var LeagueTable = __webpack_require__(381);
	var PlayerList = __webpack_require__(382);
	var GameInformation = __webpack_require__(383);
	var MatchHistory = __webpack_require__(384);
	var NewsList = __webpack_require__(385);
	var MatchStats = __webpack_require__(386);
	var Penalties = __webpack_require__(390);
	var Conversation = __webpack_require__(391);
	var Commentary = __webpack_require__(392);
	var HorizontalTimeline = __webpack_require__(393);
	var VerticalTimeline = __webpack_require__(394);
	var TeamStats = __webpack_require__(395);
	var Advert = __webpack_require__(371);
	var AdReloaderMixin = __webpack_require__(396);
	
	var TabSummary = React.createClass({
	
	    displayName: 'TabSummary',
	
	    mixins: [AdReloaderMixin],
	
	    getInitialState: function getInitialState() {
	        return {
	            adWrapSelector: '#reactContainer .react-ad'
	        };
	    },
	
	    renderAdvert: function renderAdvert() {
	        return React.createElement(
	            'article',
	            { className: 'ad-300', key: 'mpuadvert' },
	            React.createElement(
	                'div',
	                { className: 'ad-center' },
	                React.createElement(Advert, { id: 'game.rhs.mpu', className: 'ad-slot-incontent ad-wrapper', slotType: 'incontent' })
	            )
	        );
	    },
	
	    renderPlayersList: function renderPlayersList() {
	        var oStore = this.props.store;
	        var sState = this.props.matchState || 'pre'; //pre,post,live
	        var iWidth = this.props.width;
	
	        var aHomeTeam = oStore.getPlayersList('home');
	        var aAwayTeam = oStore.getPlayersList('away');
	        var oHomeTeam = oStore.getHomeTeam();
	        var oAwayTeam = oStore.getAwayTeam();
	
	        return React.createElement(PlayerList, { key: 'playerslist', homeTeam: aHomeTeam, awayTeam: aAwayTeam, matchState: sState, home: oHomeTeam, away: oAwayTeam, width: iWidth });
	    },
	
	    renderGameInformation: function renderGameInformation() {
	        var oStore = this.props.store;
	        var oGameInfo = oStore.getGameInformation();
	        return React.createElement(GameInformation, { key: 'gameinfo', capacity: oGameInfo.capacity, attendance: oGameInfo.attendance, datetime: oGameInfo.datetime, coverage: oGameInfo.coverage, venue: oGameInfo.venueName, address: oGameInfo.address });
	    },
	
	    renderConversation: function renderConversation() {
	        return React.createElement(Conversation, { key: 'conversation', query: this.props.query });
	    },
	
	    renderTeamStats: function renderTeamStats() {
	        var oStore = this.props.store;
	        var aStatsSummary = oStore.getStatSummary();
	        return React.createElement(TeamStats, { key: 'teamstats', stats: aStatsSummary });
	    },
	
	    renderMatchStats: function renderMatchStats() {
	        var oStore = this.props.store;
	        if (!oStore.hasStats()) {
	            return;
	        }
	        var possession = oStore.getStatPercent('possession');
	        var territory = oStore.getStatPercent('territory');
	        var matchStats = oStore.getMatchStats();
	        var gameStripProps = oStore.getGameStripDetails();
	        var homeTeam = oStore.getHomeTeam() || {};
	        var awayTeam = oStore.getAwayTeam() || {};
	
	        return React.createElement(MatchStats, { key: 'matchstats', changeView: this.props.changeView, stats: matchStats, territory: territory, possession: possession, home: { logo: gameStripProps.teams.home.logo, abbreviation: gameStripProps.teams.home.abbreviation, color: homeTeam.color }, away: { logo: gameStripProps.teams.away.logo, abbreviation: gameStripProps.teams.away.abbreviation, color: awayTeam.color } });
	    },
	
	    renderMatchCommentary: function renderMatchCommentary() {
	        var oStore = this.props.store;
	        var aCommentary = oStore.getCommentary();
	        return React.createElement(Commentary, { key: 'commentary', gameEvents: aCommentary, changeView: this.props.changeView });
	    },
	
	    buildColC: function buildColC() {
	        var oStore = this.props.store;
	        var leagueName = oStore.getLeagueName();
	        var aLeagueTable = oStore.getLeagueTable();
	        var newsList = oStore.getNewsList();
	
	        var aColC = [];
	
	        aColC.push(this.renderAdvert());
	
	        aColC.push(React.createElement(LeagueTable, { key: 'table', tableHref: this.props.tableHref, date: '', name: leagueName, table: aLeagueTable }));
	
	        aColC.push(React.createElement(NewsList, { key: 'news', header: newsList.header, link: newsList.link, articles: newsList.articles }));
	
	        return aColC;
	    },
	
	    render: function render() {
	
	        var sState = this.props.matchState || 'pre'; //pre,post,live
	        var oStore = this.props.store;
	        var iWidth = jQuery(window).outerWidth() || this.props.width;
	        var rSummary = null;
	        var iMaxWidth = 1279;
	
	        var aColA = [];
	        var aColB = [];
	        var aColC = [];
	
	        //<div className="hidden-sm hidden-md hidden-lg">
	        //	<div className="sub-module linkFeedItem">
	        //		<ul>
	        //			<li><a className="icon-font-before icon-listen02-solid-before" href="#">Listen</a></li>
	        //			<li><a className="icon-font-before icon-watch-outline-before" href="#">Watch</a></li>
	        //		</ul>
	        //	</div>
	        //</div>
	        //<HorizontalTimeline />
	        //<VerticalTimeline />
	        //<Penalties />
	
	        if (sState === 'post') {
	
	            if (iWidth >= iMaxWidth) {
	
	                aColA.push(this.renderPlayersList());
	                aColA.push(this.renderGameInformation());
	
	                aColB.push(this.renderMatchCommentary());
	                aColB.push(this.renderMatchStats());
	
	                aColC = this.buildColC();
	            } else if (iWidth >= 768) {
	
	                aColB.push(this.renderMatchCommentary());
	                aColB.push(this.renderMatchStats());
	                aColB.push(this.renderPlayersList());
	                aColB.push(this.renderGameInformation());
	
	                aColC = this.buildColC();
	            } else {
	                aColB.push(this.renderMatchCommentary());
	                aColB.push(this.renderMatchStats());
	                aColB.push(this.renderAdvert());
	                aColB.push(this.renderGameInformation());
	            }
	
	            aColB.push(this.renderConversation());
	
	            rSummary = React.createElement(
	                'div',
	                { className: 'layout-cbc' },
	                React.createElement(
	                    'section',
	                    { className: 'col-one' },
	                    aColA
	                ),
	                React.createElement(
	                    'section',
	                    { className: 'col-two' },
	                    aColB
	                ),
	                React.createElement(
	                    'section',
	                    { id: 'now-feed', className: 'col-three' },
	                    aColC
	                )
	            );
	        } else if (sState === 'live') {
	
	            if (iWidth >= iMaxWidth) {
	
	                aColA.push(this.renderPlayersList());
	                aColA.push(this.renderGameInformation());
	
	                aColB.push(this.renderMatchCommentary());
	                aColB.push(this.renderMatchStats());
	
	                aColC = this.buildColC();
	            } else if (iWidth >= 768) {
	
	                aColB.push(this.renderMatchCommentary());
	                aColB.push(this.renderMatchStats());
	                aColB.push(this.renderPlayersList());
	                aColB.push(this.renderGameInformation());
	
	                aColC = this.buildColC();
	            } else {
	                aColB.push(this.renderMatchCommentary());
	                aColB.push(this.renderMatchStats());
	                aColB.push(this.renderAdvert());
	                aColB.push(this.renderGameInformation());
	            }
	
	            aColB.push(this.renderConversation());
	
	            rSummary = React.createElement(
	                'div',
	                { className: 'layout-cbc' },
	                React.createElement(
	                    'section',
	                    { className: 'col-one' },
	                    aColA
	                ),
	                React.createElement(
	                    'section',
	                    { className: 'col-two' },
	                    aColB
	                ),
	                React.createElement(
	                    'section',
	                    { id: 'now-feed', className: 'col-three' },
	                    aColC
	                )
	            );
	        } else {
	
	            var head2head = oStore.getHead2Head();
	            var recentForm = oStore.getRecentForm();
	            var gameStripProps = oStore.getGameStripDetails();
	
	            aColB.push(this.renderMatchCommentary());
	            aColB.push(React.createElement(MatchHistory, { key: 'headtohead', data: head2head, head2head: true }));
	
	            if (iWidth >= iMaxWidth) {
	
	                aColA.push(this.renderPlayersList());
	                aColA.push(this.renderTeamStats());
	                aColA.push(this.renderGameInformation());
	
	                aColB.push(React.createElement(MatchHistory, { team: gameStripProps.teams.home, key: 'homeform', data: recentForm.home }));
	                aColB.push(React.createElement(MatchHistory, { team: gameStripProps.teams.away, key: 'awayform', data: recentForm.away }));
	
	                aColC = this.buildColC();
	            } else if (iWidth >= 768) {
	
	                aColB.push(React.createElement(MatchHistory, { team: gameStripProps.teams.home, key: 'homeform', data: recentForm.home }));
	                aColB.push(React.createElement(MatchHistory, { team: gameStripProps.teams.away, key: 'awayform', data: recentForm.away }));
	
	                aColB.push(this.renderPlayersList());
	                aColB.push(this.renderTeamStats());
	                aColB.push(this.renderGameInformation());
	
	                aColC = this.buildColC();
	            } else {
	                aColB.push(this.renderTeamStats());
	                aColB.push(this.renderAdvert());
	                aColB.push(this.renderGameInformation());
	            }
	
	            aColB.push(this.renderConversation());
	
	            rSummary = React.createElement(
	                'div',
	                { className: 'layout-cbc' },
	                React.createElement(
	                    'section',
	                    { className: 'col-one' },
	                    aColA
	                ),
	                React.createElement(
	                    'section',
	                    { className: 'col-two' },
	                    aColB
	                ),
	                React.createElement(
	                    'section',
	                    { id: 'now-feed', className: 'col-three' },
	                    aColC
	                )
	            );
	        }
	        return rSummary;
	    }
	});
	
	module.exports = TabSummary;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	var DateFormatMixin = __webpack_require__(365);
	
	var Table = React.createClass({
	    displayName: 'Table',
	
	    render: function render() {
	
	        var leagueTable = this.props.table;
	        var aLeagueRows = [];
	        var subHeading = null;
	
	        if (this.props.name) {
	            subHeading = React.createElement(
	                'tr',
	                null,
	                React.createElement(
	                    'th',
	                    { colSpan: '5' },
	                    this.props.name
	                )
	            );
	        }
	
	        for (var i = 0, len = leagueTable && leagueTable.length; i < len; i++) {
	            var row = leagueTable[i];
	            aLeagueRows.push(React.createElement(
	                'tr',
	                { key: i },
	                React.createElement(
	                    'td',
	                    null,
	                    row.position || 0
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    React.createElement(
	                        'a',
	                        { target: '_blank', href: row.href },
	                        row.name || 0
	                    )
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    row.played || 0
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    row.pointsDifference || 0
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    row.points || 0
	                )
	            ));
	        }
	
	        return React.createElement(
	            'table',
	            { cellSpacing: '0' },
	            React.createElement(
	                'thead',
	                null,
	                subHeading,
	                React.createElement(
	                    'tr',
	                    null,
	                    React.createElement(
	                        'th',
	                        null,
	                        'POS'
	                    ),
	                    React.createElement(
	                        'th',
	                        null,
	                        'Team'
	                    ),
	                    React.createElement(
	                        'th',
	                        null,
	                        'P'
	                    ),
	                    React.createElement(
	                        'th',
	                        null,
	                        'PD'
	                    ),
	                    React.createElement(
	                        'th',
	                        null,
	                        'PTS'
	                    )
	                )
	            ),
	            React.createElement(
	                'tbody',
	                null,
	                aLeagueRows.length ? aLeagueRows : React.createElement(
	                    'tr',
	                    null,
	                    React.createElement(
	                        'td',
	                        null,
	                        'No data available'
	                    )
	                )
	            )
	        );
	    }
	});
	
	var LeagueTable = React.createClass({
	
	    displayName: 'LeagueTable',
	
	    mixins: [DateFormatMixin],
	
	    render: function render() {
	
	        var sLeagueTitle = this.props.name + ' Standings' || '--';
	        var sLeagueDate = this.props.date || '';
	        var iLeagueId = this.props.id || '';
	        var aLeagueTable = this.props.table || [];
	        var footer = null;
	
	        if (!aLeagueTable || aLeagueTable.length <= 0) {
	            return null;
	        }
	
	        if (sLeagueDate) {
	            sLeagueDate = ' <span className="alt">As of ' + this.dateFormat(sLeagueDate, 'date1') + '</span>';
	        }
	
	        sLeagueTitle += sLeagueDate;
	
	        if (iLeagueId || this.props.tableHref) {
	            footer = React.createElement(
	                'footer',
	                { style: { margin: '0' } },
	                React.createElement(
	                    'a',
	                    { 'data-route': 'false', target: '_blank', href: this.props.tableHref || '/rugby/table/_/league/' + iLeagueId },
	                    'Full Table'
	                )
	            );
	        }
	
	        return React.createElement(
	            'article',
	            { className: 'sub-module' },
	            React.createElement(
	                'header',
	                null,
	                React.createElement('h1', { dangerouslySetInnerHTML: { __html: sLeagueTitle } })
	            ),
	            React.createElement(
	                'div',
	                { className: 'content' },
	                React.createElement(Table, { table: aLeagueTable })
	            ),
	            footer
	        );
	    }
	});
	
	module.exports = LeagueTable;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	var classNames = __webpack_require__(361);
	
	var PlayerList = React.createClass({
	
	    displayName: 'PlayerList',
	
	    getInitialState: function getInitialState() {
	        return {
	            homeAway: 'home',
	            split: this.splitTabs()
	        };
	    },
	
	    swapTeam: function swapTeam() {
	        if (this.state.homeAway === 'home') {
	            this.setState({ homeAway: 'away' });
	        } else {
	            this.setState({ homeAway: 'home' });
	        }
	    },
	
	    renderTeamList: function renderTeamList(aPlayers, sState) {
	
	        var iPlayerLen = aPlayers.length;
	        var rPlayerList = { team: [], subs: [] };
	
	        for (var i = 0; i < iPlayerLen; i++) {
	            var oPlayer = aPlayers[i];
	            if (typeof oPlayer === 'undefined') {
	                continue;
	            }
	            var props = {
	                key: oPlayer.id,
	                name: oPlayer.name,
	                number: oPlayer.number,
	                captain: oPlayer.captain,
	                tries: oPlayer.tries,
	                runs: oPlayer.runs,
	                runMetres: oPlayer.runMetres,
	                tackles: oPlayer.tackles,
	                missedTackles: oPlayer.missedTackles,
	                yellowCards: oPlayer.yellowCards,
	                redCards: oPlayer.redCards,
	                conversionGoals: oPlayer.conversionGoals,
	                matchState: sState,
	                position: oPlayer.position,
	                subbed: oPlayer.subbed,
	                penalties: oPlayer.penalties,
	                events: oPlayer.events,
	                subTip: oPlayer.subTip
	            };
	
	            if (i <= 14) {
	                rPlayerList.team.push(React.createElement(PlayerListRow, props));
	            } else {
	                rPlayerList.subs.push(React.createElement(PlayerListRow, props));
	            }
	        }
	
	        return rPlayerList;
	    },
	
	    splitTabs: function splitTabs() {
	        var iWindowWidth = this.props.width || 1280;
	        if (iWindowWidth > 1280) {
	            return true;
	        } else {
	            return false;
	        }
	    },
	
	    render: function render() {
	
	        /* confusing names of vars to enable showing and hiding of tabs, to be tidied up. */
	
	        var sState = this.props.matchState || 'pre'; //pre,post,live
	        var aHomeTeam = this.props.homeTeam || [];
	        var aAwayTeam = this.props.awayTeam || [];
	
	        if (aHomeTeam.length <= 0 && aAwayTeam.length <= 0) {
	            //return (
	            //   <div class="no-standings" style={{padding:'20px',textAlign:'center'}}>Line-ups not yet available</div>
	            //);
	        }
	
	        var bForceSplit = this.props.split || false;
	        var bSplit = this.state.split || false;
	        var oHome = this.props.home || {};
	        var oAway = this.props.away || {};
	
	        var aArticleClass = ['boxscore-tabs', 'sub-module-mobile-combine-split', 'combined'];
	        var aButtonHome = ['button-filter-alt', 'lg', 'fixed'];
	        var aButtonAway = ['button-filter-alt', 'lg', 'fixed'];
	
	        var aPlayerList = {
	            home: { team: [], subs: [] },
	            away: { team: [], subs: [] }
	        };
	
	        if (!bForceSplit) {
	            aArticleClass.push('combined');
	        }
	
	        aPlayerList = {
	            home: this.renderTeamList(aHomeTeam, sState),
	            away: this.renderTeamList(aAwayTeam, sState)
	        };
	
	        if (this.state.homeAway === 'home') {
	            aButtonHome.push('active');
	        } else {
	            aButtonAway.push('active');
	        }
	
	        var aHomeStyle = { display: 'block' };
	        var aAwayStyle = { display: 'block' };
	        if (!bSplit || !bForceSplit) {
	            if (this.state.homeAway === 'home') {
	                aAwayStyle = { display: 'none' };
	            } else {
	                aHomeStyle = { display: 'none' };
	            }
	        }
	
	        var sArticleClass = classNames(aArticleClass);
	        var sButtonHome = classNames(aButtonHome);
	        var sButtonAway = classNames(aButtonAway);
	        var sHomeAbbr = oHome.abbreviation || oHome.name;
	        var sAwayAbbr = oAway.abbreviation || oAway.name;
	        sHomeAbbr = sHomeAbbr.toUpperCase();
	        sAwayAbbr = sAwayAbbr.toUpperCase();
	        var rTableHeader = null;
	
	        if (sState === 'pre') {
	            rTableHeader = React.createElement(
	                'tr',
	                null,
	                React.createElement(
	                    'th',
	                    { className: 'number', style: { width: '33px' } },
	                    'No.'
	                ),
	                React.createElement(
	                    'th',
	                    { className: 'name', colSpan: '2' },
	                    'Name'
	                )
	            );
	        } else {
	            rTableHeader = React.createElement(
	                'tr',
	                null,
	                React.createElement('th', { style: { width: '33px' } }),
	                React.createElement(
	                    'th',
	                    { className: 'number' },
	                    'No.'
	                ),
	                React.createElement(
	                    'th',
	                    { className: 'name' },
	                    'Name'
	                )
	            );
	        }
	
	        if (aPlayerList.home.team.length <= 0) {
	            aPlayerList.home.team.push(React.createElement(
	                'tr',
	                { key: 'noHome' },
	                React.createElement(
	                    'td',
	                    { colSpan: '3', style: { padding: '20px', textAlign: 'center' } },
	                    'Line-ups not yet available'
	                )
	            ));
	        }
	
	        if (aPlayerList.away.team.length <= 0) {
	            aPlayerList.away.team.push(React.createElement(
	                'tr',
	                { key: 'noAway' },
	                React.createElement(
	                    'td',
	                    { colSpan: '3', style: { padding: '20px', textAlign: 'center' } },
	                    'Line-ups not yet available'
	                )
	            ));
	        }
	
	        return React.createElement(
	            'article',
	            { className: sArticleClass, 'data-behavior': 'content_tab_mobile' },
	            React.createElement(
	                'header',
	                null,
	                React.createElement(
	                    'div',
	                    { className: 'filter form-group button-group' },
	                    React.createElement(
	                        'button',
	                        { className: sButtonHome, onClick: this.swapTeam },
	                        React.createElement(
	                            'span',
	                            { className: 'team-name' },
	                            oHome.name
	                        ),
	                        React.createElement(
	                            'span',
	                            { className: 'team-name-short' },
	                            sHomeAbbr
	                        )
	                    ),
	                    React.createElement(
	                        'button',
	                        { className: sButtonAway, onClick: this.swapTeam },
	                        React.createElement(
	                            'span',
	                            { className: 'team-name' },
	                            oAway.name
	                        ),
	                        React.createElement(
	                            'span',
	                            { className: 'team-name-short' },
	                            sAwayAbbr
	                        )
	                    )
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'row-wrapper' },
	                React.createElement(
	                    'div',
	                    { className: 'content-tab', style: aHomeStyle },
	                    React.createElement(
	                        'div',
	                        { className: 'col column-one' },
	                        React.createElement(
	                            'div',
	                            { className: 'sub-module rugby' },
	                            React.createElement(
	                                'div',
	                                { className: 'content' },
	                                React.createElement(
	                                    'table',
	                                    { 'data-behavior': 'table_accordion', className: 'table-accordion' },
	                                    React.createElement(
	                                        'caption',
	                                        null,
	                                        React.createElement('img', { src: oHome.logo }),
	                                        oHome.name
	                                    ),
	                                    React.createElement(
	                                        'thead',
	                                        null,
	                                        rTableHeader
	                                    ),
	                                    React.createElement(
	                                        'tbody',
	                                        null,
	                                        aPlayerList.home.team
	                                    ),
	                                    React.createElement(
	                                        'thead',
	                                        null,
	                                        React.createElement(
	                                            'tr',
	                                            { className: 'secondTableHeader' },
	                                            React.createElement(
	                                                'th',
	                                                { colSpan: '3' },
	                                                'Replacements'
	                                            )
	                                        )
	                                    ),
	                                    React.createElement(
	                                        'tbody',
	                                        null,
	                                        aPlayerList.home.subs
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'content-tab', style: aAwayStyle },
	                    React.createElement(
	                        'div',
	                        { className: 'col column-two' },
	                        React.createElement(
	                            'div',
	                            { className: 'sub-module rugby' },
	                            React.createElement(
	                                'div',
	                                { className: 'content' },
	                                React.createElement(
	                                    'table',
	                                    { 'data-behavior': 'table_accordion', className: 'table-accordion' },
	                                    React.createElement(
	                                        'caption',
	                                        null,
	                                        React.createElement('img', { src: oAway.logo }),
	                                        oAway.name
	                                    ),
	                                    React.createElement(
	                                        'thead',
	                                        null,
	                                        rTableHeader
	                                    ),
	                                    React.createElement(
	                                        'tbody',
	                                        null,
	                                        aPlayerList.away.team
	                                    ),
	                                    React.createElement(
	                                        'thead',
	                                        null,
	                                        React.createElement(
	                                            'tr',
	                                            { className: 'secondTableHeader' },
	                                            React.createElement(
	                                                'th',
	                                                { colSpan: '3' },
	                                                'Replacements'
	                                            )
	                                        )
	                                    ),
	                                    React.createElement(
	                                        'tbody',
	                                        null,
	                                        aPlayerList.away.subs
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    }
	});
	
	var PlayerListRow = React.createClass({
	
	    displayName: 'PlayerListRow',
	
	    getInitialState: function getInitialState() {
	        return {
	            expanded: false
	        };
	    },
	
	    expandRow: function expandRow() {
	        if (this.state.expanded) {
	            this.setState({ expanded: false });
	        } else {
	            this.setState({ expanded: true });
	        }
	    },
	
	    renderIcons: function renderIcons() {
	
	        var hEvents = this.props.events || {};
	        var hIconCode = {
	            1: 'T',
	            2: '&#xE09F;',
	            3: '&#xE0A0;',
	            4: '&#xE097;',
	            5: '',
	            6: ''
	        };
	        var aIcons = [];
	
	        //Loop tooltips
	        for (var iEventId in hEvents) {
	            if (hEvents.hasOwnProperty(iEventId)) {
	                var iElQuant = hEvents[iEventId].length;
	                var sToolTipTxt = '(' + hEvents[iEventId].join(',') + ')';
	                if (iElQuant >= 1) {
	
	                    var sClassStr = "icon-font rugby-icon";
	                    if (iEventId == 5) {
	                        sClassStr = "game-icon icon-font-before icon-soccer-card02-solid-before icon-yellowcard";
	                    } else if (iEventId == 6) {
	                        sClassStr = "game-icon icon-font-before icon-soccer-card02-solid-before icon-redcard";
	                    }
	
	                    var sKey = "icon." + iEventId;
	                    var sSubKey = "icon.sub." + iEventId;
	                    aIcons.push(React.createElement(
	                        'div',
	                        { key: sKey, className: 'tooltip', 'data-tooltip': sToolTipTxt },
	                        React.createElement('span', { className: sClassStr, dangerouslySetInnerHTML: { __html: hIconCode[iEventId] } })
	                    ));
	                    if (iElQuant > 1) {
	                        aIcons.push(React.createElement(
	                            'span',
	                            { key: sSubKey, className: 'subscript' },
	                            iElQuant
	                        ));
	                    }
	                }
	            }
	        }
	
	        return aIcons;
	    },
	
	    render: function render() {
	
	        var sName = this.props.name || '-';
	        var bCaptain = this.props.captain || false;
	        var iNumber = this.props.number || '-';
	        var iTries = this.props.tries || 0;
	        var iRuns = this.props.runs || 0;
	        var iRunMetres = this.props.runMetres || 0;
	        var iTackles = this.props.tackles || 0;
	        var iMissedTackles = this.props.missedTackles || 0;
	        var iYellowCards = this.props.yellowCards || 0;
	        var iRedCards = this.props.redCards || 0;
	        var iConversionGoals = this.props.conversionGoals || 0;
	        var iPenGoals = this.props.penalties || 0;
	        var sPosition = this.props.position || '';
	        var bSubbed = this.props.subbed || false;
	        var hToolTips = this.props.tooltips || {};
	        var sSubTip = this.props.subTip || '';
	        var sState = this.props.matchState || 'pre'; //pre,post,live
	        var iTotalTackles = parseInt(iTackles) + parseInt(iMissedTackles);
	
	        var rStatsHtml = null;
	        var oBarBackground = { backgroundColor: '#f2f2f2' };
	        var oTackles = { backgroundColor: '#dd2126', width: '0%' };
	        var oTacklesMissed = { backgroundColor: '#dd2126', width: '0%' };
	        var aRowClass = [];
	        var aAccoClass = ['accordion-content'];
	        var aAccoBtnClass = ['icon-accordion', 'btn-accordion'];
	
	        if (sPosition && sPosition !== 'UKN') {
	            sName += ', ' + sPosition;
	        }
	
	        if (bCaptain) {
	            sName += ' (c)';
	        }
	
	        if (this.state.expanded) {
	            aAccoClass.push('open');
	            aRowClass.push('active');
	            aAccoBtnClass.push('active');
	            var sAccoClass = classNames(aAccoClass);
	
	            var iTacklesPerc = parseInt(iTackles / iTotalTackles * 100);
	            oTackles.width = iTacklesPerc + '%';
	            var iMissedPerc = parseInt(iMissedTackles / iTotalTackles * 100);
	            oTacklesMissed.width = iMissedPerc + '%';
	
	            rStatsHtml = React.createElement(
	                'div',
	                { className: sAccoClass },
	                React.createElement(
	                    'div',
	                    { className: 'lineup-stats' },
	                    React.createElement(
	                        'ul',
	                        { className: 'stats' },
	                        React.createElement(
	                            'li',
	                            { className: 'stat' },
	                            React.createElement(
	                                'span',
	                                { className: 'label' },
	                                'Tries'
	                            ),
	                            React.createElement(
	                                'span',
	                                { className: 'value' },
	                                iTries
	                            )
	                        ),
	                        React.createElement(
	                            'li',
	                            { className: 'stat' },
	                            React.createElement(
	                                'span',
	                                { className: 'label' },
	                                'Runs'
	                            ),
	                            React.createElement(
	                                'span',
	                                { className: 'value' },
	                                iRuns
	                            )
	                        ),
	                        React.createElement(
	                            'li',
	                            { className: 'stat' },
	                            React.createElement(
	                                'span',
	                                { className: 'label' },
	                                'Run Metres'
	                            ),
	                            React.createElement(
	                                'span',
	                                { className: 'value' },
	                                iRunMetres
	                            )
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'fouls' },
	                        React.createElement(
	                            'ul',
	                            { className: 'compareLineGraph sameTeam' },
	                            React.createElement(
	                                'li',
	                                null,
	                                React.createElement(
	                                    'span',
	                                    { className: 'chartLabel' },
	                                    'Tackles'
	                                ),
	                                React.createElement(
	                                    'span',
	                                    { style: oBarBackground, className: 'bar-total' },
	                                    React.createElement('span', { style: oTackles, className: 'bar-percentage' })
	                                ),
	                                React.createElement(
	                                    'span',
	                                    { className: 'chartValue' },
	                                    iTackles
	                                )
	                            ),
	                            React.createElement(
	                                'li',
	                                null,
	                                React.createElement(
	                                    'span',
	                                    { style: oBarBackground, className: 'bar-total' },
	                                    React.createElement('span', { style: oTacklesMissed, className: 'bar-percentage' })
	                                ),
	                                React.createElement(
	                                    'span',
	                                    { className: 'chartValue' },
	                                    iMissedTackles
	                                ),
	                                React.createElement(
	                                    'span',
	                                    { className: 'chartLabel' },
	                                    'Missed Tackles'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	        var sRowClass = classNames(aRowClass);
	        var sAccoBtnClass = classNames(aAccoBtnClass);
	
	        var hNameStyleHack = {
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis'
	        };
	
	        if (sState === 'pre') {
	            return React.createElement(
	                'tr',
	                { className: sRowClass },
	                React.createElement(
	                    'td',
	                    { className: 'number' },
	                    iNumber
	                ),
	                React.createElement(
	                    'td',
	                    { colSpan: '2', className: 'date', style: hNameStyleHack },
	                    sName
	                )
	            );
	        } else {
	
	            var aIcons = this.renderIcons() || [];
	
	            var rSubbed = null;
	            if (bSubbed) {
	                rSubbed = React.createElement(
	                    'div',
	                    { key: 'icon.subbed', className: 'tooltip', 'data-tooltip': sSubTip },
	                    React.createElement('span', { className: 'icon-font icon-soccer-substitution-before' })
	                );
	            }
	
	            return React.createElement(
	                'tr',
	                { className: sRowClass },
	                React.createElement(
	                    'td',
	                    { colSpan: '3', className: sRowClass },
	                    React.createElement(
	                        'div',
	                        { className: 'accordion-item ' },
	                        React.createElement(
	                            'div',
	                            { className: 'accordion-header lineup-player', onClick: this.expandRow },
	                            React.createElement('span', { key: 'btn', className: sAccoBtnClass }),
	                            rSubbed,
	                            React.createElement(
	                                'span',
	                                { key: 'no', className: 'number' },
	                                iNumber
	                            ),
	                            React.createElement(
	                                'span',
	                                { key: 'name' },
	                                React.createElement(
	                                    'span',
	                                    { className: 'name', style: hNameStyleHack },
	                                    sName
	                                ),
	                                aIcons
	                            )
	                        ),
	                        rStatsHtml
	                    )
	                )
	            );
	        }
	    }
	});
	
	module.exports = PlayerList;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	var DateFormatMixin = __webpack_require__(365);
	
	var GameInformation = React.createClass({
	
	    displayName: 'GameInformation',
	
	    mixins: [DateFormatMixin],
	
	    renderAttendance: function renderAttendance() {
	        var iCapacity = this.props.capacity || 0;
	        var iAttendance = this.props.attendance || 0;
	
	        iAttendance = isNaN(iAttendance) ? 0 : iAttendance;
	        iCapacity = isNaN(iCapacity) ? 0 : iCapacity;
	
	        if (iCapacity && iAttendance) {
	
	            var sPercent = parseInt(iAttendance / iCapacity * 100);
	            if (sPercent > 100) {
	                sPercent = 100;
	            }
	            sPercent += '%';
	            return React.createElement(
	                'div',
	                { className: 'attendance' },
	                React.createElement(
	                    'div',
	                    { className: 'people' },
	                    React.createElement('div', { className: 'people-all' }),
	                    React.createElement('div', { className: 'attendance-bar', style: { width: sPercent } })
	                ),
	                React.createElement(
	                    'span',
	                    { className: 'percentage' },
	                    sPercent
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'capacity' },
	                    'Attendance: ',
	                    this.formatNubmer(iAttendance)
	                )
	            );
	        } else if (iAttendance) {
	            return React.createElement(
	                'div',
	                { className: 'capacity' },
	                'Attendance: ',
	                this.formatNubmer(iAttendance)
	            );
	        } else {
	            return null;
	        }
	    },
	
	    renderCapacity: function renderCapacity() {
	        var iCapacity = this.props.capacity || 0;
	        iCapacity = isNaN(iCapacity) ? 0 : iCapacity;
	
	        if (iCapacity) {
	            return React.createElement(
	                'div',
	                { className: 'capacity' },
	                'Capacity: ',
	                this.formatNubmer(iCapacity)
	            );
	        } else {
	            return null;
	        }
	    },
	
	    renderWeather: function renderWeather() {
	
	        var sAddress = this.props.address || '';
	        if (sAddress === '') {
	            return null;
	        }
	
	        /* the requirment to return only 1 object means i need to return an array if i wrap this object it breaks the css */
	        var aReturn = [];
	
	        //aReturn.push(
	        //	<div className="accuweather"></div>
	        //);
	        //<li className="icon-font-after icon-weather-rain-outline-after"></li>
	        //<li className="temperature">22&deg;</li>
	
	        aReturn.push(React.createElement(
	            'ul',
	            { key: 'location' },
	            React.createElement(
	                'li',
	                { className: 'icon-font-before icon-location-solid-before' },
	                sAddress
	            )
	        ));
	
	        return aReturn;
	    },
	
	    formatNubmer: function formatNubmer(x) {
	        var parts = x.toString().split(".");
	        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	        return parts.join(".");
	    },
	
	    renderVenue: function renderVenue() {
	
	        var sImageUrl = this.props.image || '';
	        var sVenue = this.props.venue || '--';
	
	        if (sImageUrl != '') {
	            return React.createElement(
	                'figure',
	                null,
	                React.createElement('img', { src: sImageUrl }),
	                React.createElement(
	                    'figcaption',
	                    null,
	                    React.createElement(
	                        'div',
	                        { className: 'caption-wrapper' },
	                        sVenue
	                    )
	                )
	            );
	        } else {
	            return React.createElement(
	                'div',
	                { className: 'game-details location-details' },
	                React.createElement(
	                    'div',
	                    { className: 'capacity' },
	                    'Venue: ',
	                    sVenue
	                )
	            );
	        }
	    },
	
	    render: function render() {
	
	        var rWeather = this.renderWeather();
	        var rCapacity = this.renderCapacity();
	        var rAttendance = this.renderAttendance();
	        var rVenueName = this.renderVenue();
	        var iDate = this.props.datetime;
	        var sCoverage = this.props.coverage;
	        var sVenue = this.props.venue || '--';
	        var sDate = "";
	
	        if (iDate) {
	            sDate = this.dateFormat(iDate, 'dateTime1');
	        }
	
	        if (sCoverage) {
	            sCoverage = "Coverage: " + sCoverage;
	        }
	        // className="bordered"
	        return React.createElement(
	            'article',
	            { className: 'sub-module game-information' },
	            React.createElement(
	                'header',
	                null,
	                React.createElement(
	                    'h1',
	                    null,
	                    'Game Information'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'content' },
	                React.createElement(
	                    'div',
	                    { className: 'game-field' },
	                    rVenueName,
	                    React.createElement(
	                        'div',
	                        { className: 'game-details' },
	                        React.createElement(
	                            'div',
	                            { className: 'game-date-time' },
	                            sDate
	                        ),
	                        React.createElement(
	                            'div',
	                            { className: 'game-network' },
	                            sCoverage
	                        )
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'location-details' },
	                    rWeather,
	                    rCapacity,
	                    rAttendance
	                )
	            )
	        );
	    }
	});
	
	module.exports = GameInformation;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	var moment = __webpack_require__(254);
	var utils = __webpack_require__(346);
	
	var TableBody = React.createClass({
	    displayName: 'TableBody',
	
	    render: function render() {
	
	        var data = (this.props.data || []).slice(0, 5);
	        var tableRows = [];
	        var classNames = {
	            "W": "win",
	            "L": "loss",
	            "D": ''
	        };
	
	        data.map((function (game, i) {
	            var gameResult = null;
	            if (!this.props.head2head) {
	                gameResult = React.createElement(
	                    'td',
	                    { className: classNames[game.result] },
	                    game.result
	                );
	            }
	
	            tableRows.push(React.createElement(
	                'tr',
	                { key: 'game.' + i },
	                gameResult,
	                React.createElement(
	                    'td',
	                    null,
	                    React.createElement(
	                        'a',
	                        { target: '_blank', href: game.home.url },
	                        React.createElement(
	                            'span',
	                            { className: 'long-name' },
	                            game.home.name || game.home.abbreviation
	                        ),
	                        React.createElement(
	                            'abbr',
	                            null,
	                            game.home.abbreviation
	                        )
	                    )
	                ),
	                React.createElement(
	                    'td',
	                    { className: 'logo' },
	                    React.createElement(
	                        'a',
	                        { target: '_blank', href: game.home.url },
	                        React.createElement('img', { src: utils.getImageUrl(game.home.logo) })
	                    )
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    React.createElement(
	                        'a',
	                        { href: game.url },
	                        game.score
	                    )
	                ),
	                React.createElement(
	                    'td',
	                    { className: 'logo' },
	                    React.createElement(
	                        'a',
	                        { target: '_blank', href: game.away.url },
	                        React.createElement('img', { src: utils.getImageUrl(game.away.logo) })
	                    )
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    React.createElement(
	                        'a',
	                        { target: '_blank', href: game.away.url },
	                        React.createElement(
	                            'span',
	                            { className: 'long-name' },
	                            game.away.name || game.away.abbreviation
	                        ),
	                        React.createElement(
	                            'abbr',
	                            null,
	                            game.away.abbreviation
	                        )
	                    )
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    moment(game.date.replace('Z', '')).utcOffset(0).format('Do MMM, YYYY')
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    game.league
	                )
	            ));
	        }).bind(this));
	
	        return React.createElement(
	            'tbody',
	            null,
	            tableRows
	        );
	    }
	});
	
	var MatchHistory = React.createClass({
	
	    displayName: 'MatchHistory',
	
	    getTeamName: function getTeamName(data) {
	        var name = '';
	        try {
	            name = data[0].home.name;
	        } catch (e) {}
	        return name;
	    },
	
	    render: function render() {
	
	        var data = this.props.data || [];
	        var team = this.props.team;
	        var teamName;
	        var teamLogo;
	
	        if (this.props.head2head) {
	            teamName = this.getTeamName(data);
	            teamLogo = utils.getImageUrl(data && data[0] && data[0].home.logo);
	        } else {
	            teamName = team.name;
	            teamLogo = team.logo;
	        }
	
	        /* react wraps a span around the word so lets force it as it breaks the css*/
	        var sDisplayTitle = this.props.head2head ? 'Head To Head Record' : '<img src="' + utils.getImageUrl(teamLogo) + '" />' + teamName + ' Form';
	        var MatchHistoryView = null;
	
	        MatchHistoryView = React.createElement(
	            'div',
	            { className: "sub-module last-games soccer" + (this.props.head2head ? ' head-to-head' : '') },
	            React.createElement(
	                'header',
	                { className: '' },
	                React.createElement('h1', { dangerouslySetInnerHTML: { __html: sDisplayTitle } })
	            ),
	            React.createElement(
	                'div',
	                { className: 'content', style: { overflowX: 'auto' } },
	                React.createElement(
	                    'table',
	                    { 'data-fix-cols': '0', 'data-behavior': 'responsive_table' },
	                    React.createElement(
	                        'thead',
	                        null,
	                        React.createElement(
	                            'tr',
	                            null,
	                            React.createElement(
	                                'th',
	                                { colSpan: this.props.head2head ? "5" : "6" },
	                                'LAST FIVE GAMES'
	                            ),
	                            React.createElement(
	                                'th',
	                                null,
	                                'DATE'
	                            ),
	                            React.createElement(
	                                'th',
	                                null,
	                                'COMPETITION'
	                            )
	                        )
	                    ),
	                    this.props.data.length ? React.createElement(TableBody, { head2head: this.props.head2head, data: this.props.data }) : React.createElement(
	                        'tbody',
	                        null,
	                        React.createElement(
	                            'tr',
	                            null,
	                            React.createElement(
	                                'td',
	                                { colSpan: '8' },
	                                'No data available'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	
	        return MatchHistoryView;
	    }
	});
	
	module.exports = MatchHistory;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	var ResponsiveImage = __webpack_require__(373);
	
	var NewsList = React.createClass({
	
	    displayName: 'NewsList',
	
	    render: function render() {
	
	        var aArticles = this.props.articles || [];
	        var sLeagueTitle = this.props.header || '';
	        var iNewsLen = aArticles.length;
	        var aNewsRows = [];
	        var newsListView = null;
	
	        for (var i = 0, len = aArticles.length; i < len; i++) {
	            var article = aArticles[i];
	            var href = article && article.links && article.links.web && article.links.web.href;
	            aNewsRows.push(React.createElement(
	                'li',
	                { className: 'text-container', key: i },
	                React.createElement(ResponsiveImage, { url: href, image: article.images[0] }),
	                React.createElement(
	                    'div',
	                    { className: 'text-container' },
	                    React.createElement(
	                        'h2',
	                        null,
	                        React.createElement(
	                            'a',
	                            { href: href },
	                            article.headline
	                        )
	                    ),
	                    React.createElement(
	                        'p',
	                        null,
	                        article.description
	                    )
	                )
	            ));
	        }
	
	        var rFooter = null;
	        if (typeof this.props.link !== 'undefined' && this.props.link !== null && typeof this.props.link.href !== 'undefined') {
	            rFooter = React.createElement(
	                'footer',
	                null,
	                React.createElement(
	                    'a',
	                    { href: this.props.link.href ? this.props.link.href : "#" },
	                    this.props.link.text
	                )
	            );
	        }
	
	        if (aNewsRows.length) {
	            newsListView = React.createElement(
	                'aside',
	                { className: 'sub-module sub-module-news' },
	                React.createElement(
	                    'header',
	                    { className: 'section-header' },
	                    React.createElement(
	                        'h2',
	                        null,
	                        sLeagueTitle
	                    )
	                ),
	                React.createElement(
	                    'ul',
	                    { className: 'content' },
	                    aNewsRows.length ? aNewsRows : React.createElement(
	                        'div',
	                        null,
	                        React.createElement(
	                            'p',
	                            null,
	                            'No news items'
	                        )
	                    )
	                ),
	                rFooter
	            );
	        }
	
	        return newsListView;
	    }
	});
	
	module.exports = NewsList;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	var TeamCompareHeader = __webpack_require__(387);
	var VisPercent = __webpack_require__(388);
	var StatsTable = __webpack_require__(389);
	var utils = __webpack_require__(346);
	
	var MatchStats = React.createClass({
	
	    displayName: 'MatchStats',
	
	    viewAll: function viewAll(oEvent) {
	        if (this.props.changeView) {
	            this.props.changeView('matchstats');
	        }
	    },
	
	    render: function render() {
	
	        var stats = this.props.stats;
	        var possession = this.props.possession;
	        var territory = this.props.territory;
	        var homeLogo = utils.getImageUrl(this.props.home.logo);
	        var awayLogo = utils.getImageUrl(this.props.away.logo);
	        var homeAbbrev = this.props.home.abbreviation;
	        var awayAbbrev = this.props.away.abbreviation;
	        var statsView = null;
	
	        return React.createElement(
	            'div',
	            { className: 'sub-module match-stats soccer' },
	            React.createElement(
	                'header',
	                { className: 'bordered' },
	                React.createElement(
	                    'h1',
	                    null,
	                    'Match Stats'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'content', style: { overflow: 'auto' } },
	                React.createElement(
	                    'div',
	                    { className: 'data-vis' },
	                    React.createElement(TeamCompareHeader, { heading: 'possession', home: { abbreviation: homeAbbrev, logo: homeLogo }, away: { abbreviation: awayAbbrev, logo: awayLogo } }),
	                    React.createElement(VisPercent, { percent: possession, colors: [this.props.home.color, this.props.away.color] }),
	                    React.createElement(TeamCompareHeader, { heading: 'territory', noTeams: 'no-teams', home: { abbreviation: homeAbbrev, logo: homeLogo }, away: { abbreviation: awayAbbrev, logo: awayLogo } }),
	                    React.createElement(VisPercent, { percent: territory, large: true, colors: [this.props.home.color, this.props.away.color] })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'stat-list' },
	                    React.createElement(TeamCompareHeader, { bordered: 'bordered', home: { abbreviation: homeAbbrev, logo: homeLogo }, away: { abbreviation: awayAbbrev, logo: awayLogo } }),
	                    React.createElement(StatsTable, { stats: stats })
	                )
	            ),
	            React.createElement(
	                'footer',
	                null,
	                React.createElement(
	                    'a',
	                    { onClick: this.viewAll },
	                    'Full Match Stats'
	                )
	            )
	        );
	    }
	});
	
	module.exports = MatchStats;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	var TeamCompareHeader = React.createClass({
	    displayName: 'TeamCompareHeader',
	
	    render: function render() {
	        var classNames = ["teamCompareHeaderWrap", this.props.bordered || '', this.props.noTeams || ''];
	
	        var sHome = this.props.home.abbreviation.toUpperCase();
	        var sAway = this.props.away.abbreviation.toUpperCase();
	
	        return React.createElement(
	            'div',
	            { className: classNames.join(' ') },
	            React.createElement(
	                'div',
	                { className: 'teamCompareHeader' },
	                React.createElement(
	                    'div',
	                    { className: 'team team1' },
	                    React.createElement('img', { className: 'imageLoaded', src: this.props.home.logo }),
	                    React.createElement(
	                        'span',
	                        { className: 'record' },
	                        sHome
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'header' },
	                    this.props.heading
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'team team2' },
	                    React.createElement(
	                        'span',
	                        { className: 'record' },
	                        sAway
	                    ),
	                    React.createElement('img', { className: 'imageLoaded', src: this.props.away.logo })
	                )
	            )
	        );
	    }
	});
	
	module.exports = TeamCompareHeader;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(11);
	
	var VisPercent = React.createClass({
	    displayName: "VisPercent",
	
	    render: function render() {
	        var percent = this.props.percent && this.props.percent.length ? this.props.percent : [0, 0];
	        var values = this.props.values || [];
	        var colors = this.props.colors || ["#ffc300", "#d31346"];
	        var awayColor = colors[1];
	        var homeColor = colors[0];
	        var backgroundColor = percent[0] > 100 ? awayColor : homeColor;
	
	        if (percent[0] == 0 && percent[1] == 0) {
	            awayColor = '#e5e5e5';
	        }
	
	        return React.createElement(
	            "div",
	            { className: "stat-graph compareLineGraph twoTeam largeLabels" + (this.props.large ? " large" : "") },
	            React.createElement(
	                "span",
	                { className: "chartValue" },
	                !isNaN(values[0]) ? values[0] : percent[0] + "%"
	            ),
	            React.createElement(
	                "div",
	                { className: "bar-wrap" },
	                React.createElement(
	                    "span",
	                    { style: { "backgroundColor": awayColor }, className: "bar-total" },
	                    React.createElement("span", { style: { "backgroundColor": backgroundColor, "width": percent[0] + "%" }, className: "bar-percentage" })
	                ),
	                React.createElement(
	                    "span",
	                    { className: "chartValue" },
	                    !isNaN(values[1]) ? values[1] : percent[1] + "%"
	                )
	            )
	        );
	    }
	});
	
	module.exports = VisPercent;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	
	var StatsTable = React.createClass({
	    displayName: 'StatsTable',
	
	    render: function render() {
	
	        var rows = [];
	        var stats = this.props.stats || [];
	
	        stats.map(function (stat, i) {
	            rows.push(React.createElement(
	                'tr',
	                { key: i },
	                React.createElement(
	                    'td',
	                    { className: 'score', colSpan: '2' },
	                    stat.home
	                ),
	                React.createElement(
	                    'td',
	                    { className: 'label', colSpan: '2' },
	                    stat.displayName
	                ),
	                React.createElement(
	                    'td',
	                    { className: 'score', colSpan: '2' },
	                    stat.away
	                )
	            ));
	        });
	
	        return React.createElement(
	            'table',
	            { className: 'compareTable' },
	            React.createElement(
	                'tbody',
	                null,
	                rows.length ? rows : null
	            )
	        );
	    }
	});
	
	module.exports = StatsTable;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	
	var Penalties = React.createClass({
	
	    displayName: 'Penalties',
	
	    render: function render() {
	
	        return React.createElement(
	            'article',
	            { className: 'sub-module penalty-shootout' },
	            React.createElement(
	                'header',
	                null,
	                React.createElement(
	                    'h1',
	                    null,
	                    'Penalty Shootouts'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'competitors' },
	                React.createElement(
	                    'div',
	                    { className: 'team away' },
	                    React.createElement(
	                        'div',
	                        { className: 'logo' },
	                        React.createElement('img', { src: 'http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/360.png?w=100&h=100&transparent=true' })
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'team-name' },
	                        React.createElement(
	                            'span',
	                            null,
	                            'Manchester United'
	                        ),
	                        React.createElement(
	                            'abbr',
	                            null,
	                            'MUN'
	                        )
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'team home' },
	                    React.createElement(
	                        'div',
	                        { className: 'team-name' },
	                        React.createElement(
	                            'span',
	                            null,
	                            'Manchester City'
	                        ),
	                        React.createElement(
	                            'abbr',
	                            null,
	                            'MCY'
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'logo' },
	                        React.createElement('img', { src: 'http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/382.png?w=100&h=100&transparent=true' })
	                    )
	                )
	            ),
	            React.createElement(
	                'table',
	                null,
	                React.createElement(
	                    'tbody',
	                    null,
	                    React.createElement(
	                        'tr',
	                        null,
	                        React.createElement(
	                            'td',
	                            { className: 'team-away shot-made' },
	                            React.createElement('a', { className: 'game-icon icon-font-before icon-play-solid-before' }),
	                            React.createElement(
	                                'div',
	                                { className: 'player-name' },
	                                'Lorem Ipsumipsum'
	                            ),
	                            React.createElement('div', { className: 'game-icon icon-font-before icon-soccer-ball-before icon-soccerball' })
	                        ),
	                        React.createElement(
	                            'td',
	                            { className: 'penalty' },
	                            React.createElement(
	                                'span',
	                                null,
	                                'Pen'
	                            ),
	                            ' 1'
	                        ),
	                        React.createElement(
	                            'td',
	                            { className: 'team-home shot-made' },
	                            React.createElement('div', { className: 'game-icon icon-font-before icon-soccer-ball-before icon-soccerball' }),
	                            React.createElement(
	                                'div',
	                                { className: 'player-name' },
	                                'Lorem Ipsum'
	                            ),
	                            React.createElement('a', { className: 'game-icon icon-font-before icon-play-solid-before' })
	                        )
	                    ),
	                    React.createElement(
	                        'tr',
	                        null,
	                        React.createElement(
	                            'td',
	                            { className: 'team-away shot-missed' },
	                            React.createElement('a', { className: 'game-icon icon-font-before icon-play-solid-before' }),
	                            React.createElement(
	                                'div',
	                                { className: 'player-name' },
	                                'Lorem Ipsum'
	                            ),
	                            React.createElement('div', { className: 'game-icon icon-font-before icon-soccer-ball-before icon-soccerball' })
	                        ),
	                        React.createElement(
	                            'td',
	                            { className: 'penalty' },
	                            React.createElement(
	                                'span',
	                                null,
	                                'Pen'
	                            ),
	                            ' 2'
	                        ),
	                        React.createElement(
	                            'td',
	                            { className: 'team-home shot-made' },
	                            React.createElement('div', { className: 'game-icon icon-font-before icon-soccer-ball-before icon-soccerball' }),
	                            React.createElement(
	                                'div',
	                                { className: 'player-name' },
	                                'Lorem Ipsumipsum'
	                            ),
	                            React.createElement('a', { className: 'game-icon icon-font-before icon-play-solid-before' })
	                        )
	                    ),
	                    React.createElement(
	                        'tr',
	                        null,
	                        React.createElement(
	                            'td',
	                            { className: 'team-away shot-made' },
	                            React.createElement('a', { className: 'game-icon icon-font-before icon-play-solid-before' }),
	                            React.createElement(
	                                'div',
	                                { className: 'player-name' },
	                                'Lorem Ipsumipsumipsum'
	                            ),
	                            React.createElement('div', { className: 'game-icon icon-font-before icon-soccer-ball-before icon-soccerball' })
	                        ),
	                        React.createElement(
	                            'td',
	                            { className: 'penalty' },
	                            React.createElement(
	                                'span',
	                                null,
	                                'Pen'
	                            ),
	                            ' 3'
	                        ),
	                        React.createElement(
	                            'td',
	                            { className: 'team-home shot-missed' },
	                            React.createElement('div', { className: 'game-icon icon-font-before icon-soccer-ball-before icon-soccerball' }),
	                            React.createElement(
	                                'div',
	                                { className: 'player-name' },
	                                'Lorem Ipsumipsum'
	                            ),
	                            React.createElement('a', { className: 'game-icon icon-font-before icon-play-solid-before' })
	                        )
	                    ),
	                    React.createElement(
	                        'tr',
	                        { className: 'inactive' },
	                        React.createElement(
	                            'td',
	                            { className: 'team-away' },
	                            React.createElement('div', { className: 'game-icon icon-font-before icon-soccer-ball-before icon-soccerball' })
	                        ),
	                        React.createElement(
	                            'td',
	                            { className: 'penalty' },
	                            React.createElement(
	                                'span',
	                                null,
	                                'Pen'
	                            ),
	                            ' 4'
	                        ),
	                        React.createElement(
	                            'td',
	                            { className: 'team-home' },
	                            React.createElement('div', { className: 'game-icon icon-font-before icon-soccer-ball-before icon-soccerball' })
	                        )
	                    ),
	                    React.createElement(
	                        'tr',
	                        { className: 'inactive' },
	                        React.createElement(
	                            'td',
	                            { className: 'team-away' },
	                            React.createElement('div', { className: 'game-icon icon-font-before icon-soccer-ball-before icon-soccerball' })
	                        ),
	                        React.createElement(
	                            'td',
	                            { className: 'penalty' },
	                            React.createElement(
	                                'span',
	                                null,
	                                'Pen'
	                            ),
	                            ' 5'
	                        ),
	                        React.createElement(
	                            'td',
	                            { className: 'team-home' },
	                            React.createElement('div', { className: 'game-icon icon-font-before icon-soccer-ball-before icon-soccerball' })
	                        )
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = Penalties;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	
	var Conversation = React.createClass({
	
	    displayName: 'Conversation',
	
	    componentDidMount: function componentDidMount() {
	        try {
	            espn.plugins.getFacebook(function () {
	                if (!$(".fb-comments iframe").length) {
	                    FB.XFBML.parse(document.body);
	                }
	            });
	        } catch (e) {}
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        return false;
	    },
	
	    render: function render() {
	        var query = this.props.query;
	        var sPageUrl = 'http://www.espn.co.uk/rugby/conversation?gameId=' + (query.gameId || query.eventId) + '&league=' + (query.leagueId || query.league);
	
	        return React.createElement(
	            'article',
	            { className: 'sub-module conversation' },
	            React.createElement(
	                'header',
	                { className: 'bordered' },
	                React.createElement(
	                    'h1',
	                    null,
	                    'Conversation'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'content' },
	                React.createElement(
	                    'p',
	                    { className: 'condition' },
	                    'Use a ',
	                    React.createElement(
	                        'a',
	                        { href: 'https://www.facebook.com/r.php', rel: 'nofollow' },
	                        'Facebook account'
	                    ),
	                    ' to add a comment, subject to Facebook\'s ',
	                    React.createElement(
	                        'a',
	                        { href: 'https://www.facebook.com/policies/', rel: 'nofollow' },
	                        'Terms of Service'
	                    ),
	                    ' and ',
	                    React.createElement(
	                        'a',
	                        { href: 'https://www.facebook.com/about/privacy/', rel: 'nofollow' },
	                        'Privacy Policy'
	                    ),
	                    '. Your Facebook name, photo & other personal information you make public on Facebook will appear with your comment, and may be used on ESPN\'s media platforms. ',
	                    React.createElement(
	                        'a',
	                        { href: 'http://espn.go.com/community/story/_/id/8756098/espn-facebook-comments-faq' },
	                        'Learn more'
	                    ),
	                    '.'
	                ),
	                React.createElement('div', { className: 'fb-comments', 'data-numposts': '5', 'data-href': sPageUrl, 'data-width': '100%' })
	            )
	        );
	    }
	});
	
	module.exports = Conversation;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	var classNames = __webpack_require__(361);
	
	var Commentary = React.createClass({
	
	    displayName: 'Commentary',
	
	    componentDidMount: function componentDidMount() {
	        try {
	            /* Check for instance of tweet code in tweet and action if exists. */
	            var myJs = document.getElementById('twitter-wjs');
	            if (myJs == null) {
	                var js = document.createElement("script");
	                js.id = "twitter-wjs";
	                js.src = "//platform.twitter.com/widgets.js";
	                document.getElementsByTagName('head')[0].appendChild(js);
	            } else {
	                twttr.widgets.load();
	            }
	        } catch (e) {}
	    },
	
	    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	        try {
	            // Load Twitter widgets upon component update
	            twttr.widgets.load();
	        } catch (e) {}
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            tab: 'all', // all, key
	            displayQuantity: 3
	        };
	    },
	
	    swapTab: function swapTab() {
	        if (this.state.tab === 'all') {
	            this.setState({ tab: 'key' });
	        } else {
	            this.setState({ tab: 'all' });
	        }
	    },
	
	    viewAll: function viewAll(oEvent) {
	        if (this.props.changeView) {
	            this.props.changeView('commentary');
	        }
	    },
	
	    render: function render() {
	
	        var aGameEvents = this.props.gameEvents || [];
	        var sMatchState = this.props.matchState || [];
	        var bShowAll = this.props.showAll === true ? true : false;
	        var aEventsList = [];
	        var rHeader = null;
	        var rSubHeader = null;
	        var rFooter = null;
	        var sViewName = 'Match Commentary';
	
	        /* fix the ammount to show unless its all */
	        var iEventLen = aGameEvents.length;
	
	        if (iEventLen === 0) {
	            return null;
	        }
	
	        if (!bShowAll && iEventLen > this.state.displayQuantity) {
	            iEventLen = this.state.displayQuantity;
	        }
	
	        for (var i = 0; i < iEventLen; i++) {
	            var oEvent = aGameEvents[i];
	            var props = {
	                key: i,
	                type: oEvent.type,
	                text: oEvent.text,
	                time: oEvent.time,
	                homeScore: oEvent.homeScore,
	                awayScore: oEvent.awayScore
	            };
	
	            if (this.state.tab !== 'all') {
	                if (oEvent.type == 1 || oEvent.type == 2 || oEvent.type == 3 || oEvent.type == 4 || oEvent.type == 5 || oEvent.type == 6 || oEvent.type == 14) {
	                    aEventsList.push(React.createElement(CommentaryRow, props));
	                }
	            } else {
	                aEventsList.push(React.createElement(CommentaryRow, props));
	            }
	        }
	
	        if (bShowAll) {
	            var aAllBtnClass = ['button-filter-alt', 'lg', 'fixed'];
	            var aKeyBtnClass = ['button-filter-alt', 'lg', 'fixed'];
	            if (this.state.tab === 'all') {
	                aAllBtnClass.push('active');
	            } else {
	                aKeyBtnClass.push('active');
	                sViewName = 'Key Events';
	            }
	
	            var sAllClasses = classNames(aAllBtnClass);
	            var sKeyClasses = classNames(aKeyBtnClass);
	
	            rHeader = React.createElement(
	                'header',
	                null,
	                React.createElement(
	                    'div',
	                    { className: 'button-group', 'data-behavior': 'tabs' },
	                    React.createElement(
	                        'a',
	                        { className: sAllClasses, onClick: this.swapTab },
	                        'All Commentary'
	                    ),
	                    React.createElement(
	                        'a',
	                        { className: sKeyClasses, onClick: this.swapTab },
	                        'Key Events'
	                    )
	                )
	            );
	
	            rSubHeader = React.createElement(
	                'header',
	                null,
	                React.createElement(
	                    'h1',
	                    null,
	                    sViewName
	                )
	            );
	        } else {
	            rHeader = React.createElement(
	                'header',
	                null,
	                React.createElement(
	                    'h1',
	                    { style: { textAlign: 'left' } },
	                    sViewName
	                )
	            );
	
	            rFooter = React.createElement(
	                'footer',
	                null,
	                React.createElement(
	                    'a',
	                    { onClick: this.viewAll },
	                    'Full Commentary'
	                )
	            );
	        }
	
	        return React.createElement(
	            'article',
	            { className: 'sub-module match-commentary', 'data-behavior': 'accordion' },
	            rHeader,
	            React.createElement(
	                'div',
	                { className: 'content' },
	                React.createElement(
	                    'div',
	                    { id: 'tab1' },
	                    rSubHeader,
	                    React.createElement(
	                        'table',
	                        null,
	                        React.createElement(
	                            'tbody',
	                            null,
	                            aEventsList
	                        )
	                    )
	                )
	            ),
	            rFooter
	        );
	    }
	
	});
	
	var CommentaryRow = React.createClass({
	
	    displayName: 'CommentaryRow',
	
	    render: function render() {
	
	        var iEventId = this.props.id;
	        var iEventType = this.props.type;
	        var sEventText = this.props.text;
	        var sEventTime = this.props.time;
	        var sHomeScore = this.props.homeScore || 0;
	        var sAwayScore = this.props.awayScore || 0;
	        var bShowScore = false;
	        var aIconClass = ['game-icon', 'icon-font-before'];
	
	        if (iEventType == 7 || iEventType == 8) {
	            aIconClass.push('icon-soccer-substitution-before');
	        } else if (iEventType == 9 || iEventType == 10 || iEventType == 11 || iEventType == 12 || iEventType == 13) {
	            bShowScore = true;
	            aIconClass.push('icon-soccer-foul-solid-before');
	        } else if (iEventType == 5) {
	            //yellow
	            aIconClass.push('icon-soccer-card02-solid-before');
	            aIconClass.push('icon-yellowcard');
	        } else if (iEventType == 3) {
	            //penalty kick
	            bShowScore = true;
	            aIconClass.push('icon-rugby-penalty-solid-before');
	        } else if (iEventType == 4) {
	            //drop goal
	            bShowScore = true;
	            aIconClass.push('icon-rugby-drop-goal-solid-before');
	        } else if (iEventType == 6) {
	            aIconClass.push('icon-soccer-card02-solid-before');
	            aIconClass.push('icon-redcard');
	        } else if (iEventType == 1 || iEventType == 14) {
	            //try or penalty try
	            bShowScore = true;
	            aIconClass.push('icon-rugby-score-outline-before');
	        } else if (iEventType == 2) {
	            //conversion
	            bShowScore = true;
	            aIconClass.push('icon-rugby-conversion-solid-before');
	        }
	
	        //icon-rugby-solid
	        //icon-rugby-drop-goal-outline
	        //icon-rugby-drop-goal-solid
	        //icon-rugby-score-outline
	        //icon-rugby-score-solid
	        //icon-rugby-penalty-outline
	        //icon-rugby-penalty-solid
	        //icon-rugby-conversion-outline
	        //icon-rugby-conversion-solid
	
	        /* TODO hide symbol on mobile so tweets fit properly */
	
	        // if event text then use div elements to HTML encode. (hackyyy...)
	        if (sEventText.indexOf('\&lt\;') >= 0) {
	            var div = document.createElement('div');
	            div.innerHTML = sEventText;
	            sEventText = div.firstChild.nodeValue;
	        }
	
	        if (bShowScore) {
	            sEventText = '<span class="current-score">' + sHomeScore + '-' + sAwayScore + '</span> ' + sEventText;
	        }
	
	        var sIconClass = classNames(aIconClass);
	        return React.createElement(
	            'tr',
	            { key: iEventId },
	            React.createElement(
	                'td',
	                { className: 'time-stamp' },
	                sEventTime
	            ),
	            React.createElement('td', { className: sIconClass }),
	            React.createElement('td', { className: 'game-details', dangerouslySetInnerHTML: { __html: sEventText } })
	        );
	    }
	});
	
	module.exports = Commentary;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(11);
	
	var Timeline = React.createClass({
	    displayName: "Timeline",
	
	    render: function render() {
	        return React.createElement(
	            "div",
	            { className: "soccerTimeline desktop sub-module", "data-behavior": "soccer_timeline" },
	            React.createElement(
	                "div",
	                { className: "teamWrap away" },
	                React.createElement(
	                    "a",
	                    { href: "#" },
	                    React.createElement(
	                        "div",
	                        { className: "logo" },
	                        React.createElement("img", { alt: "", src: "http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/360.png&w=22&site=espnfc", width: "22" })
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "teamName" },
	                        "MUN"
	                    )
	                )
	            ),
	            React.createElement(
	                "div",
	                { className: "gameProgressWrap", style: { width: '100%' } },
	                React.createElement(
	                    "div",
	                    { className: "gameProgress" },
	                    React.createElement(
	                        "ul",
	                        { className: "timeline" },
	                        React.createElement(
	                            "li",
	                            { style: { left: '10px' } },
	                            React.createElement(
	                                "div",
	                                { className: "number" },
	                                "6"
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "wrapper" },
	                                React.createElement(
	                                    "div",
	                                    { className: "desktop iconNotification away" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "iconWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltipWrap" },
	                                            React.createElement(
	                                                "div",
	                                                { className: "tooltip" },
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip bottom" },
	                                                    "Player Tooltip"
	                                                )
	                                            )
	                                        ),
	                                        React.createElement("span", { className: "icon-font-before icon-soccer-card02-solid-before icon-redcard" })
	                                    )
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            { className: "double-notification", style: { left: '50px' } },
	                            React.createElement(
	                                "div",
	                                { className: "number" },
	                                "16"
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "wrapper" },
	                                React.createElement(
	                                    "div",
	                                    { className: "desktop iconNotification away" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "iconWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltipWrap" },
	                                            React.createElement(
	                                                "div",
	                                                { className: "tooltip" },
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip bottom" },
	                                                    "Player Tooltip"
	                                                )
	                                            )
	                                        ),
	                                        React.createElement("span", { className: "icon-font-before icon-soccer-card02-solid-before icon-yellowcard" })
	                                    )
	                                ),
	                                React.createElement(
	                                    "div",
	                                    { className: "desktop iconNotification home" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "iconWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltipWrap" },
	                                            React.createElement(
	                                                "div",
	                                                { className: "tooltip" },
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip top" },
	                                                    "Player Tooltip"
	                                                )
	                                            )
	                                        ),
	                                        React.createElement("span", { className: "icon-font-before icon-soccer-card02-solid-before icon-redcard" })
	                                    )
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            { style: { left: '115px' } },
	                            React.createElement(
	                                "div",
	                                { className: "number" },
	                                "22"
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "wrapper" },
	                                React.createElement(
	                                    "div",
	                                    { className: "desktop iconNotification away group" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "iconWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltipWrap" },
	                                            React.createElement(
	                                                "div",
	                                                { className: "tooltip" },
	                                                React.createElement(
	                                                    "div",
	                                                    { className: "groupTooltipWrap bottom" },
	                                                    React.createElement(
	                                                        "div",
	                                                        { className: "playerWrap" },
	                                                        "Player Tooltip"
	                                                    ),
	                                                    React.createElement(
	                                                        "div",
	                                                        { className: "playerWrap" },
	                                                        React.createElement(
	                                                            "div",
	                                                            { className: "playerOn" },
	                                                            React.createElement(
	                                                                "span",
	                                                                null,
	                                                                "On:"
	                                                            ),
	                                                            " P. Name"
	                                                        ),
	                                                        React.createElement(
	                                                            "div",
	                                                            { className: "playerOff" },
	                                                            "|",
	                                                            React.createElement(
	                                                                "span",
	                                                                null,
	                                                                " Off:"
	                                                            ),
	                                                            " P. Name"
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        React.createElement("span", { className: "icon-font-before icon-soccer-substitution-before icon-substitution" }),
	                                        React.createElement("span", { className: "icon-font-before icon-soccer-card02-solid-before icon-yellowcard" })
	                                    )
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            { style: { left: '180px' } },
	                            React.createElement(
	                                "div",
	                                { className: "number" },
	                                "28"
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "wrapper" },
	                                React.createElement(
	                                    "div",
	                                    { className: "desktop iconNotification home" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "iconWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltipWrap" },
	                                            React.createElement(
	                                                "div",
	                                                { className: "tooltip" },
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip top" },
	                                                    "Player Tooltip"
	                                                )
	                                            )
	                                        ),
	                                        React.createElement("span", { className: "icon-font-before icon-soccer-ball-before icon-soccerball" })
	                                    )
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            { style: { left: '198px' } },
	                            React.createElement(
	                                "div",
	                                { className: "number" },
	                                "29"
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "wrapper" },
	                                React.createElement(
	                                    "div",
	                                    { className: "desktop iconNotification home" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "iconWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltipWrap" },
	                                            React.createElement(
	                                                "div",
	                                                { className: "tooltip" },
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip top" },
	                                                    React.createElement(
	                                                        "div",
	                                                        { className: "playerOn" },
	                                                        React.createElement(
	                                                            "span",
	                                                            null,
	                                                            "On:"
	                                                        ),
	                                                        " P. Name"
	                                                    ),
	                                                    React.createElement(
	                                                        "div",
	                                                        { className: "playerOff" },
	                                                        "|",
	                                                        React.createElement(
	                                                            "span",
	                                                            null,
	                                                            " Off:"
	                                                        ),
	                                                        " P. Name"
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        React.createElement("span", { className: "icon-font-before icon-soccer-substitution-before icon-substitution" })
	                                    )
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            { style: { left: '250px' } },
	                            React.createElement(
	                                "div",
	                                { className: "number" },
	                                "39"
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "wrapper" },
	                                React.createElement(
	                                    "div",
	                                    { className: "desktop iconNotification away" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "iconWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltipWrap" },
	                                            React.createElement(
	                                                "div",
	                                                { className: "tooltip" },
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip bottom" },
	                                                    React.createElement(
	                                                        "div",
	                                                        { className: "playerOn" },
	                                                        React.createElement(
	                                                            "span",
	                                                            null,
	                                                            "On:"
	                                                        ),
	                                                        " P. Name"
	                                                    ),
	                                                    React.createElement(
	                                                        "div",
	                                                        { className: "playerOff" },
	                                                        "|",
	                                                        React.createElement(
	                                                            "span",
	                                                            null,
	                                                            " Off:"
	                                                        ),
	                                                        " P. Name"
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        React.createElement("span", { className: "icon-font-before icon-soccer-substitution-before icon-substitution" })
	                                    )
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            { style: { left: '285px' } },
	                            React.createElement(
	                                "div",
	                                { className: "number" },
	                                "41"
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "wrapper" },
	                                React.createElement(
	                                    "div",
	                                    { className: "desktop iconNotification home" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "iconWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltipWrap" },
	                                            React.createElement(
	                                                "div",
	                                                { className: "tooltip" },
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip top" },
	                                                    "Player Tooltip"
	                                                )
	                                            )
	                                        ),
	                                        React.createElement("span", { className: "icon-font-before icon-soccer-card02-solid-before icon-yellowcard" })
	                                    )
	                                )
	                            ),
	                            "style=",
	                            { left: '435px' },
	                            ">",
	                            React.createElement(
	                                "div",
	                                { className: "number" },
	                                "63"
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "wrapper" },
	                                React.createElement(
	                                    "div",
	                                    { className: "desktop iconNotification away" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "iconWrap active" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltipWrap" },
	                                            React.createElement(
	                                                "div",
	                                                { className: "tooltip" },
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip bottom" },
	                                                    "Player Tooltip"
	                                                )
	                                            )
	                                        ),
	                                        React.createElement("span", { className: "icon-font-before icon-soccer-card02-solid-before icon-yellowcard" })
	                                    )
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            { style: { right: 0 } },
	                            React.createElement(
	                                "span",
	                                { className: "gameTimeIndicator stroke" },
	                                "FT"
	                            )
	                        )
	                    )
	                )
	            ),
	            React.createElement(
	                "div",
	                { className: "teamWrap home" },
	                React.createElement(
	                    "a",
	                    { href: "#" },
	                    React.createElement(
	                        "div",
	                        { className: "logo" },
	                        React.createElement("img", { alt: "", src: "http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/382.png&w=22&site=espnfc", width: "22" })
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "teamName" },
	                        "Manchester City"
	                    )
	                )
	            ),
	            React.createElement(
	                "div",
	                { className: "timeline-controls" },
	                React.createElement(
	                    "a",
	                    { className: "icon-font-before icon-listen02-solid-before timeline-link", href: "#" },
	                    "Listen"
	                ),
	                React.createElement(
	                    "a",
	                    { className: "icon-font-before icon-watch-outline-before timeline-link", href: "#" },
	                    "Watch"
	                ),
	                React.createElement(
	                    "ul",
	                    { className: "arrows" },
	                    React.createElement(
	                        "li",
	                        null,
	                        React.createElement("span", { id: "horizDragLeft", className: "arrow icon-font-before icon-caret-left-solid-before" })
	                    ),
	                    React.createElement(
	                        "li",
	                        null,
	                        React.createElement("span", { id: "horizDragRight", className: "arrow icon-font-before icon-caret-right-solid-before" })
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = Timeline;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(11);
	
	var Timeline = React.createClass({
	    displayName: "Timeline",
	
	    render: function render() {
	        return React.createElement(
	            "div",
	            { className: "soccerTimeline mobile sub-module", "data-behavior": "soccer_timeline" },
	            React.createElement(
	                "div",
	                { className: "teamWrap away" },
	                React.createElement(
	                    "a",
	                    { href: "#" },
	                    React.createElement(
	                        "div",
	                        { className: "logo" },
	                        React.createElement("img", { alt: "", src: "http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/360.png&w=22&site=espnfc", width: "22" })
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "teamName" },
	                        "MUN"
	                    )
	                )
	            ),
	            React.createElement(
	                "div",
	                { className: "gameProgressWrap" },
	                React.createElement(
	                    "div",
	                    { className: "gameProgress" },
	                    React.createElement(
	                        "ul",
	                        { className: "timeline" },
	                        React.createElement(
	                            "li",
	                            null,
	                            React.createElement(
	                                "span",
	                                { className: "gameTimeIndicator solid" },
	                                "KO"
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            { className: "items-1" },
	                            React.createElement(
	                                "div",
	                                { className: "number" },
	                                "6"
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "mobile iconNotification home" },
	                                React.createElement(
	                                    "div",
	                                    { className: "iconWrap active" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "tooltipWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltip" },
	                                            React.createElement(
	                                                "span",
	                                                { className: "playerTooltip left" },
	                                                "Player Tooltip"
	                                            )
	                                        )
	                                    ),
	                                    React.createElement("span", { className: "icon-font-before icon-soccer-ball-before icon-soccerball" })
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            { className: "items-2" },
	                            React.createElement(
	                                "div",
	                                { className: "number" },
	                                "22"
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "mobile iconNotification away group" },
	                                React.createElement(
	                                    "div",
	                                    { className: "iconWrap active" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "tooltipWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltip" },
	                                            React.createElement(
	                                                "div",
	                                                { className: "groupSingleTooltipWrap" },
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip right" },
	                                                    "Player Tooltip"
	                                                ),
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip right" },
	                                                    "Player Tooltip"
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    React.createElement("span", { className: "icon-font-before icon-soccer-card02-solid-before icon-yellowcard" }),
	                                    React.createElement("span", { className: "icon-font-before icon-soccer-card02-solid-before icon-redcard" })
	                                )
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "mobile iconNotification home group" },
	                                React.createElement(
	                                    "div",
	                                    { className: "iconWrap active" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "tooltipWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltip" },
	                                            React.createElement(
	                                                "div",
	                                                { className: "groupSingleTooltipWrap" },
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip left" },
	                                                    "Player Tooltip"
	                                                ),
	                                                React.createElement(
	                                                    "span",
	                                                    { className: "playerTooltip left" },
	                                                    "Player Tooltip"
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    React.createElement("span", { className: "icon-font-before icon-soccer-card02-solid-before icon-yellowcard" }),
	                                    React.createElement("span", { className: "icon-font-before icon-soccer-card02-solid-before icon-redcard" })
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            null,
	                            React.createElement(
	                                "span",
	                                { className: "gameTimeIndicator halfTime solid" },
	                                "HT"
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            { className: "items-1" },
	                            React.createElement(
	                                "div",
	                                { className: "number" },
	                                "58"
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "mobile iconNotification away" },
	                                React.createElement(
	                                    "div",
	                                    { className: "iconWrap active" },
	                                    React.createElement(
	                                        "div",
	                                        { className: "tooltipWrap" },
	                                        React.createElement(
	                                            "div",
	                                            { className: "tooltip" },
	                                            React.createElement(
	                                                "span",
	                                                { className: "playerTooltip right" },
	                                                "Player Tooltip"
	                                            )
	                                        )
	                                    ),
	                                    React.createElement("span", { className: "icon-font-before icon-soccer-ball-before icon-soccerball" })
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            "li",
	                            { style: { top: '100px' } },
	                            React.createElement(
	                                "span",
	                                { className: "gameTimeIndicator halfTime stroke" },
	                                "FT"
	                            )
	                        )
	                    )
	                )
	            ),
	            React.createElement(
	                "div",
	                { className: "teamWrap home" },
	                React.createElement(
	                    "a",
	                    { href: "#" },
	                    React.createElement(
	                        "div",
	                        { className: "teamName" },
	                        "MCY"
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "logo" },
	                        React.createElement("img", { alt: "", src: "http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/382.png&w=22&site=espnfc", width: "22" })
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = Timeline;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	
	var TeamStats = React.createClass({
	
	    displayName: 'TeamStats',
	
	    render: function render() {
	
	        var aStats = this.props.stats || [];
	
	        if (aStats.length != 4) {
	            return null;
	        }
	
	        var rBoxStats = [];
	        var iStatLen = aStats.length;
	        for (var i = 0; i < iStatLen; i++) {
	            rBoxStats.push(React.createElement(TeamStatsBox, { key: i, data: aStats[i] }));
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'sub-module team-statistics rugby' },
	            React.createElement(
	                'header',
	                { className: 'bordered' },
	                React.createElement(
	                    'h1',
	                    null,
	                    'Team Stats'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'content' },
	                React.createElement(
	                    'ul',
	                    { className: 'stat-box-container' },
	                    rBoxStats
	                )
	            )
	        );
	
	        //<footer>
	        //	<a href="#">Full Team Stats</a>
	        //</footer>
	    }
	});
	
	var TeamStatsBox = React.createClass({
	
	    displayName: 'TeamStatsBox',
	
	    render: function render() {
	
	        var oStats = this.props.data || [];
	        var iMaxValue = 0;
	
	        if (iMaxValue < oStats.home.value) {
	            iMaxValue = oStats.home.value;
	        }
	
	        if (iMaxValue < oStats.away.value) {
	            iMaxValue = oStats.away.value;
	        }
	
	        var iHomePerc = parseInt(oStats.home.value / iMaxValue * 100);
	        var iAwayPerc = parseInt(oStats.away.value / iMaxValue * 100);
	
	        return React.createElement(
	            'li',
	            { className: 'stat-box' },
	            React.createElement(
	                'h3',
	                null,
	                oStats.name
	            ),
	            React.createElement(
	                'ul',
	                { className: 'compareLineGraph' },
	                React.createElement(
	                    'li',
	                    null,
	                    React.createElement(
	                        'span',
	                        { className: 'chartLabel' },
	                        oStats.home.abbreviation
	                    ),
	                    React.createElement(
	                        'span',
	                        { style: { backgroundColor: '#f2f2f2' }, className: 'bar-total' },
	                        React.createElement('span', { style: { backgroundColor: oStats.home.color, width: iHomePerc + '%' }, className: 'bar-percentage' })
	                    ),
	                    React.createElement(
	                        'span',
	                        { className: 'chartValue' },
	                        oStats.home.displayValue
	                    )
	                ),
	                React.createElement(
	                    'li',
	                    null,
	                    React.createElement(
	                        'span',
	                        { style: { backgroundColor: '#f2f2f2' }, className: 'bar-total' },
	                        React.createElement('span', { style: { backgroundColor: oStats.away.color, width: iAwayPerc + '%' }, className: 'bar-percentage' })
	                    ),
	                    React.createElement(
	                        'span',
	                        { className: 'chartValue' },
	                        oStats.away.displayValue
	                    ),
	                    React.createElement(
	                        'span',
	                        { className: 'chartLabel clear' },
	                        oStats.away.abbreviation
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = TeamStats;

/***/ },
/* 396 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    componentDidMount: function componentDidMount() {
	        if (!this._adsInited) {
	            this.initAds();
	            this._adsInited = true;
	        }
	    },
	    _adsInited: false,
	    initAds: function initAds() {
	        try {
	            var ads = jQuery(this.state.adWrapSelector || '#reactContainer .react-ad');
	            for (var i = 0, len = ads.length; i < len; i++) {
	                admgr.initSlot(ads[i], espn.ads.config);
	            }
	        } catch (e) {}
	    }
	};

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	
	/* Components */
	var LeagueTable = __webpack_require__(381);
	var NewsList = __webpack_require__(385);
	var MatchStats = __webpack_require__(386);
	var AttackingStats = __webpack_require__(398);
	var MatchEvents = __webpack_require__(399);
	var KickPassRun = __webpack_require__(400);
	var SetPieces = __webpack_require__(401);
	var Defending = __webpack_require__(402);
	var Discipline = __webpack_require__(404);
	var Advert = __webpack_require__(371);
	var AdReloaderMixin = __webpack_require__(396);
	var utils = __webpack_require__(346);
	
	var TabMatchStats = React.createClass({
	
	    displayName: 'TabMatchStats',
	
	    mixins: [AdReloaderMixin],
	
	    getInitialState: function getInitialState() {
	        return {
	            adWrapSelector: '#reactContainer .react-ad'
	        };
	    },
	
	    getPensConded: function getPensConded(oStore) {
	        var penaltiesConceded = oStore.getStat('penaltiesConceded');
	        return {
	            home: {
	                total: penaltiesConceded[0] || 0
	            },
	            away: {
	                total: penaltiesConceded[1] || 0
	            }
	        };
	    },
	
	    getLineOutsWon: function getLineOutsWon(oStore) {
	        var totalLineouts = oStore.getStat('totalLineouts');
	        var lineoutsWon = oStore.getStat('lineoutsWon');
	
	        totalLineouts = totalLineouts.length ? totalLineouts : [0, 0];
	        lineoutsWon = lineoutsWon.length ? lineoutsWon : [0, 0];
	
	        return {
	            home: {
	                total: totalLineouts[0],
	                won: lineoutsWon[0],
	                percent: lineoutsWon[0] / totalLineouts[0] * 100
	            },
	            away: {
	                total: totalLineouts[1],
	                won: lineoutsWon[1],
	                percent: lineoutsWon[1] / totalLineouts[1] * 100
	            }
	        };
	    },
	
	    getScrumsWon: function getScrumsWon(oStore) {
	        var scrumsTotal = oStore.getStat('scrumsTotal');
	        var scrumsLost = oStore.getStat('scrumsLost');
	
	        scrumsTotal = scrumsTotal.length ? scrumsTotal : [0, 0];
	        scrumsLost = scrumsLost.length ? scrumsLost : [0, 0];
	
	        return {
	            home: {
	                total: scrumsTotal[0],
	                won: scrumsTotal[0] - scrumsLost[0],
	                percent: (scrumsTotal[0] - scrumsLost[0]) / scrumsTotal[0] * 100
	            },
	            away: {
	                total: scrumsTotal[1],
	                won: scrumsTotal[1] - scrumsLost[1],
	                percent: (scrumsTotal[1] - scrumsLost[1]) / scrumsTotal[1] * 100
	            }
	        };
	    },
	
	    getTackles: function getTackles(oStore) {
	        var tackles = oStore.getStat('tackles') || [0, 0];
	        var missedTackles = oStore.getStat('missedTackles') || [0, 0];
	
	        tackles = tackles.length ? tackles : [0, 0];
	        missedTackles = missedTackles.length ? missedTackles : [0, 0];
	
	        return {
	            home: {
	                label: tackles[0] - missedTackles[0] + "/" + tackles[0],
	                percent: Math.round((tackles[0] - missedTackles[0]) / tackles[0] * 100)
	            },
	            away: {
	                label: tackles[1] - missedTackles[1] + "/" + tackles[1],
	                percent: Math.round((tackles[1] - missedTackles[1]) / tackles[1] * 100)
	            }
	        };
	    },
	
	    getRunMetresPercent: function getRunMetresPercent(metres) {
	        if (!metres.length || metres[0] === 0 && metres[1] === 0) {
	            return [0, 0];
	        } else if (metres[0] == metres[1]) {
	            return [50, 50];
	        }
	
	        var teamAPercent = Math.round(metres[0] / (metres[0] + metres[1]) * 100);
	        var teamBPercent = Math.abs(100 - teamAPercent);
	
	        return [teamAPercent, teamBPercent];
	    },
	
	    getAttackingStats: function getAttackingStats(oStore) {
	        // Get the Match stats for building a table
	        var attackingStats = oStore.getMatchStats({
	            pcPossessionFirst: {
	                order: 1,
	                name: 'Possession 1H/2H'
	            },
	            pcTerritoryFirst: {
	                order: 2,
	                name: 'Territory 1H/2H'
	            },
	            cleanBreaks: {
	                order: 3,
	                name: 'Line Breaks'
	            },
	            defendersBeaten: {
	                order: 4,
	                name: 'Defenders Beaten'
	            },
	            offload: {
	                order: 5,
	                name: 'Offloads'
	            },
	            rucksWon: {
	                order: 6,
	                name: 'Rucks Won'
	            },
	            maulsWon: {
	                order: 7,
	                name: 'Mauls Won'
	            },
	            turnoversConceded: {
	                order: 8,
	                name: 'Turnovers Conceded'
	            }
	        });
	
	        // Get individual 1st/2nd half stats and override the values
	        var pcPossessionSecond = oStore.getStat('pcPossessionSecond');
	        var pcPossessionFirst = oStore.getStat('pcPossessionFirst');
	
	        var pcTerritorySecond = oStore.getStat('pcTerritorySecond');
	        var pcTerritoryFirst = oStore.getStat('pcTerritoryFirst');
	
	        var rucksTotal = oStore.getStat('rucksTotal');
	        var rucksWon = oStore.getStat('rucksWon');
	
	        var maulsTotal = oStore.getStat('maulsTotal');
	        var maulsWon = oStore.getStat('maulsWon');
	
	        if (attackingStats[1]) {
	            attackingStats[1].home = Math.round(pcPossessionFirst[0] * 100) + '% / ' + Math.round(pcPossessionSecond[0] * 100) + '%';
	            attackingStats[1].away = Math.round(pcPossessionFirst[1] * 100) + '% / ' + Math.round(pcPossessionSecond[1] * 100) + '%';
	        }
	
	        if (attackingStats[2]) {
	            attackingStats[2].home = Math.round(pcTerritoryFirst[0] * 100) + '% / ' + Math.round(pcTerritorySecond[0] * 100) + '%';
	            attackingStats[2].away = Math.round(pcTerritoryFirst[1] * 100) + '% / ' + Math.round(pcTerritorySecond[1] * 100) + '%';
	        }
	
	        if (attackingStats[6]) {
	            attackingStats[6].home = rucksWon[0] + ' / ' + rucksTotal[0] + ' (' + Math.round((rucksWon[0] / rucksTotal[0] || 0) * 100) + '%)';
	            attackingStats[6].away = rucksWon[1] + ' / ' + rucksTotal[1] + ' (' + Math.round((rucksWon[1] / rucksTotal[1] || 0) * 100) + '%)';
	        }
	
	        if (attackingStats[7]) {
	            attackingStats[7].home = maulsWon[0] + ' / ' + maulsTotal[0] + ' (' + Math.round((maulsWon[0] / maulsTotal[0] || 0) * 100) + '%)';
	            attackingStats[7].away = maulsWon[1] + ' / ' + maulsTotal[1] + ' (' + Math.round((maulsWon[1] / maulsTotal[1] || 0) * 100) + '%)';
	        }
	
	        return attackingStats;
	    },
	
	    getEventStats: function getEventStats(oStore) {
	        var eventStats = oStore.getMatchStats({
	            tries: {
	                order: 1,
	                name: 'Tries'
	            },
	            conversionGoals: {
	                order: 2,
	                name: 'Conversions'
	            },
	            penaltyGoals: {
	                order: 3,
	                name: 'Penalties'
	            },
	            kickPercentSuccess: {
	                order: 4,
	                name: 'Kick at Goal Success'
	            }
	        });
	        var kickPercentSuccess = oStore.getStat('kickPercentSuccess');
	        if (eventStats[4]) {
	            eventStats[4].home = kickPercentSuccess[0] * 100 + '%';
	            eventStats[4].away = kickPercentSuccess[1] * 100 + '%';
	        }
	        return eventStats;
	    },
	
	    render: function render() {
	
	        var sState = this.props.matchState || 'pre'; //pre,post,live
	        var oStore = this.props.store;
	        var rSummary = null;
	
	        /* Load in the data from the Store */
	        var aLeagueTable = oStore.getLeagueTable();
	        var leagueName = oStore.getLeagueName();
	        var newsList = oStore.getNewsList();
	        var possession = oStore.getStatPercent('possession');
	        var territory = oStore.getStatPercent('territory');
	        var gameStripProps = oStore.getGameStripDetails();
	        var homeLogo = utils.getImageUrl(gameStripProps.teams.home.logo);
	        var awayLogo = utils.getImageUrl(gameStripProps.teams.away.logo);
	        var home = oStore.getHomeTeam() || {};
	        var away = oStore.getAwayTeam() || {};
	        var colors = [home.color, away.color];
	        var homeTeam = { logo: homeLogo, abbreviation: gameStripProps.teams.home.abbreviation };
	        var awayTeam = { logo: awayLogo, abbreviation: gameStripProps.teams.away.abbreviation };
	        var metres = oStore.getStat('metres');
	        var metresPercent = this.getRunMetresPercent(metres);
	        var tackles = this.getTackles(oStore);
	        var pensConceded = this.getPensConded(oStore);
	        var scrumsWon = this.getScrumsWon(oStore);
	        var lineoutsWon = this.getLineOutsWon(oStore);
	        var attackingStats = this.getAttackingStats(oStore);
	        var eventStats = this.getEventStats(oStore);
	        var kickPassRunStats = oStore.getMatchStats({
	            kicksFromHand: {
	                order: 1,
	                name: 'Kicks From Hand'
	            },
	            passes: {
	                order: 2,
	                name: 'Passes'
	            },
	            runs: {
	                order: 3,
	                name: 'Runs'
	            }
	        });
	        var disciplineStats = oStore.getMatchStats({
	            redCards: {
	                order: 1,
	                name: 'Red Cards'
	            },
	            yellowCards: {
	                order: 2,
	                name: 'Yellow Cards'
	            },
	            totalFreeKicksConceded: {
	                order: 3,
	                name: 'Free Kicks Conceded'
	            }
	        });
	
	        return React.createElement(
	            'div',
	            { className: 'layout-bc' },
	            React.createElement(
	                'section',
	                { className: 'col-b' },
	                React.createElement(
	                    'div',
	                    { className: 'sub-module-split', 'data-behavior': 'equal_height' },
	                    React.createElement(
	                        'div',
	                        { className: 'module-split' },
	                        React.createElement(MatchEvents, { eventStats: eventStats, home: homeTeam, away: awayTeam })
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'module-split' },
	                        React.createElement(KickPassRun, { colors: colors, values: metres, percent: metresPercent, kickPassRunStats: kickPassRunStats, home: homeTeam, away: awayTeam })
	                    )
	                ),
	                React.createElement(AttackingStats, { colors: colors, attackingStats: attackingStats, possession: possession, territory: territory, home: homeTeam, away: awayTeam }),
	                React.createElement(
	                    'div',
	                    { className: 'sub-module-split', 'data-behavior': 'equal_height' },
	                    React.createElement(
	                        'div',
	                        { className: 'module-split' },
	                        React.createElement(SetPieces, { colors: colors, lineOutsPieces: lineoutsWon, scrumPieces: scrumsWon, home: homeTeam, away: awayTeam })
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'module-split' },
	                        React.createElement(Defending, { colors: colors, tackles: tackles, home: homeTeam, away: awayTeam })
	                    )
	                ),
	                React.createElement(Discipline, { colors: colors, pensConceded: pensConceded, disciplineStats: disciplineStats, home: homeTeam, away: awayTeam })
	            ),
	            React.createElement(
	                'section',
	                { className: 'col-c' },
	                React.createElement(
	                    'article',
	                    { className: 'ad-300' },
	                    React.createElement(
	                        'div',
	                        { className: 'ad-center' },
	                        React.createElement(Advert, { id: 'game.rhs.mpu', className: 'ad-slot-incontent ad-wrapper', slotType: 'incontent' })
	                    )
	                ),
	                React.createElement(LeagueTable, { tableHref: this.props.tableHref, date: '', name: leagueName, table: aLeagueTable }),
	                React.createElement(NewsList, { header: newsList.header, link: newsList.link, articles: newsList.articles })
	            )
	        );
	    }
	});
	
	module.exports = TabMatchStats;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var VisPercent = __webpack_require__(388);
	var StatsTable = __webpack_require__(389);
	var TeamCompareHeader = __webpack_require__(387);
	
	var AttackingStats = React.createClass({
	    displayName: 'AttackingStats',
	
	    render: function render() {
	
	        var stats = this.props.stats;
	        var possession = this.props.possession;
	        var territory = this.props.territory;
	
	        return React.createElement(
	            'article',
	            { className: 'sub-module', style: { overflow: 'auto' } },
	            React.createElement(
	                'header',
	                { className: 'bordered' },
	                React.createElement(
	                    'h1',
	                    null,
	                    'Attacking'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'stacked-rl' },
	                React.createElement(
	                    'div',
	                    { className: 'col-a content' },
	                    React.createElement(TeamCompareHeader, { heading: 'Possession', home: this.props.home, away: this.props.away }),
	                    React.createElement(VisPercent, { colors: this.props.colors, percent: possession }),
	                    React.createElement(TeamCompareHeader, { noTeams: 'no-teams', heading: 'Territory', home: this.props.home, away: this.props.away }),
	                    React.createElement(VisPercent, { colors: this.props.colors, percent: territory, large: true })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'col-b content' },
	                    React.createElement(TeamCompareHeader, { bordered: 'bordered', home: this.props.home, away: this.props.away }),
	                    React.createElement(StatsTable, { stats: this.props.attackingStats })
	                )
	            )
	        );
	    }
	});
	
	module.exports = AttackingStats;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var StatsTable = __webpack_require__(389);
	var TeamCompareHeader = __webpack_require__(387);
	
	var MatchEvents = React.createClass({
	    displayName: 'MatchEvents',
	
	    render: function render() {
	        return React.createElement(
	            'article',
	            { className: 'sub-module equal-height countChartList height-reset', style: { "height": "238px" } },
	            React.createElement(
	                'header',
	                { className: 'bordered' },
	                React.createElement(
	                    'h1',
	                    null,
	                    'Match Events'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'content' },
	                React.createElement(TeamCompareHeader, { bordered: 'bordered', home: this.props.home, away: this.props.away }),
	                React.createElement(StatsTable, { stats: this.props.eventStats })
	            )
	        );
	    }
	});
	
	module.exports = MatchEvents;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var StatsTable = __webpack_require__(389);
	var TeamCompareHeader = __webpack_require__(387);
	var VisPercent = __webpack_require__(388);
	
	var KickPassRun = React.createClass({
	    displayName: 'KickPassRun',
	
	    render: function render() {
	        return React.createElement(
	            'article',
	            { className: 'sub-module equal-height height-reset', style: { "height": "238px" } },
	            React.createElement(
	                'header',
	                { className: 'bordered' },
	                React.createElement(
	                    'h1',
	                    null,
	                    'Kick/Pass/Run'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'content' },
	                React.createElement(TeamCompareHeader, { heading: 'Metres Run', home: this.props.home, away: this.props.away }),
	                React.createElement(VisPercent, { colors: this.props.colors, values: this.props.values, percent: this.props.percent }),
	                React.createElement(StatsTable, { stats: this.props.kickPassRunStats })
	            )
	        );
	    }
	});
	
	module.exports = KickPassRun;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var StatsTable = __webpack_require__(389);
	var TeamCompareHeader = __webpack_require__(387);
	
	var Circles = React.createClass({
	    displayName: 'Circles',
	
	    getCircles: function getCircles(count, home, filled) {
	        var circles = [];
	        var colors = this.props.colors || ["#ffc300", "#d31346"];
	        var circleStyle = filled ? { "backgroundColor": home ? colors[0] : colors[1] } : null;
	
	        for (var i = 0; i < count; i++) {
	            circles.push(React.createElement('span', { key: (filled ? 'cw.' : 'cl.') + i, className: 'circle countIcon filled', style: circleStyle }));
	        }
	
	        return circles;
	    },
	    render: function render() {
	
	        var filledCircles = this.getCircles(this.props.won, this.props.home, true);
	        var emptyCircles = this.getCircles(this.props.lost, this.props.home, false);
	
	        return React.createElement(
	            'div',
	            { className: 'countIcons' },
	            filledCircles.concat(emptyCircles)
	        );
	    }
	});
	
	var SetPieces = React.createClass({
	    displayName: 'SetPieces',
	
	    getCircles: function getCircles(count, home, filled) {
	        var circles = [];
	        var circleStyle = filled ? { "backgroundColor": home ? "#ffc300" : "#d31346" } : null;
	
	        for (var i = 0; i < count; i++) {
	            circles.push(React.createElement('span', { key: (filled ? 'cw.' : 'cl.') + i, className: 'circle countIcon filled', style: circleStyle }));
	        }
	
	        return circles;
	    },
	    render: function render() {
	
	        var scrumPieces = this.props.scrumPieces;
	        var lineOutsPieces = this.props.lineOutsPieces;
	        var homeScrumPercent = Math.round(scrumPieces.home.percent);
	        var awayScrumPercent = Math.round(scrumPieces.away.percent);
	        var homeLineOutsPercent = Math.round(lineOutsPieces.home.percent);
	        var awayhomeLineOutsPercent = Math.round(lineOutsPieces.away.percent);
	
	        homeScrumPercent = isNaN(homeScrumPercent) ? 0 : homeScrumPercent;
	        awayScrumPercent = isNaN(awayScrumPercent) ? 0 : awayScrumPercent;
	
	        homeLineOutsPercent = isNaN(homeLineOutsPercent) ? 0 : homeLineOutsPercent;
	        awayhomeLineOutsPercent = isNaN(awayhomeLineOutsPercent) ? 0 : awayhomeLineOutsPercent;
	
	        return React.createElement(
	            'article',
	            { className: 'sub-module equal-height countChartList height-reset', style: { "height": "317px" } },
	            React.createElement(
	                'header',
	                { className: 'bordered' },
	                React.createElement(
	                    'h1',
	                    null,
	                    'Set Pieces'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'content' },
	                React.createElement(TeamCompareHeader, { heading: 'Own scrums won', home: this.props.home, away: this.props.away }),
	                React.createElement(
	                    'div',
	                    { className: 'countChart' },
	                    React.createElement(
	                        'div',
	                        { className: 'home' },
	                        React.createElement(
	                            'div',
	                            { className: 'countLabel' },
	                            scrumPieces.home.won + "/" + scrumPieces.home.total,
	                            ' ',
	                            React.createElement(
	                                'span',
	                                { className: 'percentage' },
	                                "(" + homeScrumPercent + "%)"
	                            )
	                        ),
	                        React.createElement(Circles, { colors: this.props.colors, won: scrumPieces.home.won, lost: scrumPieces.home.total - scrumPieces.home.won, home: true })
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'away' },
	                        React.createElement(
	                            'div',
	                            { className: 'countLabel' },
	                            React.createElement(
	                                'span',
	                                { className: 'percentage' },
	                                "(" + awayScrumPercent + "%)"
	                            ),
	                            " " + scrumPieces.away.won + "/" + scrumPieces.away.total
	                        ),
	                        React.createElement(Circles, { colors: this.props.colors, won: scrumPieces.away.won, lost: scrumPieces.away.total - scrumPieces.away.won, home: false })
	                    )
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'content' },
	                React.createElement(
	                    'div',
	                    { className: 'teamCompareHeaderWrap ' },
	                    React.createElement(
	                        'div',
	                        { className: 'teamCompareHeader' },
	                        React.createElement('div', { className: 'team team1' }),
	                        React.createElement(
	                            'div',
	                            { className: 'header' },
	                            'Own Lineouts Won'
	                        ),
	                        React.createElement('div', { className: 'team team2' })
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'countChart' },
	                    React.createElement(
	                        'div',
	                        { className: 'home' },
	                        React.createElement(
	                            'div',
	                            { className: 'countLabel' },
	                            lineOutsPieces.home.won + "/" + lineOutsPieces.home.total,
	                            ' ',
	                            React.createElement(
	                                'span',
	                                { className: 'percentage' },
	                                "(" + homeLineOutsPercent + "%)"
	                            )
	                        ),
	                        React.createElement(Circles, { colors: this.props.colors, won: lineOutsPieces.home.won, lost: lineOutsPieces.home.total - lineOutsPieces.home.won, home: true })
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'away' },
	                        React.createElement(
	                            'div',
	                            { className: 'countLabel' },
	                            React.createElement(
	                                'span',
	                                { className: 'percentage' },
	                                "(" + awayhomeLineOutsPercent + "%)"
	                            ),
	                            " " + lineOutsPieces.away.won + "/" + lineOutsPieces.away.total
	                        ),
	                        React.createElement(Circles, { colors: this.props.colors, won: lineOutsPieces.away.won, lost: lineOutsPieces.away.total - lineOutsPieces.away.won, home: false })
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = SetPieces;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var TeamCompareHeader = __webpack_require__(387);
	var VisCircle = __webpack_require__(403);
	
	var Defending = React.createClass({
	    displayName: 'Defending',
	
	    render: function render() {
	        var home = this.props.tackles.home || {};
	        var away = this.props.tackles.away || {};
	        var homePercent = home.percent ? [home.percent, 100 - home.percent] : [0, 0];
	        var awayPercent = away.percent ? [away.percent, 100 - away.percent] : [0, 0];
	
	        return React.createElement(
	            'article',
	            { className: 'sub-module equal-height height-reset', style: { "height": " 317px" } },
	            React.createElement(
	                'header',
	                { className: 'bordered' },
	                React.createElement(
	                    'h1',
	                    null,
	                    'Defending'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'content clear' },
	                React.createElement(TeamCompareHeader, { heading: 'Tackles made/total', home: this.props.home, away: this.props.away }),
	                React.createElement(
	                    'div',
	                    { className: 'chart-container parallel' },
	                    React.createElement(VisCircle, { colors: this.props.colors, percent: homePercent, home: true, value: home.label })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'chart-container parallel' },
	                    React.createElement(VisCircle, { colors: this.props.colors, percent: awayPercent, value: away.label })
	                )
	            )
	        );
	    }
	});
	
	module.exports = Defending;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	var VisCircle = React.createClass({
	    displayName: 'VisCircle',
	
	    render: function render() {
	        var percent = this.props.percent && this.props.percent.length ? this.props.percent : [0, 0];
	        var rotationAngle = Math.round(360 * (percent[0] / 100));
	        var colors = this.props.colors || ['#ffc300', "#d31346"];
	        var teamColor = this.props.home ? colors[0] : colors[1];
	        var backgroundColor = "#e5e5e5";
	
	        return React.createElement(
	            'div',
	            { className: 'data-chart', 'data-chart': this.props.home ? "1" : "2", style: { "width": "135px", "height": "135px" } },
	            React.createElement(
	                'div',
	                { className: 'outer-circle' },
	                React.createElement(
	                    'div',
	                    { 'data-wedge-id': 'a', className: 'wedge-container', style: { transform: "rotate(0deg)", WebkitTransform: "rotate(0deg)", clip: "auto", msTransform: "rotate(0deg)" } },
	                    React.createElement('div', { className: 'wedge', style: { msTransform: "rotate(" + rotationAngle + "deg)", WebkitTransform: "rotate(" + rotationAngle + "deg)", transform: "rotate(" + rotationAngle + "deg)", clip: "rect(0px 73px 150px 0px)", backgroundColor: rotationAngle < 180 ? backgroundColor : teamColor } }),
	                    React.createElement('div', { className: 'wedge-extension', style: { opacity: 1, msTransform: "rotate(180deg)", WebkitTransform: "rotate(180deg)", transform: "rotate(180deg)", clip: "rect(0px 75px 150px 0px)", backgroundColor: rotationAngle < 180 ? backgroundColor : teamColor } })
	                ),
	                React.createElement(
	                    'div',
	                    { 'data-wedge-id': 'b', className: 'wedge-container', style: { msTransform: "rotate(" + rotationAngle + "deg)", WebkitTransform: "rotate(" + rotationAngle + "deg)", transform: "rotate(" + rotationAngle + "deg)", clip: "rect(0px 150px 150px 75px)" } },
	                    React.createElement('div', { className: 'wedge', style: { msTransform: "rotate(" + (360 - rotationAngle) + "deg)", WebkitTransform: "rotate(" + (360 - rotationAngle) + "deg)", transform: "rotate(" + (360 - rotationAngle) + "deg)", clip: "rect(0px 73px 150px 0px)", backgroundColor: rotationAngle < 180 ? teamColor : backgroundColor } }),
	                    React.createElement('div', { className: 'wedge-extension', style: { "opacity": "0" } })
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'inner-circle' },
	                React.createElement('span', { className: 'team-logo' }),
	                React.createElement('span', { className: 'team-name' }),
	                React.createElement(
	                    'span',
	                    { className: 'home-team' },
	                    this.props.value
	                ),
	                React.createElement(
	                    'span',
	                    { className: 'away-team' },
	                    percent[0] + '%'
	                )
	            )
	        );
	    }
	});
	
	module.exports = VisCircle;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var StatsTable = __webpack_require__(389);
	var TeamCompareHeader = __webpack_require__(387);
	
	var Whistles = React.createClass({
	    displayName: 'Whistles',
	
	    render: function render() {
	        var whistles = [];
	        var colors = this.props.colors || ["#ffc300", "#d31346"];
	        var count = Number(this.props.count) || 0;
	        var team = this.props.team;
	
	        for (var i = 0; i < count; i++) {
	            whistles.push(React.createElement(
	                'span',
	                { key: team + i, className: 'icon-font countIcon', style: { "color": team === 'home' ? colors[0] : colors[1] } },
	                '<'
	            ));
	        }
	        return React.createElement(
	            'div',
	            { className: 'countIcons' },
	            whistles
	        );
	    }
	});
	
	var Discipline = React.createClass({
	    displayName: 'Discipline',
	
	    render: function render() {
	
	        return React.createElement(
	            'article',
	            { className: 'sub-module', style: { overflow: 'auto' } },
	            React.createElement(
	                'header',
	                { className: 'bordered' },
	                React.createElement(
	                    'h1',
	                    null,
	                    'Discipline'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'stacked-rl' },
	                React.createElement(
	                    'div',
	                    { className: 'col-a content' },
	                    React.createElement(TeamCompareHeader, { heading: 'Penalties conceded', home: this.props.home, away: this.props.away }),
	                    React.createElement(
	                        'div',
	                        { className: 'countChart' },
	                        React.createElement(
	                            'div',
	                            { className: 'home' },
	                            React.createElement(
	                                'div',
	                                { className: 'countLabel' },
	                                this.props.pensConceded.home.total
	                            ),
	                            React.createElement(Whistles, { colors: this.props.colors, team: 'home', count: this.props.pensConceded.home.total })
	                        ),
	                        React.createElement(
	                            'div',
	                            { className: 'away' },
	                            React.createElement(
	                                'div',
	                                { className: 'countLabel' },
	                                this.props.pensConceded.away.total
	                            ),
	                            React.createElement(Whistles, { colors: this.props.colors, team: 'away', count: this.props.pensConceded.away.total })
	                        )
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'col-b content' },
	                    React.createElement(TeamCompareHeader, { bordered: 'bordered', home: this.props.home, away: this.props.away }),
	                    React.createElement(StatsTable, { stats: this.props.disciplineStats })
	                )
	            )
	        );
	    }
	});
	
	module.exports = Discipline;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	
	/* Components */
	var LeagueTable = __webpack_require__(381);
	var NewsList = __webpack_require__(385);
	var Advert = __webpack_require__(371);
	var AdReloaderMixin = __webpack_require__(396);
	var utils = __webpack_require__(346);
	var PlayerStatsTable = __webpack_require__(406);
	
	var Glossary = React.createClass({
	    displayName: 'Glossary',
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'sub-module' },
	            React.createElement(
	                'div',
	                { className: 'glossary comp' },
	                React.createElement(
	                    'h3',
	                    null,
	                    'Glossary'
	                ),
	                React.createElement(
	                    'ul',
	                    null,
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>T: </span>Tries' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>A: </span>Try Assists' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>Pts: </span>Points Scored' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>K: </span>Kicks' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>P: </span>Passes' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>R: </span>Runs' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>MR: </span>Metres Run with ball' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>CB: </span>Clean Breaks' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>DB: </span>Defenders Beaten' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>OL: </span>Offloads' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>LS: </span>Lineouts Stolen' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>TC: </span>Turnovers Conceded' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>Tack: </span>Tackles' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>MT: </span>Missed Tackles' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>LO: </span>Lineouts won on throw' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>Pen: </span>Penalties conceded' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>Y: </span>Yellow Cards' } }),
	                    React.createElement('li', { dangerouslySetInnerHTML: { __html: '<span>R: </span>Red Cards' } })
	                )
	            )
	        );
	    }
	});
	
	var TabPlayerStats = React.createClass({
	
	    displayName: 'TabPlayerStats',
	
	    mixins: [AdReloaderMixin],
	
	    getInitialState: function getInitialState() {
	        return {
	            adWrapSelector: '#reactContainer .react-ad'
	        };
	    },
	
	    render: function render() {
	
	        var sState = this.props.matchState || 'pre'; //pre,post,live
	        var oStore = this.props.store;
	        var rSummary = null;
	
	        /* Load in the data from the Store */
	        var aLeagueTable = oStore.getLeagueTable();
	        var leagueName = oStore.getLeagueName();
	        var newsList = oStore.getNewsList();
	        var gameStripProps = oStore.getGameStripDetails();
	        var homeLogo = utils.getImageUrl(gameStripProps.teams.home.logo);
	        var awayLogo = utils.getImageUrl(gameStripProps.teams.away.logo);
	        var homeTeam = { logo: homeLogo, abbreviation: gameStripProps.teams.home.abbreviation };
	        var awayTeam = { logo: awayLogo, abbreviation: gameStripProps.teams.away.abbreviation };
	
	        return React.createElement(
	            'div',
	            { className: 'layout-bc' },
	            React.createElement(
	                'section',
	                { className: 'col-b' },
	                React.createElement(PlayerStatsTable, { home: homeTeam, away: awayTeam, store: oStore }),
	                React.createElement(Glossary, null)
	            ),
	            React.createElement(
	                'section',
	                { className: 'col-c' },
	                React.createElement(
	                    'article',
	                    { className: 'ad-300' },
	                    React.createElement(
	                        'div',
	                        { className: 'ad-center' },
	                        React.createElement(Advert, { id: 'game.rhs.mpu', className: 'ad-slot-incontent ad-wrapper', slotType: 'incontent' })
	                    )
	                ),
	                React.createElement(LeagueTable, { tableHref: this.props.tableHref, date: '', name: leagueName, table: aLeagueTable }),
	                React.createElement(NewsList, { header: newsList.header, link: newsList.link, articles: newsList.articles })
	            )
	        );
	    }
	});
	
	module.exports = TabPlayerStats;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	
	var PlayerTable = React.createClass({
	    displayName: "PlayerTable",
	
	    render: function render() {
	
	        var rows = [];
	        var stats = this.props.stats || [];
	        var statList = this.props.statList || {};
	        var headings = [React.createElement(
	            "th",
	            { key: "logo" },
	            React.createElement("img", { src: this.props.team.logo, className: "imageLoaded" }),
	            " ",
	            this.props.team.abbreviation
	        )];
	
	        for (var stat in statList) {
	            headings.push(React.createElement(
	                "th",
	                { key: stat },
	                React.createElement(
	                    "span",
	                    { style: { fontFamily: 'inherit', fontWeight: 'inherit' }, className: "tooltip icon-font icon-soccer-goal-solid", "data-tooltip": statList[stat].text },
	                    statList[stat].label
	                )
	            ));
	        }
	
	        stats.map(function (stat, i) {
	            stat = stat || { stats: [] };
	            var lastRow = i == stats.length - 1;
	            var noBottomBorder = { borderBottom: 'none' };
	            var nameParts = (stat.name || '').split(' ');
	            var firstChar = (stat.name || '')[0];
	            var lastName = nameParts[nameParts.length - 1] || '';
	            var playerStats = [React.createElement(
	                "td",
	                { style: lastRow ? noBottomBorder : null, key: stat.id },
	                React.createElement(
	                    "a",
	                    { target: "_blank", href: stat.href },
	                    firstChar + ' ' + lastName
	                ),
	                React.createElement(
	                    "span",
	                    { style: { fontFamily: 'inherit', paddingLeft: '3px' }, className: "tooltip icon-font icon-soccer-goal-solid", "data-tooltip": stat.positionName },
	                    stat.position
	                )
	            )];
	
	            stat.stats.map(function (s, j) {
	                var props = {
	                    key: j
	                };
	                if (lastRow) {
	                    props.style = noBottomBorder;
	                }
	                playerStats.push(React.createElement(
	                    "td",
	                    props,
	                    s.displayValue
	                ));
	            });
	
	            if (!stat.stats.length) {
	                playerStats.push(React.createElement("td", { key: i, colSpan: headings.length - 1 }));
	            }
	
	            rows.push(React.createElement(
	                "tr",
	                { key: 'r.' + stat.id },
	                playerStats
	            ));
	        });
	
	        return React.createElement(
	            "table",
	            { className: "mod-data" },
	            React.createElement(
	                "thead",
	                null,
	                React.createElement(
	                    "tr",
	                    { className: "header" },
	                    headings
	                )
	            ),
	            React.createElement(
	                "tbody",
	                null,
	                rows
	            )
	        );
	    }
	});
	
	var Tables = React.createClass({
	    displayName: "Tables",
	
	    render: function render() {
	        return React.createElement(
	            "div",
	            null,
	            React.createElement(
	                "div",
	                { className: "table-wrap" + (this.props.selectedTeam === 'home' ? ' active' : '') },
	                React.createElement(PlayerTable, { selectedTeam: this.props.selectedTeam === 'home' ? true : false, team: this.props.home, statList: this.props.statList, stats: this.props.homeStats })
	            ),
	            React.createElement(
	                "div",
	                { className: "table-wrap" + (this.props.selectedTeam === 'away' ? ' active' : '') },
	                React.createElement(PlayerTable, { selectedTeam: this.props.selectedTeam === 'away' ? true : false, team: this.props.away, statList: this.props.statList, stats: this.props.awayStats })
	            )
	        );
	    }
	});
	
	var PlayerStatsTable = React.createClass({
	    displayName: "PlayerStatsTable",
	
	    clickHandler: function clickHandler(selected, event) {
	        this.setState({
	            selected: selected
	        });
	    },
	    switchTeam: function switchTeam(team, event) {
	        this.setState({
	            selectedTeam: team
	        });
	    },
	    getInitialState: function getInitialState() {
	        return {
	            selected: 'Scoring',
	            selectedTeam: 'home'
	        };
	    },
	    filters: {
	        Scoring: {
	            tries: {
	                label: 'T',
	                text: 'Tries',
	                index: 0
	            },
	            tryAssist: {
	                label: 'A',
	                text: 'Try Assists',
	                index: 1
	            },
	            points: {
	                label: 'Pts',
	                text: 'Points Scored',
	                index: 2
	            }
	        },
	        Attacking: {
	            kicks: {
	                label: 'K',
	                text: 'Kicks',
	                index: 0
	            },
	            passes: {
	                label: 'P',
	                text: 'Passes',
	                index: 1
	            },
	            runs: {
	                label: 'R',
	                text: 'Runs',
	                index: 2
	            },
	            metres: {
	                label: 'MR',
	                text: 'Metres Run with ball',
	                index: 3
	            },
	            cleanBreaks: {
	                label: 'CB',
	                text: 'Clean Breaks',
	                index: 4
	            },
	            defendersBeaten: {
	                label: 'DB',
	                text: 'Defenders Beaten',
	                index: 5
	            },
	            offload: {
	                label: 'OL',
	                text: 'Offloads',
	                index: 6
	            },
	            lineoutWonSteal: {
	                label: 'LS',
	                text: 'Lineouts Stolen',
	                index: 7
	            }
	        },
	        Defending: {
	            turnoversConceded: {
	                label: 'TC',
	                text: 'Turnovers Conceded',
	                index: 0
	            },
	            tackles: {
	                label: 'Tack',
	                text: 'Tackles',
	                index: 1
	            },
	            missedTackles: {
	                label: 'MT',
	                text: 'Missed Tackles',
	                index: 2
	            },
	            lineoutsWon: {
	                label: 'LO',
	                text: 'Lineouts won on throw',
	                index: 3
	            }
	        },
	        Discipline: {
	            penaltiesConceded: {
	                label: 'Pen',
	                text: 'Penalties conceded',
	                index: 0
	            },
	            yellowCards: {
	                label: 'Y',
	                text: 'Yellow Cards',
	                index: 1
	            },
	            redCards: {
	                label: 'R',
	                text: 'Red Cards',
	                index: 2
	            }
	        }
	    },
	    render: function render() {
	
	        var tabs = ['Scoring', 'Attacking', 'Defending', 'Discipline'];
	        var selected = this.state.selected;
	        var tabsList = [];
	        var store = this.props.store;
	        var homeStats = store.getPlayerStats(this.filters[selected], true);
	        var awayStats = store.getPlayerStats(this.filters[selected], false);
	
	        tabs.map((function (tab, i) {
	            var props = {
	                style: { padding: '0 7px' }
	            };
	            if (selected === tab) {
	                props.className = "active";
	            }
	            tabsList.push(React.createElement(
	                "li",
	                _extends({ onClick: this.clickHandler.bind(this, tab), key: tab }, props),
	                React.createElement(
	                    "span",
	                    null,
	                    tab
	                )
	            ));
	        }).bind(this));
	
	        return React.createElement(
	            "div",
	            { className: "sub-module tabbedTable", style: { 'overflowX': 'auto' } },
	            React.createElement(
	                "header",
	                { className: "hidden-sm hidden-md hidden-lg" },
	                React.createElement(
	                    "div",
	                    { className: "filter form-group button-group" },
	                    React.createElement(
	                        "button",
	                        { onClick: this.switchTeam.bind(this, 'home'), className: "button-filter-alt lg fixed" + (this.state.selectedTeam === 'home' ? ' active' : '') },
	                        React.createElement(
	                            "span",
	                            { className: "team-name" },
	                            this.props.home.abbreviation
	                        )
	                    ),
	                    React.createElement(
	                        "button",
	                        { onClick: this.switchTeam.bind(this, 'away'), className: "button-filter-alt lg fixed" + (this.state.selectedTeam === 'away' ? ' active' : '') },
	                        React.createElement(
	                            "span",
	                            { className: "team-name" },
	                            this.props.away.abbreviation
	                        )
	                    )
	                )
	            ),
	            React.createElement(
	                "div",
	                { className: "tab-container alt" },
	                React.createElement(
	                    "ul",
	                    { className: "tabs alt", "data-behavior": "tabs_transform" },
	                    tabsList
	                )
	            ),
	            React.createElement(
	                "div",
	                { className: "tab-content" },
	                React.createElement(
	                    "div",
	                    { className: "tab-pane" + this.state.selected == 'Scoring' ? " active" : "" },
	                    React.createElement(Tables, { selectedTeam: this.state.selectedTeam, home: this.props.home, away: this.props.away, statList: this.filters[selected], homeStats: homeStats, awayStats: awayStats, selected: this.state.selected })
	                )
	            )
	        );
	    }
	});
	
	module.exports = PlayerStatsTable;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	
	/* Components */
	var LeagueTable = __webpack_require__(381);
	var NewsList = __webpack_require__(385);
	var utils = __webpack_require__(346);
	
	var TabTable = React.createClass({
	
	    displayName: 'TabTable',
	
	    render: function render() {
	
	        var sState = this.props.matchState || 'pre'; //pre,post,live
	        var oStore = this.props.store;
	        var rSummary = null;
	
	        /* Load in the data from the Store */
	        var aLeagueTable = oStore.getLeagueTable();
	        var leagueName = oStore.getLeagueName();
	        var newsList = oStore.getNewsList();
	        var gameStripProps = oStore.getGameStripDetails();
	        var homeLogo = utils.getImageUrl(gameStripProps.teams.home.logo);
	        var awayLogo = utils.getImageUrl(gameStripProps.teams.away.logo);
	        var homeTeam = { logo: homeLogo, abbreviation: gameStripProps.teams.home.abbreviation };
	        var awayTeam = { logo: awayLogo, abbreviation: gameStripProps.teams.away.abbreviation };
	
	        if (sState === 'post') {
	            rSummary = React.createElement(
	                'div',
	                { className: 'layout-bc' },
	                React.createElement(
	                    'section',
	                    { className: 'col-b' },
	                    React.createElement(
	                        'article',
	                        { className: 'sub-module' },
	                        React.createElement(
	                            'header',
	                            { className: 'bordered' },
	                            React.createElement(
	                                'h1',
	                                null,
	                                'Table'
	                            )
	                        )
	                    )
	                ),
	                React.createElement(
	                    'section',
	                    { className: 'col-c' },
	                    React.createElement(LeagueTable, { date: '', name: leagueName, table: aLeagueTable }),
	                    React.createElement(NewsList, { header: newsList.header, link: newsList.link, articles: newsList.articles })
	                )
	            );
	        } else if (sState === 'live') {
	
	            rSummary = React.createElement(
	                'div',
	                { className: 'layout-cbc' },
	                React.createElement('section', { className: 'col-one' }),
	                React.createElement('section', { className: 'col-two' }),
	                React.createElement(
	                    'section',
	                    { id: 'now-feed', className: 'col-three' },
	                    React.createElement(LeagueTable, { date: '', name: leagueName, table: aLeagueTable }),
	                    React.createElement(NewsList, { header: newsList.header, link: newsList.link, articles: newsList.articles })
	                )
	            );
	        } else {
	
	            rSummary = React.createElement(
	                'div',
	                { className: 'layout-bc' },
	                React.createElement('section', { className: 'col-b' }),
	                React.createElement(
	                    'section',
	                    { className: 'col-c' },
	                    React.createElement(LeagueTable, { date: '', name: leagueName, table: aLeagueTable }),
	                    React.createElement(NewsList, { header: newsList.header, link: newsList.link, articles: newsList.articles })
	                )
	            );
	        }
	
	        return rSummary;
	    }
	});
	
	module.exports = TabTable;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	
	/* Components */
	var LeagueTable = __webpack_require__(381);
	var PlayerList = __webpack_require__(382);
	var NewsList = __webpack_require__(385);
	var Advert = __webpack_require__(371);
	var AdReloaderMixin = __webpack_require__(396);
	
	var TabLineup = React.createClass({
	
	    displayName: 'TabLineup',
	
	    mixins: [AdReloaderMixin],
	
	    getInitialState: function getInitialState() {
	        return {
	            adWrapSelector: '#reactContainer .react-ad'
	        };
	    },
	
	    render: function render() {
	
	        var sState = this.props.matchState || 'pre'; //pre,pos,live
	        var oStore = this.props.store;
	        var iWidth = this.props.width;
	
	        /* Load in the data from the Store */
	        var aHomeTeam = oStore.getPlayersList('home');
	        var aAwayTeam = oStore.getPlayersList('away');
	        var aLeagueTable = oStore.getLeagueTable();
	        var leagueName = oStore.getLeagueName();
	        var newsList = oStore.getNewsList();
	        var oHomeTeam = oStore.getHomeTeam();
	        var oAwayTeam = oStore.getAwayTeam();
	
	        return React.createElement(
	            'div',
	            { className: 'layout-bc' },
	            React.createElement(
	                'section',
	                { className: 'col-b' },
	                React.createElement(PlayerList, { homeTeam: aHomeTeam, awayTeam: aAwayTeam, split: true, matchState: sState, home: oHomeTeam, away: oAwayTeam, width: iWidth })
	            ),
	            React.createElement(
	                'section',
	                { className: 'col-c' },
	                React.createElement(
	                    'article',
	                    { className: 'ad-300' },
	                    React.createElement(
	                        'div',
	                        { className: 'ad-center' },
	                        React.createElement(Advert, { id: 'game.rhs.mpu', className: 'ad-slot-incontent ad-wrapper', slotType: 'incontent' })
	                    )
	                ),
	                React.createElement(LeagueTable, { tableHref: this.props.tableHref, name: leagueName, table: aLeagueTable }),
	                React.createElement(NewsList, { header: newsList.header, link: newsList.link, articles: newsList.articles })
	            )
	        );
	    }
	});
	
	module.exports = TabLineup;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	
	/* Components */
	var LeagueTable = __webpack_require__(381);
	var NewsList = __webpack_require__(385);
	var Conversation = __webpack_require__(391);
	var Advert = __webpack_require__(371);
	var AdReloaderMixin = __webpack_require__(396);
	
	var TabConversation = React.createClass({
	
	    displayName: 'TabConversation',
	
	    mixins: [AdReloaderMixin],
	
	    getInitialState: function getInitialState() {
	        return {
	            adWrapSelector: '#reactContainer .react-ad'
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        window.fbAsyncInit = function () {
	            FB.Canvas.setAutoResize();
	        };
	    },
	
	    render: function render() {
	
	        var oStore = this.props.store;
	
	        /* Load in the data from the Store */
	        var aLeagueTable = oStore.getLeagueTable();
	        var leagueName = oStore.getLeagueName();
	        var newsList = oStore.getNewsList();
	
	        return React.createElement(
	            'div',
	            { className: 'layout-bc' },
	            React.createElement(
	                'section',
	                { className: 'col-b' },
	                React.createElement(Conversation, { key: 'conversation', query: this.props.query })
	            ),
	            React.createElement(
	                'section',
	                { className: 'col-c' },
	                React.createElement(
	                    'article',
	                    { className: 'ad-300' },
	                    React.createElement(
	                        'div',
	                        { className: 'ad-center' },
	                        React.createElement(Advert, { id: 'game.rhs.mpu', className: 'ad-slot-incontent ad-wrapper', slotType: 'incontent' })
	                    )
	                ),
	                React.createElement(LeagueTable, { tableHref: this.props.tableHref, name: leagueName, table: aLeagueTable }),
	                React.createElement(NewsList, { header: newsList.header, link: newsList.link, articles: newsList.articles })
	            )
	        );
	    }
	});
	
	module.exports = TabConversation;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	
	/* Components */
	var LeagueTable = __webpack_require__(381);
	var NewsList = __webpack_require__(385);
	var Commentary = __webpack_require__(392);
	var PlayerList = __webpack_require__(382);
	var GameInformation = __webpack_require__(383);
	var Advert = __webpack_require__(371);
	var AdReloaderMixin = __webpack_require__(396);
	
	var TabCommentary = React.createClass({
	
	    displayName: 'TabCommentary',
	
	    mixins: [AdReloaderMixin],
	
	    getInitialState: function getInitialState() {
	        return {
	            adWrapSelector: '#reactContainer .react-ad'
	        };
	    },
	
	    render: function render() {
	
	        var oStore = this.props.store;
	        var sState = this.props.matchState || [];
	
	        /* Load in the data from the Store */
	        var aLeagueTable = oStore.getLeagueTable();
	        var newsList = oStore.getNewsList();
	        var aCommentary = oStore.getCommentary();
	        var aHomeTeam = oStore.getPlayersList('home');
	        var aAwayTeam = oStore.getPlayersList('away');
	        var oHomeTeam = oStore.getHomeTeam();
	        var oAwayTeam = oStore.getAwayTeam();
	        var oGameInfo = oStore.getGameInformation();
	        var sLeagueName = oStore.getLeagueName();
	
	        return React.createElement(
	            'div',
	            { className: 'layout-cbc' },
	            React.createElement(
	                'section',
	                { className: 'col-one' },
	                React.createElement(PlayerList, { homeTeam: aHomeTeam, awayTeam: aAwayTeam, matchState: sState, home: oHomeTeam, away: oAwayTeam }),
	                React.createElement(GameInformation, { capacity: oGameInfo.capacity, attendance: oGameInfo.attendance, datetime: oGameInfo.datetime, coverage: oGameInfo.coverage, venue: oGameInfo.venueName, address: oGameInfo.address })
	            ),
	            React.createElement(
	                'section',
	                { className: 'col-two' },
	                React.createElement(Commentary, { gameEvents: aCommentary, showAll: true })
	            ),
	            React.createElement(
	                'section',
	                { id: 'now-feed', className: 'col-three' },
	                React.createElement(
	                    'article',
	                    { className: 'ad-300' },
	                    React.createElement(
	                        'div',
	                        { className: 'ad-center' },
	                        React.createElement(Advert, { id: 'game.rhs.mpu', className: 'ad-slot-incontent ad-wrapper', slotType: 'incontent' })
	                    )
	                ),
	                React.createElement(LeagueTable, { tableHref: this.props.tableHref, date: '', name: sLeagueName, table: aLeagueTable }),
	                React.createElement(NewsList, { header: newsList.header, link: newsList.link, articles: newsList.articles })
	            )
	        );
	    }
	});
	
	module.exports = TabCommentary;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var React = __webpack_require__(11);
	var Advert = __webpack_require__(371);
	var AdReloaderMixin = __webpack_require__(396);
	var LeagueTable = __webpack_require__(381);
	var NewsList = __webpack_require__(385);
	var ReportPreview = __webpack_require__(412);
	
	var TabReport = React.createClass({
	
	    displayName: 'TabReport',
	
	    mixins: [AdReloaderMixin],
	
	    getInitialState: function getInitialState() {
	        return {
	            adWrapSelector: '#reactContainer .react-ad'
	        };
	    },
	
	    render: function render() {
	
	        var oStore = this.props.store;
	        var leagueName = oStore.getLeagueName();
	        var aLeagueTable = oStore.getLeagueTable();
	        var newsList = oStore.getNewsList();
	        var Article = oStore.getArticle();
	
	        var state = '';
	
	        return React.createElement(
	            'div',
	            { className: 'main-content react-content' },
	            React.createElement(
	                'div',
	                { id: 'gamepackage-wrap' },
	                React.createElement(
	                    'div',
	                    { id: 'gamepackage-content-wrap', className: 'layout-bc' },
	                    React.createElement(
	                        'section',
	                        { id: 'article-feed', className: 'col-b', 'data-behavior': 'author_overlay article_header_news_feed_item_meta social_tools comment' },
	                        React.createElement(ReportPreview, { article: Article })
	                    ),
	                    React.createElement(
	                        'section',
	                        { className: 'col-c' },
	                        React.createElement(
	                            'article',
	                            { className: 'ad-300', key: 'mpuadvert' },
	                            React.createElement(
	                                'div',
	                                { className: 'ad-center' },
	                                React.createElement(Advert, { id: 'game.rhs.mpu', className: 'ad-slot-incontent ad-wrapper', slotType: 'incontent' })
	                            )
	                        ),
	                        React.createElement(LeagueTable, { key: 'table', tableHref: this.props.tableHref, date: '', name: leagueName, table: aLeagueTable }),
	                        React.createElement(NewsList, { key: 'news', header: newsList.header, link: newsList.link, articles: newsList.articles })
	                    )
	                )
	            )
	        );
	    }
	
	});
	
	module.exports = TabReport;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	/*import ArticleHeadline          from './ArticleHeadline.jsx';
	import ArticleFooter            from './ArticleFooter.jsx';
	import ArticleSocialVertical    from './ArticleSocialVertical.jsx';
	import ArticleSocialHorizontal  from './ArticleSocialHorizontal.jsx';
	import ArticleAuthor            from './ArticleAuthor.jsx';*/
	
	var Article = (function (_React$Component) {
	    _inherits(Article, _React$Component);
	
	    function Article() {
	        _classCallCheck(this, Article);
	
	        _get(Object.getPrototypeOf(Article.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Article, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            try {
	                espn_ui.LoadBehavior(jQuery('#article-feed'));
	            } catch (e) {
	                console.log(e);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { id: 'article-feed', 'data-module': 'article' },
	                _react2['default'].createElement('div', { 'data-behavior': 'author_overlay article_header_news_feed_item_meta social_tools comment', dangerouslySetInnerHTML: { __html: this.props.article.html } })
	            );
	        }
	    }]);
	
	    return Article;
	})(_react2['default'].Component);
	
	exports['default'] = Article;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(11);
	
	var GameStatus = React.createClass({
	    displayName: "GameStatus",
	
	    render: function render() {
	
	        var broadcasts = this.props.broadcasts || {};
	        var broadcastLink;
	        var status = [React.createElement(
	            "span",
	            { key: "game.date", className: "game-date" },
	            this.props.status == 'pregame' ? this.props.date : ''
	        ), React.createElement(
	            "span",
	            { key: "game.time", className: "game-time" },
	            (this.props.time || '').toUpperCase()
	        ), React.createElement("span", { key: "game.play", className: "game-play" })];
	
	        if (broadcasts.url && broadcasts.name) {
	            broadcastLink = React.createElement(
	                "span",
	                { className: "network" },
	                React.createElement(
	                    "a",
	                    { href: broadcasts.url, className: broadcasts.external === true ? "external" : '' },
	                    broadcasts.name
	                )
	            );
	        }
	
	        if (this.props.anchor) {
	            status = React.createElement(
	                "a",
	                { "data-route": "false", href: this.props.anchor },
	                status
	            );
	        }
	
	        return React.createElement(
	            "div",
	            { className: "game-status" },
	            broadcastLink,
	            status
	        );
	    }
	});
	
	var GameHeader = React.createClass({
	    displayName: "GameHeader",
	
	    render: function render() {
	        var text = this.props.text;
	        var details = React.createElement(
	            "div",
	            { className: "game-details header" },
	            text
	        );
	
	        return text ? details : null;
	    }
	});
	
	var Competitor = React.createClass({
	    displayName: "Competitor",
	
	    render: function render() {
	
	        var team = this.props.team;
	        var isHomeTeam = this.props.team.home;
	        var scoreContainer = React.createElement(
	            "div",
	            { key: "score.container", className: "score-container" },
	            React.createElement(
	                "span",
	                { className: "score icon-font-" + (!isHomeTeam ? 'before' : 'after') },
	                this.props.score
	            )
	        );
	        var teamForm = '';
	        var teamInfoStyle = {};
	
	        if (team.form && this.props.status === 'pregame') {
	            teamForm = "Form: " + team.form;
	        } else {
	            teamInfoStyle = { top: '27px' };
	        }
	
	        var teamContainer = [React.createElement(
	            "a",
	            { href: team.url || '#', key: "team.container", className: "team-container" },
	            React.createElement(
	                "div",
	                { className: "logo" },
	                React.createElement(
	                    "picture",
	                    null,
	                    React.createElement("source", { srcSet: team.logo }),
	                    React.createElement("img", { "data-default-src": team.logo, className: "team-logo", src: team.logo })
	                )
	            ),
	            React.createElement(
	                "div",
	                { className: "team-info", style: teamInfoStyle },
	                React.createElement("span", { className: "rank" }),
	                React.createElement(
	                    "span",
	                    { className: "team-name" },
	                    React.createElement(
	                        "span",
	                        { className: "long-name" },
	                        team.name
	                    ),
	                    React.createElement(
	                        "span",
	                        { className: "short-name" },
	                        team.name
	                    ),
	                    React.createElement(
	                        "span",
	                        { className: "abbrev" },
	                        team.abbreviation
	                    )
	                ),
	                React.createElement(
	                    "span",
	                    { className: "record" },
	                    teamForm
	                )
	            )
	        )];
	
	        if (isHomeTeam) {
	            teamContainer.push(scoreContainer);
	        } else {
	            teamContainer.unshift(scoreContainer);
	        }
	
	        return React.createElement(
	            "div",
	            { className: "team " + (!isHomeTeam ? 'home' : 'away') },
	            React.createElement(
	                "div",
	                { className: "content" },
	                teamContainer
	            )
	        );
	    }
	});
	
	var GameStrip = React.createClass({
	    displayName: "GameStrip",
	
	    render: function render() {
	        var classMap = {
	            'pregame': 'pre',
	            'live': 'live',
	            'final': 'post'
	        };
	        var headerClasses = ['game-strip'];
	
	        headerClasses.push(this.props.sport || 'rugby', this.props.winnerClass || '', classMap[this.props.gameStatus] || '');
	
	        return React.createElement(
	            "header",
	            { style: this.props.styles, className: headerClasses.join(' ') },
	            React.createElement(GameHeader, { text: this.props.heading }),
	            React.createElement(
	                "div",
	                { className: "competitors sm-score" },
	                React.createElement(Competitor, { team: this.props.teams.home, score: this.props.scores.home, status: this.props.gameStatus }),
	                React.createElement(GameStatus, { broadcasts: this.props.broadcasts, status: this.props.gameStatus, date: this.props.formattedDate, time: this.props.time }),
	                React.createElement(Competitor, { team: this.props.teams.away, score: this.props.scores.away, status: this.props.gameStatus })
	            )
	        );
	    }
	});
	
	module.exports = GameStrip;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {// stores/ScoreStore.js
	'use strict';
	
	var createStore = __webpack_require__(415).createStore;
	var PersistentStateMixin = __webpack_require__(425);
	var GameStrip = __webpack_require__(426);
	var browser = __webpack_require__(252);
	var gameStripUtils = __webpack_require__(359);
	
	var ScoreStore = createStore({
	
	    storeName: 'ScoreStore',
	
	    mixins: [PersistentStateMixin],
	
	    initialize: function initialize() {
	        this.initDataStore();
	        this.status = "EMPTY";
	        this.lastUpdate = "";
	        this.article = {};
	    },
	
	    handlers: {
	        'RECEIVE_SCORES': function RECEIVE_SCORES(scores) {
	            try {
	                this.initDataStore();
	                this.setMatchState(scores);
	                this.setPlayerDisplayPosition(scores);
	                this.setPlayersList(scores);
	                this.setTeams(scores);
	                this.setCommentary(scores);
	                this.setGameStrip(scores);
	                this.setNewsList(scores);
	                this.setMatchStats(scores);
	                this.setStandings(scores);
	                this.setRecentForm(scores);
	                this.setHead2Head(scores);
	                this.setGameInformation(scores);
	                this.setRosters(scores);
	                this.setTableLink(scores);
	                this.setStatSummary(scores);
	                this.setHasStats(scores);
	                this.getDataIDs(scores);
	                this.setHasArticle(scores);
	            } catch (e) {
	                console.log(e);
	            }
	            this.status = "UPDATE_COMPLETE";
	            this.lastUpdate = new Date();
	            this.emitChange();
	        },
	        'RECEIVED_ARTICLE': function RECEIVED_ARTICLE(article) {
	            this.getArticleHTML(article);
	            this.emitChange();
	        },
	        'START_UPDATE': function START_UPDATE() {
	            this.status = "UPDATE_INITIATED";
	            this.emitChange();
	        }
	    },
	
	    getArticleHTML: function getArticleHTML(oData) {
	        if (typeof oData !== 'undefined' && typeof oData.content !== 'undefined' && oData.content !== null && typeof oData.content.html !== 'undefined') {
	            this.article = {};
	            this.article.html = oData.content.html;
	        }
	    },
	
	    getDataIDs: function getDataIDs(oData) {
	        this.data.eventId = 0;
	        this.data.leagueId = 0;
	        if (typeof oData !== 'undefined' && typeof oData.header !== 'undefined') {
	            if (typeof oData.header.id !== 'undefined' && oData.header.id !== null) {
	                this.data.eventId = oData.header.id;
	            }
	            if (typeof oData.header.league !== 'undefined' && oData.header.league !== null && typeof oData.header.league.midsizeName !== 'undefined' && oData.header.league.midsizeName !== null) {
	                this.data.leagueId = oData.header.league.midsizeName;
	            }
	        }
	    },
	
	    getArticle: function getArticle() {
	        return this.article || {};
	    },
	
	    setHasArticle: function setHasArticle(oData) {
	
	        // find if they have a report or a preview
	        if (typeof oData !== 'undefined' && typeof oData.article !== 'undefined' && oData.article !== null && typeof oData.article.type !== 'undefined') {
	
	            if (oData.article.type === "Report" || oData.article.type === "Recap") {
	                this.data.hasReport = true;
	            }
	            if (oData.article.type === "Preview") {
	                this.data.hasPreview = true;
	            }
	        }
	    },
	
	    hasReport: function hasReport() {
	        return this.data.hasReport;
	    },
	
	    hasPreview: function hasPreview() {
	        return this.data.hasPreview;
	    },
	
	    setHasStats: function setHasStats(oData) {
	        try {
	            var bHasStats = false;
	            if (typeof oData !== 'undefined' && typeof oData.boxscore !== 'undefined' && typeof oData.boxscore.teams !== 'undefined') {
	                var aTeams = oData.boxscore.teams || [];
	                var iTeamLen = aTeams.length;
	                for (var i = 0; i < iTeamLen; i++) {
	                    var oTeam = aTeams[i];
	                    if (typeof oTeam.statistics !== 'undefined' && typeof oTeam.statistics[0] !== 'undefined' && typeof oTeam.statistics[0].stats !== 'undefined') {
	                        var aStats = oTeam.statistics[0].stats || [];
	                        var iStatLen = aStats.length;
	                        for (var x = 0; x < iStatLen; x++) {
	                            var oStat = aStats[x];
	                            if (oStat.type == 'possession' || oStat.type == 'pcpossessionfirst') {
	                                // has to be > 1 as somtimes it arrives a 1% and 99% which is way wrong
	                                if (oStat.value * 100 > 1) {
	                                    bHasStats = true;
	                                    break;
	                                }
	                            }
	                        }
	                        if (bHasStats) {
	                            break;
	                        }
	                    }
	                }
	            }
	            this.data.hasStats = bHasStats;
	        } catch (e) {}
	    },
	
	    hasStats: function hasStats() {
	        return this.data.hasStats;
	    },
	
	    setStatSummary: function setStatSummary(oData) {
	        // takes the home team and the away team and searches the table if available to calculate the positions.
	        var aStatsBox = [];
	        if (typeof oData !== 'undefined' && typeof oData.standings !== 'undefined' && typeof oData.standings.children !== 'undefined') {
	            var fValueCompare = function fValueCompare(a, b) {
	                if (a.value < b.value) {
	                    return -1;
	                }
	                if (a.value > b.value) {
	                    return 1;
	                }
	                return 0;
	            };
	
	            var aGroups = oData.standings.children || [];
	            var oStandings = {};
	            var iGroupLen = aGroups.length;
	            var hHomeTeam = this.getHomeTeam();
	            var hAwayTeam = this.getAwayTeam();
	            var bFound = false;
	            var aEntries = [];
	
	            if (iGroupLen > 1) {
	                // we have more then 1 group we need to find the correct group
	                for (var i = 0; i < iGroupLen; i++) {
	                    oStandings = aGroups[i];
	                    aEntries = oStandings.standings && oStandings.standings.entries ? oStandings.standings.entries : [];
	                    for (var x = 0; x < aEntries.length; x++) {
	                        var hTeam = aEntries[x];
	                        if (hTeam.team.id == hHomeTeam.id) {
	                            bFound = true;
	                        }
	                        if (bFound) {
	                            break;
	                        }
	                    }
	                    if (bFound) {
	                        break;
	                    }
	                }
	            } else {
	                // only one group so must be in that group
	                oStandings = aGroups[0];
	                aEntries = oStandings.standings && oStandings.standings.entries ? oStandings.standings.entries : [];
	            }
	
	            var iEntryLen = aEntries.length;
	            var hStatsData = {};
	
	            for (var x = 0; x < iEntryLen; x++) {
	                var hTeam = aEntries[x];
	                for (var j = 0; j < hTeam.stats.length; j++) {
	                    if (typeof hStatsData[hTeam.stats[j].type] === 'undefined') {
	                        hStatsData[hTeam.stats[j].type] = [];
	                    }
	                    var hTmpdata = {
	                        value: hTeam.stats[j].value * 1,
	                        description: hTeam.stats[j].description,
	                        displayValue: hTeam.stats[j].displayValue,
	                        team: hTeam.team.id
	                    };
	                    hStatsData[hTeam.stats[j].type].push(hTmpdata);
	                }
	            }
	
	            // if neither team has played again don't show the stats.
	            if (typeof hStatsData['gamesplayed'] !== 'undefined') {
	                if (typeof hStatsData['gamesplayed'][0] !== 'undefined' && hStatsData['gamesplayed'][0].value == 0 && typeof hStatsData['gamesplayed'][1] !== 'undefined' && hStatsData['gamesplayed'][1].value == 0) {
	                    return;
	                }
	            } else {
	                return; // no played data so i assume never played.
	            }
	
	            // priority order of the stats, so if i can't find 1 move on to the next
	            var aPriorityStats = ['pointsfor', 'pointsagainst', 'pointsdifference', 'triesfor', 'triesagainst', 'triesdifference', 'gameswon', 'gameslost', 'gamesdrawn', 'bonuspoints', 'bonuspointslosing', 'bonuspointstry', 'gamesbye', 'points', 'gamesplayed'];
	            var aReverseStats = [true, false, true, true, false, true, true, false, true, true, false, true, true, true, true];
	            var iPriorityLen = aPriorityStats.length;
	            var aStatsToSort = [];
	            for (var x = 0; x < iPriorityLen; x++) {
	                if (typeof hStatsData[aPriorityStats[x]] !== 'undefined') {
	                    aStatsToSort.push(aPriorityStats[x]);
	                }
	                if (aStatsToSort.length >= 4) {
	                    break;
	                }
	            }
	
	            // sort each piece of data
	            var iStatLen = aStatsToSort.length;
	            for (var x = 0; x < iStatLen; x++) {
	                var aStats = hStatsData[aStatsToSort[x]];
	                var aSorted = aStats.sort(fValueCompare);
	                var bReverse = aReverseStats[x] || false;
	                if (bReverse) {
	                    aSorted.reverse();
	                }
	
	                // loop the records looking for teams
	                var iSortedLen = aSorted.length;
	                var hBoxData = {
	                    name: aSorted[0].description,
	                    home: {
	                        abbreviation: '',
	                        position: 0,
	                        value: 0,
	                        displayValue: 0
	                    },
	                    away: {
	                        abbreviation: '',
	                        position: 0,
	                        value: 0,
	                        displayValue: 0
	                    }
	                };
	                var iTeamWatch = 0;
	                for (var i = 0; i < iSortedLen; i++) {
	                    var oStatData = aSorted[i];
	                    if (oStatData.team == hHomeTeam.id) {
	                        hBoxData.home.color = hHomeTeam.color;
	                        hBoxData.home.abbreviation = hHomeTeam.abbreviation;
	                        hBoxData.home.position = i + 1;
	                        hBoxData.home.value = oStatData.value;
	                        hBoxData.home.displayValue = oStatData.displayValue;
	                        iTeamWatch++;
	                    } else if (oStatData.team == hAwayTeam.id) {
	                        hBoxData.away.color = hAwayTeam.color;
	                        hBoxData.away.abbreviation = hAwayTeam.abbreviation;
	                        hBoxData.away.position = i + 1;
	                        hBoxData.away.value = oStatData.value;
	                        hBoxData.away.displayValue = oStatData.displayValue;
	                        iTeamWatch++;
	                    }
	                }
	                // if we have found at least 1 team allow it to continue.
	                if (iTeamWatch == 2) {
	                    aStatsBox.push(hBoxData);
	                }
	            }
	        }
	        this.data.teamStatsBox = aStatsBox;
	    },
	
	    getStatSummary: function getStatSummary() {
	        return this.data.teamStatsBox || [];
	    },
	
	    setRosters: function setRosters(data) {
	        this.data.rosters = data.rosters;
	    },
	
	    setMatchState: function setMatchState(oData) {
	        if (typeof oData !== 'undefined' && typeof oData.header !== 'undefined' && typeof oData.header.competitions !== 'undefined' && typeof oData.header.competitions[0] !== 'undefined' && typeof oData.header.competitions[0].status !== 'undefined' && typeof oData.header.competitions[0].status.type !== 'undefined' && typeof oData.header.competitions[0].status.type.state !== 'undefined') {
	            var sState = oData.header.competitions[0].status.type.state;
	            if (sState == 'pre') {
	                this.data.matchState = 'pre';
	            } else if (sState == 'in') {
	                this.data.matchState = 'live';
	            } else {
	                this.data.matchState = 'post';
	            }
	            //console.log(this.data.matchState);
	        }
	    },
	
	    getMatchState: function getMatchState() {
	        return this.data.matchState;
	    },
	
	    setGameInformation: function setGameInformation(oData) {
	
	        var oGameInfo = {
	            venueName: '',
	            address: '',
	            capacity: 0,
	            attendance: 0,
	            datetime: '',
	            coverage: ''
	        };
	
	        if (typeof oData !== 'undefined' && typeof oData.gameInfo !== 'undefined' && typeof oData.gameInfo.venue !== 'undefined') {
	            var oVenue = oData.gameInfo.venue;
	            oGameInfo.venueName = oVenue && (oVenue.shortName || oVenue.fullName) || '--';
	            oGameInfo.address = oVenue && oVenue.address && oVenue.address.summary || '';
	            oGameInfo.capacity = oVenue && oVenue.capacity || 0;
	            oGameInfo.attendance = oVenue && oVenue.attendance || 0;
	            // images are got here as well
	        }
	        if (typeof oData !== 'undefined' && typeof oData.gameInfo !== 'undefined' && typeof oData.gameInfo.attendance !== 'undefined') {
	            oGameInfo.attendance = oData.gameInfo.attendance || 0;
	        }
	
	        if (typeof oData !== 'undefined' && typeof oData.header !== 'undefined' && typeof oData.header.competitions !== 'undefined' && typeof oData.header.competitions[0] !== 'undefined') {
	            var oEvent = oData.header.competitions[0];
	            oGameInfo.datetime = oEvent.date || '';
	        }
	
	        this.data.gameInformation = oGameInfo;
	    },
	
	    getGameInformation: function getGameInformation() {
	        return this.data.gameInformation || {};
	    },
	
	    setTeams: function setTeams(oData) {
	        var oTeams = {};
	        if (typeof oData !== 'undefined' && typeof oData.header !== 'undefined' && typeof oData.header.competitions !== 'undefined' && typeof oData.header.competitions[0] !== 'undefined' && typeof oData.header.competitions[0].competitors !== 'undefined') {
	            var aTeams = oData.header.competitions[0].competitors;
	            var iTeamLen = aTeams.length;
	            for (var i = 0; i < iTeamLen; i++) {
	                var oTeam = aTeams[i];
	                var iId = oTeam.team.id || 0;
	                var sHomeAway = oTeam.homeAway || '';
	                var sName = oTeam.team.name || '--';
	                var sAbbr = oTeam.team.abbreviation || sName;
	                var sLogo = '';
	                var sColor = oTeam.team.color || null;
	                if (typeof oTeam.team.logos[0] !== 'undefined' && typeof oTeam.team.logos[0].href !== 'undefined') {
	                    sLogo = oTeam.team.logos[0].href;
	                } else {
	                    sLogo = 'http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/default-team-logo-500.png?w=100&h=100&transparent=true';
	                }
	
	                if (sColor === null) {
	                    if (sHomeAway == 'home') {
	                        sColor = '#ffc300';
	                    } else {
	                        sColor = '#d31346';
	                    }
	                } else {
	                    if (sColor.substring(0, 1) != "#") {
	                        sColor = '#' + sColor;
	                    }
	                }
	
	                oTeams[sHomeAway] = {
	                    name: sName,
	                    abbreviation: sAbbr,
	                    logo: sLogo,
	                    id: iId,
	                    color: sColor
	                };
	            }
	        }
	        this.data.teams = oTeams;
	    },
	
	    getHomeTeam: function getHomeTeam() {
	        return this.data.teams.home || {};
	    },
	
	    getAwayTeam: function getAwayTeam() {
	        return this.data.teams.away || {};
	    },
	
	    setHead2Head: function setHead2Head(data) {
	        this.data.head2head = data.headToHeadGames;
	    },
	
	    setRecentForm: function setRecentForm(oData) {
	        if (typeof oData !== 'undefined' && typeof oData.lastFiveGames !== 'undefined') {
	            this.data.form = oData.lastFiveGames;
	        }
	    },
	
	    setNewsList: function setNewsList(oData) {
	        if (typeof oData !== 'undefined' && typeof oData.news !== 'undefined') {
	            this.data.newsList = oData.news;
	        }
	    },
	
	    setStandings: function setStandings(oData) {
	        if (typeof oData !== 'undefined' && typeof oData.standings !== 'undefined') {
	            this.data.standings = oData.standings;
	        }
	    },
	
	    setGameStrip: function setGameStrip(data) {
	        try {
	            this.data.gameStrip = new GameStrip({
	                sport: 'rugby',
	                event: data.header
	            });
	        } catch (e) {}
	    },
	
	    setMatchStats: function setMatchStats(data) {
	        try {
	            var strip = this.getGameStripDetails();
	            var homeData;
	            var awayData;
	            // Added team id check to set home/away stats
	            if (data.boxscore.teams[0].team.id === strip.teams.home.id) {
	                homeData = data.boxscore.teams[0].statistics[0].stats;
	                awayData = data.boxscore.teams[1].statistics[0].stats;
	            } else {
	                homeData = data.boxscore.teams[1].statistics[0].stats;
	                awayData = data.boxscore.teams[0].statistics[0].stats;
	            }
	            this.data.matchStats = {
	                home: homeData,
	                away: awayData
	            };
	        } catch (e) {
	            this.data.matchStats = {
	                home: {},
	                away: {}
	            };
	        }
	    },
	
	    setTableLink: function setTableLink(oData) {
	
	        this.data.tableLink = '';
	
	        if (typeof oData !== 'undefined' && typeof oData.header !== 'undefined' && typeof oData.header.league !== 'undefined' && typeof oData.header.league.midsizeName !== 'undefined') {
	            this.data.tableLink = '/rugby/table/_/league/' + oData.header.league.midsizeName;
	        } else {
	            // during data migration this is a fallback until above is populated.
	            if (typeof oData !== 'undefined' && typeof oData.header !== 'undefined' && typeof oData.header.league !== 'undefined' && typeof oData.header.league.id !== 'undefined') {
	                this.data.tableLink = '/rugby/table/_/league/' + oData.header.league.id;
	            }
	        }
	    },
	
	    getTableLink: function getTableLink(oData) {
	        return this.data.tableLink || '';
	    },
	
	    setCommentary: function setCommentary(oData) {
	        // Look for the data
	        var aCommentary = [];
	        if (typeof oData !== 'undefined' && typeof oData.header !== 'undefined' && typeof oData.header.competitions !== 'undefined' && typeof oData.header.competitions[0] !== 'undefined' && typeof oData.header.competitions[0].details !== 'undefined') {
	            var aEvents = oData.header.competitions[0].details;
	            var iEventLen = aEvents !== null ? aEvents.length : 0;
	            var iPrevType = 0;
	            for (var i = 0; i < iEventLen; i++) {
	                var oEvent = aEvents[i];
	                var sTime = '';
	                if (typeof oEvent.clock !== 'undefined') {
	                    sTime = oEvent.clock.displayValue || '';
	                } else if (typeof oEvent.time !== 'undefined') {
	                    sTime = oEvent.time.displayValue || '';
	                }
	                var sText = oEvent.type.text || oEvent.text || '';
	                var sType = oEvent.type.id * 1 || 0;
	                var iHomeScore = oEvent.homeScore * 1 || 0;
	                var iAwayScore = oEvent.awayScore * 1 || 0;
	                var iId = oEvent.sequenceNumber || 0;
	                var sTeamName = '';
	
	                if (typeof oEvent.team !== 'undefined' && typeof oEvent.team.displayName !== 'undefined') {
	                    var sTeamName = oEvent.team.displayName;
	                }
	
	                if (typeof oEvent.participants !== 'undefined' && typeof oEvent.participants[0] !== 'undefined' && typeof oEvent.participants[0].athlete !== 'undefined') {
	                    var oAthlete = oEvent.participants[0].athlete;
	                    var sName = oAthlete.displayName;
	
	                    if (sType == 8) {
	                        sText = sName + ' is brought on';
	                    } else if (sType == 7) {
	                        sText = sName + ' is taken off';
	                    } else if (sType == 1) {
	                        sText = 'TRY! ' + sName + ' scores for ' + sTeamName;
	                    } else if (sType == 2) {
	                        sText = sName + ' makes the conversion';
	                    } else if (sType == 3) {
	                        sText = 'Penalty to ' + sTeamName + '! ' + sName + ' scores';
	                    } else if (sType == 4) {
	                        sText = 'Drop Goal! ' + sName + ' scores for ' + sTeamName;
	                    } else if (sType == 5) {
	                        sText = sName + ' receives a yellow card';
	                    } else if (sType == 6) {
	                        sText = sName + ' is sent off';
	                    }
	                }
	
	                if (sType == 14) {
	                    sText = 'PENALTY! Try awarded to ' + sTeamName;
	                }
	
	                /* Knockout the doubles */
	                if (sType == 9 && iPrevType == 9 || sType == 10 && iPrevType == 10 || sType == 11 && iPrevType == 11 || sType == 12 && iPrevType == 12 || sType == 13) {
	                    continue;
	                }
	
	                // Capitalize words for events that indicate start/end of halves
	                if (sType == 12 || sType == 11 || sType == 10 || sType == 9) {
	                    sText = sText.replace(/(?:^|\s)\S/g, function (a) {
	                        return a.toUpperCase();
	                    });
	                }
	
	                var oTmpEvent = {
	                    id: iId,
	                    type: sType,
	                    text: sText,
	                    time: sTime,
	                    homeScore: iHomeScore,
	                    awayScore: iAwayScore
	                };
	
	                aCommentary.push(oTmpEvent);
	                iPrevType = sType;
	            }
	            if (this.getMatchState !== 'live') {
	                aCommentary = aCommentary.reverse();
	            }
	        }
	
	        if (aCommentary.length >= 1) {
	            this.data.hasCommentary = true;
	        }
	
	        this.data.commentary = aCommentary;
	    },
	
	    getCommentary: function getCommentary() {
	        return this.data.commentary || [];
	    },
	
	    hasCommentary: function hasCommentary() {
	        return this.data.hasCommentary || false;
	    },
	
	    setPlayerDisplayPosition: function setPlayerDisplayPosition(oData) {
	
	        var rSortedPlayers = {};
	        var rHomeAwayMap = {};
	        var oSub = {
	            home: {},
	            away: {}
	        };
	
	        //loop players and add to default order
	        if (typeof oData !== 'undefined' && typeof oData.rosters !== 'undefined') {
	            var iTeamLen = oData.rosters.length;
	            for (var x = 0; x < iTeamLen; x++) {
	                if (typeof oData.rosters[x].roster === 'undefined') {
	                    continue;
	                }
	                var aPlayers = oData.rosters[x].roster || [];
	                var sHomeAway = oData.rosters[x].homeAway || '';
	                rSortedPlayers[sHomeAway] = {};
	                rSortedPlayers[sHomeAway].playerList = [];
	                rSortedPlayers[sHomeAway].playerMap = {};
	                var iPlayerLen = aPlayers.length;
	                for (var i = 0; i < iPlayerLen; i++) {
	                    var oPlayer = aPlayers[i];
	                    rSortedPlayers[sHomeAway].playerList.push(oPlayer.athlete.id);
	                    rSortedPlayers[sHomeAway].playerMap[oPlayer.athlete.id] = rSortedPlayers[sHomeAway].playerList.length - 1;
	                    rHomeAwayMap[oPlayer.athlete.id] = sHomeAway;
	                }
	            }
	        }
	
	        // loop details to find when a player goes on and off and map to a single event.
	        if (typeof oData !== 'undefined' && typeof oData.header !== 'undefined' && typeof oData.header.competitions !== 'undefined' && typeof oData.header.competitions[0] !== 'undefined' && typeof oData.header.competitions[0].details !== 'undefined') {
	            var aEvents = oData.header.competitions[0].details;
	            var iEventLen = aEvents !== null ? aEvents.length : 0;
	            for (var i = 0; i < iEventLen; i++) {
	                var oEvent = aEvents[i];
	                var sType = oEvent.type.id || 0;
	                if (sType == 7 || sType == 8) {
	                    // get the player id
	                    if (typeof oEvent.participants !== 'undefined' && typeof oEvent.participants[0] !== 'undefined' && typeof oEvent.participants[0].athlete !== 'undefined') {
	                        var oAthlete = oEvent.participants[0].athlete;
	                        var sTeam = rHomeAwayMap[oAthlete.id] || '';
	                        var sTime = oEvent.clock.value || '';
	
	                        if (sTeam !== '') {
	                            //if for some reason the player is not in the roster.
	                            if (typeof oSub[sTeam] === 'undefined') {
	                                oSub[sTeam] = {};
	                            }
	
	                            if (typeof oSub[sTeam][sTime] === 'undefined') {
	                                oSub[sTeam][sTime] = {
	                                    'in': null,
	                                    out: null
	                                };
	                            }
	
	                            if (sType == 7) {
	                                oSub[sTeam][sTime].displayTime = oEvent.clock.displayValue;
	                                oSub[sTeam][sTime].out = oAthlete.id;
	                                oSub[sTeam][sTime].outName = oAthlete.displayName;
	                            } else {
	                                oSub[sTeam][sTime].displayTime = oEvent.clock.displayValue;
	                                oSub[sTeam][sTime]['in'] = oAthlete.id;
	                                oSub[sTeam][sTime].inName = oAthlete.displayName;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        // now we know who subbed who we need to map these changes into positions.
	        for (var sKey in oSub) {
	            if (oSub.hasOwnProperty(sKey)) {
	
	                var aKeys = Object.keys(oSub[sKey]),
	                    iLen = aKeys.length;
	                aKeys.sort();
	
	                for (var i = 0; i < iLen; i++) {
	                    var oSubstitute = oSub[sKey][aKeys[i]];
	
	                    if (oSubstitute['in'] !== null && oSubstitute.out !== null) {
	                        var iCurrPosIn = rSortedPlayers[sKey].playerMap[oSubstitute['in']];
	                        var iCurrPosOut = rSortedPlayers[sKey].playerMap[oSubstitute.out];
	
	                        // move the player
	                        rSortedPlayers[sKey].playerList[iCurrPosIn] = oSubstitute.out;
	                        rSortedPlayers[sKey].playerList[iCurrPosOut] = oSubstitute['in'];
	                        rSortedPlayers[sKey].playerMap[oSubstitute.out] = iCurrPosIn;
	                        rSortedPlayers[sKey].playerMap[oSubstitute['in']] = iCurrPosOut;
	                    }
	                }
	            }
	        }
	
	        this.data.playersList = rSortedPlayers;
	        this.data.substituteEvents = oSub;
	    },
	
	    setPlayersList: function setPlayersList(oData) {
	        var hSortedPlayers = {};
	        var oSubs = this.data.substituteEvents;
	
	        if (typeof oData !== 'undefined' && typeof oData.rosters !== 'undefined') {
	            // itterate all events to see who was subbed on
	            var rSubbed = {};
	            var rAthleteEvents = {};
	            if (typeof oData.header !== 'undefined' && typeof oData.header.competitions !== 'undefined' && typeof oData.header.competitions[0] !== 'undefined' && typeof oData.header.competitions[0].details !== 'undefined') {
	                var aEvents = oData.header.competitions[0].details;
	                var iEventLen = aEvents !== null ? aEvents.length : 0;
	                for (var i = 0; i < iEventLen; i++) {
	                    var oEvent = aEvents[i];
	                    var sType = oEvent.type.id || 0;
	
	                    var iAthleteId = 0;
	                    if (typeof oEvent.participants !== 'undefined' && typeof oEvent.participants[0] !== 'undefined' && typeof oEvent.participants[0].athlete !== 'undefined') {
	                        var oAthlete = oEvent.participants[0].athlete;
	                        iAthleteId = oAthlete.id;
	                    }
	
	                    if (iAthleteId) {
	                        if (typeof rAthleteEvents[iAthleteId] === 'undefined') {
	                            rAthleteEvents[iAthleteId] = {};
	                        }
	                        if (sType == 8) {
	                            // get the player id
	                            if (typeof oEvent.participants !== 'undefined' && typeof oEvent.participants[0] !== 'undefined' && typeof oEvent.participants[0].athlete !== 'undefined') {
	                                var oAthlete = oEvent.participants[0].athlete;
	                                var rSubbData = {};
	                                if (typeof oSubs.home[oEvent.clock.value] !== 'undefined' && oSubs.home[oEvent.clock.value]['in'] == iAthleteId) {
	                                    rSubbData = oSubs.home[oEvent.clock.value];
	                                } else if (typeof oSubs.away[oEvent.clock.value] !== 'undefined' && oSubs.away[oEvent.clock.value]['in'] == iAthleteId) {
	                                    rSubbData = oSubs.away[oEvent.clock.value];
	                                }
	                                rSubbed[iAthleteId] = '(' + rSubbData.displayTime + ') ' + rSubbData.outName;
	                            }
	                        } else {
	                            // build an array of every type and time.
	                            if (typeof rAthleteEvents[iAthleteId][sType] === 'undefined') {
	                                rAthleteEvents[iAthleteId][sType] = [];
	                            }
	                            rAthleteEvents[iAthleteId][sType].push(oEvent.clock.displayValue);
	                        }
	                    }
	                }
	            }
	
	            //console.log(rAthleteEvents);
	
	            var iTeamLen = oData.rosters.length;
	            for (var x = 0; x < iTeamLen; x++) {
	
	                if (typeof oData.rosters[x].roster === 'undefined') {
	                    continue;
	                }
	
	                var aPlayers = oData.rosters[x].roster || [];
	                var sHomeAway = oData.rosters[x].homeAway || '';
	                var iPlayerLen = aPlayers.length;
	                for (var i = 0; i < iPlayerLen; i++) {
	
	                    var oPlayer = aPlayers[i];
	                    var bActive = oPlayer.active === true ? true : false;
	                    var bCaptain = oPlayer.captain === true ? true : false;
	                    var iId = oPlayer.athlete.id || 0;
	                    var sName = oPlayer.athlete.displayName || '-';
	                    var iNumber = oPlayer.jersey || '-';
	                    var sPosition = oPlayer.position.abbreviation || '';
	                    var aStats = oPlayer.stats || [];
	                    var iTries = 0;
	                    var iRuns = 0;
	                    var iMetres = 0;
	                    var iTackles = 0;
	                    var iMissed = 0;
	                    var iYellow = 0;
	                    var iRed = 0;
	                    var iConverted = 0;
	                    var iPenalties = 0;
	
	                    var hToolTips = {};
	                    if (typeof rAthleteEvents[iId] !== 'undefined') {
	                        if (typeof rAthleteEvents[iId]['1'] !== 'undefined') {
	                            iTries = rAthleteEvents[iId]['1'].length || 0;
	                        }
	                        if (typeof rAthleteEvents[iId]['2'] !== 'undefined') {
	                            iConverted = rAthleteEvents[iId]['2'].length || 0;
	                        }
	                        if (typeof rAthleteEvents[iId]['3'] !== 'undefined') {
	                            iPenalties = rAthleteEvents[iId]['3'].length || 0;
	                        }
	                        if (typeof rAthleteEvents[iId]['5'] !== 'undefined') {
	                            iYellow = rAthleteEvents[iId]['5'].length || 0;
	                        }
	                        if (typeof rAthleteEvents[iId]['6'] !== 'undefined') {
	                            iRed = rAthleteEvents[iId]['6'].length || 0;
	                        }
	                    }
	
	                    var iStatLen = aStats.length;
	                    var iStatWatch = 0;
	                    for (var v = 0; v < iStatLen; v++) {
	                        var oStat = aStats[v];
	                        if (oStat.type == 'tries') {
	                            iTries = iTries || oStat.displayValue || '0';
	                            iStatWatch++;
	                        } else if (oStat.type == 'runs') {
	                            iRuns = oStat.displayValue || '0';
	                            iStatWatch++;
	                        } else if (oStat.type == 'metres') {
	                            iMetres = oStat.displayValue || '0';
	                            iStatWatch++;
	                        } else if (oStat.type == 'tackles') {
	                            iTackles = oStat.displayValue || '0';
	                            iStatWatch++;
	                        } else if (oStat.type == 'missedtackles') {
	                            iMissed = oStat.displayValue || '0';
	                            iStatWatch++;
	                        } else if (oStat.type == 'yellowcards') {
	                            iYellow = iYellow || oStat.displayValue || '0';
	                            iStatWatch++;
	                        } else if (oStat.type == 'redcards') {
	                            iRed = iRed || oStat.displayValue || '0';
	                            iStatWatch++;
	                        } else if (oStat.type == 'conversiongoals') {
	                            iConverted = iConverted || oStat.displayValue || '0';
	                            iStatWatch++;
	                        }
	
	                        if (iStatWatch >= 8) {
	                            break;
	                        }
	                    }
	
	                    var bSubbed = false;
	                    var sSubTooltip = '';
	                    if (typeof rSubbed[iId] !== 'undefined') {
	                        //console.log(rSubbed[iId]);
	                        sSubTooltip = rSubbed[iId];
	                        bSubbed = true;
	                    }
	
	                    var oTmpPlayer = {
	                        id: iId,
	                        number: iNumber,
	                        name: sName,
	                        captain: bCaptain,
	                        onPitch: bActive,
	                        tries: iTries,
	                        runs: iRuns,
	                        runMetres: iMetres,
	                        tackles: iTackles,
	                        yellowCards: iYellow,
	                        redCards: iRed,
	                        conversionGoals: iConverted,
	                        missedTackles: iMissed,
	                        homeAway: sHomeAway,
	                        position: sPosition,
	                        subbed: bSubbed,
	                        penalties: iPenalties,
	                        events: rAthleteEvents[iId],
	                        subTip: sSubTooltip
	                    };
	
	                    hSortedPlayers[iId] = oTmpPlayer;
	                }
	            }
	        }
	        this.data.playersData = hSortedPlayers;
	    },
	
	    getPlayersList: function getPlayersList(sTeam) {
	
	        if (sTeam !== 'home' && sTeam !== 'away') {
	            sTeam = 'home';
	        }
	
	        var hTeamInfo = this.data.playersList[sTeam] || {};
	        var aPlayersList = [];
	        if (typeof hTeamInfo.playerList !== 'undefined') {
	            var iPlayerLen = hTeamInfo.playerList.length;
	            for (var i = 0; i < iPlayerLen; i++) {
	                aPlayersList.push(this.data.playersData[hTeamInfo.playerList[i]]);
	            }
	        }
	        return aPlayersList;
	    },
	
	    getTeamGroup: function getTeamGroup(childStandings) {
	        var self = this;
	        var homeId = self.data.gameStrip.teams.home.id;
	        var awayId = self.data.gameStrip.teams.away.id;
	        var _r = {};
	
	        childStandings.map(function (standing, i) {
	            standing.standings.entries.map(function (entry) {
	
	                // console.log(entry.team.id , homeId,  awayId);
	                // console.log(entry.team.id === homeId || entry.team.id === awayId);
	                if (entry.team.id === homeId || entry.team.id === awayId) {
	                    // return entry;
	                    // console.log(standing,1377);
	                    _r = standing;
	                }
	            });
	        });
	        // console.log(entries);
	        return _r;
	    },
	
	    getLeagueTable: function getLeagueTable() {
	        var leagueTable = [];
	        try {
	            var childStandings = this.data && this.data.standings && this.data.standings.children;
	            var standings = childStandings.length === 1 ? childStandings[0] : this.getTeamGroup(childStandings);
	            var entries = standings.standings.entries;
	
	            for (var i = 0; i < entries.length; i++) {
	                var standing = entries[i];
	                var tableData = {
	                    name: standing.team.displayName,
	                    href: standing.team.links && standing.team.links[0].href || '#'
	                };
	                for (var j = 0; j < standing.stats.length; j++) {
	                    if (standing.stats[j].name === 'rank') {
	                        tableData.position = standing.stats[j].displayValue;
	                    }
	                    if (standing.stats[j].name === 'gamesPlayed') {
	                        tableData.played = standing.stats[j].displayValue;
	                    }
	                    if (standing.stats[j].name === 'pointsDifference') {
	                        tableData.pointsDifference = standing.stats[j].displayValue;
	                    }
	                    if (standing.stats[j].name === 'points') {
	                        tableData.points = standing.stats[j].displayValue;
	                    }
	                }
	                leagueTable.push(tableData);
	            }
	        } catch (e) {}
	        return leagueTable;
	    },
	
	    setLeagueName: function setLeagueName(oData) {
	        var sLeagueName = '';
	        if (typeof oData !== 'undefined' && typeof oData.standings !== 'undefined' && typeof oData.standings.name !== 'undefined') {
	            sLeagueName = oData.standings.name;
	        }
	        this.data.leagueName = sLeagueName;
	    },
	
	    getLeagueName: function getLeagueName() {
	        return this.data.leagueName || '';
	    },
	
	    initDataStore: function initDataStore() {
	
	        /* remember to initilise so it will work later */
	        this.data = {};
	        this.data.commentary = [];
	        this.data.hasCommentary = false;
	        this.data.hasStats = false;
	        this.data.playersData = {};
	        this.data.playersList = {};
	        this.data.teams = {};
	        this.data.gameInformation = {};
	        this.data.newsList = {};
	        this.data.matchState = 'pre';
	        this.data.tableLink = '';
	        this.data.leagueName = '';
	        this.data.teamStatsBox = [];
	        this.data.substituteEvents = {};
	        this.data.standings = {};
	
	        this.data.homeTeam = [];
	        this.data.awayTeam = [];
	        this.data.homeTeamAbbr = "";
	        this.data.awayTeamAbbr = "";
	        this.data.homeTeamName = "-";
	        this.data.awayTeamName = "-";
	        this.data.homeTeamScore = "-";
	        this.data.awayTeamScore = "-";
	        this.data.homeTeamId = 0;
	        this.data.awayTeamId = 0;
	        this.data.homeTeamStats = {};
	        this.data.awayTeamStats = {};
	        this.data.events = [];
	
	        // Set up the venues
	        this.data.venue = {};
	        this.data.venue.name = "";
	        this.data.venue.capacity = "";
	        this.data.venue.address = "";
	
	        // Set up the home team
	        this.data.homeTeam = {};
	        this.data.homeTeam.name = "";
	        this.data.homeTeam.abbr = "";
	        this.data.homeTeam.score = "";
	        this.data.homeTeam.id = "";
	        this.data.homeTeam.stats = {};
	        this.data.homeTeam.roster = [];
	
	        // Set up reports+previews
	        this.data.hasReport = false;
	        this.data.hasPreview = false;
	    },
	    getStatus: function getStatus() {
	        return this.status;
	    },
	    getLastUpdate: function getLastUpdate() {
	        return this.lastUpdate;
	    },
	    getHomeSquad: function getHomeSquad() {
	        return this.data.homeTeam.roster;
	    },
	    getAwaySquad: function getAwaySquad() {
	        return this.data.awayTeam;
	    },
	    getHomeScore: function getHomeScore() {
	        return this.data.homeTeam.score;
	    },
	    getAwayScore: function getAwayScore() {
	        return this.data.awayTeamScore;
	    },
	    getHomeAbbr: function getHomeAbbr() {
	        return this.data.homeTeam.abbr;
	    },
	    getAwayAbbr: function getAwayAbbr() {
	        return this.data.awayTeamAbbr;
	    },
	    getHomeName: function getHomeName() {
	        return this.data.homeTeam.name;
	    },
	    getAwayName: function getAwayName() {
	        return this.data.awayTeamName;
	    },
	    getHomeStats: function getHomeStats() {
	        return this.data.homeTeam.stats;
	    },
	    getAwayStats: function getAwayStats() {
	        return this.data.awayTeamStats;
	    },
	    getAwayId: function getAwayId() {
	        return this.data.awayTeamId;
	    },
	    getHomeId: function getHomeId() {
	        return this.data.homeTeamId;
	    },
	    getAthletes: function getAthletes() {
	        return this.data.athletes;
	    },
	    getAthlete: function getAthlete(iAthleteId) {
	        return this.data.athletes[iAthleteId];
	    },
	    getMatchEvents: function getMatchEvents() {
	        return this.data.events;
	    },
	    getGameStripDetails: function getGameStripDetails() {
	        return this.data.gameStrip;
	    },
	    getNewsList: function getNewsList() {
	        return this.data.newsList;
	    },
	
	    getMatchStats: function getMatchStats(map) {
	        var _filterMap = {
	            rugby: {
	                runs: {
	                    order: 1,
	                    name: 'Runs'
	                },
	                metres: {
	                    order: 2,
	                    name: 'Metres Run'
	                },
	                cleanBreaks: {
	                    order: 3,
	                    name: 'Line Breaks'
	                },
	                tackles: {
	                    order: 4,
	                    name: 'Tackles'
	                },
	                missedTackles: {
	                    order: 5,
	                    name: 'Missed Tackles'
	                },
	                turnoverKnockOn: {
	                    order: 6,
	                    name: 'Knock Ons'
	                }
	            }
	        };
	        var matchStats = [];
	        var homeStats = this.data.matchStats.home;
	        var awayStats = this.data.matchStats.away;
	
	        _filterMap = map || _filterMap.rugby;
	
	        processStats(homeStats, 'home');
	        processStats(awayStats, 'away');
	
	        function processStats(stats, team) {
	            for (var i = 0, len = stats && stats.length; i < len; i++) {
	                var stat = stats[i];
	                var matchStat = {};
	                var order = _filterMap[stat.name] && _filterMap[stat.name].order;
	
	                if (order) {
	                    matchStats[order] = matchStats[order] || {};
	                    matchStats[order][team] = stat.displayValue;
	                    matchStats[order].displayName = _filterMap[stat.name].name || stat.displayName;
	                    matchStats[order].abbreviation = stat.abbreviation;
	                }
	            }
	        }
	
	        return matchStats;
	    },
	
	    getStatPercent: function getStatPercent(statName) {
	        var homeStats = this.data.matchStats.home;
	        var statPercent = [];
	
	        for (var i = 0, len = homeStats && homeStats.length; i < len; i++) {
	            var stat = homeStats[i];
	            if (stat.name === statName) {
	                var displayNumber = Number(stat.displayValue);
	                var isDecimal = displayNumber % 1 !== 0;
	                var homeStat = Math.round(displayNumber * (isDecimal ? 100 : 1));
	                statPercent.push(homeStat);
	                statPercent.push(homeStat === 0 ? 0 : 100 - homeStat);
	            }
	        }
	        return statPercent;
	    },
	
	    getStat: function getStat(statName) {
	        var homeStats = this.data.matchStats.home;
	        var awayStats = this.data.matchStats.away;
	        var foundStat = [];
	
	        function process(stats) {
	            for (var i = 0, len = stats && stats.length; i < len; i++) {
	                var stat = stats[i];
	                if (stat.name === statName) {
	                    var displayNumber = Number(stat.displayValue);
	                    foundStat.push(displayNumber);
	                }
	            }
	        }
	        process(homeStats);
	        process(awayStats);
	        return foundStat;
	    },
	
	    getHead2Head: function getHead2Head() {
	        var head2head = [];
	        try {
	            var self = this;
	            var head2headEvents = this.data.head2head[0].events;
	            var team = this.data.head2head[0].team;
	            var home = {
	                id: this.data.gameStrip.teams.home.id,
	                name: this.data.gameStrip.teams.home.name,
	                abbreviation: this.data.gameStrip.teams.home.abbreviation,
	                logo: this.data.gameStrip.teams.home.logo,
	                url: this.data.gameStrip.teams.home.url
	            };
	            var away = {
	                id: this.data.gameStrip.teams.away.id,
	                name: this.data.gameStrip.teams.away.name,
	                abbreviation: this.data.gameStrip.teams.away.abbreviation,
	                logo: this.data.gameStrip.teams.away.logo,
	                url: this.data.gameStrip.teams.away.url
	            };
	
	            head2headEvents.map(function (game, i) {
	
	                var scores = game.score.split('-');
	                var winningTeamScore = scores[0];
	                var loosingTeamScore = scores[1];
	                var gameResult = '' + game.gameResult;
	                var concatenatedScore = '';
	                var atVs = game.atVs;
	                var homeTeam = home;
	                var awayTeam = away;
	
	                if (atVs == "vs") {
	                    if (gameResult == "W" || gameResult == "D") {
	                        concatenatedScore = winningTeamScore + '-' + loosingTeamScore;
	                    } else {
	                        concatenatedScore = loosingTeamScore + '-' + winningTeamScore;
	                    }
	                } else {
	                    homeTeam = away;
	                    awayTeam = home;
	                    if (gameResult == "W" || gameResult == "D") {
	                        concatenatedScore = loosingTeamScore + '-' + winningTeamScore;
	                    } else {
	                        concatenatedScore = winningTeamScore + '-' + loosingTeamScore;
	                    }
	                }
	
	                head2head.push({
	                    result: gameResult,
	                    home: homeTeam,
	                    away: awayTeam,
	                    date: game.gameDate,
	                    league: game.leagueName,
	                    score: concatenatedScore,
	                    url: self.getGameUrl(game.links)
	                });
	            });
	        } catch (e) {}
	
	        return head2head;
	    },
	
	    getGameUrl: function getGameUrl(links) {
	        for (var i = 0, len = links && links.length; i < len; i++) {
	            var link = links[i];
	            if (link.text === "Match") {
	                return link.href;
	            }
	        }
	        return '#';
	    },
	
	    getRecentForm: function getRecentForm() {
	
	        var recentForm = {
	            home: [],
	            away: []
	        };
	
	        try {
	            var self = this;
	            var formData = this.data.form || [];
	
	            formData.map(function (form, i) {
	                var isHomeTeam = form.team.id === self.data.gameStrip.teams.home.id;
	                form.events.map(function (game, j) {
	
	                    var homeTeam = form.team;
	                    var awayTeam = game.opponent;
	                    var scores = game.score.split('-');
	                    var winningTeamScore = scores[0];
	                    var loosingTeamScore = scores[1];
	                    var gameResult = '' + game.gameResult;
	                    var concatenatedScore = '';
	                    var atVs = game.atVs;
	
	                    homeTeam.url = gameStripUtils.getTeamUrl(homeTeam);
	                    homeTeam.logo = homeTeam.logo || gameStripUtils.getDefaultLogo(homeTeam.logo);
	                    awayTeam.url = gameStripUtils.getTeamUrl(awayTeam);
	                    awayTeam.logo = awayTeam.logo || gameStripUtils.getDefaultLogo(awayTeam.logo);
	
	                    if (atVs == "vs") {
	                        if (gameResult == "W" || gameResult == "D") {
	                            concatenatedScore = winningTeamScore + '-' + loosingTeamScore;
	                        } else {
	                            concatenatedScore = loosingTeamScore + '-' + winningTeamScore;
	                        }
	                    } else {
	                        homeTeam = game.opponent;
	                        awayTeam = form.team;
	                        if (gameResult == "W" || gameResult == "D") {
	                            concatenatedScore = loosingTeamScore + '-' + winningTeamScore;
	                        } else {
	                            concatenatedScore = winningTeamScore + '-' + loosingTeamScore;
	                        }
	                    }
	
	                    recentForm[isHomeTeam ? 'home' : 'away'].push({
	                        result: gameResult,
	                        home: homeTeam,
	                        away: awayTeam,
	                        date: game.gameDate,
	                        league: game.leagueName,
	                        score: concatenatedScore,
	                        url: self.getGameUrl(game.links)
	                    });
	                });
	            });
	        } catch (e) {}
	
	        return recentForm;
	    },
	
	    getPlayerStats: function getPlayerStats(statsFilter, home) {
	        var filtered = [];
	        try {
	            var rosters = this.data.rosters;
	            var playerList = home && rosters[0].homeAway === 'home' ? rosters[0].roster : rosters[1].roster;
	
	            var orderedList = this.data.playersList;
	            var orderedPlayerMap = orderedList[home ? 'home' : 'away'].playerMap;
	
	            for (var i = 0; i < playerList.length; i++) {
	
	                var player = playerList[i];
	                var athlete = player.athlete || {};
	                var playerPos = orderedPlayerMap[athlete.id];
	                var playerDetail = {
	                    name: athlete.displayName,
	                    id: athlete.id,
	                    jersey: player.jersey,
	                    position: player.position.abbreviation,
	                    positionName: player.position.name,
	                    stats: [],
	                    href: athlete.links && athlete.links[0] && athlete.links[0].href || '#'
	                };
	                var stats = player.stats;
	                for (var j = 0; j < stats.length; j++) {
	                    var stat = stats[j];
	                    var sStatName = stat.name;
	                    // backward compatability for migration of data.
	                    if (sStatName === 'tryAssists') {
	                        sStatName = 'tryAssist';
	                    }
	                    if (statsFilter[sStatName]) {
	                        playerDetail.stats[statsFilter[sStatName].index] = stat;
	                    }
	                }
	                filtered[playerPos] = playerDetail;
	            }
	        } catch (e) {}
	        return filtered;
	    }
	});
	
	module.exports = ScoreStore;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	module.exports = {
	    BaseStore: __webpack_require__(416),
	    connectToStores: __webpack_require__(420),
	    createStore: __webpack_require__(422),
	    FluxibleComponent: __webpack_require__(218),
	    FluxibleMixin: __webpack_require__(246),
	    provideContext: __webpack_require__(424)
	};


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	module.exports = __webpack_require__(417);


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var inherits = __webpack_require__(418);
	var EventEmitter = __webpack_require__(419);
	var CHANGE_EVENT = 'change';
	
	/**
	 * @class BaseStore
	 * @extends EventEmitter
	 * @param dispatcher The dispatcher interface
	 * @constructor
	 */
	function BaseStore(dispatcher) {
	    this.dispatcher = dispatcher;
	    this._hasChanged = false;
	    if (this.initialize) {
	        this.initialize();
	    }
	}
	
	inherits(BaseStore, EventEmitter);
	
	/**
	 * Convenience method for getting the store context object.
	 * @method getContext
	 * @return {Object} Returns the store context object.
	 */
	BaseStore.prototype.getContext = function getContext() {
	    return this.dispatcher.getContext();
	};
	
	/**
	 * Add a listener for the change event
	 * @method addChangeListener
	 * @param {Function} callback
	 */
	BaseStore.prototype.addChangeListener = function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	};
	
	/**
	 * Remove a listener for the change event
	 * @method removeChangeListener
	 * @param {Function} callback
	 */
	BaseStore.prototype.removeChangeListener = function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	};
	
	/**
	 * Determines whether the store should dehydrate or not. By default, only dehydrates
	 * if the store has emitted an update event. If no update has been emitted, it is assumed
	 * that the store is in its default state and therefore does not need to dehydrate.
	 * @method shouldDehydrate
	 * @returns {boolean}
	 */
	BaseStore.prototype.shouldDehydrate = function shouldDehydrate() {
	    return this._hasChanged;
	};
	
	/**
	 * Emit a change event
	 * @method emitChange
	 * @param {*} param=this
	 */
	BaseStore.prototype.emitChange = function emitChange(param) {
	    this._hasChanged = true;
	    this.emit(CHANGE_EVENT, param || this);
	};
	
	module.exports = BaseStore;


/***/ },
/* 418 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} once Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Holds the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Functon} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var React = __webpack_require__(11);
	var objectAssign = __webpack_require__(217);
	var contextTypes = __webpack_require__(237);
	var hoistNonReactStatics = __webpack_require__(421);
	
	/**
	 * Registers change listeners and retrieves state from stores using `getStateFromStores`
	 * method. Concept provided by Dan Abramov via
	 * https://medium.com/@dan_abramov/mixins-are-dead-long-live-higher-order-components-94a0d2f9e750
	 * @method connectToStores
	 * @param {React.Component} Component component to pass state as props to
	 * @param {array} stores List of stores to listen for changes
	 * @param {function} getStateFromStores function that receives all stores and should return
	 *      the full state object. Receives `stores` hash and component `props` as arguments
	 * @returns {React.Component}
	 */
	module.exports = function connectToStores(Component, stores, getStateFromStores) {
	    var componentName = Component.displayName || Component.name;
	    var StoreConnector = React.createClass({
	        displayName: componentName + 'StoreConnector',
	        contextTypes: {
	            getStore: contextTypes.getStore
	        },
	        getInitialState: function getInitialState() {
	            return this.getStateFromStores(this.props);
	        },
	        componentDidMount: function componentDidMount() {
	            stores.forEach(function storesEach(Store) {
	                this.context.getStore(Store).addChangeListener(this._onStoreChange);
	            }, this);
	        },
	        componentWillUnmount: function componentWillUnmount() {
	            stores.forEach(function storesEach(Store) {
	                this.context.getStore(Store).removeChangeListener(this._onStoreChange);
	            }, this);
	        },
	        getStateFromStores: function () {
	            if ('function' === typeof getStateFromStores) {
	                var storeInstances = {};
	                stores.forEach(function (store) {
	                    var storeName = store.storeName || store.name || store;
	                    storeInstances[storeName] = this.context.getStore(store);
	                }, this);
	                return getStateFromStores(storeInstances, this.props);
	            }
	            var state = {};
	            //@TODO deprecate?
	            Object.keys(getStateFromStores).forEach(function (storeName) {
	                var stateGetter = getStateFromStores[storeName];
	                var store = this.context.getStore(storeName);
	                objectAssign(state, stateGetter(store, this.props));
	            }, this);
	            return state;
	        },
	        _onStoreChange: function onStoreChange() {
	            if (this.isMounted()) {
	                this.setState(this.getStateFromStores());
	            }
	        },
	        render: function render() {
	            return React.createElement(Component, objectAssign({}, this.props, this.state));
	        }
	    });
	
	    hoistNonReactStatics(StoreConnector, Component);
	
	    return StoreConnector;
	};


/***/ },
/* 421 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent) {
	    var keys = Object.getOwnPropertyNames(sourceComponent);
	    for (var i=0; i<keys.length; ++i) {
	        if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]]) {
	            targetComponent[keys[i]] = sourceComponent[keys[i]];
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	module.exports = __webpack_require__(423);


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var inherits = __webpack_require__(418);
	var BaseStore = __webpack_require__(417);
	var IGNORE_ON_PROTOTYPE = ['statics', 'storeName', 'handlers', 'mixins'];
	
	function createChainedFunction(one, two) {
	    return function chainedFunction() {
	        one.apply(this, arguments);
	        two.apply(this, arguments);
	    };
	}
	
	function mixInto(dest, src) {
	    Object.keys(src).forEach(function (prop) {
	        if (-1 !== IGNORE_ON_PROTOTYPE.indexOf(prop)) {
	            return;
	        }
	        if ('initialize' === prop) {
	            if (!dest[prop]) {
	                dest[prop] = src[prop];
	            } else {
	                dest[prop] = createChainedFunction(dest[prop], src[prop]);
	            }
	        } else {
	            if (dest.hasOwnProperty(prop)) {
	                throw new Error('Mixin property collision for property "' + prop + '"');
	            }
	            dest[prop] = src[prop];
	        }
	    });
	}
	
	/**
	 * Helper for creating a store class
	 * @method createStore
	 * @param {Object} spec
	 * @param {String} spec.storeName The name of the store
	 * @param {Object} spec.handlers Hash of action name to method name of action handlers
	 * @param {Function} spec.initialize Function called during construction for setting the default state
	 * @param {Function} spec.dehydrate Function that returns serializable data to send to the client
	 * @param {Function} spec.rehydrate Function that takes in serializable data to rehydrate the store
	 */
	module.exports = function createStore(spec) {
	    spec.statics = spec.statics || {};
	    if (!spec.storeName && !spec.statics.storeName) {
	        throw new Error('createStore called without a storeName');
	    }
	    var Store = function (dispatcher) {
	        BaseStore.call(this, dispatcher);
	    };
	
	    inherits(Store, BaseStore);
	
	    Object.keys(spec.statics).forEach(function (prop) {
	        Store[prop] = spec.statics[prop];
	    });
	
	    Store.storeName = spec.storeName || Store.storeName;
	    Store.handlers = spec.handlers || Store.handlers;
	    Store.mixins = spec.mixins || Store.mixins;
	
	    if (Store.mixins) {
	        Store.mixins.forEach(function(mixin) {
	            mixInto(Store.prototype, mixin);
	        });
	    }
	    mixInto(Store.prototype, spec);
	
	    return Store;
	};


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(11);
	/**
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var objectAssign = __webpack_require__(217);
	var contextTypes = __webpack_require__(237);
	var hoistNonReactStatics = __webpack_require__(421);
	
	/**
	 * Provides context prop to all children as React context
	 * @method provideContext
	 * @param {React.Component} Component component to wrap
	 * @param {object} customContextTypes Custom contextTypes to add
	 * @returns {React.Component}
	 */
	module.exports = function provideContext(Component, customContextTypes) {
	    var childContextTypes = objectAssign({}, contextTypes, customContextTypes || {});
	
	    var ContextProvider = React.createClass({
	        displayName: 'ContextProvider',
	
	        propTypes: {
	            context: React.PropTypes.object.isRequired
	        },
	
	        childContextTypes: childContextTypes,
	
	        getChildContext: function () {
	            var childContext = {
	                executeAction: this.props.context.executeAction,
	                getStore: this.props.context.getStore
	            };
	            if (customContextTypes) {
	                Object.keys(customContextTypes).forEach(function (key) {
	                    childContext[key] = this.props.context[key];
	                }, this);
	            }
	            return childContext;
	        },
	
	        render: function () {
	            return React.createElement(Component, this.props);
	        }
	    });
	
	    hoistNonReactStatics(ContextProvider, Component);
	
	    return ContextProvider;
	};


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var debug = __webpack_require__(8)('app:mixin:persistentStateMixin');
	var warn = __webpack_require__(8)('app:mixin:persistentStateMixin:warn');
	
	module.exports = {
	    dehydrate: function dehydrate() {
	        debug('dehydrating %s', this.constructor.storeName);
	        if (!this.data) {
	            warn('missing data object');
	            return;
	        }
	        return Object.keys(this.data).reduce((function (result, prop) {
	            result[prop] = this.data[prop];
	            return result;
	        }).bind(this), {});
	    },
	    rehydrate: function rehydrate(state) {
	        debug('rehydrating %s', this.constructor.storeName);
	        Object.keys(state).forEach((function (prop) {
	            this.data[prop] = state[prop];
	        }).bind(this));
	    }
	};

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var gameStripUtils = __webpack_require__(359);
	
	/**
	 * A class to build data for game strips
	 *
	 * @constructor
	 * @param {Object} params
	 */
	function GameStrip(params) {
	
	    if (!(this instanceof GameStrip)) {
	        return new GameStrip(params);
	    }
	    var event = params.event;
	    var competition = event.competitions[0];
	    var home = competition.competitors[0] || {};
	    var away = competition.competitors[1] || {};
	
	    // Set form on the home and away team objects
	    if (home.form) {
	        if ('team' in home) {
	            home.team.form = home.form;
	        }
	    }
	
	    if (away.form) {
	        if ('team' in away) {
	            away.team.form = away.form;
	        }
	    }
	
	    this.id = event.id;
	    this.sport = params.sport;
	    this.league = event.leagues && event.leagues[0];
	    this.date = event.date || competition.date;
	    this.formattedDate = gameStripUtils.getFormattedDate(this.date);
	    this.gameStatus = gameStripUtils.getGameStatus(competition.status.type.state);
	
	    // This logic accomodates anomalies in rugby/soccer data
	    // TODO: Cleanup after it gets fixed
	    if (this.gameStatus == 'pregame') {
	        this.time = gameStripUtils.getLocalTime(this.date);
	    } else {
	        this.time = gameStripUtils.getActiveGameStatus(this.gameStatus, competition.status, competition.timeValid);
	    }
	
	    var rugbyDetails = [];
	    if ('details' in competition) {
	        rugbyDetails = competition.details;
	        if (rugbyDetails === null) {
	            rugbyDetails = [];
	        }
	    }
	
	    // Lookup data formatter function based on sports
	    var sportSettings = {
	        'soccer': {
	            formatter: 'getGameDetails',
	            args: [competition.details, home.id]
	        },
	        'rugby': {
	            formatter: 'getRugbyDetails',
	            args: [rugbyDetails, home.id]
	        }
	    };
	    // Get formatter function and arguments for a sport
	    var settings = sportSettings[this.sport];
	    var formatter = settings.formatter;
	    var args = settings.args;
	
	    //console.info('formatter', formatter);
	    // Extract data from utility functions
	    this.teams = gameStripUtils.getTeamsInfo(home.team, away.team);
	    this.scores = gameStripUtils.getScores(home, away);
	    this.winnerClass = gameStripUtils.getWinnerClass(home, away);
	    this.gameDetails = gameStripUtils[formatter](args[0], args[1]);
	    this.venue = gameStripUtils.getVenueDetails(competition);
	    this.broadcasts = gameStripUtils.getBroadcasts(competition.broadcasts);
	    this.gameLinks = event.links;
	    this.footer = gameStripUtils.getGameNotes(competition, home, away);
	    this.heading = gameStripUtils.getHeading(event);
	
	    /* itterate game links and correct match this is a HACK for now*/
	    var editionsHost = window ? window.location.hostname : 'www.espn.co.uk';
	    this.gameLinks.map(function (link, j) {
	        if (link.text === 'Match' || link.text === 'Report' || link.text === 'Preview') {
	            link.href = link.href.replace('www.espn.co.uk', editionsHost);
	        }
	    });
	
	    return this;
	}
	
	module.exports = GameStrip;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var createStore = __webpack_require__(415).createStore;
	var PersistentStateMixin = __webpack_require__(425);
	
	var StandingsStore = createStore({
	    storeName: 'StandingsStore',
	
	    mixins: [PersistentStateMixin],
	
	    initialize: function initialize() {
	        this.data = {};
	        this.loading = false;
	        this.ready = false;
	        this.pathname = '';
	    },
	
	    handlers: {
	        RECEIVED_STANDINGS: function RECEIVED_STANDINGS(payload) {
	
	            var oGlossary = {};
	            var oClincher = {};
	            var aNotes = [];
	            this._buildAncilleryData(payload.data, oGlossary, aNotes, oClincher);
	
	            this.data.raw = payload.data;
	            this.data.sport = payload.sport;
	            this.data.league = payload.league;
	            this.data.leagueName = payload.data.name;
	            this.data.params = payload.params;
	            this.data.seasons = this._buildSeasonData(payload.sport, payload.league, payload.data) || [];
	            this.data.glossary = oGlossary;
	            this.data.notes = aNotes;
	            this.data.clinchers = oClincher;
	            this.loading = false;
	            this.ready = true;
	            this.pathname = payload.pathname;
	
	            this.emitChange();
	        },
	        REQUEST_STANDINGS: function REQUEST_STANDINGS(payload) {
	            this.loading = true;
	            this.emitChange();
	        }
	    },
	
	    /*
	     * Checks to see if loading if so return false as the store
	     * is not ready to allow update
	     */
	    isReady: function isReady() {
	        return this.ready;
	    },
	
	    /*
	     * Checks to see if the store is loading data
	     */
	    isUpdating: function isUpdating() {
	        try {
	            return this.loading;
	        } catch (e) {
	            return false;
	        }
	    },
	
	    getStandings: function getStandings() {
	        try {
	            return this.data || {};
	        } catch (e) {
	            return {};
	        }
	    },
	
	    _buildAncilleryData: function _buildAncilleryData(oData, oGlossary, aNotes, oClincher) {
	
	        /* itterate the data and pull the descriptions for each column */
	        if (typeof oData === "undefined") {
	            return {};
	        }
	
	        if (typeof oData.children !== "undefined") {
	            for (var i = 0; i < oData.children.length; i++) {
	                this._buildAncilleryData(oData.children[i], oGlossary, aNotes, oClincher);
	            }
	        }
	
	        if (typeof oData.standings !== "undefined") {
	            this._buildAncilleryData(oData.standings, oGlossary, aNotes, oClincher);
	        }
	
	        if (typeof oData.entries !== "undefined") {
	            for (var i = 0; i < oData.entries.length; i++) {
	                this._buildAncilleryData(oData.entries[i], oGlossary, aNotes, oClincher);
	            }
	        }
	
	        if (typeof oData.stats !== "undefined") {
	            for (var i = 0; i < oData.stats.length; i++) {
	                oGlossary[oData.stats[i].type] = oData.stats[i].description;
	                if (oData.stats[i].type === 'clincher') {
	                    oClincher[oData.stats[i].displayValue] = oData.stats[i].description;
	                }
	            }
	        }
	
	        if (typeof oData.note !== "undefined") {
	            aNotes.push(oData.note);
	        }
	    },
	
	    _buildSeasonData: function _buildSeasonData(sSport, sLeague, oData) {
	
	        /* itterate the data and pull the descriptions for each column */
	        if (typeof oData === "undefined" || typeof oData.seasons === "undefined") {
	            return [];
	        }
	        var aSeasons = oData.seasons;
	
	        /* set a year cap */
	        var minSeason = {
	            'nba': 2002,
	            'mlb': 2002,
	            'usa.1': 2002,
	            'ncf': 2002,
	            'nfl': 2002
	        };
	        var iMinYear = minSeason[sLeague] || 2002;
	
	        /* itterate seasons data available at the end of the feed and format accordingly. */
	        var dToday = new Date();
	        var aTmpSeasons = [];
	
	        for (var i = 0; i < aSeasons.length; i++) {
	            var oSeason = aSeasons[i];
	            if (oSeason.startDate != "" && oSeason.endDate != "") {
	                var dStartDate = new Date(oSeason.startDate);
	                var dEndDate = new Date(oSeason.endDate);
	
	                /* dump all early years */
	                if (iMinYear > dStartDate.getFullYear()) {
	                    continue;
	                }
	
	                var sDisplayValue = dStartDate.getFullYear();
	                if (sDisplayValue !== dEndDate.getFullYear()) {
	                    sDisplayValue = dStartDate.getFullYear() + '-' + dEndDate.getFullYear().toString().slice(-2);
	                }
	
	                var bIsCurrent = false;
	                if (dToday.getTime() >= dStartDate.getTime() && dToday.getTime() <= dEndDate.getTime()) {
	                    bIsCurrent = true;
	                }
	
	                /* itterate the types for this season and build an acceptable list */
	                var aTmpTypes = [];
	                var iLeagueId = sLeague;
	                if (typeof oSeason.types !== "undefined") {
	                    for (var v = 0; v < oSeason.types.length; v++) {
	                        var oType = oSeason.types[v];
	
	                        if (oType.startDate === null || oType.startDate === '' || oType.abbreviation === null || oType.abbreviation === '' || oType.abbreviation === 'off' || oType.abbreviation === 'post') {
	                            /* ignored in standings if no or incorrect data */
	                            continue;
	                        }
	
	                        var dTypeStartDate = new Date(oType.startDate);
	                        var dTypeEndDate = new Date(oType.endDate);
	
	                        if (dToday.getTime() < dTypeStartDate.getTime()) {
	                            /* start date in the future so ignore */
	                            continue;
	                        }
	
	                        var bTypeIsCurrent = false;
	                        if (dToday.getTime() >= dTypeStartDate.getTime() && dToday.getTime() <= dTypeEndDate.getTime()) {
	                            bTypeIsCurrent = true;
	                        }
	
	                        aTmpTypes.push({
	                            id: oType.id,
	                            name: oType.name,
	                            abbreviation: oType.abbreviation,
	                            isCurrent: bTypeIsCurrent
	                        });
	
	                        if (oType.abbreviation === 'reg' && sSport === 'rugby') {
	                            iLeagueId = oType.id;
	                        }
	                    }
	                }
	
	                aTmpSeasons.push({
	                    displayValue: sDisplayValue,
	                    year: oSeason.year,
	                    isCurrent: bIsCurrent,
	                    types: aTmpTypes,
	                    league: iLeagueId
	                });
	            }
	        }
	        //console.log(aTmpSeasons);
	        return aTmpSeasons;
	    }
	
	});
	
	module.exports = StandingsStore;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var createStore = __webpack_require__(415).createStore;
	var PersistentStateMixin = __webpack_require__(425);
	
	var storeLeagues = createStore({
	
	    storeName: 'LeagueStore',
	
	    mixins: [PersistentStateMixin],
	
	    initialize: function initialize() {
	        this.data = {
	            leagues: [],
	            sport: null,
	            league: null,
	            params: null,
	            allLeaguesOption: {
	                "id": "1",
	                "name": "All Leagues",
	                "abbreviation": "All Leagues",
	                "midsizeName": "1"
	            }
	        };
	    },
	
	    handlers: {
	        RECEIVED_LEAGUES: function RECEIVED_LEAGUES(payload) {
	
	            var leagues = (payload && payload.data && payload.data.leagues || []).unshift(this.data.allLeaguesOption);
	            this.data.leagues = payload.data.leagues || [];
	            this.data.sport = payload.sport;
	            this.data.league = payload.league;
	            this.data.params = payload.params;
	
	            this.emitChange();
	        }
	    },
	
	    getLeagues: function getLeagues(sSport) {
	        try {
	            return this.data || {};
	        } catch (e) {
	            return {};
	        }
	    }
	
	});
	
	module.exports = storeLeagues;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var createStore = __webpack_require__(415).createStore;
	var PersistentStateMixin = __webpack_require__(425);
	var browser = __webpack_require__(252);
	var moment = __webpack_require__(254);
	var GameStrip = __webpack_require__(426);
	
	var ScoreboardStore = createStore({
	
	    storeName: 'ScoreboardStore',
	
	    mixins: [PersistentStateMixin],
	
	    initialize: function initialize() {
	        this.data = {
	            leagues: [],
	            aggregated: false,
	            formattedDates: []
	        };
	        this._cache = {};
	    },
	
	    handlers: {
	        RECEIVED_SCOREBOARD: function RECEIVED_SCOREBOARD(payload) {
	            var self = this;
	            var scores;
	
	            self.data = {
	                leagues: []
	            };
	            self._cache = {};
	
	            payload = payload || { leagues: [{}], events: [] };
	
	            if (payload && payload.scores) {
	                scores = payload.scores;
	                self.data.aggregated = true;
	            } else {
	                scores = [payload];
	                self.data.aggregated = false;
	            }
	
	            scores.map(function (score, i) {
	                var id = score.leagues[0].id;
	                if (!self._cache[id]) {
	                    var leagueScores = {
	                        events: [],
	                        name: score.leagues[0].name,
	                        calendar: score.leagues[0].calendar
	                    };
	                    score.events.map(function (event, j) {
	                        leagueScores.events.push(new GameStrip({
	                            sport: payload.sport,
	                            event: event
	                        }));
	                    });
	                    self.data.leagues.push(leagueScores);
	                    self.data.formattedDates = self.getCalendar();
	                    self._cache[id] = 1;
	                }
	            });
	            this.emitChange();
	        }
	    },
	    getScoreboard: function getScoreboard() {
	        try {
	            return this.data || {};
	        } catch (e) {
	            return {};
	        }
	    },
	    getCalendar: function getCalendar() {
	        var dates = [];
	        var calendar = [];
	
	        this.data.leagues.map(function (league, i) {
	            calendar = calendar.concat(league.calendar);
	        });
	
	        calendar.map(function (date, i) {
	            dates.push(new Date(date).setHours(0, 0, 0, 0));
	        });
	
	        return dates;
	    }
	});
	
	module.exports = ScoreboardStore;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var createStore = __webpack_require__(415).createStore;
	var PersistentStateMixin = __webpack_require__(425);
	var DateFormatMixin = __webpack_require__(365);
	
	var storeSchedule = createStore({
	
	    storeName: 'ScheduleStore',
	
	    mixins: [PersistentStateMixin, DateFormatMixin],
	
	    initialize: function initialize() {
	        this.data = {
	            events: {}
	        };
	    },
	
	    handlers: {
	        RECEIVED_SCHEDULE: function RECEIVED_SCHEDULE(payload) {
	
	            //this.data.sport       = payload.sport;
	            //this.data.league      = payload.league;
	
	            this._formatData(payload.data, payload.sport, payload.league);
	
	            //console.log(this.data.events);
	
	            this.emitChange();
	        }
	    },
	
	    haveData: function haveData(sSport, sLeague, sDateKey) {
	        if (typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' || typeof this.data.events[sSport][sLeague].events[sDateKey] === 'undefined') {
	            return false;
	        }
	        return true;
	    },
	
	    getLeagueName: function getLeagueName(sSport, sLeague) {
	        if (typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' || typeof this.data.events[sSport][sLeague].name === 'undefined') {
	            return '';
	        }
	        return this.data.events[sSport][sLeague].name;
	    },
	
	    getDefaultDate: function getDefaultDate(sSport, sLeague) {
	        if (typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' || typeof this.data.events[sSport][sLeague].defaultDate === 'undefined') {
	            return '';
	        }
	        return this.data.events[sSport][sLeague].defaultDate;
	    },
	
	    getCalendar: function getCalendar(sSport, sLeague) {
	        if (typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' || typeof this.data.events[sSport][sLeague].calendar === 'undefined') {
	            return [];
	        }
	        return this.data.events[sSport][sLeague].calendar;
	    },
	
	    getSchedule: function getSchedule(sSport, sLeague, oDate) {
	
	        var sDateKey = 0;
	        if (!oDate) {
	            sDateKey = this.getDateKey(sSport, sLeague);
	        } else {
	            sDateKey = this.dateToObject(oDate).getTime();
	        }
	
	        /* no data for this sport or date */
	        if (typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' || typeof this.data.events[sSport][sLeague].events[sDateKey] === 'undefined') {
	            return null;
	        }
	
	        return this.data.events[sSport][sLeague].events[sDateKey];
	    },
	
	    getRelatedDates: function getRelatedDates(sSport, sLeague, sDateKey) {
	
	        if (!sDateKey) {
	            sDateKey = this.getDateKey(sSport, sLeague);
	        }
	
	        /* no data for this sport or date */
	        if (typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' || typeof this.data.events[sSport][sLeague].events[sDateKey] === 'undefined') {
	            return [];
	        }
	        return this.data.events[sSport][sLeague].events[sDateKey].otherDates || [];
	    },
	
	    getDateKey: function getDateKey(sSport, sLeague) {
	        /* takes todays date and works out the closest date in the available sports */
	        if (typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined') {
	            return null;
	        }
	
	        for (var sDatekey in this.data.events[sSport][sLeague].events) {
	            return sDatekey;
	        }
	    },
	
	    _formatData: function _formatData(oData, sSport, sLeague) {
	
	        var iDaysForward = 0;
	        var sLeagueName = '';
	        var iFirstDate = 0;
	
	        if (typeof oData.events === 'undefined') {
	            return [];
	        }
	
	        /* set up data */
	        if (typeof this.data.events[sSport] === 'undefined') {
	            this.data.events[sSport] = {};
	        }
	
	        if (typeof this.data.events[sSport][sLeague] === 'undefined') {
	            this.data.events[sSport][sLeague] = {};
	        }
	
	        if (typeof this.data.events[sSport][sLeague].events === 'undefined') {
	            this.data.events[sSport][sLeague].events = {};
	            this.data.events[sSport][sLeague].name = '';
	            this.data.events[sSport][sLeague].defaultDate = null;
	        }
	
	        /* itterate other dates and jump forward by X? */
	        var aAltDates = [];
	        if (typeof oData.leagues !== 'undefined' && typeof oData.leagues[0] !== 'undefined' && typeof oData.leagues[0].calendar !== 'undefined') {
	            this.data.events[sSport][sLeague].calendar = [];
	            this.data.events[sSport][sLeague].name = oData.leagues[0].name;
	            for (var i = 0; i < oData.leagues[0].calendar.length; i++) {
	                aAltDates.push(this.dateToObject(oData.leagues[0].calendar[i]));
	            }
	            this.data.events[sSport][sLeague].calendar = aAltDates;
	        }
	
	        var oEvents = this.data.events[sSport][sLeague].events;
	
	        /* itterate the events */
	        for (var i = 0; i < oData.events.length; i++) {
	            var oEvent = oData.events[i];
	
	            if (typeof oEvent.competitions === 'undefined' || typeof oEvent.date === 'undefined') {
	                continue;
	            }
	
	            var oEventData = {
	                homeTeam: null,
	                awayTeam: null,
	                thisGameDate: null,
	                time: null,
	                displayTime: null,
	                result: null,
	                link: null,
	                note: '',
	                gameId: null,
	                tv: null,
	                betting: null,
	                tickets: null,
	                soccerRecord: 'v',
	                timeValid: false,
	                gameState: null,
	                period: null,
	                attendance: 'N/A',
	                location: '--'
	            };
	
	            /* get the start time */
	            var dEventDate = new Date(oEvent.date);
	            oEventData.time = oEvent.date;
	            oEventData.displayTime = this.dateFormat(oEvent.date, 'time1');
	            var sDateKey = dEventDate.setHours(0, 0, 0, 0);
	
	            if (!iFirstDate) {
	                iFirstDate = dEventDate.getTime();
	            }
	
	            /* get the game state  */
	            if (typeof oEvent.status !== 'undefined' && typeof oEvent.status.type !== 'undefined' && typeof oEvent.status.type.state !== 'undefined') {
	                oEventData.gameState = oEvent.status.type.state;
	                oEventData.result = oEvent.status.type.shortDetail;
	                oEventData.period = oEvent.status.period || 0;
	
	                if (oEventData.gameState === 'in') {
	                    oEventData.gameState === 'live';
	                }
	            } else {
	
	                oEventData.gameState = 'pre';
	            }
	
	            /* original code makes and assuption there is only 1 competition so i will do the same. */
	            var oCompetition = oEvent.competitions[0];
	
	            /* get the team data */
	            var oHomeAway = this._getCompetitors(oCompetition.competitors);
	            oEventData.homeTeam = oHomeAway.homeTeam;
	            oEventData.awayTeam = oHomeAway.awayTeam;
	
	            /* set is time valid? */
	            oEventData.timeValid = oCompetition.timeValid || false;
	
	            /* Game id = compid */
	            oEventData.gameId = oCompetition.id;
	
	            /* Get the game venue */
	            if (typeof oCompetition.venue !== 'undefined') {
	
	                var sVenue = oCompetition.venue.fullName || '';
	                var sCountry = oCompetition.venue.address.country || null;
	                var sCity = oCompetition.venue.address.city || null;
	
	                if (sCity != null) {
	                    sVenue = sVenue + ', ' + sCity;
	                }
	
	                if (sCountry != null && sLeague != 'usa.1') {
	                    sVenue = sVenue + ', ' + sCountry;
	                }
	
	                oEventData.location = sVenue;
	            }
	
	            /* Build a map of all the links for easy reference */
	            var rLinkMap = {};
	            for (var v = 0; v < oEvent.links.length; v++) {
	                var oLink = oEvent.links[v];
	                var sLinkKey = oLink.text.toLowerCase().replace(' ', '');
	                var oBetLink = {};
	
	                oBetLink.href = oLink.href || '#';
	                oBetLink.text = oLink.text;
	                oBetLink.isExternal = oLink.isExternal || false;
	
	                rLinkMap[sLinkKey] = oBetLink;
	            }
	
	            /* Build the game links */
	            var rLinkTypeMap = {
	                preLink: 'preview',
	                liveLink: 'gamecast',
	                secondLiveLink: 'play-by-play',
	                postLink: 'recap',
	                secondPostLink: 'box score',
	                'default': 'conversation'
	            };
	
	            if (sSport === 'soccer' || sSport === 'rugby') {
	                rLinkTypeMap = {
	                    'default': 'statistics',
	                    postLink: 'report',
	                    secondLiveLink: 'statistics',
	                    secondPostLink: 'statistics'
	                };
	            }
	
	            oEventData.link = rLinkMap['default'];
	            if (oEventData.gameState === 'pre') {
	                oEventData.link = rLinkMap[rLinkTypeMap['preLink']] ? rLinkMap[rLinkTypeMap['preLink']] : rLinkMap[rLinkTypeMap['default']];
	            } else if (oEventData.gameState === 'live') {
	                oEventData.link = rLinkMap[rLinkTypeMap['liveLink']] ? rLinkMap[rLinkTypeMap['liveLink']] : rLinkMap[rLinkTypeMap['secondLiveLink']];
	            } else if (oEventData.gameState === 'post') {
	                oEventData.link = rLinkMap[rLinkTypeMap['postLink']] ? rLinkMap[rLinkTypeMap['postLink']] : rLinkMap[rLinkTypeMap['secondPostLink']];
	            }
	            //link = call format.util.href(params, link);
	
	            //if(notes != null and (sport == "soccer" or seasonType == 3)){
	            //	note = call t.find(notes, "headline");
	            //}
	
	            /* build post game data */
	            if (oEventData.gameState == 'post') {
	
	                if (sSport === 'soccer') {
	
	                    /* get and format the attendance */
	                    if (typeof oCompetition.attendance !== 'undefined' && oCompetition.attendance > 0) {
	                        oEventData.attendance = this._numberWithCommas(oCompetition.attendance);
	                    }
	
	                    var iLeg = null;
	                    if (typeof oCompetition.leg !== 'undefined' && typeof oCompetition.leg.value !== 'undefined') {
	                        iLeg = oCompetition.leg.value;
	                    }
	
	                    /* build the score */
	                    if (iLeg == 2 && oEventData.homeTeam.aggregateScore != null && oEventData.awayTeam.aggregateScore != null) {
	                        oEventData.soccerRecord = oEventData.homeTeam.score + ' (' + oEventData.homeTeam.aggregateScore + ') - (' + oEventData.awayTeam.aggregateScore + ') ' + oEventData.awayTeam.score;
	                    } else {
	                        oEventData.soccerRecord = oEventData.homeTeam.score + ' - ' + oEventData.awayTeam.score;
	                    }
	
	                    if (iLeg != null && iLeg > 0) {
	
	                        if (oEventData.note !== '') {
	                            oEventData.note += ' - ';
	                        }
	
	                        oEventData.note += this.getOrdinal(iLeg) + ' Leg';
	
	                        /* build aggeragate winner text */
	                        if (oEventData.gameState !== 'pre') {
	                            oEventData.note += this._getSoccerNote(oEventData.homeTeam, oEventData.awayTeam, iLeg, 'aggregate', oEventData.period);
	                        }
	                    }
	
	                    /* build penalties text */
	                    if (oEventData.gameState !== 'pre' && (oEventData.homeTeam.shootoutScore > 0 || oEventData.awayTeam.shootoutScore > 0)) {
	                        oEventData.note += this._getSoccerNote(oEventData.homeTeam, oEventData.awayTeam, iLeg, 'penalties', oEventData.period);
	                    }
	                } else {}
	            } else {
	
	                /* build the betting links */
	                var oBetLink = rLinkMap.bet365;
	                if (oBetLink) {
	                    oBetLink.linkTrack = 'bet365';
	                    oBetLink.text = 'Football Odds with Bet365';
	                }
	                oEventData.betting = oBetLink;
	            }
	
	            /* if before or in match set to time */
	            if (oEventData.gameState == 'pre' || oEventData.gameState == 'live') {
	                oEventData.result = oEventData.displayTime;
	            }
	
	            /* build the tickets Links */
	            /*
	            gcid = call format.util.advertising.stubhub.shGCID(sport&'schedule');
	            if(ticketInfo != null){
	            	ticketText = optString(ticketInfo, "summary");
	            	ticketLink = call t.find(ticketInfo, #("links", 0, "href"));
	            	numAvailable = optInt(ticketInfo, 'numberAvailable');
	            	ticketText = replace(ticketText, 'available', '<span id="ticketAvailable">available</span>');
	            	keyword = homeDisplayName;
	            	keyword = replace(toLowerCase(keyword), ' ', '+');
	            	if(sport != 'soccer'){
	            		if(numAvailable == 0){
	            			ticketText = 'Buy on StubHub';
	            			ticketLink = 'http://www.stubhub.com/';
	            		}
	            		ticketLink = ticketLink & '?gcid=' & gcid & '&keyword=' & keyword;
	            	}
	            } else {
	            	if(sport != 'soccer'){
	            		if(homeTeamActive){
	            			generateSHLink = 'http://stubhub.com/';
	            			slug = replace(toLowerCase(homeDisplayName), ' ', '-') & '-tickets/';
	            			ticketLink = generateSHLink & slug & '?gcid=' & gcid;
	            			ticketText = 'Buy on StubHub';
	            		}
	            	}
	            }
	            */
	
	            /* set up output or reset if we are getting it again */
	            if (typeof oEvents[sDateKey] === 'undefined' || i == 0) {
	                oEvents[sDateKey] = {};
	                oEvents[sDateKey].key = sDateKey;
	                oEvents[sDateKey].displayValue = this.dateFormat(oEvent.date, 'date10');
	                oEvents[sDateKey].incomplete = [];
	                oEvents[sDateKey].complete = [];
	            }
	
	            if (oEventData.gameState != 'post') {
	                oEvents[sDateKey].incomplete.push(oEventData);
	            } else {
	                oEvents[sDateKey].complete.push(oEventData);
	            }
	        }
	
	        this.data.events[sSport][sLeague].defaultDate = iFirstDate;
	
	        /*
	        {
	            homeTeam={
	                id=3132,
	                name=Randers FC,
	                abbrev=Randers FC,
	                displayName=Randers FC,
	                logo=null,
	                link=http://espn.co.uk/football/club/_/id/3132
	            },
	            awayTeam={id=5243, name=UE Sant Julia, abbrev=UE Sant Juli, displayName=UE Sant Julia, logo=http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/5243.png&h=50, link=http://espn.co.uk/football/club/_/id/5243},
	            thisGameDate=2015-07-09T17:05Z,
	            result=1:05 PM ET,
	            link=http://en.espn.co.uk/football/sport/match/redirect.html?espn_fc_id=426274,
	            note=null,
	            gameId=426274,
	            columns={tv=null,betting={ticketText=Football Odds with Bet365, ticketLink=null, isExternal=true, linkTrack=bet365}},
	            soccerRecord=v,
	            timeValid=true
	        }
	        */
	    },
	
	    _getSoccerNote: function _getSoccerNote(oHomeTeam, oAwayTeam, iLeg, sType, iPeriod) {
	
	        if (iLeg <= 1) {
	            return '';
	        }
	
	        var sNote = '';
	        var sResult = '';
	        var bTied = false;
	        var sWillAdvance = oHomeTeam.name;
	        //var sWonMatch       = oHomeTeam.name;
	        var sWinning = null;
	        var iHomeScore = sType === 'aggregate' ? oHomeTeam.aggregateScore : oHomeTeam.shootoutScore;
	        var iAwayScore = sType === 'aggregate' ? oAwayTeam.aggregateScore : oAwayTeam.shootoutScore;
	        var iFirstScore = iHomeScore;
	        var iSecondScore = iAwayScore;
	
	        if (iAwayScore > iHomeScore) {
	            sWinning = oAwayTeam.name;
	        } else if (iAwayScore < iHomeScore) {
	            sWinning = oHomeTeam.name;
	        }
	
	        if (oAwayTeam.willAdvance) {
	            sWillAdvance = oAwayTeam.name;
	            iFirstScore = iAwayScore;
	            iSecondScore = iHomeScore;
	        }
	
	        //if(oAwayTeam.isWinner){
	        //    sWonMatch = oAwayTeam.name;
	        //}
	
	        sResult = sWillAdvance + ' win';
	        if (iHomeScore === iAwayScore) {
	            sResult = 'Tied';
	            if (sType === 'aggregate' && iPeriod != 5) {
	                bTied = true;
	            }
	        } else if (sWinning != null && sWillAdvance !== sWinning) {
	            sResult = sWinning + ' lead';
	        }
	
	        sNote = ' - ' + sResult + ' ' + iFirstScore + '-' + iSecondScore + ' on ' + sType;
	
	        if (bTied) {
	            sNote += ' - ' + sWillAdvance + ' advances';
	        }
	
	        return sNote;
	    },
	
	    _getCompetitors: function _getCompetitors(oCompetitors) {
	
	        var rComps = {
	            homeTeam: null,
	            awayTeam: null
	        };
	
	        if (typeof oCompetitors === 'undefined') {
	            return rComps;
	        }
	
	        for (var i = 0; i < oCompetitors.length; i++) {
	            var oCompetitor = oCompetitors[i];
	            if (oCompetitor.homeAway === 'home') {
	                rComps.homeTeam = this._getTeamInformation(oCompetitor.team);
	                rComps.homeTeam.isWinner = oCompetitor.winner || false;
	                rComps.homeTeam.willAdvance = oCompetitor.advance || false;
	                rComps.homeTeam.score = oCompetitor.score || 0;
	                rComps.homeTeam.aggregateScore = oCompetitor.aggregateScore || 0;
	                rComps.homeTeam.shootoutScore = oCompetitor.shootoutScore || 0;
	            } else {
	                rComps.awayTeam = this._getTeamInformation(oCompetitor.team);
	                rComps.awayTeam.isWinner = oCompetitor.winner || false;
	                rComps.awayTeam.willAdvance = oCompetitor.advance || false;
	                rComps.awayTeam.score = oCompetitor.score || 0;
	                rComps.awayTeam.aggregateScore = oCompetitor.aggregateScore || 0;
	                rComps.awayTeam.shootoutScore = oCompetitor.shootoutScore || 0;
	            }
	        }
	
	        return rComps;
	    },
	
	    _getTeamInformation: function _getTeamInformation(oTeamData) {
	
	        var iLogoSize = 25;
	
	        var rTmpTeam = {
	            id: null,
	            name: null,
	            abbrev: null,
	            displayName: null,
	            hasLogo: false,
	            logo: 'http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/default-team-logo-500.png&h=' + iLogoSize,
	            link: '#',
	            isActive: false,
	            willAdvance: false,
	            advance: false,
	            score: null,
	            aggregateScore: null,
	            shootoutScore: null
	        };
	
	        rTmpTeam.id = parseInt(oTeamData.id) || null;
	        rTmpTeam.name = oTeamData.name || null;
	        rTmpTeam.abbrev = oTeamData.abbreviation || null;
	        rTmpTeam.displayName = oTeamData.displayName || null;
	        rTmpTeam.isActive = oTeamData.isActive || false;
	
	        // get image or leave as default
	        var sTmpLogo = this._imageToCombiner({ image: oTeamData.logo, height: iLogoSize });
	        if (sTmpLogo !== null) {
	            rTmpTeam.logo = sTmpLogo;
	            rTmpTeam.hasLogo = true;
	        }
	
	        /* search for clubhouse links */
	        for (var i = 0; i < oTeamData.links.length; i++) {
	            var oLink = oTeamData.links[i];
	            if (oLink['text'] === 'Clubhouse') {
	                rTmpTeam.link = oLink.href || '#';
	            }
	        }
	
	        return rTmpTeam;
	    },
	
	    _numberWithCommas: function _numberWithCommas(x) {
	        var parts = x.toString().split(".");
	        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	        return parts.join(".");
	    },
	
	    getOrdinal: function getOrdinal(n) {
	        var s = ["th", "st", "nd", "rd"],
	            v = n % 100;
	        return n + (s[(v - 20) % 10] || s[v] || s[0]);
	    },
	
	    _imageToCombiner: function _imageToCombiner(oOpts) {
	
	        var sImage = oOpts.image || null;
	        var h = oOpts.height || null;
	        var w = oOpts.width || null;
	        var sImageUrl = null;
	        var sImageRef = 'http://a.espncdn.com';
	        var bFromSoccer = false;
	
	        if (sImage != null) {
	            var iImagedomainEnd = sImage.indexOf('.com/');
	            if (iImagedomainEnd > -1) {
	                iImagedomainEnd = iImagedomainEnd + 4;
	                sImageRef = sImage.substring(0, iImagedomainEnd);
	                var sOriginalRef = sImageRef;
	                if (sImage.indexOf('i.espncdn.com') > -1) {
	                    bFromSoccer = true;
	                    sImageRef = replace(sImageRef, 'i.', 'a.');
	                }
	                sImageUrl = sImageRef + '/combiner/i?img=';
	                if (bFromSoccer) {
	                    sImageUrl = sImageUrl + '/soccernet';
	                }
	                sImageUrl = sImageUrl + sImage.replace(sOriginalRef, '');
	                if (h != null) {
	                    sImageUrl = sImageUrl + '&h=' + h;
	                }
	                if (w != null) {
	                    sImageUrl = sImageUrl + '&w=' + w;
	                }
	            }
	        }
	
	        return sImageUrl;
	    }
	
	});
	
	module.exports = storeSchedule;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var createStore = __webpack_require__(415).createStore;
	var PersistentStateMixin = __webpack_require__(425);
	
	var HomeStore = createStore({
	
	    storeName: 'HomeStore',
	
	    mixins: [PersistentStateMixin],
	
	    initialize: function initialize() {
	        this.data = {};
	    },
	
	    handlers: {
	        RECEIVED_HOME: function RECEIVED_HOME(payload) {
	            this.data.columns = payload.columns;
	            this.emitChange();
	        }
	    },
	
	    getColumn: function getColumn(columnName) {
	        try {
	            for (var i = 0, len = this.data.columns.length; i < len; i++) {
	                var column = this.data.columns[i];
	                if (column.name === columnName) {
	                    return column;
	                }
	            }
	            return {};
	        } catch (e) {
	            return {};
	        }
	    }
	
	});
	
	module.exports = HomeStore;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var request = __webpack_require__(433);
	var config = __webpack_require__(206);
	
	module.exports = {
	    name: 'ServicePlugin',
	    plugContext: function plugContext(options) {
	        var api = options.api;
	        var auth = config.auth;
	        var proxyUrl = config.proxy.url || null;
	
	        function getProxyUrl() {
	            // TODO: Clean ups and cross domain checks
	            try {
	                proxyUrl = proxyUrl || proxyUrl == "" ? proxyUrl : 'http://' + location.hostname + ':' + config.proxy.port + '/';
	            } catch (e) {
	                proxyUrl = '';
	            }
	            return "";
	        }
	
	        return {
	            plugActionContext: function plugActionContext(actionContext) {
	                actionContext.service = {
	                    read: function read(resource, params, config, done) {
	                        var endpoint = getProxyUrl() + ((config && config.api || api) + resource);
	
	                        request.get(endpoint).query(params).type('json').auth(auth.user, auth.password).end(function (err, res) {
	                            try {
	                                var text = err || res.text;
	                                done(JSON.parse(text));
	                            } catch (e) {}
	                        });
	                    },
	                    get: function get(params) {
	                        var endpoint = getProxyUrl() + (params.url || options.endpoint);
	                        // For IE9 - Use Microsoft XDR
	                        if (navigator.userAgent.toLowerCase().indexOf('msie') != -1 && window.XDomainRequest) {
	                            //console.info("xdr start");
	                            var xdr = new XDomainRequest();
	                            xdr.open("get", endpoint);
	                            // Need to attach event handlers otherwise request gets aborted in IE
	                            xdr.onerror = function () {};
	                            xdr.ontimeout = function () {};
	                            xdr.onprogress = function () {};
	
	                            xdr.onload = function () {
	                                //console.info('callback', xdr.responseText);
	                                params.done(JSON.parse(xdr.responseText));
	                            };
	                            xdr.send();
	                            //console.info("xdr end");
	                        } else {
	                                request.get(endpoint)
	                                //.type('json')
	                                // TODO: Store auth in config and authenticate only if required
	                                //.auth(auth.user, auth.password)
	                                //.on('error', handle)
	                                .end(function (err, res) {
	                                    if (!err && res.ok) {
	                                        try {
	                                            params.done(JSON.parse(res.text));
	                                        } catch (e) {}
	                                    } else {
	                                        params.done();
	                                    }
	                                });
	                            }
	                    }
	                };
	            },
	            dehydrate: function dehydrate() {
	                return {
	                    api: api
	                };
	            },
	            rehydrate: function rehydrate(state) {
	                api = state.api;
	            }
	        };
	    }
	};

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(434);
	var reduce = __webpack_require__(435);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root = 'undefined' == typeof window
	  ? (this || self)
	  : window;
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return obj === Object(obj);
	}
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(obj[key]));
	    }
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  Emitter.call(this);
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {};
	  this._header = {};
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    if (err) {
	      return self.callback(err, res);
	    }
	
	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }
	
	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;
	
	    self.callback(err || new_err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Allow for extension
	 */
	
	Request.prototype.use = function(fn) {
	  fn(this);
	  return this;
	}
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.timeout = function(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.clearTimeout = function(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 */
	
	Request.prototype.getHeader = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass){
	  var str = btoa(user + ':' + pass);
	  this.set('Authorization', 'Basic ' + str);
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.field = function(name, val){
	  if (!this._formData) this._formData = new root.FormData();
	  this._formData.append(name, val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  if (!this._formData) this._formData = new root.FormData();
	  this._formData.append(field, file, filename);
	  return this;
	};
	
	/**
	 * Send `data`, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // querystring
	 *       request.get('/search')
	 *         .end(callback)
	 *
	 *       // multiple data "writes"
	 *       request.get('/search')
	 *         .send({ search: 'query' })
	 *         .send({ range: '1..5' })
	 *         .send({ order: 'desc' })
	 *         .end(callback)
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"})
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this.getHeader('Content-Type');
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this.getHeader('Content-Type');
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Origin is not allowed by Access-Control-Allow-Origin');
	  err.crossDomain = true;
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  xhr.open(this.method, this.url, true);
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var serialize = request.serialize[this.getHeader('Content-Type')];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  // send stuff
	  this.emit('request', this);
	  xhr.send(data);
	  return this;
	};
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new Request('GET', method);
	  }
	
	  return new Request(method, url);
	}
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.del = function(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * Expose `request`.
	 */
	
	module.exports = request;


/***/ },
/* 434 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 435 */
/***/ function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	'use strict';
	
	var browser = __webpack_require__(252);
	var appConfig = __webpack_require__(206);
	var jQuery = __webpack_require__(379);
	var mainContainerId = 'main-container';
	var mainContainerSelector = '#' + mainContainerId;
	var customNavSelector = '#custom-nav';
	var paneMainSelector = '#pane-main';
	
	/**
	 * Clears the original ref to main-container and custom-nav
	 */
	function clearOriginalRefs() {
		try {
			jQuery(mainContainerSelector).remove();
			jQuery(customNavSelector).remove();
			if (history.state && history.state.customNav) {
				history.state.customNav = null;
			}
		} catch (e) {}
	}
	
	/**
	 * Appends a new main-container to pane-main
	 */
	function appendNewContainer() {
		try {
			jQuery(paneMainSelector).append('<section id="' + mainContainerId + '" data-react="true"></section>');
		} catch (e) {}
	}
	
	/**
	 * Appends class names required on the game package page
	 */
	function addGamePackageClassNames() {
		try {
			if (!jQuery(paneMainSelector).attr('class')) {
				jQuery(paneMainSelector).addClass('in details-header details-footer');
			}
		} catch (e) {}
	}
	
	/**
	 * Updates the page Object
	 *  - Resets the new main-container
	 *  - Updates the contentPreBehavior (required on history.change)
	 * @return {[type]} [description]
	 */
	function updatePageObject() {
		try {
			espn_ui.Helpers.page.container = jQuery(mainContainerSelector);
			espn_ui.Helpers.page.contentPreBehavior = '<div class="main-content layout-bc"><div id="reactApp"></div></div>';
		} catch (e) {}
	}
	
	module.exports = {
		postRouteRender: function postRouteRender(sport, page, routeChange, isGamePackage) {
	
			if (isGamePackage) {
				var $mainContainer = jQuery(paneMainSelector + '>' + mainContainerSelector);
				if ($mainContainer.length && !$mainContainer.attr('data-react')) {
					clearOriginalRefs();
					appendNewContainer();
					updatePageObject();
				}
				addGamePackageClassNames();
			}
	
			if (!routeChange) {
				return;
			}
	
			updatePageObject();
		},
		preRouteRender: function preRouteRender(sport, page, routeChange) {
			if (!routeChange) {
				return;
			}
			browser.call('admgr.refreshInPageAdSlots');
			browser.call('espn_ui.Helpers.load_progress.start');
			try {
				page = page === 'fixtures' ? 'schedule' : page;
				// Triggers page pre-render that loads necessary CSS
				jQuery(document).trigger("page.preRender", ['', page, false, page, page == 'scoreboard' ? 'scoreboards-rugby' : null]);
			} catch (e) {}
		}
	};

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.bundle.js
 **/